webpackJsonp([139],{

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  isLogin: function isLogin() {
    return !!window.sessionStorage.getItem('accessToken');
  },
  save: function save(userinfo, uiLang) {
    var newHome = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    // alert(userinfo)
    // alert(userinfo.result.tokens)
    // userinfo && userinfo.username && window.sessionStorage.setItem('username', userinfo.username)
    // accessToken && window.sessionStorage.setItem('accessToken', accessToken)
    // uuid && window.sessionStorage.setItem('uuid', uuid)
    sessionStorage.setItem('accessToken', userinfo.accessToken);
    sessionStorage.setItem('uiLang', uiLang);
    this.saveNewHome(newHome);
    // window.sessionStorage.setItem('userId', '10001')
    // window.sessionStorage.setItem('supplierId', '12345')
    // window.sessionStorage.setItem('distributorId', '54321')
  },
  saveNewHome: function saveNewHome(newHome) {
    sessionStorage.setItem('newHome', newHome);
  },
  getAccessToken: function getAccessToken() {
    return window.sessionStorage.getItem('accessToken');
  },
  getUiLang: function getUiLang() {
    return window.sessionStorage.getItem('uiLang');
  },
  loadUserInfo: function loadUserInfo() {
    var accessToken = window.sessionStorage.getItem('accessToken');
    if (accessToken) {
      // 登入
    }
  }
});

/***/ }),

/***/ 114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_MSG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_ERROR_MSG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPDATE_SCROLLTOP_POSITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_SHOW_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPDATE_DIRECTION; });
// 系统消息
var UPDATE_MSG = 'UPDATE_MSG';
// 错误消息
var UPDATE_ERROR_MSG = 'UPDATE_ERROR_MSG';
// 记录距离顶部位置
var UPDATE_SCROLLTOP_POSITION = 'UPDATE_SCROLLTOP_POSITION';
// 加载状态
var UPDATE_LOADING = 'UPDATE_LOADING';
// 标题
var UPDATE_SHOW_TITLE = 'UPDATE_SHOW_TITLE';
// 显示画面方向
var UPDATE_DIRECTION = 'UPDATE_DIRECTION';

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_i18n__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_css_main_css__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_css_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__static_css_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_css_color_dark_css__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_css_color_dark_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__static_css_color_dark_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_css_m_cover_css__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_css_m_cover_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__static_css_m_cover_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__plugins_ajax__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__vuex_index__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_common__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_button__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__vuex_mutation_types__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_user__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_locale_lang_en__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_locale_lang_zh_CN__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_locale_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_locale_lang_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_locale_lang_zh_TW__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_locale_lang_zh_TW___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_locale_lang_zh_TW__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_locale_lang_ja__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_locale_lang_ja___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_locale_lang_ja__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_locale_lang_ko__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_locale_lang_ko___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_locale_lang_ko__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_storage__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_utils__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_dateUtils__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_dateExtend__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__libs_ui__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_quill_editor__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_basePage_js__ = __webpack_require__(318);



// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





// ElementUI











// 国际化





// utils





// 富文本编辑器


__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_29_vue_quill_editor___default.a);

__webpack_require__(604).polyfill();

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13__plugins_ajax__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24__utils_storage__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_28__libs_ui__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_16__mixins_button__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].mixin({
  methods: __WEBPACK_IMPORTED_MODULE_15__mixins_common__["a" /* default */]
});
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].mixin({
  methods: __WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */]
});
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].mixin({
  methods: __WEBPACK_IMPORTED_MODULE_26__utils_dateUtils__["a" /* default */]
});
window.basePage = __WEBPACK_IMPORTED_MODULE_30__utils_basePage_js__["a" /* default */];

var messages = {
  en: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(__webpack_require__(309).default, __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_locale_lang_en___default.a),
  ja: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(__webpack_require__(310).default, __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_locale_lang_ja___default.a),
  tw: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(__webpack_require__(313).default, __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_locale_lang_zh_TW___default.a),
  zh: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(__webpack_require__(312).default, __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_locale_lang_zh_CN___default.a),
  ko: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(__webpack_require__(311).default, __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_locale_lang_ko___default.a)
};

var langNow = 'en';
if (window.sessionStorage.getItem('uiLang') && window.sessionStorage.getItem('uiLang') !== 'undefined') {
  langNow = window.sessionStorage.getItem('uiLang');
} else {
  window.sessionStorage.setItem('uiLang', 'zh');
}

// Create VueI18n instance with options
var _i18n = new __WEBPACK_IMPORTED_MODULE_7_vue_i18n__["a" /* default */]({
  locale: langNow, // set locale
  fallbackLocale: 'en',
  messages: messages // set locale messages
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_element_ui___default.a, {
  i18n: function i18n(key, value) {
    return _i18n.t(key, value);
  }
});
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_14__vuex_index__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]);

var history = window.sessionStorage;
// history.clear()
var historyCount = history.getItem('count') * 1 || 0;
history.setItem('/', 0);

__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].beforeEach(function (to, from, next) {
  // 检查进入的页面是否需要登入
  // 检查进to是否需要登入
  var name = 'sys.user.accessToken=';
  var ca = document.cookie.split(';');
  var tokens = '';
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) === 0) {
      tokens = c.substring(name.length, c.length);
    }
  }
  if (to.meta.isLogin && __WEBPACK_IMPORTED_MODULE_18__utils_user__["a" /* default */].isLogin() === false && tokens === '') {
    next({ path: '/' });
  } else {
    next();
  }
});

__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_14__vuex_index__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_17__vuex_mutation_types__["a" /* UPDATE_LOADING */], true);
  var toIndex = history.getItem(to.path);
  var fromIndex = history.getItem(from.path);
  // start标题
  if (to.meta && to.meta.title) {
    __WEBPACK_IMPORTED_MODULE_14__vuex_index__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_17__vuex_mutation_types__["b" /* UPDATE_SHOW_TITLE */], to.meta.title);
  } else {
    __WEBPACK_IMPORTED_MODULE_14__vuex_index__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_17__vuex_mutation_types__["b" /* UPDATE_SHOW_TITLE */], '');
  }
  // end标题

  if (toIndex) {
    if (toIndex > fromIndex || !fromIndex || toIndex === '0' && fromIndex === '0') {
      __WEBPACK_IMPORTED_MODULE_14__vuex_index__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_17__vuex_mutation_types__["c" /* UPDATE_DIRECTION */], 'forward'); // 向前
    } else {
      __WEBPACK_IMPORTED_MODULE_14__vuex_index__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_17__vuex_mutation_types__["c" /* UPDATE_DIRECTION */], 'reverse'); // 回退
    }
  } else {
    ++historyCount;
    history.setItem('count', historyCount);
    to.path !== '/' && history.setItem(to.path, historyCount);
    __WEBPACK_IMPORTED_MODULE_14__vuex_index__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_17__vuex_mutation_types__["c" /* UPDATE_DIRECTION */], 'forward');
  }
  if (/\/http/.test(to.path)) {
    console.log('***************' + to.path);
    var url = to.path.split('http')[1];
    window.location.href = 'http' + url;
  } else {
    next();
  }
});

__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].afterEach(function (to, from) {
  __WEBPACK_IMPORTED_MODULE_14__vuex_index__["a" /* default */].commit('UPDATE_LOADING', false);
  var token = to.query.accessToken;
  if (token) {
    __WEBPACK_IMPORTED_MODULE_18__utils_user__["a" /* default */].save({ accessToken: token }, to.query.uiLang, to.query.newHome);
    var newQuery = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, to.query);
    delete newQuery.accessToken;
    delete newQuery.uiLang;
    delete newQuery.newHome;
    // 创建新的路由对象，移除参数
    __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].replace(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, to, { query: newQuery }));
  }
});
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.interceptors.request.use(function (config) {
  config.headers.common['uiLang'] = sessionStorage.getItem('langType');
  config.headers.common['accessToken'] = sessionStorage.getItem('accessToken');
  // document.cookie = 'accessToken' + "=" + accessToken;expires=" + exdate.toGMTString())
  // alert(document.cookie['sys.user.accessToken'])
  var date = new Date();
  config.headers.common['timeZone'] = date.getTimezoneOffset() / 60;
  //  config.headers.common['supplierId'] = sessionStorage.getItem('supplierId')
  //  config.headers.common['distributorId'] = sessionStorage.getItem('distributorId')
  return config;
}, function (error) {
  // Do something with request error
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// 响应拦截器
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.interceptors.response.use(function (response) {
  var res = response.data || {};
  // 检查token状态码
  if (__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].currentRoute.path !== '/login' && res && (res === -403 || res.code === -403)) {
    __WEBPACK_IMPORTED_MODULE_8_element_ui___default.a.Message.error(_i18n.t('newHome.expired'));
    sessionStorage.clear();
    var exp = new Date();
    exp.setTime(exp.getTime() + 1 * 1 * 1 * 1 * 1);
    document.cookie = 'sys.user.accessToken=;expires=' + exp.toGMTString() + ';path=/';
    __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push('/');
  }
  return response;
});
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]({
  i18n: _i18n,
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_14__vuex_index__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_4__App___default.a);
  }
}).$mount('#app');

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);




/**
 */
var flag = false;
/* harmony default export */ __webpack_exports__["a"] = ({
  /*
   * 统一log方法
   * */
  log: function log() {
    if (flag) return;

    for (var _len = arguments.length, msgs = Array(_len), _key = 0; _key < _len; _key++) {
      msgs[_key] = arguments[_key];
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(msgs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var msg = _step.value;
        console.log('统一LOG:', msg);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  },
  logCord: function logCord() {
    if (flag) return;
    var newMsg = '';

    for (var _len2 = arguments.length, msgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      msgs[_key2] = arguments[_key2];
    }

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(msgs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var msg = _step2.value;

        if ((typeof msg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(msg)) === 'object') {
          newMsg += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(msg) + ' ';
        } else {
          newMsg += msg + ' ';
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    console.log('统一LOG:', newMsg);
  },

  /**
   * 引用类型克隆
   */
  clone: function clone(obj) {
    if ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(obj)) !== 'object') return obj;
    var newObj = obj instanceof Array ? [] : {};
    for (var i in obj) {
      var val = obj[i];
      if (val instanceof Date) {
        newObj[i] = new Date(val.valueOf());
      } else if (!val) {
        newObj[i] = val;
      } else {
        newObj[i] = (typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(val)) === 'object' ? this.clone(val) : val;
      }
    }
    return newObj;
  },

  /**
   * 改变对象中某个值的key
   */
  replaceKey: function replaceKey(obj, oldKey, newKey) {
    obj[newKey] = obj[oldKey];
    delete obj[oldKey];
    return obj;
  },

  /**
   * @param value
   * 如果是number类型: 大于等于 0 返回 true, 否则返回 false, NaN 也是返回 false
   * 如果是Array类型: 长度大于 0 返回 true, 否则返回 false
   * 如果是Date类型: 返回 if (value)
   * 如果是Object类型: 如果不为null且不为空对象(如:{}) 返回 true, 否则返回 false
   * @returns {boolean}
   */
  isNotEmpty: function isNotEmpty(value) {
    if (value === null || value === undefined || value === '') return false;
    if (typeof value === 'number') {
      if (value >= 0) return true;else return false;
    } else if (Array.isArray(value)) {
      return value.some(function (item) {
        return item != null;
      });
    } else if (value instanceof Date) {
      if (value) return true;else return false;
    } else if (value instanceof Object) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(value).length === 0) return false;else return true;
    } else if (value) return true;else if (value) return true;else false;
  },

  /**
   * let els = this.$refs[formName].$el.elements
   * 表单原始值设置
   */
  setFormDefault: function setFormDefault(els) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(els), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var el = _step3.value;

        var type = el.type;
        if (type === 'checkbox' || type === 'radio') {
          el.defaultChecked = el.checked;
        } else if (type === 'hidden' || type === 'password' || type === 'text' || type === 'textarea') {
          el.defaultValue = el.value;
        } else if (type === 'select-one' || type === 'select-multiple') {
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(el.options), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var opt = _step4.value;

              opt.defaultSelected = opt.selected;
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  },

  /**
   * let els = this.$refs[formName].$el.elements
   * 查表单值是否有改变
   */
  formIsChange: function formIsChange(els) {
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(els), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var el = _step5.value;

        var type = el.type;
        if (type === 'checkbox' || type === 'radio') {
          if (el.checked !== el.defaultChecked) {
            this.logCord('表单值改变', el);
            return true;
          }
        } else if (type === 'hidden' || type === 'password' || type === 'text' || type === 'textarea') {
          if (el.value !== el.defaultValue) {
            this.logCord('表单值改变', el);
            return true;
          }
        } else if (type === 'select-one' || type === 'select-multiple') {
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(el.options), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var opt = _step6.value;

              if (opt.selected !== opt.defaultSelected) {
                this.logCord('表单值改变', el);
                return true;
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    return false;
  },

  /**
   * 数组已知值，不知下标，删除元素
   * @param arr
   * @param val
   */
  arrDel: function arrDel(arr, val) {
    var i = arr.indexOf(val);
    if (i !== -1) {
      arr.splice(i, 1);
    }
    return arr;
  },

  /**
   * 替换空值，并可设置一个默认值
   * @param val
   * @param defaultVal
   * @returns {*}
   */
  ridEmpty: function ridEmpty(val, defaultVal) {
    if (this.isNotEmpty(val)) return val;else if (defaultVal) return defaultVal;else return '';
  },

  /**
   * 如果value为空，返回一个格格符
   * 使用 ridEmpty (val, defaultVal) 替换
   * @param value
   * @returns {*}
   */
  getNewValue: function getNewValue(value) {
    if (this.isNotEmpty(value)) return value;else return '..';
  },

  /*
  不确定是 普通类型 还是 对象类型 用这个方法比较是否相同
  注意： 不等于才返回 true
   */
  compare: function compare(arg0, arg1) {
    var sub0 = void 0,
        sub1 = void 0;
    if ((typeof arg0 === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(arg0)) === 'object') {
      sub0 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(arg0);
      sub1 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(arg1);
    } else {
      sub0 = arg0;
      sub1 = arg1;
    }
    if (sub0 === null || sub0 === undefined) sub0 = '';
    if (sub1 === null || sub1 === undefined) sub1 = '';
    if (sub0 !== sub1) return true;else return false;
  },

  /**
   * 把阿拉伯数字转成中文大写数字
   * trip组件中有使用
   * */
  numberConvert: function numberConvert(num) {
    num = Number(num);
    var upperCaseNumber = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '百', '千', '万', '亿'];
    var length = String(num).length;
    if (length === 1) {
      return upperCaseNumber[num];
    } else if (length === 2) {
      if (num === 10) {
        return upperCaseNumber[num];
      } else if (num > 10 && num < 20) {
        return '十' + upperCaseNumber[String(num).charAt(1)];
      } else {
        return upperCaseNumber[String(num).charAt(0)] + '十' + upperCaseNumber[String(num).charAt(1)].replace('零', '');
      }
    }
  },
  getEditorHtml: function getEditorHtml(content) {
    return '<div class="ql-editor" data-gramm="false" contenteditable="true" data-placeholder="Insert text here ...">' + content + '</div><div class="ql-clipboard" contenteditable="true" tabindex="-1"></div>';
  },
  getRichTextHtml: function getRichTextHtml(content) {
    return '<div class="ql-editor" data-gramm="false" contenteditable="true" data-placeholder="Insert text here ...">' + content + '</div><div class="ql-clipboard" contenteditable="true" tabindex="-1"></div>';
  },

  // 给一个dom节点添加一个class
  addClass: function addClass(obj, cls) {
    var objClass = obj.className; // 获取 class 内容.
    var blank = objClass !== '' ? ' ' : ''; // 判断获取到的 class 是否为空, 如果不为空在前面加个'空格'.
    var added = objClass + blank + cls; // 组合原来的 class 和需要添加的 class.
    obj.className = added; // 替换原来的 class.
  },

  // 移除一个dom节点的class
  removeClass: function removeClass(obj, cls) {
    var objClass = ' ' + obj.className + ' '; // 获取 class 内容, 并在首尾各加一个空格. ex) 'abc    bcd' -> ' abc    bcd '
    objClass = objClass.replace(/(\s+)/gi, ' '); // 将多余的空字符替换成一个空格. ex) ' abc    bcd ' -> ' abc bcd '
    var removed = objClass.replace(' ' + cls + ' ', ' '); // 在原来的 class 替换掉首尾加了空格的 class. ex) ' abc bcd ' -> 'bcd '
    removed = removed.replace(/(^\s+)|(\s+$)/g, ''); // 去掉首尾空格. ex) 'bcd ' -> 'bcd'
    obj.className = removed; // 替换原来的 class.
  },

  // 判断一个节点是否有一个某个class
  hasClass: function hasClass(obj, cls) {
    var objClass = obj.className; // 获取 class 内容.
    var objClassLst = objClass.split(/\s+/); // 通过split空字符将cls转换成数组.
    var x = 0;
    for (x in objClassLst) {
      if (objClassLst[x] === cls) {
        // 循环数组, 判断是否包含cls
        return true;
      }
    }
    return false;
  }
});

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);

/**
 * date 的各工具方法
 */
//
var today = new Date();
/* harmony default export */ __webpack_exports__["a"] = ({
  getTimeObj: function getTimeObj(h, m, s) {
    var d = new Date();
    h = h < 0 ? d.getHours() : h;
    m = m < 0 ? d.getMinutes() : m;
    s = s < 0 ? d.getSeconds() : s;
    // let utc = Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, d.getUTCDate(), h, m, s)
    return new Date(today.getFullYear(), 0, 1, h, m, s);
  },

  /**
   * 将 date 字符串转换成 date 对象。
   * 可以是时间戳（number类型或字符类型都可以）
   * 可以是时间格式字符串（如：'yyyy-MM-dd'）
   * @param dateString
   * @returns {Date}
   */
  convertDate4String: function convertDate4String(dateString) {
    if (dateString instanceof Date) return dateString;
    var timeStamp = Number(dateString);
    var isInteger = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(timeStamp);
    if (isInteger) return new Date(timeStamp);else return new Date(dateString);
  },
  convertTime4String: function convertTime4String(dateString) {
    if (dateString instanceof Date) return dateString.getTime() + 8.64e7;
    var timeStamp = Number(dateString);
    var isInteger = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(timeStamp);
    if (isInteger) return new Date(timeStamp).getTime();else return new Date(dateString).getTime();
  },

  /**
   * 接收: HH:mm:ss
   * 返回：date
   * @param timeStr
   * @returns {Date}
   */
  getHmsDate: function getHmsDate(timeStr) {
    var a = timeStr.split(':');
    if (a && a.length !== 0) {
      if (a.length === 2) {
        a[2] = '00';
      }
      return new Date(today.getFullYear(), 0, 1, parseInt(a[0]), parseInt(a[1]), parseInt(a[2]));
    } else {
      console.log('getHmsDate 取值错误');
    }
  },

  /*
  接收两个 date 对象
  如果 date1 大， 返回：1
  如果 date1 小， 返回：-1
  如果 相等，     返回：0
  */
  dateCompare: function dateCompare(date1, date2, isShowLog) {
    if (isShowLog) {
      console.log(date1.Format('yyyy-MM-dd HH:mm:ss'));
    }
    if (date1 && date2) {
      if (date1.getTime() > date2.getTime()) return 1;else if (date1.getTime() < date2.getTime()) return -1;else return 0;
    } else {
      return -2;
    }
  },
  isSameDate: function isSameDate(date1, date2) {
    if (date1 && date2) {
      date1.setHours(0, 0, 0, 0);
      date2.setHours(0, 0, 0, 0);
      if (date1.getTime() > date2.getTime()) return 1;else if (date1.getTime() < date2.getTime()) return -1;else return 0;
    } else {
      return -2;
    }
  },

  /**
   * 接收 date对象 或 日期字符串， 转换为格式： yyyy-MM-dd
   * 弃用：已在 Date对象中扩展了方法:Date.Format
   */
  getFormatDate: function getFormatDate(date) {
    if (!date || date === '') return null;
    var subDate = void 0;
    if (date instanceof Date) {
      subDate = date;
    } else {
      subDate = new Date(date);
    }
    var y = subDate.getFullYear();
    var m = subDate.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    var d = subDate.getDate();
    d = d < 10 ? '0' + d : d;
    return y + '-' + m + '-' + d;
  },

  // 接收 时间戳（毫秒） 转换为格式： yyyy-MM-dd
  getDateStrByTimestamp: function getDateStrByTimestamp(timestamp) {
    if (!timestamp || timestamp === '') return '';
    timestamp = parseInt(timestamp);
    if (timestamp.toString().length < 13) timestamp *= 1000;
    return this.getFormatDate(new Date(timestamp));
  },

  /**
   * 接收：date
   * 返回：HH:mm:ss
   * @param timeDate
   * @returns {string}
   */
  getTimeStr: function getTimeStr(timeDate, number) {
    if (!timeDate) return '';
    if (timeDate) {
      var h = timeDate.getHours();
      var m = timeDate.getMinutes();
      var s = timeDate.getSeconds();
      h = h < 10 ? '0' + h : h;
      m = m < 10 ? '0' + m : m;
      s = s < 10 ? '0' + s : s;
      if (number === 2) {
        if (s < 30) return h + ':' + m;else if (m === 59) return ++h + ':00';else return h + ':' + ++m;
      } else {
        return h + ':' + m + ':' + s;
      }
    }
  },
  getHmsFormat: function getHmsFormat(timeStr, format) {},

  // 接收 HH:mm:ss 时间字符串，返回 date 对象
  getDateByAtwillDate: function getDateByAtwillDate(timeStr) {
    if (!timeStr || timeStr === '') return '';
    var a = timeStr.split(':');
    if (this.isNotEmpty(a)) {
      return new Date(1970, 0, 1, a[0], a[1], a[2]);
    }
  },

  // 接收 date 对象， 返回时间 HH:mm:ss
  getTimeStrByAtwillDate: function getTimeStrByAtwillDate(d) {
    if (!d) return '';
    if (this.isNotEmpty(d)) {
      var h = d.getHours();
      var m = d.getMinutes();
      var s = d.getSeconds();
      h = h < 10 ? '0' + h : h;
      m = m < 10 ? '0' + m : m;
      s = s < 10 ? '0' + s : s;
      return h + ':' + m + ':' + s;
    }
  }
});

/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__input_vInput_vue__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__input_vInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__input_vInput_vue__);


var jphUi = {
  install: function install(Vue) {
    Vue.component('vInput', __WEBPACK_IMPORTED_MODULE_0__input_vInput_vue___default.a);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (jphUi);

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.default = {
  common: {
    zh: '简体中文',
    tw: '繁體中文',
    ja: '日本語',
    en: 'English',
    ko: '한국어',
    title: 'Management Console',
    exit: 'Exit',
    search: 'Search',
    tel: 'Tel',
    address: 'Product location',
    scenicSpotAreaSelection: 'Select scenic spot area',
    inputRequiredTip: 'Please enter the scenic spot name',
    edit: 'Edit',
    delete: 'Delete',
    recommend: 'Recommend',
    pay: 'Pay',
    printOrder: 'Print order',
    download: 'Download',
    cancelRecommend: 'Cancel recommend',
    cancel: 'Cancel',
    confirm: 'Confirm',
    submit: 'Submit',
    searchMore: 'View more',
    prompt: 'Prompt',
    basicInfo: 'Basic Info',
    day: 'Day',
    hour: 'Hour',
    minute: 'Min',
    second: 'Sec'
  },
  title: {
    supplement: 'Additional how to use',
    addDining: 'Add product(Restaurant)',
    balanceSetting: '库存价格',
    productPriceNumber: 'Inventory price',
    productState: 'Product review',
    productAll: 'All',
    productStated: 'Wait Audit',
    productNotState: 'Audit Fail',
    orderReport: 'Order Management',
    orderDetail: 'Order details',
    scenicSpotList: 'Scenic Spot Management',
    addScenicSpot: 'Add Scenic Spot',
    editScenicSpot: 'Edit the Scenic Spot',
    scenicSpotDetail: 'Scenic spot detail',
    popularCities: 'Popular Destinations Management',
    addHotCity: 'Add Popular Destination',
    editHotCity: 'Edit Popular Destination',
    productManager: 'Product Management',
    pdfFilesManage: 'PDF File Database Management',
    supplyManageProduct: 'Sales Management of Products',
    tocDistributorManageProduct: 'TOC Sales Management of Products',
    pdfBatchList: 'Batch list',
    bulkPurchaseList: 'Bulk purchase list',
    bulkPurchaseDetail: 'Bulk purchase details',
    submitAndPayOrderBatch: 'batch purchase ',
    batchPdfFilesList: 'Batch file list',
    addPdfFiles: 'Add PDF file database',
    importPdf: 'Import PDF file',
    pdfFiles: 'PDF file',
    DiningDetail: 'Restaurant product\'s detail ',
    financeStatement: 'Automatically generate financial statements',
    statementDetail: 'Statement Detail',
    warehouse: 'Warehouse Management',
    ticketDepot: 'Ticket depot Management',
    addTicketDepot: 'Add new ticket depot',
    importTicket: 'Import ticket to depot',
    pinTicket: 'Pin ticket',
    pinTicketMagn: 'Pin ticket Management',
    trades: 'Trades Details',
    record: 'Withdraw history',
    counter: 'Counter Management',
    addCounter: 'Add counter',
    editCounter: 'Edit counter',
    liaison: 'Liaison Management',
    addLiaison: 'Add liaison',
    editLiaison: 'Edit liaison',
    updatePDFfiles: 'Edit PDF file database',
    importThirdSystemProduct: 'Product Import Management',
    productLogList: 'Product modification record',
    productLogDetail: 'Details of product changes',
    productLanguageLogList: 'Product modification record',
    productLanguageLogDetail: 'Details of product multilingual changes',
    bannerManage: 'Banner Management'
  },
  lable: {
    translation: 'AI Translation',
    translationing: 'AI Translationing...',
    translationTip: 'No data to translate',
    isOnline: 'Release Status',
    hotCity: 'Popular Destinations',
    cityName: 'Destination Name',
    cityPicture: 'Destination Picture',
    languageType: 'Language',
    sort: 'Sort',
    sortTip: 'The smaller the value, the higher the ranking',
    onlineTip: 'Will not be displayed on the client after being removed from the shelf',
    hotType: 'Popular Type',
    type1: 'Popular Area',
    type2: 'Popular Destination',
    type3: 'Popular Landmark',
    addProduct: 'Add Product',
    productInformation: 'Product Information',
    price: 'Price',
    tags: 'Tags',
    productList: 'Product List',
    bannerTitle: 'Banner Main Title',
    bannerSubTitle: 'Banner Sub Title',
    bannerImages: 'Banner Images',
    selectLogType: 'Select search type',
    selectLogType_1: 'Based on field',
    selectLogType_2: 'Multilingual field',
    inputProductId: 'Enter the product ID',
    inputProductId_placeholder: 'Enter the product ID',
    customerDataType: 'Guest profile type',
    customerDataInfo: 'Guest information',
    chooseProductLanguage: 'Select language',
    noDataForLanguage: 'No data yet, please select another language',
    newOrderEmail: 'Order notification email',
    batchStatus: 'Batch status',
    proofPath: 'Voucher link',
    pinTicketNum: 'Verify number',
    KlookTicketCanbeUsedDateTBList: ' Within six months',
    KlookTicketCanbeUsedDate: ' A day at the same price is valid for 6 months ',
    QuantityMismatch: 'If the number of tickets sold is inconsistent with the actual purchase quantity, shall we continue to sell the tickets',
    importProduct: 'import product',
    system: 'system',
    chooseSystem: 'Please select system',
    klook: 'KLOOK',
    link: 'LINK',
    thirdNum: 'Third party productId',
    enterThirdNum: 'Please enter third party productId',
    thirdProductTime: 'Time：',
    timeTips: 'Please enter time period (1-24)',
    haveInventory: 'in stock',
    noInventory: 'sold out',
    travlerFirstName: 'visitor\'s firstName',
    travlerFamilyName: 'visitor\'s familyName',
    travlerCall: 'call',
    enterGolfCourseCode: '请输入高尔夫场地编号',
    enterPrefecture: '请输入行政区域编号',
    Mr: 'Mr',
    Ms: 'Ms',
    Miss: 'Miss',
    Mrs: 'Mrs',
    duration: 'duration',
    travellers: 'Suggested number of visitors',
    voucherUsage: 'voucher usage',
    voucherTypeDesc: 'voucher type',
    voucherValidity: 'Validity period of voucher',
    redemptionProcess: 'redemption process',
    transportation: 'transportation',
    insiderTips: 'Warm prompt',
    joinAstrict: 'Participation restrictions',
    demand: 'demand',
    packageOptions: 'Package instructions',
    itinerary: 'Schedule instructions',
    additionalInformation: 'Additional information',
    meetUpLocation: 'Collection instructions',
    pickUpLocation: 'Get the address',
    surcharge: 'Overtime fee',
    location: 'address',
    submitOrderTip: 'This product is a special product and will be paid automatically after the order is submitted. Do you want to submit it?',
    submitOrderBatch: 'Please check your purchase. When sending a reservation, the total purchase amount will be automatically deducted from your AGT balance. Please be careful！',
    location_placeholder: 'Please enter address',
    duration_placeholder: 'Please enter activity duration',
    productConfirmType_placeholder: 'Please enter the confirmation type',
    transportation_placeholder: 'Please enter the mode of transportation',
    voucherTypeDesc_placeholder: 'Please enter the credential type',
    voucherUsage_placeholder: 'Please enter how to use the credential',
    voucherValidity_placeholder: 'Please enter the validity period of the certificate',
    pickUpLocation_placeholder: 'Please enter the claim address',
    redemptionProcess_placeholder: 'Please enter address',
    packageOptions_placeholder: 'Please enter the package description',
    itinerary_placeholder: 'Please enter itinerary description',
    additionalInformation_placeholder: 'Please enter additional information',
    surcharge_placeholder: 'Please enter timeout fee',
    insiderTips_placeholder: 'Please enter tips',
    updateType: 'Type modification',
    updateFloatPrice: 'Float Price',
    shareQrCode: 'share QR code',
    setQrCode: 'set QR code',
    addCoupon: 'Add new coupon',
    couponName: 'Coupon name',
    couponAmount: 'Coupon amount',
    couponOrder: 'Coupon transaction',
    couponCode: 'Coupon code',
    addCouponCode: 'New coupon code added',
    downloadCouponCode: 'Download coupon code',
    batchDelete: 'Batch deletion',
    downloadNow: '{cnt} records added successfully. Download now?',
    tipMessage1: 'Please enter a name',
    examine: 'Distributor review',
    revenueManagement: 'Manage Revenue',
    revenueDetail: 'Manage Revenue',
    cashManager: 'Manage Cash Withdrawal',
    productState: 'State selection',
    orderNum1: 'sort',
    netError: 'This product has already been taken offline at the supplier.',
    updateProduct: 'Update',
    addQrCode: 'Add Qr Code',
    pleasechoice: 'Please choose',
    identity: 'ID',
    studentId: 'Student ID card',
    officerId: 'certificate of officers',
    passport: 'passport',
    residence: 'Account book (children please choose this item)',
    hongKongandMacaopass: 'Hong Kong and Macao pass',
    cellsyndrome: 'Cell syndrome',
    identificationNumber: 'Identification Number',
    children: '(children enter birth date)',
    addressinformation: 'Address information',
    expressaddress: 'Express address',
    postalCode: 'Postal Code',
    suborderinformation: 'Suborder ID',
    subordersId: 'JTRConfirmation of order',
    qxzfbcplx: 'Please select the product type for release',
    selectTreeId: '请选择产品类型',
    ticketType: 'Ticket type：',
    jtrticketType: '类型',
    productPriceTypeSetting: 'Price type Setting',
    batchPriceRuleSetting: 'Batch price rule setting',
    specificDatePriceSetting: 'Specified date price setting',
    currentProducts: 'Current product：',
    currentProducts_saleDate: 'Date of current product online：',
    unlimited: 'Unlimited',
    setProductInventoryAndPrice: 'Price and stock setting',
    setProductPriceType: 'Set product price type',
    serialNumber: 'Account',
    period: 'Period',
    timelimit: 'Time range',
    selectDateRange: 'Select date range',
    selectTimeRange: 'Select time range',
    inventory: 'Stock',
    purchasePrice: 'Supplier price',
    jtrDistributionPrice: 'EasyGo supplier price',
    stockNum: 'Field Inventory',
    distributionPrice: 'EasyGo price',
    marketPrice: 'Market price',
    retailPrice: 'Recommended retail price',
    operating: 'Operation',
    delete: 'Delete',
    chargeback: '退单',
    addTimePeriod: 'Add time period',
    reset: 'Reset',
    save: 'Save',
    goBack: 'Return',
    confirm: 'Confirm',
    confirmOrder: 'Order detail confirmation ',
    confirmOrder1: '北海道确认订单',
    jtrconfirmOrder: 'JTRConfirmation of order',
    refuse: 'Refuse the order',
    cancelOrder: '取消订单',
    requestCancel: 'Cancel order',
    specialRequestRefund: '特殊申请退款',
    requestRefund: '申请退款',
    makeSure: 'Confirm',
    cancel: 'Cancel',
    productName: 'Product name',
    scene: '场次',
    dataSource: 'data source',
    selectDistributor: 'Select distributor',
    authorizedMerchant: 'Authorized merchant',
    businessName: 'Business name',
    priceFloatRange: 'Distribution price authorization',
    distributorNameOrNumber: 'Distributor name/number',
    distributorNumber: 'Distributor number',
    distributorName: 'Distributor name',
    changeValidTime: 'Change validity',
    // suoCountry: 'Country name',
    suoCountry: 'Country',
    suoCountrys: 'Keywords',
    productNameOrId: 'Product name/number',
    productNameOrIds: 'Destination, activity, product number, etc.',
    productNameOrIdRemark: 'Product name/number/remark/tag',
    productDiff: 'Classification',
    productDiffs: 'Categories',
    confirmMethod: 'Confirm way',
    managerArea: 'Management area',
    productCode: 'Product ID',
    golfCourseCode: '高尔夫场地编号',
    prefecture: '地方行政区域',
    suoCity: 'Popular Destination',
    confirmMethods: 'Confirm way',
    confirmMethodss: 'Confirmation',
    managerAreas: 'Management area',
    different: 'Ticket class',
    number: '人数',
    status: 'Status',
    ticketType0: 'E-ticket',
    ticketType1: 'Ticket',
    ticketType2: 'Activities & Experience',
    ticketType22: 'Activities & Experience',
    ticketType3: 'Tours',
    ticketType33: 'Tours',
    ticketType4: 'Wi-Fi',
    ticketType5: 'SIM Card',
    ticketType6: 'Cuisine',
    ticketType66: 'Cuisine',
    ticketType7: 'Transport Services',
    ticketType77: 'Transport Services',
    ticketType8: 'Package Deals',
    ticketType88: 'Package Deals',
    ticketType9: 'Overnight bus',
    ticketType99: 'Overnight bus',
    jtrticketType0: 'Admission ticket',
    jtrticketType1: 'A package or a packaged product',
    jtrticketType2: '自由行',
    jtrticketType3: '线路',
    jtrticketType12: '预售',
    isOnlinePay0: '线下',
    isOnlinePay1: '线上',
    isOnlinePay2: 'Online payment',
    isOnlinePay3: '酒店前台现付（返佣）',
    confirmType0: 'Instant confirmation',
    confirmType00: 'Instant confirmation',
    confirmType1: 'Delayed confirmation',
    confirmType11: 'Delayed. Confirmation within',
    confirmType12: 'Delayed Confirmation',
    confirmType2: 'hours.',
    productSource0: 'JPH Product',
    productSource1: 'Partner Product',
    status0: 'Wait audit',
    status1: 'Audit pass',
    status2: 'Audit fail',
    status3: 'Offline',
    status4: 'Draft',
    online: 'Online',
    checkAll: 'View',
    faverite0: 'Recommend',
    faverite1: 'Not Recommend',
    toldAllLeft: 'Directions: Reserve at',
    toldAllMiddle: 'Days',
    toldAllMiddles: 'days in advance at ',
    toldAllRight: '.',
    orderEmergentTag: 'Urgent',
    orderUncertainTag: 'Pending',
    orderConfirmedTag: 'Confirmed',
    orderCancellingTag: 'Cancelling',
    orderCanceledTag: 'Canceled',
    orderCompletedTag: 'Completed',
    orderExpiredTag: 'Expired',
    orderPaymentTag: '已支付（JTR）',
    orderRefundedRequestTag: '已申请退款（JTR）',
    orderRefundedTag: 'Refunded',
    orderUnpaidTag: 'Unpaid',
    otherSelection: 'Other selection',
    remark: 'Remark',
    createRoleRemark: 'General user account,administration use,etc.',
    productHighlights: 'Highlight',
    currentState: 'Current status',
    youHave: 'You have',
    processOrder: 'Days to deal with this order',
    toPayOrder: 'To pay this order',
    OrderHistory: 'Order timeline',
    orderDisExplain: 'Additional order remarks (Distributor view only)',
    orderDisExplains: 'Remarks (only visible to the supplier)',
    CustomersInvisible: 'Remarks(for communication with suppliers)',
    SupplierInvisible: 'Customer message',
    addRemark: 'Add remarks',
    addMessage: 'Add message',
    addExplain: 'Add remarks',
    confirmation: 'Are you sure to confirm this order?',
    confirmationPdf: '确认作废此PDF吗',
    confirmationticket: '确认作废此实体票吗',
    specialRefundConfirm: '确认退款后钱款将会全额返还给分销商,是否确认',
    specialRefundCancel: '拒绝退款则订单会继续进行下去',
    DeleteConfirmation: 'Do you really want to delete it?',
    refusal: 'Are you sure to refuse this order?',
    voucherPath: 'Voucher',
    messageInfo: 'Order reserve info',
    orderID: 'Order ID',
    sonOrderID: 'Order ID',
    jtrOrderId: 'channel Order ID',
    orderSource: 'Order source',
    useDate: 'Reservation closes',
    sonProduct: 'Subproducts',
    useDates: 'Selected date',
    useDate1: 'Specified date',
    travelDate: 'Selected date',
    createTime: 'Order date',
    endTravelDate: 'End time',
    arrivedTime: '到达时间',
    touristRemarks: '游客备注',
    reserveNum: '预定数量',
    linkMan: 'Contact name',
    warnning1: '必须真实姓名，用于景区验证',
    linkPhone: 'Contact phone',
    linkEmail: 'Contact mailbox',
    linkAddress: 'Delivery address',
    linkCode: '邮政编码',
    linkCreditType: 'Type of contact document',
    linkoptionA: '身份证',
    linkoptionB: '护照',
    linkCreditNo: '联系人证件号码',
    customerUseDate: 'Ticket use date',
    customerTravelDate: '游玩日期',
    customerEndTravelDate: '游玩结束日期',
    customerArriveTime: '到达日期',
    customerGetTicType: '取票方式',
    customerGetTicType0: '免费',
    customerGetTicType1: '快递费',
    distributor: 'Distributor',
    PDFSendingMode: 'PDF E-ticket sending method',
    productPrice: 'Product price',
    Purchase: 'Supplier price',
    distributionPriceToc: 'distribution Price',
    distributionPriceSum: 'distribution PriceSum',
    productSalePrice: 'The floating price of the product',
    productMinPrice: 'Minimum price (for display)',
    productTcPrice: 'Product offset price',
    buyNum: 'Quantity',
    seatName: 'Name of field',
    jtrAppendNum: 'Add quantity',
    primarynum: 'Original quantity',
    cancelNum: 'Cancellations',
    orderCnt: 'Number of successful',
    totalAmount: 'Total cost',
    customerInfo: 'Customer Info',
    customerName: 'Name',
    cusEmail: 'Email address',
    Email: 'Email address',
    receiveDate: 'Ticket collection date',
    returnDate: 'Return Date：',
    FileImport: 'Import file',
    upload: 'Upload',
    onlyUpload: 'Only upload',
    noMoreThan: 'Files, no more than',
    generateOrder: 'Generate order',
    thisOrder: 'This order consumed at',
    hasConsumed: 'By customer',
    noData: 'No data',
    viewName: 'Scenic spot name',
    viewLocal: 'Location',
    viewAddress: 'Address',
    viewPicture: 'Scenic spot picture',
    viewRemark: 'Scenic spot remark',
    viewTelephone: 'Scenic spot Tel.',
    payOrder: 'Order payment',
    jtrpayOrder: 'JTR Payment order',
    jtrAppend: 'Additional orders',
    operated: 'Operation',
    productSource: 'Product Sources',
    searchType: 'Select search type',
    searchType1: 'Order ID',
    searchType2: 'Product name',
    searchType3: 'Customer name',
    searchType4: '',
    searchType5: 'Customer email',
    searchType6: 'Channel ID',
    searchType7: 'Tag',
    system1: 'ToB',
    system2: '2cycle System',
    system3: '乐天系统',
    productConfirmType: 'Confirmation',
    reserve: 'Reserve',
    isOnlinePay: 'Payment method',
    startDate: 'Earliest possible date of use',
    maxNum: 'Max per order',
    minNum: 'Min per order',
    startNum: 'Min per order',
    isExpress: 'Does it support express delivery',
    yesExpress: '支持',
    noExpress: '不支持',
    expressPrice: 'Distribution cost',
    priceStartDate: '价格开始时间',
    priceEndDate: '价格结束时间',
    priceDate: 'Product online duration',
    soldNum: 'Sales status',
    soldNumSort: 'Best Sellers',
    ticketCount: '销量',
    sourceType: 'source',
    sourceType1: 'JPH',
    sourceType2: 'JTR',
    sourceType3: 'KLOOK',
    supplySourceType1: 'JPH',
    supplySourceType2: 'JTR',
    supplySourceType3: 'KLOOK',
    supplySourceType4: 'TWOCYCLE',
    supplySourceType5: 'LINK',
    haveNoReserve: 'Sold Out',
    upTime: 'Online time',
    productReserve: 'Reserve product',
    pictureDown: 'Download picture',
    voideDown: 'Video download',
    fileDepot: '文件仓库',
    takeView: 'Similar products',
    productNumber: 'Product ID',
    supplier: 'Supplier',
    operator: 'Operator',
    useFate: 'How to use',
    supplement: 'Additional how to use (shown in QR code voucher email)',
    supplements: 'Additional how to use',
    ticketTypeName: 'Ticket type',
    isOnlinepay: 'Payment method',
    num: 'Piece',
    nums: 'Booked',
    num01: 'booked',
    money: '￥',
    serviceLanguage: 'Service language',
    productPeople: 'Age limit',
    takeTimeDesc: 'Business hours',
    productUpTime: 'Product online period',
    diningTime: 'Dinning time',
    diningPeople: 'Dinning people',
    useTime: 'Use time',
    trafficMethod: 'How to get there',
    moneyContant: 'Price includes',
    moneyNotContant: 'Price excludes',
    priceOrFloat: 'Price/Stock',
    diningDescription: 'Product detail',
    picture: 'Picture',
    titles: 'Title',
    numberBuy: 'Quantity',
    reserveDescription: 'Reservation details',
    beforeDay: 'Reservation deadline',
    minteBefore: 'Minutes before to reserve',
    usingDate: 'Effective date',
    canBeUseDate: 'Ticket valid duration',
    canBeUseDate1: 'Ticket valid date',
    returnMethod: 'Change & refund',
    returnDescription: 'Additional policy details',
    reserveNotice: 'Additional reservation notes',
    importantNote: 'Important notice',
    userNote: 'Additional reservation notes',
    changeMethod: 'Ticket exchange method',
    comnicationPeople: 'Reservation inquiry',
    contionMen: 'Contact',
    telphone: 'Contact method',
    welcomeData: 'Reception hours',
    productDescription: 'Product Description',
    dangerConcationMen: 'Emergency contact',
    productPackageContainDetail: 'Set content detail',
    productPackageDetail: 'Set product detail',
    productContainDetail: 'Product content detail',
    SIMSize: 'SIM card size',
    netCover: 'Network coverage',
    threeGNetCover: '3G quota',
    fourGNetCover: '4G quota',
    parts: 'Accessories',
    SIMProductDetail: 'SIM card detail',
    WIFIProductDetail: 'Wifi detail',
    tourProductDetail: 'One/Multi day tour detail',
    ticketProductDetail: '门票详情',
    packageProductDetail: '套餐或打包产品详情',
    freeTourDetail: '自由行详情',
    routeDetail: '路线详情',
    advanceDetail: '预售详情',
    toursTime: 'Tour length',
    travelStyle: 'Transport purpose',
    trafficStyle: 'Transport vehicle',
    startCourtyOrEnd: 'Departure city/Destination',
    jtrPeopleNum: 'No.of adults ticket included',
    jtrChildrenNum: 'No.of child ticket included',
    peopleNum: 'Minimum no.of people per tour',
    buyMessage: 'Purchase info',
    tourDetail: 'Tour detail',
    giveClass: 'Free part',
    trafficProductDetail: 'Transportation detail',
    ybProductDetail: 'Overnight bus detail',
    //  takePomStyle: '1.Ticket exchange way',
    takePomStyle: '',
    longWord: 'QR code will be sent to the provided email address. Bring the QR code to the counters listed below to exchange for ticket.',
    //  canBeTakePom: '2.Exchange counter',
    canBeTakePom: '',
    counterLink: 'Exchange counter',
    orderMessages: 'New contact',
    saleTimes: 'Business hour',
    telphoneCommicta: 'Tel number：',
    jtrOrderVaildType0: '游客选定的游玩日期当天有效',
    jtrOrderVaildType1: 'Valid for',
    jtrOrderVaildType2: 'valid from booking date to',
    jtrOrderVaildType3: 'Valid for',
    jtrOrderVaildType4: '游客选定日期截止到',
    orderVaildType0: 'Valid only for selected use date',
    ordervaildType12: 'Valid for',
    ordervaildType1: 'days from booking date',
    ordervaildType2: 'Valid from booking date to',
    ordervaildType3: 'days from booking date',
    ordervaildType4: 'Valid for',
    ordervaildType5: 'Valid from selected use date to',
    ordervaildType55: 'Valid from selected use date to',
    ordervaildType6: 'Valid from',
    ordervaildType7: 'to',
    ordervaildType8: '',
    ordervaildType9: 'Valid from',
    ordervaildType10: 'days before selected date to',
    ordervaildType11: 'days after selected date',
    ordervaildType13: 'days from selected use date',
    ordervaildType14: ' ',
    ordervaildType15: ' ',
    orderRefundType0: 'No change or refund',
    orderRefundType1: 'Refundable before use',
    orderRefundType4: '游玩日期',
    orderRefundType5: '天前可以退款',
    orderRefundType3: 'Your order has expired, the system does not provide refund service!',
    orderRefundType7: '您的订单产品属于不可退款类型，无法提供退款服务！',
    orderRefundType6: '此订单您尚未支付，无法退款',
    eleDetail: 'E-ticket detail',
    jtrticketDetail: '门票产品详情',
    entityDetail: 'Ticket detail',
    experienceDetail: 'Experience detail',
    detail3: 'One/Multi day detail',
    detail4: 'WIFI detail',
    detail5: 'SIM card detail',
    detail6: 'Restaurant detail',
    detail7: 'Traffic detail',
    detail8: 'Set product detail',
    eleDetailPreview: 'E-ticket preview',
    entityDetailPreview: 'Ticket preview',
    experienceDetailPreview: 'Experience product preview',
    tourPreview: 'One/Multi day tour preview',
    wifiPreview: 'WIFI preview',
    simPreview: 'SIM card preview',
    diningPreview: 'Restaurant preview',
    trafficPreview: 'Traffic preview',
    packagePreview: 'Set product preview',
    spread: 'Sheet',
    diningDetail: 'Restaurant detail',
    diningDetailPreview: 'Restaurant preview',
    orderStatus: 'Order status',
    floatPrice: '浮动价格',
    ifOnLine: 'Online status',
    onLine: 'Online',
    isEdit: 'Waiting for on-line',
    offLine: 'Offline',
    SalesSituation: 'Sales',
    orderNum: 'Order',
    copyOperating: 'Copy',
    graphicEditing: '图文编辑',
    revoke: 'Revoke review',
    modify: 'Edit',
    jtrModifylanguage: 'Multilingual Edit',
    more: 'More',
    distributionAuthorization: 'Distribution Authorization',
    specialPrice: 'Special Price',
    specialPriceSet: 'Distributor Special Price Setting',
    distributionRange: 'Distribution Range Authorization',
    distributionRangeAll: 'All merchant',
    distributionRangeYes: 'Only designated merchant can distribute',
    distributionRangeNo: 'Except designated merchant can distribute',
    merchantRangeAll: 'All Merchants',
    merchantRangeYes: 'Designated Merchants',
    merchantRangeNo: 'Except Designated Merchants',
    specifiedRange: 'Range',
    account: 'Account',
    PDFSendWay: 'PDF Send Way',
    PDFOnLine: 'Online',
    PDFOffLine: 'Offline',
    connectInformation: 'Connect Info',
    dialogCancel: 'Cancel',
    dialogSure: 'Confirm',
    dialogSave: 'Save Changes',
    selectProCategory: 'Please select the product type',
    ticketsMessage: 'Ticket for recreation facilities directly entering or consuming with QR code.',
    ticketsMessage2: 'Entity tickets for scenic spots or recreation facilities changing with QR code and using.',
    ticketsMessage3: 'Ticket for recreation facilities changing or directly consuming on the spot with QR code.',
    ticketsMessage4: 'one day tour、servel days tour、car rental tour products',
    ticketsMessage5: 'Wi-Fi rental',
    ticketsMessage6: 'SIM internet-access card',
    ticketsMessage7: 'table reservation, set meals booking',
    ticketsMessage8: 'traffic tickets，airport pickup，car rental products',
    ticketsMessage9: 'discount price for combination products',
    ticketsMessage10: 'Overnight bus products',
    serialNumbers: 'No.',
    belongArea: 'Belong Area',
    connectWay: 'Connect Way',
    purchasingSituation: 'Purchasing Situation',
    proStatus: 'Status',
    ifOnlineStatus: 'Online Status',
    today: 'Available today',
    tomorrow: 'Available tomorrow',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    checkPassword: 'Check Password',
    limitDay: 'Other',
    limitDays: 'Availability',
    auditCannot: 'Reasons for audit failure：',
    notMust: 'No limit',
    breakfast: 'Breakfast',
    lunch: 'Lunch',
    afternoonTea: 'Afternoon Tea',
    dinner: 'Dinner',
    buffet: '自助餐',
    bus: '班车',
    caddie: '球童',
    cart: '高尔夫球具车',
    overnight_accommodation: '住宿一晚',
    play_early: '提前玩',
    play_through: '优先玩',
    play_through_am: '上午优先玩',
    play_through_pm: '下午优先玩',
    nightSnack: 'Night Snack',
    singleMeal: 'Single Meal',
    doubleMeal: 'Double Meal',
    thirdMeal: 'Meal for three to four people',
    fiveMeal: 'Meal for five to ten people',
    tenMeal: 'Meal for more than ten people',
    haveMustData: 'Have specific time',
    common: 'Common',
    species: 'Species',
    dayBefore: 'Day Before',
    applyToRefund: '(local time)Apply a refund before.',
    updateNotAudited: 'Edit the reason for audit failure',
    pleaseEnterAudited: 'Please enter the reason for audit failure',
    updateSuccess: 'Update Success！',
    updateFliture: 'Update Failed！',
    submitError: 'Sorry,submit the audit error, please try again',
    letterCounter: 'Return to the counter',
    car: 'Car',
    tram: 'Tram',
    cruise: 'Cruise',
    tourDetailTemp: 'Tour Details',
    auditingProductNum: 'Auditing Product Quantity',
    productNum: 'Quantity',
    orderSum: 'Order Quantity',
    payBySupplierNum: 'Turnover',
    balanceNum: 'Balance',
    productOrderNum: 'Number of platform products',
    distritorNum: 'Number of Distritor',
    supplierNum: 'Number of Supplier',
    urgentNum: 'Urgent Order',
    confirmNum: 'Confirmed',
    unpassNum: 'Audit Unpass Product',
    beConfirmNum: 'Orders to be confirmed',
    cancelingNum: 'Canceling Orders',
    unPaymentNum: 'Unpaid Orders',
    cancelingOrder: 'Canceling Order',
    becancelOrder: 'Cancelled',
    auditingProduct: 'Auditing Product',
    supplierAuditing: 'Auditing Supplier',
    distributorAuditing: 'Auditing Distributor',
    notice: 'Notice',
    releaseNotice: 'Release Notice',
    haveNotNotice: 'No Notice！',
    unRead: 'Unread',
    readed: 'Read on',
    unReadNotice: 'Unread Notice',
    noticeDetail: 'Notice Detail',
    messageStart: 'Message Start',
    messageMiddle: 'Come into effect. Admin to',
    messageEnd: 'Release Message',
    country: 'Country',
    province: 'Province',
    city: 'City',
    area: 'Area',
    year: '/',
    month: '',
    one: 'Monday',
    two: 'Tuesday',
    three: 'Wednesday',
    four: 'Thursday',
    five: 'Friday',
    six: 'Saturday',
    seven: 'Sunday',
    buyPrice: 'Purchase Price',
    selectSupplier: 'Select Supplier',
    updloadFiles: 'Updload Files：',
    pleaseChange: 'Please Select',
    auditMessageEnter: 'Booking Message Enter',
    auditMessageEnter1: '',
    enterAmount: 'Quantity',
    pleaseEnterProductAmount: 'Please Enter Product Amount',
    endSlary: 'Order subtotal',
    endTotalAmount: 'Total',
    ridePlace: 'Boarding location',
    getOnTheTrain: 'Boarding location',
    onTrainTime: 'Boarding time',
    choseUpPlace: 'Please select boarding location',
    choseDownPlace: 'Please select arrival destination',
    getDownTheTrain: 'Arrival destination',
    downTrainTime: 'Arrival time',
    orderMessageByMe: 'Order details',
    confirmEmail: 'Recipient email',
    aboutTipMessage: 'The email must be checked for QR code and any guest detail mistakes',
    aboutOrderLanguageType: 'Order language',
    aboutChangeData: 'Select Date',
    travler: 'Guest',
    mainTravler: 'Guest representative',
    travlerName: 'Name',
    travlerPhone: 'Phone',
    customerEmail: 'E-mail',
    customerWechat: 'Wechat',
    customerPassport: 'Passport',
    customerSex: 'Sex',
    orderByMessage: 'Additional information',
    orderExplain: 'Additional order remarks',
    productUseData: 'How to use',
    canBeTaken: ' Counter can be taken',
    mustBeComplate: 'Full name must be provided for identification purposes',
    productCanBeReciveTo: 'This product needs to send a text message or E-mail to the guest, and the phone number or E-mail must be filled in (please fill in the E-mail if the non-chinese mobile phone).',
    submitOrder: 'Submit Order',
    nowPages: 'Current Product',
    travlerEmail: 'Recipient email',
    travlerWebchat: 'Webchat',
    travlerPassport: 'Passport',
    travlerAddress: '邮寄地址',
    travlerPostCode: '邮政编码',
    travlerCreditType: '证件类型',
    travlerCreditNo: '证件号码',
    travlerSex: 'Sex',
    mustToWrite: 'Must to Write',
    notMustToWrite: 'Optional',
    orderStatus0: 'Order generated.',
    orderStatus1: 'Order payment processed.',
    orderStatus2: 'Cancel the order（Distritor）',
    orderStatus3: 'Cancel the order（Supplier）',
    orderStatus4: 'Confirm the order',
    orderStatus5: 'Order has been exchanged/used. Order complete.',
    orderStatus6: 'Cancel the order without payment',
    orderStatus7: 'Refuse the order',
    orderStatus8: 'Confirm to cancel the order',
    orderStatus9: 'Refuse to cancel the order',
    orderStatus10: 'Order confirmed automatically.',
    orderStatus11: 'Automatic to complete the order',
    orderStatus12: 'Automatic to cancel the order',
    orderStatus13: 'Payment times out and the order is cancelled automatically.',
    orderStatus14: '申请退款',
    orderStatus15: '确认退款',
    orderStatus16: '拒绝退款',
    orderStatus17: '订单已核销',
    orderStatus18: 'Order confirmed',
    orderStatus19: 'Carrier Special Cancel',
    orderStatus20: 'Special cancellation of pass',
    orderStatus21: 'Automatic processing of expired orders',
    orderStatus22: 'Cancel API of connection destination',
    orderStatus23: 'One side cancellation of system',
    notPaymentTag: 'Cancel without payment',
    travelsSelectData: '',
    jtrOrderRefund0: 'Ticket change/refund for free until ',
    jtrOrderRefund1: '游玩日期后',
    jtrOrderRefund2: ' days prior to reserved date',
    jtrOrderRefund3: 'Ticket change/refund for free within its valid period',
    jtrOrderRefund4: ' 天可退款',
    day: 'days prior to selected date',
    ticketPrice: 'ticket price.',
    refundPayment: 'change/refund fee is',
    cancelCannot: 'Reason for Canceling',
    refundCannot: 'Grounds for refunds',
    cancelOrRefund: 'Reason for Refusing',
    cancelReason: '取消理由',
    admin: 'Admin',
    clerk: 'Clerk',
    refuseCannot: ' Reasons for Refusing',
    updateTime: 'Update Time',
    counterDetails: 'Counter',
    applyDate: 'Apply Date',
    pleaseIntoCancelReason: 'Please enter the reasons for refusing',
    pleaseIntoCancelCannot: 'Please enter the reason for canceling',
    pleaseIntoInfo: '请输入文字',
    applyType: {
      applyType0: 'Distributor',
      applyType1: 'Supplier',
      applyType2: 'Admin',
      applyType3: 'Clerk',
      applyType4: 'Other'
    },
    adminAccount: {
      createUser: 'Add Role',
      roleName: ' User Name',
      createRoleName: ' Role name',
      account: 'Account Affiliation',
      applyType: 'Types',
      isEnable: 'Disable or Enable',
      enable: 'Enable',
      disable: 'Disable',
      roleDistribution: 'Authority',
      roleManager: 'Create role',
      authMenu: 'Set Menu Access Permission',
      checkAll: 'Select All'
    }
  },
  viewMessage: {
    message1: 'Sure to save or not?',
    message2: 'Please enter the name of the scenic spot',
    hotCity_message2: 'Please enter the name of the destination',
    hotCity_message19: 'Length must be 1 to 200 characters',
    hotCity_remark_placeholder: 'Please enter remark',
    message3: 'Please enter the address of the scenic spot',
    message4: 'Recommend to use',
    message5: 'Sure to save or not?',
    message6: 'Sure to save or not?',
    message7: 'Sure to save or not?',
    message8: 'Please select the location of the scenic spot',
    message9: 'The length is 3 to 50 characters',
    sysError: 'System Error!',
    revokeMessage: 'This operation will revoke audit, continue or not?',
    revokeSuccess: 'Revoke Audit Success!',
    revokeHavePassed: 'The product audit has been passed and can\'t be revoked!',
    revokeHaveNotPassed: 'The product audit hasn\'t been passed and can\'t be revoked.Please resubmit your application!',
    revokeOperationCanceled: 'Revoke audit has been cancelled!',
    offLineMessage: 'This operation will remove the product from shelves, continue or not?',
    offLineSuccess: 'OffLine Success!',
    offLineOperationCanceled: 'Offline operation has be canceled',
    onLineSuccess: 'OnLine Success!',
    onLineMessage: 'This operation will put the product on shelves, continue or not?',
    deleteMessage: 'This operation will permanently delete the product, continue or not?',
    deleteMessageOrder: 'This operation will permanently delete the order, continue or not?',
    deleteSuccess: 'Delete Success!',
    deleteOperationCanceled: 'Delete operation has been canceled!',
    thisRangeNotEmpty: 'Merchant within the specified range can\'t be empty!',
    thisPriceRangeNotEmpty: 'Merchant distribution price authorization can\'t be empty!',
    thisPriceRangeNotNum: 'Please enter the number!',
    editSuccess: 'Edit Success!',
    pleaseDeletePackageProduct: 'Please delete the package first, or remove the product from the package!',
    upToLine: 'After this operation, the product will go online, continue or not?',
    newToUse1: 'After this operation, the product will change the batch status to close, continue or not?',
    newToUse0: 'After this operation, the product will change the batch status to normal, continue or not?',
    fileToDelete: 'After this operation, the files library will be permanently deleted, continue or not?',
    useSuccess: 'Operation Success',
    useFail: 'Operation Fail',
    holdSuccess: 'Save Success!',
    holdError: 'Save Fail!',
    maxDay: 'Set a max of 10 year\'s data at a time',
    submitSuccess: 'Submit Success!',
    submitSuccessconfirmed: '提交成功！等待确认！',
    submitError: 'Submit Fail!',
    balanceNotDone: 'Your account balance is not enough, please recharge and complete this order',
    balanceDone: 'Congratulations, pay success',
    cancelDone: 'Your cancellation request has been sent, please wait for the merchant to handle it',
    cancelDone2: 'Cancelled and refunded! Please refresh the page to confirm',
    cancelDone3: '您的退款申请已发送，请等候商户处理',
    cancelError: 'Merchant balance is not enough, order can\'t be cancelled temporarily',
    cancelError1: '系统异常，请联络管理员',
    message10: 'Whether to save editing?',
    lable1: 'Cancel',
    lable2: 'Not Save',
    lable3: 'Save',
    message11: 'The length is 3 to 50 characters',
    message12: 'Please Select Country',
    message13: 'Please Select Region',
    message14: 'The length is 3 to 50 characters',
    message15: 'The basic information is incomplete',
    message16: 'Whether to give up editing?',
    message17: 'The scenic spot is in use, can\'t delete!',
    confirmDone: ' Confirm Success',
    tipMessage1: 'Please enter the remark for the role',
    tipMessage2: 'The input length is no more than 255 digits',
    tipMessage3: 'Please enter the role name',
    tipMessage4: 'The input length is no more than 100 digits',
    tipMessage5: 'Commission rate must be an integer (whole number) from 0-100. ',
    messageNotCompleteIn: 'The necessary information is incomplete',
    orderStatusHadUpdate: 'Status of the order has been updated',
    orderRefundFalse: '订单退款申请失败',
    message18: 'The length is 0 to 500 characters',
    message19: 'The length is 3 to 500 characters',
    message20: 'It already exists.',
    cleckOrder: 'Confirmation Write off Order',
    cleckOrderCanceled: 'Cancel',
    cleckSucc: 'Success Write off',
    banner_save_success: 'Banner saved successfully!',
    banner_save_error: 'Failed to save banner!'
  },
  counterMessage: {
    counterName: 'Counter Name',
    counterAddress: 'Counter Address',
    counterTelephone: 'Counter Telephone',
    busineTime: 'Opening Hours',
    counterPic: 'Counter Pic',
    lable1: 'Cancel',
    lable2: 'Not Save',
    lable3: 'Save',
    message1: 'Please enter the counter name',
    message2: 'This operation will permanently delete the counter, continue or not?',
    message3: 'Delete Success',
    message4: 'In use，can\'t be deleted',
    message5: 'Upload picture of the counter',
    message6: 'Whether to save editing?',
    message7: 'Please enter the counter name',
    message8: 'Please enter the counter address',
    message9: 'Please enter the counter phone',
    message10: 'Please enter the correct counter phone',
    message11: 'The length is between 6 and 500 characters',
    message12: 'Please enter the reception time of the counter',
    message13: 'Save Fail',
    message14: 'Save Success',
    message15: 'Whether to give up editing?',
    message16: 'The length is between 1 and 500 characters'
  },
  liaisonMessage: {
    liaisonName: 'Name',
    liaisonTelephone: 'Contact Way',
    receptionTime: 'Reception Time',
    message1: 'Please enter contact name',
    message2: 'Please enter contact telphone',
    message3: 'Please enter the contact person reception time',
    message4: 'Sure to delete this contact?',
    message5: 'Delete Success',
    message6: 'In use，can\'t be deleted',
    message7: 'Whether to save editing?',
    message8: 'Cancel',
    message9: 'Not Save',
    message10: 'Save',
    message11: 'Save Fail',
    message12: 'Whether to give up editing?',
    message13: 'Save Fail',
    message14: 'Save Success'
  },
  registerMessage: {
    directorWechatComment: 'In order to quickly introduce the company and so on,the recommended use of the service.Please confirm the instruction manual separately distributed in detail.',
    supplierRegister: 'Supplier Register',
    distributorRegister: 'Distributor Register',
    accountInfo: 'Account Info',
    companyInfo: 'Company Info',
    mainBusiness: 'Main Business (We will recommend the fit products to you base on these)',
    mainBusiness1: 'Main Business',
    saleType: 'Sales Method (OTA)',
    trafficCardTicket: 'Transportation',
    carFree: 'Private car service',
    admissionToThePark: 'Entry ticket',
    foodAndBeverage: 'Restaurant Reservation',
    oneDayTour: 'Day tour',
    daysTour: 'Day tour(2days or above)',
    characteristicExperience: 'Activity',
    hotel: 'Hotel',
    physicalShop: 'Shop',
    fzShop: 'Figgy',
    mfwShop: 'Mafengwo',
    tbShop: 'Taobao',
    xcShop: 'Ctrip',
    tcShop: 'Tongcheng',
    qneShop: 'Qunaer',
    tnShop: 'Tu niu',
    cupang: 'Cupang',
    gmarket: 'Gmarket',
    entry: 'Please Entry',
    directorInfo: 'Business Leader Info',
    account: 'Login Account',
    password: 'Enter Password',
    passwordConfirm: 'Password Confirm',
    address: 'Location',
    companyName: 'Company Name',
    logo: 'Company Logo',
    legalRepresentative: 'Legal Person',
    companyAddress: 'Company Add.',
    companyTelephone: 'Company Tel.',
    companyEmail: 'Company E-mail',
    companyWebsite: 'Web/Store Link',
    bankCardNumber: 'Bank account',
    qualification: 'Qualification',
    directorName: 'Name',
    directorTelephone: 'Telephone',
    directorPosition: 'Position',
    directorWechat: 'Wechat ID',
    directorEmail: 'E-mail',
    directorCard: 'Business Card',
    directorCode: 'Invited Code',
    phDirectorCode: 'Please enter the invited code',
    directorCodeTip: 'Enter an invitation code to enjoy priority review and many other exclusive benefits',
    phAccount: 'Please enter the login account',
    phPassword: 'Please enter the login password',
    phPasswordConfirm: 'Please confirm the login password',
    phCompanyName: 'Please enter the company\'s official registration name',
    phLogo: 'Upload Company Logo',
    phLegalRepresentative: 'Please enter the company\'s legal person',
    phCompanyAddress: 'Please enter the company detailed address',
    phCompanyTelephone: 'Please enter the company telephone',
    phCompanyEmail: 'Please enter the company E-mail',
    phCompanyWebsite: 'Please enter the company\'s official website(Or other platform store links)',
    phBankCardNumber: 'Please enter the company bank account',
    phQualification: 'Scan company registration certificate of qualification',
    phDirectorName: 'Please enter the name',
    phDirectorTelephone: 'Please enter the telephone',
    phDirectorPosition: 'Please enter the position',
    phDirectorWechat: 'Please enter the webchat ID',
    phDirectorEmail: 'Please enter the E-mail',
    phDirectorCard: 'Please upload the card',
    submitResigt: 'Submit Application',
    message1: 'Please enter 6-16 upper and lower case letters or digits',
    message2: 'Please make sure the account info is correct',
    message3: 'Please enter password',
    message4: 'Please enter the correct password',
    message5: 'The length is 6 to 16 characters',
    message6: 'Please enter password again',
    message7: 'The two passwords differ!',
    message8: 'Please enter the correct password',
    message9: 'Please Select Country',
    message10: 'Please enter the company\'s official registration name',
    message11: 'The length is 6 to 200 characters',
    message12: 'Please upload company Logo',
    message13: 'Please enter the company\'s legal person',
    message14: 'The length is 2 to 200 characters',
    message15: 'Please enter the company detailed address',
    message16: 'The length is 10 to 200 characters',
    message17: 'Please enter the company telephone',
    message18: 'Please enter the correct telephone number',
    message19: 'The length is 6 to 20 characters',
    message20: 'Please enter the company E-mail',
    message21: 'Please enter the correct company E-mail',
    message22: 'The length is 7 to 50 characters',
    message23: 'Please enter company official website',
    message24: 'The length is 4 to 300 characters',
    message25: 'Please enter the company bank account',
    message26: 'Please enter the correct company bank account',
    message27: 'The length is 10 to 100 characters',
    message28: 'Please upload the company\'s formal qualification certificate',
    message29: 'Please enter the business owner\'s name',
    message30: 'The length is 2 to 50 characters',
    message31: 'Please enter telephone',
    message32: 'Please enter correct telephone',
    message33: 'The length is 6 to 20 characters',
    message34: 'Please enter the position',
    message35: 'The length is 2 to 50 characters',
    message36: 'Please enter the WeChat ID',
    message37: 'The length is 6 to 50 characters',
    message38: 'Please enter the business owner\'s card',
    message39: 'Submit registration or not?',
    message40: 'Register Success',
    message41: 'Register Fail',
    message42: 'Please enter the account',
    message43: 'The length is 6 to 30 characters',
    message44: 'The user name already exists',
    message45: 'Please enter the E-mail',
    message46: 'The length is 5 to 50 characters',
    message47: 'Please enter the correct E-mail',
    message48: 'E-mail already registered',
    message49: 'Give up registering or not?',
    message50: 'Check at least one of the main businesses and multiple choices are allowed',
    message51: 'Check at least one sales method, multiple choices are allowed',
    message52: 'This information is required when other options are selected',
    message53: 'The maximum length of the input is 20'
  },
  menu: {
    sysHome: 'Home',
    product: 'Manage Products',
    productList: 'My Products',
    releaseProducts: 'New Product',
    releaseThirdProducts: '发布第三方产品',
    supplyManageProduct: 'Manage BtC Products',
    importThirdSystemProduct: 'Import Third Party Product',
    conciseEticket: 'Release E-ticket Products',
    conciseTicket: 'Release Ticket Products',
    conciseTravel: 'Release Travel Products',
    conciseWifi: 'Release WiFi Products',
    conciseSIM: 'Release SIM Products',
    conciseDining: 'Release Dining Products',
    conciseTransport: 'Release Transport Products',
    conciseDiscount: 'Release Discount Products',
    conciseSetMeal: 'Add packaging products',
    conciseExperience: 'Release Experience Products',
    productAuditing: 'Product Auditing',
    addBusFlag: 'Issuing overnight bus product. ',
    orderManagement: 'Manage Orders',
    orderManagementC: 'C-terminal management',
    operatorOrderManagement: 'Manage Orders',
    operatorOrderMagnToC: 'ToC Order Management',
    operatorOrderManagement_chargeback: '订单退单权限',
    reserve: 'Products',
    distriOrderMagn: 'Manage Orders',
    disTocOrderManagement: 'ToC Order Management',
    bulkPurchaseList: 'Manage Bulk Order',
    tocDistributorManageProduct: 'ToC Sell Products',
    distriOrderMagnToC: 'ToC Order Management',
    applyDistribution: 'Retailer review',
    revenueManagement: 'Manage BtoC Distributor',
    revenueDetail: 'Manage ToC Revenue',
    applyCash: 'Manage ToC Cash Withdrawal',
    operatApplyCash: 'ToC Withdrawal Management',
    coupon: 'ToC Coupon management',
    pinTicketMagn: 'Manage verified Vouchers',
    ticket: 'Manage Stock',
    ticketDepot: 'Manage Tickets',
    warehouse: 'Warehouse Stock',
    userDepot: 'Manage User Warehouse',
    pinTicket: 'Verify QR Voucher',
    pdfTicket: 'Manage E-tickets',
    pdfFiles: 'PDF File Library',
    shopManage: 'Manage Partner Company',
    distributor: 'Manage Distributor',
    supplier: 'Manage Supplier',
    scenicSpot: 'Manage Similar Products',
    scenicSpotList: 'Similar Products List',
    finance: 'Financial Statistics',
    financeStatement: 'Financial Statements',
    financeDetail: 'Financial Statement Details',
    ActuarialManagement: 'Actuarial Management',
    withdrawals: 'Transaction History',
    operatorWithdrawal: 'Recharge/Withdrawal',
    trades: 'Order History',
    record: 'Recharge/Withdrawal Records',
    withdrawal: 'Recharge History',
    recharge: 'Recharge/Withdrawal',
    sys: 'Manage Account',
    merchantInfo: 'Company Details',
    clerk: 'Manage User Accounts',
    adminAccount: 'Manage User Permission',
    secondaryAgent: 'Secondary Agent',
    operator: 'Admin Management',
    exportRules: 'Export Rules Management',
    noticeManager: 'Manage Notice',
    liaisons: 'Manage Contact',
    counter: 'Manage Counter',
    pwdSet: 'Password Setting',
    payType: 'PayType Setting',
    newOrderEmail: 'New order mail notification settings',
    ticketDepot_ticketDepotManager: 'Ticket Manager',
    ticketDepot_stockManager: 'Ticket Stock Manager',
    pdfFiles_stockManager: 'E-ticket Stock Manager',
    operatorWithdrawal_operationAuth: 'Financial Operation Authority',
    operatorWithdrawal_auditAuth: 'Financial Audit Authority',
    auditFlag: 'No Review Required',
    loginNotice: 'Self-travel system function upgrade notice（20170621）',
    recover: 'Reset',
    clear: 'Clear all',
    pageSetting: 'Homepage picture\'s setting',
    productLogList: 'Product modification record',
    popularCities: 'Popular Destinations Management',
    banner: 'Banner Management',
    recommendedAttractions: 'Homepage Recommended'
  },
  login: {
    userLogin: 'User Login',
    rememberLoginStatus: 'Remember Login Status',
    forgetPassword: 'Forgot password?',
    loginIn: 'Log In',
    register: 'Register',
    copyRight: 'Copyright © 2019 Japan Holiday',
    recordInformation: 'Sichuan ICP No.18029410-2',
    recordInformation2: '特定商取引法',
    message1: 'Please Enter Username',
    message2: 'Please enter password',
    message3: 'Please enter the correct password'
  },
  selectMerchantType: {
    imSupplier: 'I am Supplier',
    imDistributor: 'I am Distributor',
    selectType: 'Please select merchant type'
  },
  notice: {
    noticeModify: 'Notice Edit',
    noticeAdd: 'Notice Add',
    noticeTitle: 'Notice Title：',
    noticeContent: 'Notice Content',
    noticeTitlePlaceholder: 'Please enter the notice title',
    validDate: 'Valid Date：',
    DateSelectRange: 'Select Date Range',
    publicationScope: 'Select Range：',
    all: 'All',
    distributor: 'Distributor',
    supplier: 'Supplier',
    pulicationConfirm: 'Pulication Confirm',
    tip: 'Reminder',
    saveOrNot: 'Save or not?',
    notSave: 'Not Save',
    save: 'Save',
    message1: 'The length is 3 to 150 characters',
    message2: 'Please select a valid date',
    message3: 'Please select range',
    message4: 'Give up editing or not?',
    message5: 'The basic information is not complete',
    message6: 'Save Success',
    message7: 'Save Fail',
    message8: 'Delete Fail!',
    message9: 'Delete Success!',
    message10: 'This operation will permanently delete the product,continue or not?',
    message11: 'Merchant selection can\'t be empty!',
    noticeManage: 'Notice Management',
    noticePublication: 'Add Notice',
    noticeTitle1: 'Notice Title',
    search: 'Search',
    index: 'No.',
    title: 'Title',
    publicationScope1: 'Range',
    validDate1: 'Valid Date'
  },
  exportRules: {
    exportRuleTitle: 'Export Rule Management',
    newExportRule: 'Add Export Rule',
    editExportRule: 'Edit Export Rule',
    lableBusinessType: 'Business Type',
    pageType: 'Page Type',
    exportRuleName: 'Export Rule Name',
    exportRuleRemark: 'Export Rule Remark',
    search: 'Search',
    ruleName: 'Rule Name',
    ruleRemark: 'Rule Remark',
    modify: 'Edit',
    delete: 'Delete',
    lable1: 'All',
    lable2: 'Distributor',
    lable3: 'Supplier',
    lable4: 'Products List',
    lable5: 'Order List',
    lable6: 'Carrier',
    lable7: 'Unknown',
    lable8: 'Export Item Setting',
    lable9: 'Remove',
    lable10: 'Add',
    lable11: 'All Items',
    lable12: 'Export Items',
    lable13: 'Write off list',
    message1: 'Sure to delete or not?',
    message2: 'Delete Success',
    message3: 'Basic rules, can\'t be deleted',
    message4: 'Rules in use, can\'t be deleted',
    message5: 'Please enter the export rule name',
    message6: 'Please enter the export rule remark',
    message7: 'Please select merchant type',
    message8: 'Please select page type',
    message9: 'The length is 3 to 100 characters',
    message10: 'The length is 3 to 500 characters',
    message11: 'Sure to reset or not?',
    message12: 'Save Success',
    message13: 'Give up editing or not?',
    button1: 'Submit to save',
    button2: 'Immediately Create',
    button3: 'Reset'
  },
  clerk: {
    clerkTitle: 'Clerk Management',
    addClerk: 'Add Clerk',
    editClerk: 'Edit Clerk',
    account: 'Account',
    name: 'Name',
    telphone: 'Telphone',
    emailAddress: 'E-mail',
    clerkAccount: 'Clerk Account',
    clerkName: 'Clerk Name',
    clerkPwd: 'Clerk Password',
    confirmPwd: 'Confirm Password',
    clerkTel: 'Clerk Telphone',
    message1: 'Clerk Account/Name',
    message2: 'Please select roles',
    message3: 'Sure to delete or not?',
    message4: 'Delete Success',
    message5: 'Set Success',
    message6: 'Please enter the clerk\'s account',
    message7: 'Account should be formed from letters, digits, underba, delimiters, and begin with a letter',
    message8: 'Please enter the cleck\'s name',
    message9: 'The cleck name can\'t be empty',
    message10: 'Please enter the cleck\'s password',
    message11: 'Please enter 6-16 upper and lower case letters or digits',
    message12: 'Must be consistent with the input above',
    message13: 'Please enter the cleck\'s phone number',
    message14: 'Please enter the cleck\'s E-mail',
    message15: 'You can receive system information by E-mail',
    message16: 'The length is 3 to 50 characters',
    message17: 'Please enter the correct password',
    message18: 'The length is 6 to 16 characters',
    message19: 'Please enter the correct password',
    message20: 'Submit the save or not?',
    message21: 'Save Success',
    message22: 'Please enter the account',
    message23: 'The length is 6 to 30 characters',
    message24: 'Please enter the correct account',
    message25: 'The user name already exists',
    message26: 'Please enter the password again',
    message27: 'The two passwords differ',
    message28: 'The length is 5 to 50 characters',
    message29: 'Please enter the correct E-mail',
    message30: 'E-mail already registered',
    message31: 'The length is 6 to 20 characters',
    message32: 'Please enter the correct phone number',
    message33: 'Give up editing or not?',
    lable1: 'Role',
    lable2: 'Move',
    lable3: 'Add',
    lable4: 'Role List',
    lable5: 'Added Role'
  },
  merchant: {
    merchantInfo: 'Merchant Info',
    distributorManage: 'Distributor Management',
    supplierManege: 'Supplier Management',
    all: 'All',
    waitAudit: 'Wait Audit',
    auditPass: 'Audit Pass',
    auditNG: 'Audit Fail',
    auditNG2: 'Audit Unpass',
    auditNGReason: 'Edit the reason for auditing Unpass',
    searchContent: 'Merchant Name/ID',
    businessName: 'Merchant Name',
    createDate: 'Application Date',
    auditStatus: 'Status',
    auditUserName: 'Auditor',
    lableTodo: 'Todo',
    lableWatch: 'Watch',
    lableAuth: 'Role',
    lableExpSet: 'Export Setting',
    accountInfo: 'Account Info',
    loginAccount: 'Login Account',
    companyName: 'Company Name',
    companyLogo: 'Company Logo',
    legalRepresentative: 'Legal Person',
    companyAddress: 'Company Add.',
    companyTelephone: 'Company Tel.',
    companyWebsite: 'Web/Store Link',
    companyEmail: 'Company E-mail',
    bankCardNumber: 'Bank account',
    qualificationPath: 'Qualification',
    location: 'Location',
    baseInfo: 'Company Info',
    directorInfo: 'Business Leader Info',
    directorName: 'Name',
    directorPosition: 'Position',
    directorEmail: 'E-mail',
    directorTelephone: 'Telephone',
    directorWechat: 'Wechat ID',
    directorCardPath: 'Business Card',
    setAuthAuditPass: 'Set previlege and verify accessbility',
    selectAuth: 'Please choose the Role',
    message1: 'Please choose the Role',
    message2: 'Export setting',
    message3: 'Export the type of page',
    message4: 'Export settings for product',
    message5: 'Export settings for oder',
    message6: 'Export rules',
    message7: 'Please choose the export rules',
    message8: 'Please choose the export type of page',
    message9: 'Please choose the export rules',
    message10: 'Set successfully',
    message11: 'The unique ID in business system for user identification)',
    message12: 'Distribution Summary',
    message13: 'Order amount',
    message14: 'Order account',
    message15: 'Ticket amount',
    message16: 'Account balance status',
    message17: 'Account balance',
    message18: 'View account history',
    message19: 'Charge/Withdraw history',
    message20: 'Process success',
    message21: 'Process fail',
    message22: 'Quit audit',
    message23: 'Quota setting',
    message24: 'Write off export item settings',
    lable1: 'Delete',
    lable2: 'Add',
    lable3: 'Role list',
    lable4: 'Added role',
    yayaPaySet: 'Pin ticket account set',
    easyGoUser: 'Supplier Account',
    yayaPayUser: 'Pin ticket account',
    pleaseEnterYayaPayUser: 'Please enter pin ticket account.',
    pleaseEnterLessTen: 'Bind at most ten accounts!',
    lengthMustLess100: 'Account length should be less than or equal to 100!',
    yayaAccountHadExists: 'The pin ticket account had existed, adding fail.',
    yayaAccountExists: 'The pin ticket account is repeated, please re-enter.',
    enableSwitch: 'Enable Switch',
    lineOfCredit: 'Line Of Credit',
    creditDate: 'Credit Date'
  },
  merchantInfo: {
    merchantInfo: 'Company Info',
    merchantInfoEdit: 'Edit company info',
    auditNG: 'Audit denied',
    accountInfo: 'Account Info',
    auditStatus: 'Audit status',
    loginAccount: 'Login Account',
    location: 'Location',
    baseInfo: 'Company Info',
    companyName: 'Company Name',
    companyLogo: 'Company logo',
    legalRepresentative: 'Legal Person',
    companyAddress: 'Company Add.',
    companyTelephone: 'Company Tel.',
    companyWebsite: 'Web/Store Link',
    companyEmail: 'Company E-mail',
    bankCardNumber: 'Bank account',
    qualificationPath: 'Qualification',
    supplierSummary: 'Distribution Summary',
    orderTotal: 'Order amount',
    orderTotalPay: 'Order account',
    ticketTotal: 'Ticket amount',
    accountBalanceInfo: 'Account balance status',
    accountBalance: 'Account balance',
    seeBusinessLog: 'View account history',
    seeRechargeLog0: 'View charge/withdraw history',
    seeRechargeLog1: 'View withdraw history',
    directorInfo: 'Business Leader Info',
    directorName: 'Name',
    directorPosition: 'Position',
    directorEmail: 'E-mail',
    directorTelephone: 'Telephone',
    directorWechat: 'Wechat ID',
    directorCardPath: 'Business Card',
    submitAudit: 'Submit audit',
    submitEdit: 'Submit edit',
    notSave: 'Not save',
    save: 'Save',
    message1: '(The unique ID in business system for user identification)',
    message2: 'Please confirm the account info is correct',
    message3: 'Save edit?',
    message4: 'Please select country',
    message5: 'Please enter company official name',
    message6: 'Length limited within 6 to 200',
    message7: 'Please upload company Logo',
    message8: 'Please enter company\'s legal person',
    message9: 'Length limited within 2 to 200',
    message10: 'Please enter company detailed address',
    message11: 'Length limited within 10 to 200',
    message12: 'Please enter company\'s telphone',
    message13: 'Please enter correct phone number',
    message14: 'Length limited within 6 to 20',
    message15: 'Please enter company\'s email address',
    message16: 'Please enter correct email address',
    message17: 'Length limited within 7 to 50',
    message18: 'Please enter company\'s official website',
    message19: 'Length limited within 4 to 50',
    message20: 'Please enter company\'s bank account',
    message21: 'Please enter correct bank account',
    message22: 'Length limited within 4 to 5',
    message23: 'Please upload company\'s official qualification',
    message24: 'Please enter business leader\'s name',
    message25: 'Length limited within 2 to 50',
    message26: 'Please enter telephone',
    message27: 'Please enter correct telephone',
    message28: 'Please enter position',
    message29: 'Please enter wechat ID',
    message30: 'Length limited within 6 to 50',
    message31: 'Please enter business leaser\'s card',
    message32: 'Submit edit？',
    message33: 'Edit successfully',
    message34: 'Edit failed',
    message35: 'Please enter email address',
    message36: 'Length limited from 5 to 50',
    message37: 'Please enter correct email address',
    message38: 'Email address used'
  },
  secondaryAgent: {
    secondaryAgentTitle: 'Secondary Agent',
    message1: 'Please enter name',
    search: 'Search',
    name: 'Name',
    time: 'Registration time',
    remark: 'Remark',
    label: 'Unbind',
    addCode: 'Generate invitation code',
    copySuccess: 'Copy successfully',
    copyError: 'Copy failed',
    operator: 'Edit remark',
    remarkTip: 'Please enter remark',
    message2: 'Edit successfully',
    message3: 'Edit failed',
    message4: 'Unbind successfully',
    message5: 'Unbind failed'
  },
  errorMsg: {
    user: {
      noAuth: 'User permission unavailable, please contact administrator',
      systemMsg: 'System error',
      noUserOrPassword: 'Account not exists or wrong password ',
      setUsernameOrPassword: 'Please enter account and password'
    }
  },
  operator: {
    jtrOrderReimburse: 'One side cancellation of system',
    operatorManege: 'Administrator Manage',
    addOperator: 'Add administrator',
    updateOperator: 'Edit administrator',
    updatePwd: 'Password',
    updateInfo: 'Edit',
    auth: 'Role',
    searchText: 'Administrator account/name',
    account: 'Account',
    name: 'Name',
    opearate: 'Operation',
    opeAccount: 'Administrator account',
    opeName: 'Administrator name',
    opePwd: 'Password',
    opeNewPwd: 'New administrator password',
    checkPwd: 'Confirm password',
    lable1: 'Delete',
    lable2: 'Add',
    lable3: 'Role list',
    lable4: 'Added role',
    message1: 'Please select roles',
    message2: 'Are you sure to delete？',
    message3: 'Delete successfully',
    message4: 'Set up successfully',
    message5: 'Please enter administrator account',
    message6: 'Only letter,num, underbar,partition can be used for account, and letter should be put in the first',
    message7: 'Please enter administrator name',
    message8: 'Administrator name should not be blank',
    message9: 'Please enter password',
    message10: 'Please enter case letters or numbers at the length of 6-16',
    message11: 'Must be same with the above',
    message12: 'Length limited within 1 to 50',
    message13: 'Length limited within 6 to 16',
    message14: 'Please enter correct password',
    message15: 'Are you sure to save？',
    message16: 'Save successfully',
    message17: 'Please enter account',
    message18: 'Length limited within 6 to 30',
    message19: 'Please enter correct account',
    message20: 'User name existed',
    message21: 'Please enter password again',
    message22: 'The password is not the same！',
    message23: 'Are you sure to abandon edit？'
  },
  product: {
    rule_0_500: 'Length limited within 0 to 5000',
    rule_0_5000: 'Length limited within 0 to 5000',
    rule_1_200: 'Length limited within 1 to 200',
    rule_1_2000: 'Length limited within 1 to 2000',
    rule_1_500: 'Length limited within 1 to 500',
    rule_0_200: 'Length limited within 0 to 200',
    rule_0_2000: 'Length limited within 0 to 2000',
    rule_0_50: 'Length limited within 0 to 50',
    rule_0_1_500: 'Length limited within 0 to 500',
    rule_1_50: 'Length limited within 1 to 50',
    rule_0_20: 'Length limited within 0 to 20',
    rule_n1_2: 'Length limited within 1 to 2',
    rule_n1_4: 'Length limited within 1 to 4',
    rule_n1_6: 'Length limited within 1 to 6',
    rule_n0_2: 'Length limited within 0 to 2',
    rule_n0_5: 'Length limited within 0 to 5',
    rule_n0_6: 'Length limited within 0 to 6',
    rule_mail: 'Please enter the message content',
    integer_1: 'Please enter integer',
    integer_2: 'Please enter positive integer',
    selDate: 'Select date',
    back: 'Return',
    ticketType_1: 'Auto-issue from linked ticket vault',
    ticketType_3: 'Manual voucher upload within order',
    ticketType_4: 'System-generated EasyGo vouchers',
    choose_sys: 'Choose System：',
    chooseDepot: '选择仓库',
    baseInfo: 'Base info',
    content: 'Product content',
    priceSet: 'Set price',
    reserveSet: 'Set reservation',
    saveDraft: 'Save to draft',
    preview: 'Preview',
    submitCheck: 'Submit audit',
    submitAuditAndPass: 'Submit audit and pass',
    isExitProduct: 'Quit product editing?',
    isSaveDraft: 'Save draft？',
    noSave: 'Don\'t save',
    save: 'Save',
    add: 'Add',
    edit: 'Edit',
    product_0: 'Product(electronic ticket)',
    product_1: 'Product(ticket)',
    product_2: 'Product(experience)',
    product_3: 'Product(one day tour/long period tour)',
    product_4: 'Produc(WIFI)',
    product_5: 'Product(SIM Card)',
    product_6: 'Product(restaurant)',
    product_7: 'Product(traffic)',
    product_8: 'Product(set)',
    doNotSave: 'No update content, don\'t need to save',
    reqMsg_1: 'Congratulations，audit submitted',
    reqMsg_2: 'Congratulations，save successfully',
    reqMsg_3: 'Sorry，failed to submit audit！',
    reqMsg_4: 'Sorry，failed to save！',
    reqMsg_5: 'Save，false audit submission，please retry',
    reqMsg_6: 'Sorry，failed to save，please retry',
    reqMsg_7: 'This set is without subproduct！',
    reqMsg_8: 'Congratulations, it has been approved.',
    reqMsg_9: 'Sorry, the audit failed!',
    reqMsg_10: 'Sorry, the audit error, please try again!',
    reqMsg_11: 'Product import failed, please try again. ',
    reqMsg_12: 'Product ID has been bound，please re-enter.',
    reqMsg_13: 'This product is not in stock at this time and cannot be imported.',
    fileDepot_no: 'Please select a file repository',
    baseInfo_no: 'Base info is not completed',
    content_no: 'Product info is not completed',
    reserveSet_no: 'Setting reservation is not completed',
    explain01: 'Name combined with:address+product name+amount+name for another product+amount+special，eg“BeijingShunjing Hot spring(fish spa contained)2 tickets+Nanshan Skiing(Electronic ticket)2”',
    explain02: 'Key word below product\'s title',
    explain03: 'Distributors invisible，easy for supplier searching product',
    explain04: 'Adult（above 18），student（12~17），child，baby，couple',
    productName01: 'Set name：',
    productName02: 'Name：',
    qrCodeName: 'Qr Code name',
    productName_placeholder: 'Please enter product name',
    qrCodeName_placeholder: 'Please enter qr Code name',
    productPrice_placeholder: 'Please enter product offset price',
    productMin_Price_placeholder: '请输入产品最低价格',
    errorProductConfirmType1: 'The sub product includes the secondary confirmation product. Only manual confirmation can be selected for order confirmation',
    errorProductConfirmType2: 'The sub product does not include the secondary confirmation product. Only automatic confirmation can be selected for order confirmation',
    errorProductConfirmType3: 'The reservation confirmation method cannot be changed because the product is included in the set product.',
    orderNum_placeholder: '请输入排序',
    productHighlights01: 'Set highlight：',
    productHighlights02: 'Highlight：',
    productHighlights_placeholder: 'Please highlight product',
    productInsideRemark: 'Inside remark：',
    productInsideRemark_placeholder: 'Please enter inside remark',
    scenicSpot: 'Spot：',
    ticketType: 'Ticket type：',
    ticketType_placeholder: 'Please enter ticket type',
    productSaleDate: 'Product online period：',
    productSaleDate_placeholder: 'Please select time on sale',
    categoryLabel: 'Category Label：',
    categoryLabel_placeholder: 'Please enter category label, press Enter to confirm',
    belongCity: 'Belong City：',
    belongCity_placeholder: 'Please select belong city',
    chooseDepot_rule: '请选择仓库',
    productName_rule: 'Please enter product name',
    scenicSpotArr_rule: 'Please select at least one spot',
    scheduleDuration: 'Duration：',
    scheduleDuration_placeholder: 'Please enter journey duration',
    imageExplain: 'Image info：',
    uploadBtn: 'Click to upload',
    videoExplain: 'Video info：',
    productPackageDetail: 'Set detailes：',
    mealTimeInterval: 'Meal time：',
    mealTime_1: 'No limitation',
    mealTime_2: 'Breakfast',
    mealTime_3: 'Lunch',
    mealTime_4: 'Afternoon tea',
    mealTime_5: 'Supper',
    mealTime_6: 'Evening dish',
    mealNumber: 'No. of meal：',
    mealNumber_1: 'Meal for single',
    mealNumber_2: 'Meal for double',
    mealNumber_3: 'Meal for 3~4 people',
    mealNumber_4: 'Meal for 5~10 people',
    mealNumber_5: 'Meal for more than 10 people',
    mealDetail01: 'Name',
    mealDetail01_placeholder: 'Please enter set name',
    mealDetail02: 'Content',
    mealDetail03: 'No.',
    mealDetail04: 'Name',
    mealDetail05: 'Amount',
    mealDetail06: 'Photo',
    mealDetail07: 'Multiply',
    mealDetail07_del: 'Delete',
    mealDetail07_up: 'Up',
    mealDetail07_down: 'Down',
    up_msg: 'This is the head',
    down_msg: 'This is the end',
    mealDetail07_add: 'Add row',
    md_delGroup: 'Delete group',
    md_addGroup: 'Add group',
    md_validMsg: 'The set info is not complete',
    md_addMsg: 'Max add row is 20！',
    md_addMsg1: 'Max add group is 10！',
    useTime: 'Use time：',
    useTime_1: 'Unlimited',
    useTime_2: 'Detailed time',
    editorProductDetail: 'Detailes：',
    viewAddress: 'Address：',
    viewAddress_placeholder: 'Please enter spot address',
    businessTime: 'Business time：',
    businessTime_placeholder: 'Please enter business time',
    productPeople_placeholder: 'Please enter fit people',
    exclusive: 'Vehicle specific identification：',
    exclusive_1: 'Non special purpose vehicle',
    exclusive_2: 'Male vehicles',
    exclusive_3: 'Women\'s vehicles',
    lang: 'Service lang：',
    lang_1: 'Chinese',
    lang_2: 'English',
    lang_3: 'Japanese',
    lang_4: 'Korean',
    productTraffic: 'Traffic way：',
    productTraffic_placeholder: 'Enter the traffic way',
    networkFlow4g: '4G network：',
    networkFlow4g_placeholder: 'Enter 4G network traffic',
    networkFlow3g: '3G network：',
    networkFlow3g_placeholder: 'Enter 3G network traffic',
    networkCoverage: 'Coverage：',
    networkCoverage_placeholder: 'Enter the network coverage',
    wifiAccessories: 'ACCY：',
    wifiAccessories_placeholder: 'Enter ACCY',
    simSize: 'SIM size：',
    simSize_placeholder: 'Enter SIM size',
    pathType: 'Path type：',
    pathType_1: 'Group tour',
    pathType_2: 'Chartered tour',
    pathType_3: 'airport transfer',
    traffic: 'Transportation：',
    traffic_1: 'Automobile',
    traffic_2: 'Train',
    traffic_3: 'Cruise',
    groupNumber: 'No. of people：',
    groupNumber_placeholder: 'Enter the number of people',
    shoppingType: 'Shopping info：',
    shoppingType_1: 'Non purchase',
    shoppingType_2: 'Incl purchase',
    scheduleInfo: 'Itinerary：',
    productCostInclude: 'Fee include：',
    productCostInclude_placeholder: 'Enter expense items',
    productCostExclusive: 'Fees exclude：',
    productCostExclusive_placeholder: 'Enter the items not covered',
    productUseFlow: 'How to use：',
    productUseFlow_placeholder: 'Enter the procedure',
    productSupplementPath: '使用流程补充',
    userNote: 'Instructions for use：',
    userNote_placeholder: 'Enter the Instructions for use',
    importantNote: 'Important hints：',
    importantNote_placeholder: 'Enter the Important hints',
    editorFreeItem: 'Free items：',
    newProductPackageDtoList_rule: 'At least one package detail is required',
    scheduleInfoDtoList_rule: 'At least one itinerary is required',
    reserveLimitDay: 'Booking deadline：',
    rld01: ' ',
    rld02: 'days',
    rld03_placeholder: 'Time',
    rld04: 'o’clock before. (Japan standard time)',
    confirmHour: 'Confirm type：',
    confirmHour_1: 'Instant confirm',
    confirmHour_2: 'Manually confirm',
    ch01: 'Duration For Re-check：',
    ch02: 'Japan business day working hour',
    ch03: '小时（自然时长）',
    maxReserveNummber: 'Max per order：',
    minReserveNummber: 'Min per order：',
    mrn_explain: '\'0\' for no limit',
    orderValid: 'Ticket valid duration：',
    ov01: 'Valid only on specified use date',
    ov02: 'From purchasing date',
    ov03: 'From purchasing date to specified date',
    ov04: 'From specified use date',
    ov05: 'From specified use date to specified date',
    ov06: 'Specified date',
    ov07: 'On specified use date',
    orderRefund: 'Change & refund：',
    orderRefund_1: 'No change & refund',
    orderRefund_2: 'Flexible',
    orderRefund_tip: '1. The cutoff time is 23:59:59 on the specified day.\n2. Example: If the departure date is January 3, cancellations made before January 2 are free of charge,\n while cancellations made on January 2 or January 3 are subject to a 100% cancellation fee. The settings are as follows:\n0 day(s) before the order validity cutoff time (including the current day), the change/cancellation fee: 100%\n2 day(s) before the order validity cutoff time (including the current day), the change/cancellation fee: 100%\n3 day(s) before the order validity cutoff time (including the current day), the change/cancellation fee: 0%',
    orderRefund_3: 'Change/refund with fee',
    refundDescription: 'Additional policy details：',
    rdi_placeholder: 'Change/refund policies',
    customerData: 'Required guest information：',
    customerData_1: 'All guest(s) info required',
    customerData_2: 'Guest(s) representative info required',
    mustFillInInf: 'Required guest info：',
    mustFillInInf_1: 'Name',
    mustFillInInf_2: 'Mobile',
    mustFillInInf_3: 'Wechat',
    mustFillInInf_4: 'Passport number',
    mustFillInInf_5: 'Gender',
    mustFillInInf_6: 'Ticket use date',
    mustFillInInf_7: 'Ticket collection date',
    mustFillInInf_8: 'Passenger family name',
    mustFillInInf_9: 'Passenger first name',
    mustFillInInf_10: 'Passenger phone number',
    mustFillInInf_11: 'Passenger email',
    mustFillInInf_12: 'Passenger gender',
    mustFillInInf_13: 'Passenger age',
    mustFillInInf_14: 'Emergency contact number',
    mustFillInInf_15: 'Passenger type',
    mustFillInInf_16: '同行者',
    customItem: 'Add item',
    ci01: 'Item',
    ci01_placeholder: 'Item name',
    ci02: 'Requirement',
    ci02_placeholder: 'Select',
    ci02_1: 'Optional',
    ci02_2: 'Required',
    ci03: 'Instructions',
    ci03_placeholder: 'Instructions',
    ci04: 'Action',
    ci04_del: 'Delete',
    ci05: 'Add customized item',
    editorNotice: 'Notice for book：',
    orderLiaison: 'Order contact：',
    emergencyLiaison: 'Urgent contact：',
    validateAuthority: 'Verify authority：',
    receiveCounter01: 'Receive counter：',
    receiveCounter02: 'Counter For Paper Ticket Pick-up：',
    returnCounter: 'Return counter：',
    reserveLimitDay_rule: 'Please enter reservation time limit',
    reserveLimitDay_rule1: 'In 99 days',
    reserveLimitDay_rule2: 'Please enter the time',
    orderDayNotMore: 'Not later than 99 days from order date',
    trip01: 'The',
    trip02: 'Day',
    trip03: 'Itinerary：',
    trip04: 'Add new itinerary',
    trip05: 'Add one day',
    trip06: 'Time Range：',
    trip06_placeholder: 'Select time range',
    trip06_phBegin: 'Start time',
    trip06_phEnd: 'End time',
    trip07: 'Destination：',
    trip07_placeholder: 'Destination & departure time?',
    trip08: 'Detail：',
    trip08_placeholder: 'E.g.:The destination for which day? How to get there?  Attractions and culture?',
    trip09: 'Images：',
    trip09_btn: 'Upload',
    trip10: 'Save Itinerary',
    trip_msg1: 'No itinerary is selected',
    trip_msg2: 'Days, itinerary',
    tripRange_rule: 'Please set time range',
    trip_interval_rule: 'Please enter end time and start time',
    groupContentTitle_rule: 'Please enter destination',
    groupContent_rule: 'Please enter itinerary details',
    imageList_rule: 'Please select images for itinerary',
    trip_msg3: 'Please select an itinerary then save!',
    trip_msg4: 'Congratulation, save succeed',
    price01: 'Stock & price',
    price02: 'Time range-',
    price03: 'Add time range',
    price04: 'Delete',
    price05: 'Time range',
    price06: 'Select time range',
    price061: 'Time range can`t be overlapped',
    price07: 'Procurement price',
    price08: 'Please enter procurement price',
    price09: 'EasyGo price',
    price10: 'Please enter distribution price',
    price11: 'Market price',
    price12: 'Please enter market price',
    price13: 'Stock',
    price14: 'Please enter stock',
    price15: 'Piece',
    price16: 'Save',
    price17: 'Reset',
    price18: 'Date range can`t be empty',
    price19: 'Time range can`t be empty',
    price20: 'Date range',
    price21: '円',
    price22: 'EasyGo supplier price',
    price23: 'Please enter EasyGo supplier price',
    price24: 'Recommended retail price',
    price25: 'Retail price',
    price26: 'Add Ticket class',
    price27: 'Ticket class',
    price28: 'Price category',
    price29: 'Price class-',
    price30: 'Price class',
    price31: 'Please enter the total stock of the price category',
    price32: 'The total inventory shall be greater than the usage',
    price33: 'Total inventory should be greater than 0',
    price34: 'Please enter price type (Japanese): 大人、小児、身障者大人、 身障者小児. ',
    price_msg1: 'Please select date first',
    price_msg2: 'Time range-',
    price_msg3: 'Not saved',
    price_msg4: 'Please select date and time range first',
    price_msg5: 'Save succeed',
    price_msg6: 'Save fail',
    price_msg7: 'Delete succeed',
    price_msg8: 'Delete fail',
    price_msg9: 'Can add at most 50 records',
    price_msg10: 'The selected item can\'t be empty',
    price_msg11: 'All current data would be replaced for this period when submitted. Sure to save?',
    price_msg12: 'All data would be deleted for “',
    price_msg13: '” when confirmed, Confirm to delete it?',
    price_msg14: 'All existing data of this price category will be overwritten. Please confirm whether to save or not.',
    price_msg15: 'Confirm that all data of this price category will be deleted, please confirm whether to delete?',
    price_msg16: 'This price category is in use and cannot be removed',
    price_msg17: 'The product already has the same price category, save failed',
    refund01: '',
    refund02: 'days before the order validity cutoff time (including the current day), the change/cancellation fee: ',
    refund03: 'Remove',
    refund04: 'Add new rule',
    refund05: 'Change/refund fee：',
    counter01: 'Select counter',
    counter02: 'Counter',
    counter03: 'Addr',
    counter04: 'Tel',
    counter05: 'Business hours',
    liaison01: 'Select contact',
    clerk01: 'Select a Salesperson',
    clerk02: '账号',
    clerk03: '业务员',
    clerk04: 'Contact number',
    clerk05: '邮箱',
    liaison02: 'Contact',
    liaison03: 'Contact way',
    liaison04: 'Reception time',
    spot01: 'Select relevant attractions',
    spot02: 'Select scenic spot',
    spot03: 'Cancel',
    spot04: 'Confirm',
    takeP01: 'Pick product from repository',
    takeP02: 'Must select one sub-product before save or submit your package',
    takeP03: 'No.',
    takeP04: 'Title',
    takeP05: 'Procurement price',
    takeP06: 'Distribution price',
    takeP07: 'Market price',
    takeP08: 'Amounts',
    takeP09: 'Action',
    takeP10: 'Reference',
    takeP11: 'Pick product from repository',
    takeP12: 'Delete',
    takeP13: 'Ticket class',
    takeP14: 'Vehicle specific identification',
    stockNumber01: 'The inventory',
    stockNumber02: 'Use the number',
    stockNumber03: 'disable',
    stockNumber04: 'enable',
    priceTypeHistory01: 'Check the record',
    priceTypeHistory02: 'inventories increased by',
    priceTypeHistory03: 'Inventory is down by',
    upload01: 'Only files in jpg/png/jpeg/gif format and size not more than {0}MB can be uploaded',
    upload02: 'Maximum size is 20MB for video upload',
    upload03: 'Maximum numbers for uploads',
    upload04: 'Pics!',
    upload05: 'Videos!',
    upload06: 'The image format is not valid!',
    upload07: 'Can`t upload image more than {0}MB!',
    upload08: 'The file name can`t contain comma!',
    upload09: 'The video format is not valid!',
    upload10: 'Can`t upload video more than 20MB!',
    upload11: 'Upload failed!',
    upload12: 'File upload error!',
    upload13: '请提供实体票·柜台·接待设施外观的照片',
    upload14: 'A file',
    upload15: 'The size of the uploaded file cannot exceed 5MB！',
    calendar01: '/',
    calendar02: '',
    calendar03: 'Select all the inventories of current month',
    calendar04: 'Piece',
    clerkTable01: 'By default all salesmen are verifiable',
    week_1: 'Mon.',
    week_2: 'Tues.',
    week_3: 'Wed.',
    week_4: 'Thur.',
    week_5: 'Fri.',
    week_6: 'Sat.',
    week_7: 'Sun.',
    explain_1: 'Procurement Price: the price in which be sold to platform(purchase price), the unit price supplier request payout from platform regularly',
    explain_2: 'Distribution Price: the price in which platform sales to travel agencies(distributors)',
    explain_3: 'The profit of platform is the difference between procurement price and distribution price',
    explain_4: '说明："0"代表无库存',
    explain_5: '分销平台采购价：EASYGO系统售卖给其他分销平台的价格，与采购价的差额是平台的利润。',
    explain_6: '市场价：一般市场参考售价',
    explain_7: '零售价：建议分销商设定的BtoC售价',
    explain_8: 'Price type (Japanese) details:',
    explain_9: 'Adult fare',
    explain_10: 'Child fare',
    explain_11: 'Disabled adult charge',
    explain_12: 'Handicapped children fee',
    explain_13: '(only supports: 大人、小児、身障者大人、 身障者小児. Other price types will not be processed. )',
    explain_14: '(Please set the product inventory according to the available date of the respective price type. Unavailable dates will not be processed even if set. Purchase price will not be processed even if set)',
    explain_15: 'Valid period：',
    explain_16: 'No date available for current price type. ',
    explain_17: 'On sale or not',
    explain_18: 'Price rule setting description：',
    explain_19: '乐天产品价格及日期填写说明：',
    explain_20: '请根据可用日期进行设置，设置不可用日期不生效，采购价不生效',
    isSale: 'On sale',
    notSale: 'Not on sale',
    productDeleteMessage: 'Please delete the package first, or remove the product from the package!',
    none: 'none',
    sendMailSet: 'Advance delivery day：',
    mailContent: 'Email content：',
    noSend: 'Don not send',
    mailTime: 'Before date',
    mailContent_placeholder: 'Please enter the message content',
    mailsetTips: 'Only e-tickets without PDF are supported'
  },
  recharge: {
    depositWithdraw: 'Recharge/Withdraw',
    depositWithdrawHistoryRecord: 'History of recharge/Withdraw',
    searchStr: 'Shop name/ID：',
    placeholder1: 'Please enter shop name/ID',
    businessType: 'Shop type：',
    businessType1: 'Shop type',
    placeholder2: 'Please select',
    search: 'Search',
    businessName: 'Shop name',
    businessName1: 'Shop name：',
    balance: 'Balance',
    accountBalance: 'Account balance：',
    operation: 'Operation',
    deposit: 'Manual recharge',
    depositAuto: 'Online recharge',
    automatic: 'automatic',
    withdraw: 'Withdraw',
    record: 'Record',
    withdrawAvail: 'Available amount：',
    withdrawAmount: 'Withdraw Amount：',
    withdrawRemark: 'Withdraw remark：',
    cancel: 'Cancel',
    submit: 'Submit for audit',
    depositAmount: 'Recharge amount：',
    depositRemark: 'Recharge remark：',
    all: 'All',
    supplier: 'Supplier',
    distributor: 'Distributor',
    submitSuccess: 'Submit succeed',
    subimitFailed: 'Submit fail',
    message: 'More than the amount you can withdraw!',
    goBack: 'Return',
    dateRange: 'Time range：',
    placeholder3: 'Select date range',
    date: 'Date',
    operator: 'Operator',
    type: 'Type',
    supplierWithdraw: 'Withdraw request of merchants',
    platformWithdraw: 'Operator withdraw',
    operationAmount: 'Amount',
    remark: 'Comment',
    lastWeek: 'In the latest week',
    lastMonth: 'In the latest month',
    lastThreeMonth: 'In the latest 3 months',
    message2: 'Recharge amount should be positive integer!',
    message3: 'Withdraw amount should be positive integer!',
    message4: 'Recharge amount should be positive integer and less than 2000,000,000!'
  },
  order: {
    batchSummary: 'Batch details',
    canBeUseStartDate: 'Start date',
    canBeUseEndDate: 'End date',
    createUserName: 'creator ',
    bulkPurchase: 'Bulk purchase',
    remarks: 'remarks',
    orderSource0: 'ToB',
    orderSource1: 'SupplierToC',
    orderSource2: 'External API',
    orderSource3: 'JTR',
    orderSource4: 'KLOOK',
    orderSource5: 'Easygo',
    orderSource6: 'KKday',
    orderSource7: 'CKMap',
    orderSource8: 'DistributorToC',
    orderSource9: 'LINK',
    toCDistributorName: 'EasyGo BtoC',
    submitTime: 'Booking time',
    sourceType: 'Order source',
    sourceJtr: 'Supplier',
    sourceJph: 'JPH Supplier',
    allDate: 'Date',
    productPrice: 'productPrice',
    totalPrice: 'Total(JPY)',
    orderInfo: 'Order info',
    newSourceJtr: '运营者订单',
    payTime: 'Pay time',
    productUseDate: 'Participation Date',
    cancelTime: 'Cancel date',
    keyWorld: 'Keyword',
    distributor: 'Distributor',
    secondAgentId: 'Distributor ID',
    secondAgentCommission: 'Distributor Revenue',
    productArea: 'Product area',
    supplier: 'Supplier',
    search: 'Search',
    synchronousTime_01: '（Data update time：',
    synchronousTime_02: '）',
    synchronousOrder_01: 'Update',
    synchronousOrder_02: '(',
    synchronousOrder_03: 's)',
    validateTime: 'Verify date',
    validateDate: 'Ticket valid date',
    expirationTime: 'Expiration time',
    timeSlot: 'Select time range for search',
    searchMsg: 'Order ID/Product name/Customer name/Customer email',
    channelOrderId: 'Channel ID',
    searchDistributor: 'Please enter distributor name',
    searchSupplier: 'Please enter supplier name',
    orderExport: 'Export order',
    ticketDepotExport: 'Download warehouse list',
    ticketBatchDetailExport: 'Download batch details list',
    productExport: 'Export product',
    productExports: 'Export product list',
    orderId: 'Order ID',
    sonOrderId: '子订单号',
    productName: 'Product name',
    allBuyQuantity: 'Quantity',
    customerName: 'Customer',
    orderExplain: 'Remarks',
    orderExplain1: 'Remarks (for own company\'s accounts)',
    orderStatus: 'Status',
    notPay: 'Unpaid',
    beConfirm: 'Wait for confirm',
    beingCancel: 'Canceling',
    haveCanceled: 'Canceled',
    haveConfirmed: 'Confirmed',
    beTicket: '待出票',
    batchHaveDone: 'Purchased',
    haveDone: 'Finish',
    haveCancel: 'Canceled',
    haveRefundRequest: '已申请退款',
    haveRefund: 'Refunded',
    havePay: 'Paid',
    failedPay: '支付失败',
    refuseRefund: '拒绝退款',
    haveTicket: 'Comfirmed',
    notPayButCanceled: 'Unpaid & Canceled',
    haveExpired: 'Expired',
    leftHandleTime: 'Processing time',
    operation: 'Operation',
    addOrSub: 'Partial cancellation',
    refund: 'refund',
    beAdd: 'Order addition',
    addOrSubOrRefund: 'Partial cancellation / refunds',
    source: 'soruce',
    validateOrder1: 'Authentication is successful',
    validateOrder2: 'You are not authorized to validate this order',
    validateOrder3: 'Validation fails',
    validateOrder4: '',
    date_empty: 'Invalid date.',
    myouji_kana_empty: 'Invalid family name (hiragana) format.',
    namae_kana_empty: 'Invalid first name (hiragana) format.',
    bin_key_id_empty: 'Invalid product ID，Please re-enter',
    sex_empty: 'Invalid gender format. ',
    tel_empty: 'The format of mobile phone is incorrect, please input 10-11 digits',
    email_empty: 'The email format is incorrect. Please enter the correct email',
    total_num_empty: 'Invalid age parameter. ',
    age_empty: 'Age format is incorrect, please enter a number',
    emergency_phone_empty: 'Invalid emergency contact number format. ',
    ctype_empty: 'Invalid age / disability parameter. ',
    recep_empty: 'Reception has ended. ',
    num_over: 'Insufficient tickets.',
    num_not_sale: 'The selected specified date has not been put on sale',
    r_id_empty: 'Specified reservation ID has already been cancelled. ',
    r_id_already_cancel_ok: 'Specified reservation ID has already been cancelled. ',
    r_id_already_payment_ok: 'Order payment completed. ',
    thirdMethodErr: 'Connection error occurred, please contact administrators. ',
    systemErr: 'System error, please contact administrators. '
  },
  jtrOrder: {},
  withdrawal: {
    withdrawalCash: 'Recharge/withdraw',
    withdrawalCashManager: 'Recharge/Withdraw Management',
    withdrawalOnline: 'Online recharge',
    withdrawalOffline: 'Manual recharge',
    applyWithdraw: 'Submit for withdraw',
    beingHandel: 'Pending',
    beingAudit: 'Wait for audit',
    notPass: 'Audit Fail',
    selectTimeSlot: 'Select Date',
    selectDateSlot: 'Please select date',
    createTime: 'Created on',
    operationPeople: 'Operator',
    type: 'Type',
    recharge: 'Recharge',
    withdraw: 'Withdraw',
    withdrawAmount: 'Withdraw amount',
    rechargeWithdrawAmount: 'Amount',
    rechargeWithdrawAmount2: 'Amount',
    remark: 'Notes',
    refundReason: 'Failure reason',
    accountBalance: 'Account balance',
    canWithdrawalBalance: 'Available amount',
    applyWithdrawalBalance: 'Withdraw amount',
    applyWithdrawalBalance2: 'Recharge amount',
    selectWithdrawalAccount: 'Select/input withdraw amount',
    withdrawRemark: 'Withdraw remark',
    withdrawRemark2: 'Recharge remark',
    inputWithdrawRemark: 'Input withdraw remark',
    cancel: 'Cancel',
    sure: 'Confirm',
    submitResigt: 'Submit application',
    oneWeek: 'One week',
    oneMonth: 'One month',
    threeMonth: 'Tree months',
    withdrawAmoutIsNotNull: 'Withdraw amount cannot be null!',
    withdrawAmoutZS: 'Please input positive integer!',
    withdrawAmoutMustNumber: 'Withdraw amount must be a number!',
    withdrawAmoutIsNot0: 'Withdraw amount must be greater than 0!',
    withdrawAmoutIsNotNegative: 'Withdraw amount cannot be negative!',
    withdrawAmoutIsNotEnough: 'Withdraw amount is not enough!',
    comformWithdrawMsg: 'Please check the withdraw massage if go on?',
    comformWithdrawMsgIfGo: 'Please check the withdraw massage if go on?',
    sureSubmit: 'Confirm and submit',
    returnEdit: 'Return and edit',
    submitSuccess: 'Submit succeeded,waiting for review!',
    companyName: 'Shop name',
    companyName2: 'Shop name',
    companyType: 'Shop type',
    distributor: 'Distributor',
    supplier: 'Supplier',
    inputCompanyNameAndId: 'Please input shop name/ID',
    handle: 'Process',
    auditor: 'Audit',
    auditorPass: 'Approved',
    auditorNotPass: 'Disapproved',
    withdrawHander: 'Withdraw processing',
    withDrawAuditor: 'Withdraw auditing',
    withDrawAuditor2: 'Recharge auditing',
    withdrawHander2: 'Recharge processing',
    refuseApply: 'Refuse application',
    refuseApplyReason: 'Please input reasons for refusal',
    handlingSubmittingAudits: 'Process and submit for review',
    handelSuccess: 'Process succeeded!',
    rechargeFail: 'Failure'
  },
  password: {
    getPassword: 'Get password',
    pleaseInputMailAccount: 'Please input the mail account',
    sendPasswordToMail: 'Send password to mail',
    returnToIndex: 'Return',
    sendMsg: 'Enter your registered director mail，systerm will initialize a password to the corresponding mail.',
    mattersNeedingAttention: 'Attention',
    tips1: 'Please do not retrieve the password frequently, use most of the day',
    tips2: 'Secondary retrieving function.',
    tipsMsg: 'Tips',
    loginAtonce: 'Login',
    getUrlAgain: 'Get again',
    mailCanNotBeEmpty: 'Mail cannot be blank!',
    mailStyleNotRight: 'Please enter a legitimate mailbox format!',
    mailHaveSendSuccess: 'Send succeeded,please verify in your mail!',
    theMailInputNotExist: 'The mail does not exist!',
    theMailNotHaveRight: 'The mailbox is not activated or banned',
    aboveOneDayPermit: 'Over the maximum of permitting operations one day!',
    mailSendFail: 'Mail send failed!'
  },
  orderMessage: {
    pleaseIntoConfirmEmail: 'Please input email',
    emailError: 'Email input format is incorrect',
    confirmEmailError: 'Email of confirmation slip has an incorrect format',
    pleaseIntoUseDate: 'Please choose a use date',
    pleaseIntprodDate: '请选择游玩时间',
    pleaseIntoHandDate: 'Please choose a receive date',
    pleaseIntoReturnDate: '请选择归还时间',
    pleaseIntoLinkCounter: '请选择领取柜台',
    pleaseIntoReturnCounter: '请选择归还柜台',
    pleaseIntoCustomEmail: 'Please enter visitor\'s name',
    pleaseSelectStock: 'Please choose the venue',
    customEmailLength: 'The length of visitor\'s name cannot more than 20',
    pleaseIntoCustomTel: 'Please enter visitor\'s phone number',
    pleaseIntoNationality: 'Please enter visitor\'s nationality',
    pleaseIntoBirthday: 'Please enter visitor\'s Birthday',
    customTelError: 'The format of visitor\'s mail is incorrect',
    customTelError1: 'Phone number format incorrect. Please enter a valid 10 or 11 digit phone number. ',
    customAgeError: 'Invalid age format. ',
    customSexError2: 'bus for exclusive use of the woman. Please select bus for exclusive use of the man. the correct passenger gender. ',
    customSexError1: 'bus for exclusive use of the man. Please select bus for exclusive use of the man. the correct passenger gender. ',
    pleaseIntoCustomWechat: 'Please enter visitor\'s wechat ID',
    customWechatError: 'The format of visitor\'s wechat ID',
    pleaseIntoCustomPass: 'Please enter visitor\'s passport ',
    customPassError: 'The format of visitor\'s passport is incorrect',
    pleaseIntoCustomAddress: '请输入快递地址',
    pleaseIntoCustomPostcode: '请输入邮政编码',
    customPostcodeError: '邮政编码格式不正确',
    pleaseIntoCustomCreditType: '请选择游客证件类型',
    pleaseIntoCustomCreditNo: '请输入游客证件号',
    customCreditNoError: '游客证件号格式不正确',
    customSexMale: 'Male',
    customSexFalmale: 'Female',
    customCtype1: '大人',
    customCtype2: '小児',
    customCtype3: '身障者大人',
    customCtype4: '身障者小児',
    pleaseRechangeCtype: 'Passenger type does not match with passenger details. Please select the correct passenger type. ',
    pleaseIntoCustomItem: 'Please input the visitor custom content',
    quotaPrompt: 'Please enter an integer greater than 0',
    orderOnceBeOne: 'The number of every single order is at least 1',
    orderNumberOnceBeOne: '单次订单预定人数至少为1',
    orderStockBeMax: '本产品场次库存数至多为',
    orderOnceBeMax: 'ERROR! The maximum number of this product per order is ',
    orderNumOnceBeMax: '本产品单次订单预定人数至多为',
    orderOnceBeMin: 'ERROR! The minimum order is from ',
    orderNumOnceBeMin: '本产品单次订单预定人数至少为',
    validateDateExpire: 'The expiry date has expired',
    productsNumError: 'ERROR. Lack of stock! Order cannot be completed!',
    productsNumError1: 'Product ',
    productsNumError2: ' - :',
    productsNumError3: ' Insufficient inventory',
    productsNumError4: ' Insufficient stock of PDF electronic tickets',
    productPriceError: '价格已变化，请重新刷新',
    systemErrorMsg: '系统异常,请稍后再试!',
    pleaseUploadPDF: '需先上传PDF文件才能确认！',
    pleaseIntoUseData: 'Please input the specified time',
    productUseDateBeNull: 'The specified time of orders cannot be null',
    jtrordermessage: '数量最多为',
    jtrplayDate: '请先选择游玩时间',
    jtrnum: '请选择数量',
    jtrphone: '请输入手机号',
    jtrphonefalse: '手机号不正确',
    linkCreditTypeErr: '请选择证件类型',
    linkCreditNoErr: '请输入证件号码',
    error: '订单无法追加、或已达到上限',
    limitedDate: 'The current time has exceeded the scheduled time limit of the product, please re-order',
    limitBulking: 'The distributor is in bulk purchase, cannot submit a new batch reservation before purchase complete, please wait!',
    designatedDateNull: 'The specified date is empty'
  },
  actuary: {
    all: '全部',
    actuaryType: '内容',
    actuaryType1: '预存款进款',
    actuaryType2: '请款书支付',
    actuaryType3: '临时采购',
    actuaryType4: '采购待支付',
    actuaryType5: '采购支付',
    actuaryType6: '售卖',
    actuaryState: '状态',
    actuaryState1: '正常',
    actuaryState2: '取消',
    actuaryState3: '完成',
    actuaryState4: '待处理',
    depositStatus0: '待处理',
    depositStatus1: '待审核',
    depositStatus2: '已完成',
    depositStatus3: '已拒绝',
    jphOrderStatus0: '待支付',
    jphOrderStatus1: '待确认',
    jphOrderStatus2: '取消中',
    jphOrderStatus3: '已取消',
    jphOrderStatus4: '已确认',
    jphOrderStatus5: '已完成',
    jphOrderStatus6: '未支付取消',
    jtrOrderStatus0: '待确认',
    jtrOrderStatus1: '待支付',
    jtrOrderStatus2: '已完成',
    jtrOrderStatus3: '取消订单',
    jtrOrderStatus4: '已付款',
    jtrOrderStatus5: '已申请退款',
    jtrOrderStatus6: 'Refunded',
    jtrOrderStatus7: '支付失败',
    jtrOrderStatus8: '拒绝退款',
    jtrOrderStatus9: '已出票',
    searchTime: '日期',
    searchWords: 'Keywords',
    searchMsg: '分销商名称/产品名称/设施',
    search: '搜索',
    exportExcel: 'Excel下载',
    addNew: '新增',
    actuaryId: '号码',
    createTime: '日期',
    facilitiesName: '设施',
    distributorName: '分销商',
    productName: '商品名',
    productNum: '张数',
    depositAmount: '预存款',
    payoutAmount: '支出',
    incomeAmount: '进价',
    saleAmount: '销售额',
    distributorBalance: '分销商预存款余额',
    salableQuantity: '可售张数',
    stockQuantity: '实际在库',
    operation: '操作',
    viewNum: '张数',
    viewNumErr: '张数不能为空或负数',
    view: '景点',
    viewIdErr: '景点必选',
    viewIdErr1: '只能选择一个景点',
    amount: '金额',
    amountErr: 'Amount cannot be blank',
    requestForm: '请求书',
    payDate: '支付日',
    payDateErr: '支付日不能为空',
    remark: '备考',
    remarkErr: '备考不能为空',
    validTime: '有效期',
    addAmount: '合计金额',
    money: '日元',
    confirm: '确认',
    timeSlot: '选择输入时间段',
    nameErr: '设施不能为空',
    validDateErr: '有效期不能为空',
    productInfo: '注 : 当前仅支持选择一种产品',
    productErr: '产品不能为空',
    productErr1: '当前只能选择一种产品',
    chooseActuaryType: '请选择新增精算类型',
    messageNotCompleteIn: '必要信息未输入完整',
    addSuccess: '添加成功',
    addError1: 'Add error,Products Existing or Not Selected',
    addError2: 'Add error',
    submitPrice: 'Prices cannot be empty!',
    submitMinPrice: 'Min price cannot be empty!',
    submitMinPrice0: 'The minimum amount required to enter cannot be less than or equal to 0!',
    submitMinPrice1: '分销价格必须大于0!',
    submitOrderNum: 'Sort cannot be empty!',
    submitLength: 'Price and ranking must be less than or equal to 10 digits',
    addFailed: 'System exception, please try again later',
    operatorBalance: '余款',
    actuaryDetail: '精算详情'
  },
  finance: {
    calculatePeriod: 'Settlement cycle：',
    calculatePeriod1: 'Settlement cycle',
    placeholderCalculatePeriod: 'Choose the settlement cycle',
    supplierNameAndId: 'Shop name/ID：',
    placeholderSupplierNameAndId: 'Please input shop name/ID',
    search: 'Search',
    supplierName: 'Shop name',
    distributorPayoutAmount: 'Receivable（JPY）',
    operatorIncomeAmount: 'Commission（JPY）',
    supplierIncomeAmount: 'Settlement（JPY）',
    operation: 'Operation',
    detail: 'Detail',
    downloadBill: 'Download the bill',
    lastSixMonth: 'Last six months',
    return: 'Return',
    distributorName: 'Distributor name：',
    distributorName1: 'Distributor name',
    placeholderDistributorName: 'Please enter the distributor name/ID',
    finishTime: 'Finish time',
    orderId: 'Order ID',
    productId: 'Product ID',
    productName: 'Product name',
    productType: 'Product type',
    elecTicket: 'E-ticket',
    paperTicket: 'Entity ticket',
    experTicket: 'Experience',
    daysTicket: 'Day/Days Tour',
    wifi: 'Wi-Fi',
    sim: 'SIM Card',
    restTicket: 'Food',
    traffTicket: 'Traffic',
    packTicket: 'Dicount Tickets',
    distributorPayoutAmount1: 'Receivable',
    operatorIncomeAmount1: 'Commission',
    supplierIncomeAmount1: 'Settlement'
  },
  payOrder: {
    payMessageOne: 'Please check the order details for any mistakes before proceeding to payment.',
    payMessageOne1: 'The order will be cancelled automatically after one hour if the payment is not processed. ',
    payMessageOne2: 'Please complete the payment as soon as possible to confirm the order.',
    payMessageOne3: 'Tickets are limited and are not booked and confirmed until payment is processed.',
    jtrpayMessageOne: 'Please confirm the details of the order at the end of the order.',
    jtrcancel: 'Cancel part of the order',
    jtrAppend: '追加订单',
    jtrpayMessageTwo: 'No payment in minutes will be cancelled.',
    payMessageTwo: 'Please pay as soon as possible,otherwise the product will be sold out and the order cannot be purchased.',
    payMessageThree: 'Order',
    payMessageFour: 'It will be canceled if not paid within minutes. Please pay as soon as possible.',
    payMessageFive: 'Payment times out, please place the order again.',
    lineDownTicket: 'Line down electronic ticket',
    lineUpTicket: 'Online electronic ticket',
    salaryByNow: 'Payment',
    thirdPayment: 'E-wallet payments',
    canBeUseMoney: 'Available account balance：',
    jtrcanBeUseMoney: 'Payment amount',
    remainTimes: 'Validity period',
    payMoney: 'Total cost：',
    applyCancel: 'Apply for cancellation',
    payByNow: 'Pay now',
    canBeUseMoneyError: 'Available balance is not enough,order cannot be generated',
    orderCanceled: 'Order cancelled',
    consentRefund: '已同意退款',
    refuseRefund: '已拒绝退款',
    overTimeByPay: 'Payment times out and the order is cancelled automatically.',
    orderHaveUpdate: '支付失败，订单状态已更新',
    orderException: '订单异常，请重试',
    productException: '产品异常,无法编辑说明',
    payerror: '支付失败',
    error: 'Cancelling the number of errors',
    applyerror: 'Application failure'
  },
  supplyOrder: {
    confirmCancel: 'Confirm cancel',
    refuseCancel: 'Refuse cancel',
    canceleOrder: 'Cancel order',
    specialCanceleOrder: 'Special Cancel',
    partnerCancleOrder: 'Cancel API of connection destination',
    jtrSpecialCanceleChannel: 'Special cancellation of pass',
    writeFff: 'Write off',
    confirmSpecialRefund: '确认特殊退款',
    refuseSpecialRefund: '拒绝特殊退款',
    orderConfirmDetail: 'Details and QR code',
    system: 'System',
    checkedForNew: 'Click to see the latest message',
    orderRefuseMessage: 'This product cannot be refunded,the payment will not be returned if the application is cancelled, please be notified',
    canBeTakeBackFree: 'Refund fee',
    canBeTakeBack: 'Refund poundage',
    exchangeRate: '汇率差额',
    takeMoney: 'Returned money',
    orderDetailByDialog: 'Details and QR code',
    orderdetail1: 'Order①',
    orderdetail2: 'Order②',
    orderdetail3: 'Order③',
    orderdetail4: 'Order④',
    orderdetail5: 'Order⑤',
    orderdetail6: 'Order⑥',
    orderdetail7: 'Order⑦',
    orderdetail8: 'Order⑧',
    orderdetail9: 'Order⑨',
    fileTypes: 'This file is not in a valid pdf format!',
    reselectFile: 'The PDF file is not included in this file. Please re-select it!',
    zipTypes: 'This file is not in a valid ZIP format!',
    fileSize: 'The size of uploaded pdf cannot exceed 5MB！',
    fileTypeBy: 'The file name cannot have a comma!',
    canCancel: 'Cancel',
    downFiles: 'Download files',
    vailTimeMsg: 'Order status does not support modifying the validity period',
    vailTimelaterMsg: 'The end date cannot be less than the current date',
    vailTimeFsjMsg: 'Fujikyu products do not support changing the validity period',
    vailTimeEmpty: 'Please select the validity period'
  },
  productNumberPrice: {
    pleaseIntoTime: 'Please select time',
    pleaseIntoNumber: 'Please fill the stock',
    pleaseGetOneToSix: 'Please enter 1-6 numbers',
    pleaseIntoPurchasePrice: 'Please fill the purchase price ',
    pleaseIntoDistorbutionPrice: 'Please fill the distribution price',
    pleaseIntoMarketPrice: 'Please fill the market price',
    dateCanotBeNull: 'Date cannot be null',
    confirmDateCanotBeMax: 'The set time period must be within the product\'S sale time!',
    distributorCanotBuyMessage: 'Reservation cannot be made because you do not have permission to sell the product',
    distributorCanotBuyMessage2: 'This product is offline. You can\'t buy this product'
  },
  pwdSet: {
    pleaseIntoOldPwd: 'Please enter the original password ',
    pleaseIntoNewPwd: 'Please enter the new password ',
    pleaseConfirmPwd: 'Please confirm new password ',
    pleaseIntoIntoSix: 'Please enter 6-16 capital or small English letters or numbers',
    mustBeOne: 'Must be consistent with the above input',
    pleaseIntoCorrectPwd: 'Please enter the correct password ',
    lengthMustOneToSix: 'Length must between 6 to 16 characters',
    canotBeIntoNull: 'Cannot input blank or other characters',
    updateNewPwdSuccess: 'Update new password succeeded,please login again!',
    oldPwdError: 'Old password is error，please try again!',
    oldAndNewNotOne: 'Entered passwords differ!',
    pleaseIntoMustItem: 'Please enter the must item',
    pleaseEnterPwd: 'Please enter the password',
    pleaseEnterPwdAgain: 'Please enter the password again'
  },
  homeMessage: {
    urgnMessage: 'You have no permission to operate this function!'
  },
  entityTicket: {
    pinTicketNo: 'Pin ticket Number',
    selectDepot: 'Select depot',
    pleaseSelect: 'Please select',
    selectProduct: 'Select product',
    relationProduct: 'Associated Products',
    selectPriceType: 'Select product price type',
    saveTicketDepot: 'Save the ticket depot',
    onlySelectOnePro: 'Adding a ticket depot at one time only allows an alternative product!',
    onlySelectOnePriceType: 'Adding a ticket depot at one time only allows an alternative product Price Type!',
    depotNameNotBeEmpty: 'Depot name cannot be empty!',
    productNameNotBeEmpty: 'Product name cannot be empty!',
    productPriceTypeNotBeEmpty: 'Product type cannot be empty!',
    addSuccess: 'Add succeeded!',
    inDepotSuccess: 'Stored succeeded!',
    proHaveExist: 'This product has already existed!',
    selectDepotOut: 'Out depot',
    selectDepotIn: 'Entry depot',
    depotProNum: 'Inventory',
    validDate: 'Valid date',
    selectDate: 'Select date',
    starEndTicketNo: 'Start and end ticket number',
    starTicketNo: 'The initial ticket number',
    endTicketNo: 'The end ticket number',
    inDepotTicketNo: 'Entry ticket number',
    textArea: 'Separate scavenging entrance,move the cursor to here and then sweep dimensional code on a solid ticket by scavenging gun',
    saveToDepot: 'Save and entry',
    pleaseInputStarTicketNo: 'Please input the initial ticket number!',
    pleaseInputEndTicketNo: 'Please input the end ticket number!',
    errorMsg01: 'The initial ticket number must be no more than 10 digits!',
    errorMsg02: 'The end ticket number must be no more than 10 digits!',
    errorMsg03: 'The initial ticket number cannot be more than the end one!',
    errorMsg04: 'The number of entry tickets cannot be more than 2000!',
    errorMsg05: 'The length of following ticket number is longer than tens digit',
    errorMsg06: 'Please select the entry warehouse!',
    errorMsg07: 'Out warehouse cannot be the same as the entry warehouse!',
    errorMsg08: 'Please select the expiry date!',
    errorMsg09: 'Please input the ticket number of entry!',
    errorMsg10: 'This entry warehouse and this product have not yet been set up in the warehouse,please set up a warehouse before input!',
    errorMsg11: 'Following ticket number exist in the entry warehouse ',
    errorMsg12: 'Following ticket number does not exist in the out warehouse',
    errorMsg13: 'This out warehouse and this product have not yet been set up in the warehouse,please set up a warehouse before output!',
    allBathList: 'Lists of all batches',
    batchDetailList: 'Detail list of batch',
    batchNO: 'Batch ID',
    ticketNO: 'Ticket number',
    pleaseInputBatchNo: 'Please input the batch id',
    pleaseInputTicketNo: 'Please input the ticket number',
    inDepotTime: 'Warehousing date',
    inDepotUser: 'Warehousing user',
    importNumber: 'Total',
    userNumber: 'Quantity of usage',
    invalidateNumber: 'Invalid',
    leftNumber: 'Left',
    exportNumber: 'Export',
    thisBatchDetail: 'Details',
    clearDepot: 'Clear',
    batchState: 'Batch state',
    ticketState: 'Ticket state',
    stateOne: 'Normal',
    stateTwo: 'Used',
    stateThree: 'Cancel',
    stateFour: 'Exported',
    stateFive: 'Cleared',
    stateSix: 'Locked',
    userOperationTime: 'Operation（Cancel） time',
    unUseRemark: 'Invalidation description',
    orderId: 'Order ID',
    sureClearDepot: 'Are you sure to clear this batch of products?',
    sureClearDepot2: 'Are you sure to clear this depot?',
    clearDepotSuccess: 'Clear succeeded',
    haveCancelClearDepot: 'Have cancel the clearance of depot!',
    invalidTicketSuccess: 'All invalidated succeeded!',
    addTicketDepot: 'Add ticket depot',
    depot: 'Depot',
    keyWorld: 'Keyword',
    inputProNameAndNo: 'Please input product name/number',
    userTimeQuantum: 'Using time',
    inputSelectTimeQuantum: 'Select/input queried time',
    depotId: 'Depot ID',
    ticketDepotId: 'Ticket DepotID',
    depotName: 'Depot name',
    productId: 'Product ID',
    productName: 'Product name',
    fileName: 'Total',
    depotIn: 'Warehousing',
    depotId2: 'Input',
    depotId3: 'to',
    depotId4: 'The initial inventory',
    depotOut: 'Output',
    history: 'Record',
    zhang: 'Zhang',
    operationUser: 'Operator',
    depotType: 'Depot type',
    addDepot: 'Add depot',
    inputDepotName: 'Please input the depot name',
    notAllDepot: 'Not central warehouse',
    allDepot: 'The central warehouse',
    depotRemark: 'Depot remark',
    remarkMsg: 'Remark',
    inventoryNumber: 'Inventory',
    ifIsAllDepot: 'Central warehouse sign',
    yes: 'YES',
    no: 'NO',
    tips: 'Note:there is only one central warehouse',
    depotEdit: 'Edit the depot',
    deleteDepot: 'Sure to delete this depot?',
    depotNameIsNotEmpty: 'Depot name cannot be empty!',
    allDepotOnlyOne: 'The central warehouse is only allowed to have one!',
    depotNameOnlyOne: 'This depot name has already existed!',
    userDepotManager: 'Management of users\' depot',
    addDepotToUser: 'Appointed depot',
    addDepotToUserSuccess: 'Appoint succeeded!',
    notHistory: 'This product has no history!',
    pleaseSelectInvalidTicket: 'Please select invalid ticket!',
    invalidTicketFalid: 'All invalid failed!',
    someInvalidTicketFalid: 'Fail to cancel the following ticket numbers.',
    orderQuery: 'Order query：',
    orderQueryPlac: 'Please enter order number or scan code.',
    orderInfo: 'Order Info：',
    startStopNumber: 'Start and end ticket number：',
    startNumber: 'The initial ticket number',
    stopNumber: 'The end ticket number',
    numberEditPlac: 'Separate scavenging entrance,move the cursor to here and then sweep dimensional code on a solid ticket by scavenging gun',
    confirmPin: 'Confirm the pin ticket',
    formMsg1: 'Please enter the verification code, order number or scan code.',
    rule_n1_10: 'Length limited within 1 to 10',
    querySuccess: 'Query Success',
    queryFailure: 'Order does not exist',
    queryMsg1: 'The starting ticket number can\'t be greater than the ending ticket number, and can only 100 tickets at most once.',
    queryMsg2: 'Confirm the pin ticket：',
    pinMsg1: 'Pin ticket success',
    pinMsg2: 'Pin ticket fail!',
    clearRemark: 'Inventory remark'
  },
  ticketMessage: {
    pleaseEnterOrderId: 'Please enter your reservation number.',
    depotName: 'Depot name：',
    pleaseIntoDepotName: 'Please input depot name',
    depotNameNotNull: 'Depot name cannot be blank',
    ticketRemark: 'Remark：',
    remarkNotNull: 'Remark cannot be blank',
    pleaseGetProduct: 'Please choose product',
    fileDepotName: 'File depot name：',
    batchStatus: 'Batch status：',
    batchId: 'Batch ID',
    pleaseEnterBatchId: 'Please input the batch id',
    enterDate: 'Import date',
    enterUser: 'Import user',
    close: 'Close',
    Processing: 'Processing',
    uploadFailure: 'upload failure',
    ticketDetail: 'Detail',
    newToUse: 'Priority use',
    fileStatus: 'File status：',
    fileName: 'File name：',
    pleaseEnterFileName: 'Please input the PDF file name',
    fileId: 'File ID',
    fileNames: 'File name',
    downPdf: 'Download PDF',
    ticketMessageBy: 'Following tickets are in an abnormal state，delete failed!',
    noUseMessage: 'Select at least one file!',
    ticketMessageBy2: 'This operation has an abnormal ticket,please retry again after refresh!',
    operationSuccess: 'Operation succeeded!',
    getFile: 'Choose file',
    getZipFile: 'Choose ZIP',
    getFilesOnlyFive: '*Note: Each PDF will be split into multiple e-tickets by page. Limit the quantity of uploaded PDF files to 5 and a single file size can\'t exceed 10MB',
    getZipOnlyOne: 'Limit the quantity of uploaded ZIP files to 1 and a single file size can\'t exceed 300MB',
    usedDate: 'Expire date：',
    usedDates: 'Expire date',
    ticketMessageBy3: 'Null is always valid.',
    intoNow: 'Import now',
    intoSuccess: 'Import succeeded!',
    insertFileDepot: 'Add file depot',
    choose: '选择',
    fileDepotNames: 'File depot name',
    pleaseIntoFileName: 'Please input file name',
    canBeUseDate: 'Used（cancel） time：',
    intoSearchDate: 'Input search date',
    into: 'Import',
    fivePdf: 'PDF!',
    oneZip: 'ZIP!',
    ticketOpen: 'Open',
    intoIng: 'Importing, please wait...',
    fileHadExists: 'The file already exists in the library!',
    uploadSize: 'The uploaded picture size should not exceed 10MB!',
    uploadZipSize: 'The uploaded picture size should not exceed 300MB!',
    fileNotFors: 'Don\'t upload files repeatedly!',
    pleaseGetFile: 'Please select file',
    fileBatchRemarkNotNull: 'Please enter remark'
  },
  remind: {
    remindId: 'The serial number',
    title: 'Email alerts',
    date: 'Send mass of date',
    accessory: 'The attachment',
    add: 'New remind',
    upload: 'To upload attachments',
    beforeDay: 'Send an email notification N days before the group date',
    before: 'Hair group has',
    days: 'Send email reminders days',
    download: 'Download the attachment',
    reminder: 'prompt',
    confirm: 'determine',
    inputDate: 'Please enter the date of dispatch',
    uploadAccessory: 'Please upload the attachment.',
    inputbeforeDay: 'Please enter advance delivery date',
    inputContent: 'Please enter the message content',
    sendContent: 'Send content',
    addRemind: 'Email alerts',
    existRemind: 'A day reminder already exists',
    set: 'Email Settings'
  },
  trades: {
    platform: 'Platform',
    excel: 'Export to Excel',
    tradesTime: 'Trades Time',
    inputOrderId: 'Please enter the order number',
    tradingTime: 'Trading Date',
    operatorUser: 'Operator',
    expenditure: 'Expenditure',
    income: 'Income',
    buyQuantity: 'Num of Units',
    customerName: 'Traveler Name',
    orderExplain: 'Order Info',
    content: 'Content'
  },
  pinTicketMagn: {
    pinTicket: 'Pin ticket',
    shortcutOut: 'Shortcut pin ticket',
    all: 'All',
    pinTime: 'Authentication time',
    validationType: 'Pin ticket type：',
    productName: 'Product name：',
    placeholder1: 'Please enter the product name',
    validateTime: 'Pin ticket date：',
    placeholder2: 'Please select the pin ticket date.',
    orderId: 'Order ID：',
    placeholder3: 'Please enter the order id',
    distributor: 'Distributor：',
    placeholder4: 'Please enter the distributor',
    validationUser: 'Verifier：',
    placeholder5: 'Please enter the verifier',
    ticketNo: 'Ticket number：',
    placeholder6: 'Please enter the ticket number',
    colOrderId: 'Order ID',
    colOrderContent: 'Product content',
    colValidateTime: 'Pin ticket time',
    colValidateType: 'Type',
    colValidateUser: 'Verifier',
    colDistributor: 'Distributor',
    colCustomerOrderNo: 'Shortcut NO.',
    placeholder7: 'Please enter the express ticket No',
    colCustomerOperator: 'Operator',
    placeholder8: 'Please enter operator',
    colticketNo: 'Ticket number',
    shortcutOutDepot: 'Pin ticket depot',
    shortcutOutProduct: 'Pin ticket product',
    company: 'Company',
    orderIdNo: 'Order ID',
    distributorNameAndOrderNo: 'Distributor name (suggested: initials) +order number',
    pleaseInputOrderCustomer: 'Please enter the customer order ID',
    pleaseInputCustomerOperator: 'Please enter the operator',
    shortcutOutSure: 'Confirm the pin ticket',
    ticketCanNotBeCutOut: 'The following tickets can\'t be pined.',
    ticketCanNotBeCutOuts: 'Do not enter duplicate ticket numbers.',
    distributeOnlySelectOne: 'The distributor can only choose one.',
    ticketNumber100: 'The number of incoming tickets can\'t be greater than 100!',
    pleaseInputDistribute: 'Please Select Distributor!',
    pleaseInputOrder: 'Please enter the order ID!',
    orderLine100: 'The length of order ID cannot more than 100!',
    inputOperation: 'Please enter the operator!',
    operationLine100: 'The length of Operator cannot more than 100',
    shortcutOutSuccess: 'Pin ticket success!'
  },
  errMsg: {
    errMsg100: 'Order does not exist',
    errMsg101: 'No corresponding warehouse',
    errMsg102: 'Only operator could delete it',
    errMsg103: 'This order is no longer valid',
    errMsg104: 'The following tickets can\'t be pined.',
    errMsg105: 'Operation from carrier or supplier with special permissions to pass the audit is failed',
    errMsg106: 'Product ID cannot be empty',
    errMsg107: 'Updload file cannot be empty',
    errMsg108: 'Server inner error',
    errMsg109: 'The order has been completed',
    errMsg110: 'Order not confirmed',
    errMsg111: 'The number to delete doesn\'t match the number purchased',
    errMsg112: 'No corresponding ticket warehouse',
    errMsg113: 'No conrresponding ticket',
    errMsg114: 'Please select the product source',
    errMsg115: 'Enter at least one',
    errMsg116: 'The order has been cancelled',
    errMsg117: '',
    errMsg118: '',
    errMsg119: '',
    errMsg120: '',
    errMsg121: 'In process, do not submit again'
  },
  pay: {
    type: 'Recharge method',
    success: 'Payment completed',
    fail: 'Payment incompleted',
    toUrl: 'Please go the the payment platform you chose to complete the payment',
    toPay: 'Go on recharging',
    error01: 'Payment failed, please try again',
    error02: 'Payment is completed, please do not repeat the payment',
    loading: 'Payment data is under processing...',
    message: '支払いが成功したら、振込はサービス方で遅れます。お待ちください。'
  },
  pageSetting: {
    upload01: 'Only files in jpg/png/jpeg format and size not more than 1MB can be uploaded',
    upload02: 'The size of the homepage pictures is 1920x500 pixels, and the element pattern of the homepage pictures needs to be 430 pixels from the left. ',
    pageImg: ' Homepage pictures：',
    errorByPage01: 'There is no change in the homepage pictures',
    errorByPage02: 'The homepage pictures can not be empty！'
  },
  barCode: {
    urlError: 'Url Error!',
    getInfoError: 'QRCode Loading Error!',
    productTextDescription: 'Reservation details',
    customerReceiveDate: 'Ticket collection date：',
    returnDate: 'Return Date：',
    productUseDate: 'Selected date：',
    buyQuantity: 'Order details：',
    productUseFlow: 'How to use：',
    productUseName: 'Guest name(s)：',
    validityDate: 'Ticket valid period：'
  },
  supplementInfo: {
    urlError: '地址链接异常!',
    getSupplementInfo: '内容获取失败!',
    supplementOfUseFlow: '使用流程补充详细说明'
  },
  qrCode: {
    qrCodeSource: 'Name',
    isDistribution: 'Distributor',
    scale: 'Commission rate',
    YES: '是',
    NO: '否',
    noValue: 'Commission rate value empty',
    distributionRange: 'Distribution Product Scope Authorization',
    distributionRangeAll: 'All qrcodes distributable',
    distributionRangeYes: 'Designated qrcodes are distributable',
    distributionRangeNo: 'qrcodes are distributable except for specified qrcodes',
    selectDistributor: 'Product selection',
    tipMessage1: 'Please enter a name',
    tipMessage2: 'Please select the scope of authorization',
    tipMessage3: 'Please enter commission rate',
    addError1: 'Two-dimensional code source already exists, please re-enter',
    prompt: 'Are you sure to delete the two-dimensional code?？',
    searchMore: 'View products',
    choseCode: 'Selection of two-dimensional codes',
    choseCodeError: 'Please select two-dimensional code',
    nickName: 'Nickname',
    auditStatus: 'Audit status',
    submitAudit: 'Confirmation of approval?',
    submitAudit1: 'Confirm cash withdrawal?',
    cannotSale: 'Products purchased through the QR Code after the user has been deactivated will not receive commission fee.',
    canSale: 'Products purchased through the QR Code after the user has been activated will process commission fee. ',
    remark: 'Remarks',
    agree: 'Accept',
    handle: 'Process',
    notAgree: 'Decline',
    applyMoney: 'Withdrawal amount',
    applyMoney1: 'Withdrawal amount(excluding fees)',
    chargeMoney: 'Commission fee',
    chargeMoney2: 'Including fees',
    aduitTime: 'Review time',
    aduitName: 'Auditor',
    remittanceExport: 'Export Remittance Data',
    realName: 'Account holder\'s name',
    bankNo: 'Account number',
    bankName: 'Bank name',
    branchName: 'Branch name',
    accountType: 'Account type',
    tocDistributor: 'Distributor',
    distributorName: 'Distributor nickname',
    twoDistributor: 'Distributor',
    oneDistributor: 'Distributor',
    drawaltip1: 'Withdrawal amount exceeds current balance.',
    drawaltip2: 'Withdrawal amount less than commission fee.',
    drawaltip3: 'Please enter withdrawal amount.',
    drawaltip4: 'Please wait for the pending cash withdrawal request to be processed. ',
    saleName: 'Username',
    saleMoney: 'Distributor Revenue',
    distributorMoney: 'Distributor Revenue',
    isHasMoney: 'Deposit status',
    isPay: 'Cash deposited',
    notPay: 'Unpaid',
    handleStatus: 'Processing status',
    handleStatus1: 'Pending processing',
    handleStatus2: 'Processed',
    handleStatus3: 'Declined',
    handleBy: 'Processed by',
    handleTime: 'Time of Process',
    setCharge: 'Manage Commission Fee',
    chargeConfirm: 'Finalise withdrawal fees?',
    accountStatus: 'Account Status',
    canUse: 'Enable',
    cannotUse: 'Disable',
    cannotUse1: 'Disconnected',
    incomeAmount: 'Amount of earnings',
    tocIncomeAmount: 'Customer account balance',
    withdrawalError1: 'Please enter account holder\'s name',
    withdrawalError2: 'Please enter account number',
    withdrawalError3: 'Please enter bank name',
    withdrawalError4: 'Please enter branch name',
    withdrawalError5: 'Please enter account type',
    handleError1: 'Insufficient balance, withdrawal request declined.',
    handleError2: 'Cash withdrawal access restricted to operating user. ',
    handleError3: 'Insufficient balance, withdrawal request declined.',
    withdrawalTips: 'Purchases of 10,000 JPY or more: No fees. Purchases less than 10,000 JPY will incur a fee',
    withdrawalTips1: 'Purchases of 10,000 JPY or more: No fees. ',
    withdrawalTips2: 'Purchases less than 10,000 JPY will incur a fee',
    applyCash: 'Cash Withdrawal',
    applyBy: 'Applicant type',
    applyUser: 'Applicant',
    twoApplyName: 'Distributor',
    cannotCharge: 'The set amount can only be a positive integer',
    name: 'name',
    Unbundling: 'Disconnect',
    UnbundTips: 'Once disconnected, this user will not receive further sales commissions. ',
    cannotUnbund: 'This user has a commission transfer in progress. Unable to disconnect. ',
    twoApplyNameID: 'Distributor ID',
    inputScale: 'Please enter the percentage of commission for distribution. ',
    keyTips: 'Distributor ID/Nickname',
    saleLog: 'Direct sales record',
    withdrawalTips4: 'Cannot withdraw due to insufficient balance'
  },
  payWay: {
    balance: 'Account balance',
    weChat: 'Wechat',
    alipay: 'Alipay',
    creditCard: 'CreditCard',
    unionPay: 'UnionPay',
    weChatWay: 'Wechat Pay',
    payedId: 'Payment order No',
    alipayWay: 'Alipay',
    linePay: 'Line Pay',
    grabPay: 'Grab Pay',
    zaloPay: 'Zalo Pay',
    aliPayHK: 'AlipayHK',
    isPay: 'Reservation settlement',
    codeTips: 'QR code expired, please reacquire',
    codeTips1: 'QR code reacquisition',
    codeTips2: 'On WeChat',
    codeTips3: 'Scan the QR code',
    codeTips4: 'On Alipay',
    codeTips5: 'Scan the QR code',
    codeTips6: 'On Camera',
    refundTips: 'The reservation has been canceled and the full payment will be refunded to the payer. Thank you for your receipt.',
    refundTips1: 'The reservation has already been paid and the full amount of the payment will be refunded to the payer. Thank you for your receipt.',
    refundTips2: 'Please note that depending on the payment method of the reservation, no refund will be given if the payment exceeds 30 days.',
    refundTips3: 'If your reservation has failed or you have already paid, we will refund the full amount to the payer. Thank you for your receipt.',
    errorTips: 'Failed to obtain payment information, please try again',
    partialRefundTips: 'In case of partial refund, the handling fee is not refundable',
    payTitle: 'Partner Order payment'
  },
  newHome: {
    priceFormat: '<span class="price-format">From</span> JPY {0}',
    expired: 'Login expired, please log in again ',
    searchPlaceholder: 'Search destinations/activities',
    searchButton: 'Search',
    searchResults: 'results available for booking ',
    category: {
      transport: 'Transport',
      themePark: 'Admission Tickets ',
      wifi: 'WiFi & SIM Card',
      carRental: 'Special Packages ',
      dayTrip: 'Day Trips & Multi-day',
      hotel: 'Experiences & Dining '
    },
    productSaleLabel: {
      osakaSalesOffice: 'Osaka Office',
      tokyoSalesOffice: 'Tokyo Office',
      fukuokaSalesOffice: 'Fukuoka Office',
      kyotoSalesOffice: 'Okinawa Office ',
      nagoyaSalesOffice: 'Nagoya Office',
      hokkaidoSalesOffice: 'Hokkaido Office'
    },
    popularCities: 'Popular Destinations ',
    popularCitiesEn: 'Popular Destinations & Seasonal Events Collection ',
    activeNumber: 'activities',
    balance: 'Balance',
    switchToOldVersion: 'Switch to Old Version ',
    switchToNewVersion: 'Switch to New Version ',
    viewMore: 'View More',
    all: 'All',
    sortBy: 'Sort by',
    easyGoRecommend: 'EasyGo Recommended',
    allDates: 'Date',
    priceRange: 'Price Range',
    other: 'Others',
    selectedExperiences: 'Selected Must-Try Experiences ',
    topActivities: 'Top Activities in Japan ',
    sales: 'Sales',
    price: 'Price',
    stockQuery: 'Stock on Request ',
    noProducts: 'No Data Available ',
    salesLessThan1k: ' Less than 1k ',
    sortOptions: {
      new: 'Newest',
      sales: 'Best Selling'
    },
    autoConfirm: 'Instant Confirmation ',
    secondConfirm: 'Manual Confirmation'

  }
};

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.default = {
  common: {
    zh: '中国語',
    tw: '繫体中文',
    ja: '日本語',
    en: '英語',
    ko: '韓国語',
    title: 'コンソル管理システム',
    exit: '終了',
    search: '検索',
    tel: '電話番号',
    address: '住所',
    scenicSpotAreaSelection: '観光地の地域選択',
    inputRequiredTip: '観光地名を入力してください',
    edit: '編集',
    delete: '削除',
    recommend: 'おすすめに設定',
    pay: '支払い',
    printOrder: '印刷',
    download: 'ダウンロード',
    cancelRecommend: 'おすすめ設定を削除',
    cancel: 'キャンセル',
    confirm: '確認',
    submit: '確認',
    searchMore: '詳細を見る',
    prompt: '注意',
    basicInfo: '基本情報',
    day: '日',
    hour: '時間',
    minute: '分',
    second: '秒'
  },
  title: {
    supplement: '利用手順補充',
    addDining: '商品追加（レストラン）',
    balanceSetting: '库存价格',
    productPriceNumber: '在庫価格',
    productState: '商品審査',
    productAll: '全部',
    productStated: '審査待ち',
    productNotState: '審査失敗',
    orderReport: '予約管理',
    orderDetail: '予約詳細',
    scenicSpotList: '観光地管理',
    addScenicSpot: '観光スポット追加',
    editScenicSpot: '観光スポット編集',
    scenicSpotDetail: '観光スポットの詳細',
    popularCities: '人気目的地管理',
    addHotCity: '人気目的地を追加',
    editHotCity: '人気目的地を編集',
    productManager: '商品管理',
    pdfFilesManage: 'PDFデータ管理',
    supplyManageProduct: '商品販売管理',
    tocDistributorManageProduct: 'TOC商品販売管理',
    pdfBatchList: 'バッチリスト',
    bulkPurchaseList: '一括購入リスト',
    bulkPurchaseDetail: '一括購入詳細',
    submitAndPayOrderBatch: '一括仕入れ',
    batchPdfFilesList: 'バッチファイルリスト',
    addPdfFiles: 'PDFデータフォルダ追加',
    importPdf: 'PDFデータ導入',
    pdfFiles: 'PDFファイル',
    DiningDetail: 'レストラン商品詳細',
    financeStatement: '精算管理',
    statementDetail: '明細書詳細',
    warehouse: '倉庫管理',
    ticketDepot: 'チケット倉庫管理',
    addTicketDepot: 'チケット倉庫を新規追加',
    importTicket: '倉庫に導入',
    pinTicket: '認証出庫',
    pinTicketMagn: '認証出庫管理',
    trades: '取引明細',
    record: '残金引出履歴',
    counter: 'カウンター管理',
    addCounter: 'カウンター追加',
    editCounter: 'カウンター編集',
    liaison: '連絡先管理',
    addLiaison: '連絡先追加',
    editLiaison: '連絡先編集',
    updatePDFfiles: 'PDFデータフォルダ編集',
    importThirdSystemProduct: '商品導入管理',
    productLogList: '商品变更記録',
    productLogDetail: '商品变更の詳細',
    productLanguageLogList: '商品变更記録',
    productLanguageLogDetail: '商品の多言語変更の詳細',
    bannerManage: 'バナー管理'
  },
  lable: {
    translation: 'AI翻訳',
    translationing: 'AI翻訳中...',
    translationTip: '翻訳するデータがありません',
    isOnline: 'リリースするかどうか',
    hotCity: '人気目的地',
    cityName: '目的地名',
    cityPicture: '目的地画像',
    languageType: '言語',
    sort: '並び順',
    sortTip: '数値が小さいほど上位に表示されます',
    onlineTip: 'オフラインにするとクライアントに表示されなくなります',
    hotType: '人気タイプ',
    type1: '人気地域',
    type2: '人気目的地',
    type3: '人気のランドマーク',
    addProduct: '商品を追加',
    productInformation: '商品情報',
    price: '価格',
    tags: 'タグ',
    productList: '商品リスト',
    bannerTitle: 'バナーメインタイトル',
    bannerSubTitle: 'バナーサブタイトル',
    bannerImages: 'バナー画像',
    selectLogType: '記録タイプ',
    selectLogType_1: '基礎フィールド',
    selectLogType_2: '多言語フィールド',
    inputProductId: 'キーワード',
    inputProductId_placeholder: '商品番号を入力',
    customerDataType: 'お客様資料タイプ',
    customerDataInfo: 'お客様情報',
    chooseProductLanguage: '商品言語',
    noDataForLanguage: 'まだデータがありません。別の言語を選択してください',
    newOrderEmail: '注文通知メール',
    batchStatus: 'バッチ状態',
    proofPath: 'チケットリンク',
    pinTicketNum: '認証数',
    KlookTicketCanbeUsedDateTBList: ' から六ヶ月以内',
    KlookTicketCanbeUsedDate: ' から六ヶ月以内、同じ価額種類がある日は有効であります',
    QuantityMismatch: '認証数と予約購入数が不一致です、認証しますか',
    importProduct: '商品導入',
    system: '接続先システム',
    chooseSystem: '接続先システムを選択してください',
    klook: 'KLOOK',
    link: 'LINK',
    thirdNum: '接続先の商品番号',
    enterThirdNum: '接続先の商品番号を入力してください',
    thirdProductTime: '時間：',
    timeTips: '時間帯を入力してください（1～24）',
    haveInventory: '在庫あり',
    noInventory: '在庫なし',
    travlerFirstName: '名前',
    travlerFamilyName: '姓氏',
    travlerCall: '敬称',
    enterGolfCourseCode: '请输入高尔夫场地编号',
    enterPrefecture: '请输入行政区域编号',
    Mr: 'ミスター',
    Ms: 'ミズ',
    Miss: 'ミス',
    Mrs: 'ミセス',
    duration: 'コース時間',
    travellers: '勧め人数',
    voucherUsage: 'チケット利用方法',
    voucherTypeDesc: 'チケット種類',
    voucherValidity: 'チケット有効期間',
    redemptionProcess: '認証手順',
    transportation: '交通手段',
    insiderTips: '注意事項',
    joinAstrict: '参加制限',
    demand: '要件',
    packageOptions: 'セット商品説明',
    itinerary: 'コース説明',
    additionalInformation: '付加情報',
    meetUpLocation: '集合説明',
    pickUpLocation: '引き取り場所',
    surcharge: 'タイムオーバー費用',
    location: 'アドレス',
    submitOrderTip: '当該商品は特殊商品であります。予約送信する場合には、購入総金額が直ちに自動的に残高から引き落とすことになります。ご注意ください。',
    submitOrderBatch: '購入内容をご確認ください。予約送信する場合には、購入総金額が自動的にAGTの残高から引き落とすことになります。ご注意ください。',
    location_placeholder: 'アドレスを入力してください',
    duration_placeholder: 'イベント時間帯を入力してください',
    productConfirmType_placeholder: '商品確認方法を入力してください',
    transportation_placeholder: '交通手段を入力してください',
    voucherTypeDesc_placeholder: 'チケット種類を入力してください',
    voucherUsage_placeholder: 'チケット使用方法を入力してください',
    voucherValidity_placeholder: 'チケット有効期限を入力してください',
    pickUpLocation_placeholder: '引き取り場所を入力してください',
    redemptionProcess_placeholder: 'アドレスを入力してください',
    packageOptions_placeholder: 'セット商品説明を入力してください',
    itinerary_placeholder: 'コース説明を入力してください',
    additionalInformation_placeholder: '付加情報を入力してください',
    surcharge_placeholder: 'タイムオーバー費用を入力してください',
    insiderTips_placeholder: '注意事項を入力してください',
    updateType: '種類編集',
    updateFloatPrice: 'フロート価格',
    shareQrCode: 'QRコードをシェア',
    setQrCode: '二次元コードの設定',
    addCoupon: 'クーポン新規追加',
    couponName: 'クーポン名称',
    couponAmount: 'クーポン金額',
    couponOrder: 'クーポン取引',
    couponCode: 'クーポンコード',
    addCouponCode: 'クーポンコード新規追加',
    downloadCouponCode: 'クーポンコードをダウンロード',
    batchDelete: '一括削除',
    downloadNow: '{cnt}枚を新規追加いたしました。ダウンロードしますか。',
    tipMessage1: '名称を入力してください',
    examine: '販売店審査',
    revenueManagement: '収益管理',
    revenueDetail: '収益管理',
    cashManager: '現金引き出し管理',
    productState: '状態を選択してください',
    orderNum1: 'ソート順',
    netError: 'この商品はサプライヤー側で既に下線されています。',
    updateProduct: '更新',
    addQrCode: 'QR코드 추가',
    pleasechoice: '選択してください',
    identity: '身分証明書',
    studentId: '学生証',
    officerId: '士官証明',
    passport: 'パスポート',
    residence: '戸籍謄本',
    hongKongandMacaopass: '香港とマカオの通行証',
    cellsyndrome: '台湾人証明書',
    identificationNumber: '証明書の番号',
    children: '子供の生年月日',
    addressinformation: '連絡先',
    expressaddress: '住所',
    postalCode: '郵便番号',
    suborderinformation: '分支注文情報',
    subordersId: '分支注文書ID',
    qxzfbcplx: '商品種類を選択してください',
    selectTreeId: '请选择产品类型',
    ticketType: '種類',
    jtrticketType: '種類',
    productPriceTypeSetting: '価格カテゴリー設定',
    batchPriceRuleSetting: 'まとめて設定',
    specificDatePriceSetting: '日付別設定',
    currentProducts: '当商品：',
    currentProducts_saleDate: '販売期間：',
    unlimited: '制限なし',
    setProductInventoryAndPrice: 'まとめて料金と在庫を設定',
    setProductPriceType: '商品価格カテゴリーの設定',
    serialNumber: '番号',
    period: '時間帯',
    timelimit: '時間帯範囲',
    selectDateRange: '期間選択',
    selectTimeRange: '時間帯選択',
    inventory: '在庫',
    purchasePrice: '仕入価格',
    jtrDistributionPrice: 'B toB価格',
    stockNum: '時間帯在庫',
    distributionPrice: '卸価格',
    marketPrice: '市場価格',
    retailPrice: '推奨価格',
    operating: '操作',
    delete: '削除',
    chargeback: '予約取り消し',
    addTimePeriod: '時間帯を追加',
    reset: 'リセット',
    save: '保存',
    goBack: '戻る',
    confirm: '確認',
    confirmOrder: '予約確認',
    confirmOrder1: '北海道确认订单',
    jtrconfirmOrder: 'JTR注文情报を確認する',
    refuse: '予約拒否',
    cancelOrder: '予約取り消し',
    requestCancel: 'キャンセル申請',
    specialRequestRefund: '特殊予約取り消し',
    requestRefund: '返金申請',
    makeSure: '確認',
    cancel: 'キャンセル',
    productName: '商品名',
    scene: '场次',
    dataSource: 'データソース',
    selectDistributor: 'AGT選択',
    authorizedMerchant: '権限設定済みAGT',
    businessName: '販売店名',
    priceFloatRange: 'AGT特別卸値（通常価格の増減計算）',
    distributorNameOrNumber: '販売店名/番号',
    distributorNumber: 'AGT番号',
    distributorName: 'AGT名',
    changeValidTime: '有効期間変更',
    // suoCountry: '所属城市',
    suoCountry: 'キーワード',
    suoCountrys: 'キーワード',
    productNameOrId: '商品名/番号',
    productNameOrIds: '商品名/番号',
    productNameOrIdRemark: '商品名/番号/備考/タグ',
    productDiff: '種類',
    productDiffs: '種類',
    confirmMethod: '確認方法',
    managerArea: '管理地域',
    productCode: '商品番号',
    golfCourseCode: '高尔夫场地编号',
    prefecture: '地方行政区域',
    suoCity: '人気の目的地',
    confirmMethods: '確認方法',
    confirmMethodss: '確認方法',
    managerAreas: '管理地域',
    different: '種類',
    number: '人数',
    status: '状態',
    ticketType0: '電子チケット',
    ticketType1: '実物券',
    ticketType2: '体験',
    ticketType22: '体験',
    ticketType3: 'ツアー',
    ticketType33: 'ツアー',
    ticketType4: 'Wi-Fi',
    ticketType5: 'SIMカード',
    ticketType6: 'レストラン',
    ticketType66: 'レストラン',
    ticketType7: '交通',
    ticketType77: '交通',
    ticketType8: 'お得セット商品',
    ticketType88: 'お得セット商品',
    ticketType9: '夜行バス',
    ticketType99: '夜行バス',
    jtrticketType0: '入場券',
    jtrticketType1: 'お得セット',
    jtrticketType2: 'ツアー',
    jtrticketType3: '路線',
    jtrticketType12: '前売り',
    isOnlinePay0: '販売停止',
    isOnlinePay1: 'オンライン',
    isOnlinePay2: 'オンライン決済（先払い）',
    isOnlinePay3: 'ホテルカウンター現金払い（返佣）',
    confirmType0: '自動確認',
    confirmType00: '自動確認',
    confirmType1: '二次確認',
    confirmType11: '二次確認',
    confirmType12: '二次確認',
    confirmType2: '',
    productSource0: 'JPH商品',
    productSource1: '接続先商品',
    status0: '審査待ち',
    status1: '審査通過',
    status2: '審査失敗',
    status3: '販売停止',
    status4: '下書き',
    online: 'オンライン',
    checkAll: '詳細',
    faverite0: 'おすすめ',
    faverite1: 'おすすめしません',
    toldAllLeft: '説明：利用日の',
    toldAllMiddle: '日前',
    toldAllMiddles: '日前',
    toldAllRight: 'までに予約',
    orderEmergentTag: '緊急処理',
    orderUncertainTag: '確認待ち',
    orderConfirmedTag: '予約済',
    orderCancellingTag: 'キャンセル処理中',
    orderCanceledTag: 'キャンセル済',
    orderCompletedTag: 'スキャン済',
    orderExpiredTag: '有効期切れ',
    orderPaymentTag: '支払い済み（JTR）',
    orderRefundedRequestTag: '返金申請済み（JTR）',
    orderRefundedTag: '返金済',
    orderUnpaidTag: '未支払い',
    otherSelection: 'その他のフィルター',
    remark: '備考',
    createRoleRemark: '備考',
    productHighlights: 'セールスポイント',
    currentState: '予約状態',
    youHave: '残り',
    processOrder: '予約を処理する',
    toPayOrder: '予約を支払う',
    OrderHistory: '操作履歴',
    orderDisExplain: '予約説明(AGTのみ表示)',
    orderDisExplains: '備考(施設のみ表示)',
    CustomersInvisible: '予約についての確認連絡',
    SupplierInvisible: 'お客様の伝言',
    addRemark: '備考を追加',
    addMessage: 'メッセージを追加',
    addExplain: '備考入力',
    confirmation: 'この注文を確認しますか',
    confirmationPdf: 'このPDFを無効化しますか',
    confirmationticket: 'この実物券を無効化しますか？',
    specialRefundConfirm: '返金確認後、全額がAGTに返還されます、確認しますか确认退款后钱款将会全额返还给分销商,是否确认',
    specialRefundCancel: '返金拒むと、予約は続きます',
    DeleteConfirmation: '削除しますか',
    refusal: '予約を断りますか',
    voucherPath: 'チケットリンク',
    messageInfo: '予約詳細情報',
    orderID: '予約番号',
    sonOrderID: '予約番号',
    jtrOrderId: 'チャネル番号',
    orderSource: '予約元',
    useDate: '指定利用日',
    sonProduct: '商品',
    useDate1: '指定利用日',
    useDates: '指定利用日',
    travelDate: '利用日',
    createTime: '予約時間',
    endTravelDate: '終了時間',
    arrivedTime: '到着時間',
    touristRemarks: 'お客様メモ',
    reserveNum: '予約数',
    linkMan: '名前',
    warnning1: '本人確認が必要のため、本名しか入力しないでください。',
    linkPhone: '電話番号',
    linkEmail: 'メールボックス',
    linkAddress: '宅便アドレス',
    linkCode: '郵便番号',
    linkCreditType: '連絡者証明書類型',
    linkoptionA: '身分証明',
    linkoptionB: 'パスポート',
    linkCreditNo: '連絡者証明書番号',
    customerUseDate: '利用日',
    customerTravelDate: '利用日',
    customerEndTravelDate: '利用最終日',
    customerArriveTime: '到着日付',
    customerGetTicType: 'チケット受け取り方法',
    customerGetTicType0: '無料',
    customerGetTicType1: '宅便料金',
    distributor: 'AGT',
    PDFSendingMode: 'PDF電子チケットの送付方法',
    productPrice: '商品価格',
    Purchase: '仕入価格',
    distributionPriceToc: 'AGTtoC卸価格',
    distributionPriceSum: 'AGTtoC総計価格',
    productSalePrice: '商品特別価格',
    productMinPrice: '最低価額(展示用)',
    productTcPrice: '商品特別価格',
    buyNum: '購入数',
    seatName: '時間帯名称',
    jtrAppendNum: '追加数',
    primarynum: '注文数量',
    cancelNum: '取り消し数',
    orderCnt: '成功数',
    totalAmount: '合計額',
    customerInfo: 'お客様情報',
    customerName: 'お名前',
    cusEmail: 'メールアドレス',
    Email: 'メールアドレス',
    receiveDate: '引換日',
    returnDate: '返却日付',
    FileImport: 'ファイル導入',
    upload: 'アップロード',
    onlyUpload: 'アップロードできるのは',
    noMoreThan: 'ファイルだけであり、最大サイズは',
    generateOrder: '予約作成',
    thisOrder: 'この予約は',
    hasConsumed: 'お客様がすでに利用した',
    noData: 'データなし',
    viewName: '観光地名',
    viewLocal: '所在地',
    viewAddress: '観光地住所',
    viewPicture: '観光地の写真',
    viewRemark: '観光地の備考',
    viewTelephone: '観光地の電話番号',
    payOrder: '予約を支払う',
    jtrpayOrder: 'jtr決済予約',
    jtrAppend: 'jtr追加予約',
    operated: '操作',
    productSource: '商品所属元',
    searchType: '検索の種類を選択',
    searchType1: '予約番号',
    searchType2: '商品名',
    searchType3: 'お客様名前',
    searchType4: '',
    searchType5: 'お客様メールアドレス',
    searchType6: 'チャネル番号',
    searchType7: 'タグ',
    system1: 'EASYGOシステム',
    system2: '2cycleシステム',
    system3: '乐天系统',
    productConfirmType: '確認方法',
    reserve: '予約',
    isOnlinePay: '支払い方法',
    startDate: '観光始め時間',
    maxNum: '最多注文量',
    minNum: '最少受け入れ人数',
    startNum: '最低注文量',
    isExpress: '宅便は可能かどうか',
    yesExpress: '支持',
    noExpress: '支持しない',
    expressPrice: '宅便料金',
    priceStartDate: '価格開始時間',
    priceEndDate: '価格終了時間',
    priceDate: '価格開始/価格終了',
    soldNum: '販売数',
    soldNumSort: '販売数',
    ticketCount: '売上数',
    sourceType: 'ソース',
    sourceType1: 'JPH施設',
    sourceType2: 'JTR施設',
    sourceType3: 'KLOOK施設',
    supplySourceType1: 'JPH商品',
    supplySourceType2: 'JTR商品',
    supplySourceType3: 'KLOOK商品',
    supplySourceType4: '2CYCLE商品',
    supplySourceType5: 'LINK',
    haveNoReserve: '売り切れ',
    upTime: 'オンライン時間',
    productReserve: '商品予約',
    pictureDown: '写真素材ダウンロード',
    voideDown: '動画素材ダウンロード',
    fileDepot: 'ファイル倉庫',
    takeView: '観光地',
    productNumber: '商品番号',
    supplier: 'サプライヤー',
    operator: '運営者',
    useFate: '利用手順',
    supplement: '利用手順補充',
    supplements: '利用手順補充',
    ticketTypeName: 'チケットタイプ',
    isOnlinepay: '決済方法',
    num: '件',
    nums: '件',
    num01: '件',
    money: '￥',
    serviceLanguage: '対応言語',
    productPeople: '年齢制限など',
    takeTimeDesc: '営業時間説明',
    productUpTime: '商品販売期間',
    diningTime: '利用時間帯',
    diningPeople: '利用人数',
    useTime: '利用時間',
    trafficMethod: 'アクセス',
    moneyContant: '料金に含まれる',
    moneyNotContant: '料金に含まれない',
    priceOrFloat: '価格/在庫',
    diningDescription: '商品内容',
    picture: '写真',
    titles: 'タイトル',
    numberBuy: '数量',
    reserveDescription: '予約説明',
    beforeDay: '何日前',
    minteBefore: '何分前に予約',
    usingDate: '有効期間',
    canBeUseDate: '有効期限',
    canBeUseDate1: '有効期限',
    returnMethod: '返金設定',
    returnDescription: '返金説明',
    reserveNotice: '予約注意事項',
    importantNote: 'ご注意',
    userNote: '使用説明',
    changeMethod: 'チケット引換及びカウンター',
    comnicationPeople: '連絡先',
    contionMen: '連絡係',
    telphone: '連絡方法',
    welcomeData: '対応時間',
    productDescription: '商品説明',
    dangerConcationMen: '緊急連絡先',
    productPackageContainDetail: 'セット商品詳細情報',
    productPackageDetail: 'セット商品詳細',
    productContainDetail: '商品詳細情報',
    SIMSize: 'SIMカードサイズ',
    netCover: 'カバー範囲',
    threeGNetCover: '3G通信量',
    fourGNetCover: '4G高速通信量',
    parts: '部品',
    SIMProductDetail: 'SIMカード商品詳細情報',
    WIFIProductDetail: 'wifi商品詳細情報',
    tourProductDetail: '1Day観光/数泊の商品詳細情報',
    ticketProductDetail: 'チケット情報',
    packageProductDetail: 'お得セット商品情報',
    freeTourDetail: '自由ツアー情報',
    routeDetail: '路線情報',
    advanceDetail: '前売り情報',
    toursTime: '行程時間数',
    travelStyle: '行程種類',
    trafficStyle: '交通機関',
    startCourtyOrEnd: '出発都市/目的地',
    jtrPeopleNum: '商品に含む成人数 ',
    jtrChildrenNum: '商品に含む子供数',
    peopleNum: '催行最小人数',
    buyMessage: 'ショッピング情報',
    tourDetail: 'コース詳細',
    giveClass: '無料キャンペーン',
    trafficProductDetail: '交通商品詳細情報',
    ybProductDetail: '夜行バス商品詳細情報',
    // takePomStyle: '1.引換方法',
    takePomStyle: '',
    longWord: '予約が成功な場合、プラットフォームより指定されたメールアドレスに予約成功のメールを送信する。そのメールにある認証コード又はQRコードを下記カウンターに提示し、実物券を引換してください。',
    // canBeTakePom: '2.引換可能カウンター',
    canBeTakePom: '',
    counterLink: '引換カウンター',
    orderMessages: '新しい連絡',
    saleTimes: '営業時間',
    telphoneCommicta: '連絡先電話番号：',
    jtrOrderVaildType0: 'お客様の指定利用日当日のみ有効',
    jtrOrderVaildType1: 'お客様の予約日延期',
    jtrOrderVaildType2: '游客预订日期截止到',
    jtrOrderVaildType3: 'お客様の指定利用日延期',
    jtrOrderVaildType4: '游客选定日期截止到',
    orderVaildType0: '指定日当日のみ有効',
    ordervaildType12: '予約日から',
    ordervaildType1: '日以内に有効',
    ordervaildType2: '予約日から指定日',
    ordervaildType3: '有効',
    ordervaildType4: '指定利用日から',
    ordervaildType5: '指定利用日から指定日',
    ordervaildType55: '指定利用日から指定日',
    ordervaildType6: '指定日',
    ordervaildType7: 'から',
    ordervaildType8: '以内有效',
    ordervaildType9: '指定利用日の',
    ordervaildType10: '日前から指定利用日の',
    ordervaildType11: '日まで有効',
    ordervaildType13: '日以内に有効',
    ordervaildType14: '有効',
    ordervaildType15: '以内有效',
    orderRefundType0: '変更キャンセル不可',
    orderRefundType1: '利用前いつでもキャンセル可能',
    orderRefundType4: '利用日',
    orderRefundType5: '日前は返金可能',
    orderRefundType3: '期限切れなので、キャッシュバックできない！',
    orderRefundType7: '予約は返金不可能です！',
    orderRefundType6: '未支払い予約は返金できません',
    eleDetail: '電子チケット詳細',
    jtrticketDetail: 'チケット商品情報',
    entityDetail: '実物券詳細',
    experienceDetail: '体験詳細',
    detail3: 'ツアー詳細',
    detail4: 'WI-FI詳細',
    detail5: 'SIMカード詳細',
    detail6: 'レストラン詳細',
    detail7: '交通詳細',
    detail8: 'お得セット詳細',
    eleDetailPreview: '電子チケットのプレビュー',
    entityDetailPreview: '実物券のプレビュー',
    experienceDetailPreview: '体験のプレビュー',
    tourPreview: '1Day観光/数泊のプレビュー',
    wifiPreview: 'WIFI商品プレビュー',
    simPreview: 'SIMカード商品プレビュー',
    diningPreview: 'レストラン商品プレビュー',
    trafficPreview: '交通商品プレビュー',
    packagePreview: 'セット商品プレビュー',
    spread: '枚',
    diningDetail: 'レストラン商品詳細',
    diningDetailPreview: 'レストランのプレビュー',
    orderStatus: '予約状態',
    floatPrice: '浮动价格',
    ifOnLine: '販売状態',
    onLine: 'オンライン',
    isEdit: 'オンライン待ち',
    offLine: 'オフライン',
    SalesSituation: '販売状況',
    orderNum: '件',
    copyOperating: 'コピー',
    graphicEditing: '图文编辑',
    revoke: '審査キャンセル',
    modify: '編集',
    jtrModifylanguage: '多言語編集',
    more: 'その他',
    distributionAuthorization: '販売権設定',
    specialPrice: '特別価格設定',
    specialPriceSet: 'AGT特別価格設定',
    distributionRange: '販売権の範囲の設定',
    distributionRangeAll: '全てのAGTが販売可能',
    distributionRangeYes: '指定AGTのみ販売可能',
    distributionRangeNo: '指定AGT以外は販売可能',
    merchantRangeAll: '全てのAGT',
    merchantRangeYes: '指定AGT',
    merchantRangeNo: '指定AGT以外',
    specifiedRange: '指定範囲',
    account: 'ID',
    PDFSendWay: 'PDF送付方法',
    PDFOnLine: 'オンライン',
    PDFOffLine: 'オフライン',
    connectInformation: '連絡先',
    dialogCancel: 'キャンセル',
    dialogSure: '確認',
    dialogSave: '上書き保存',
    selectProCategory: '追加したい商品の種類を選択してください',
    ticketsMessage: 'QRコードにより直接入場/利用する施設のチケット。',
    ticketsMessage2: '指定場所でQRコードにより実物券と引換し、利用する施設のチケット。',
    ticketsMessage3: 'QRコードにより現地での引換、もしくは直接入場/利用する施設のチケット。',
    ticketsMessage4: 'バスツアー、チャーター商品',
    ticketsMessage5: 'ポケットWi-Fi商品',
    ticketsMessage6: 'プリペイドカード商品',
    ticketsMessage7: '席予約、コース料理予約商品',
    ticketsMessage8: '交通券、チャーター商品',
    ticketsMessage9: 'お得な組み合わせ商品',
    ticketsMessage10: '夜行バス商品',
    serialNumbers: '番号',
    belongArea: '地域',
    connectWay: '連絡先',
    purchasingSituation: '購入状況',
    proStatus: '商品状態',
    ifOnlineStatus: '販売状態',
    today: '本日利用は予約可',
    tomorrow: '明日利用は予約可',
    oldPassword: '現在のパスワード',
    newPassword: '新しいパスワード',
    checkPassword: 'パスワードの再確認',
    limitDay: 'その他',
    limitDays: 'その他',
    auditCannot: '審査失敗理由：',
    notMust: '制限なし',
    breakfast: '朝食',
    lunch: '昼食',
    afternoonTea: 'アフタヌーンティー',
    dinner: '夕食',
    buffet: '自助餐',
    bus: '班车',
    caddie: '球童',
    cart: '高尔夫球具车',
    overnight_accommodation: '住宿一晚',
    play_early: '提前玩',
    play_through: '优先玩',
    play_through_am: '上午优先玩',
    play_through_pm: '下午优先玩',
    nightSnack: '夜食',
    singleMeal: 'シングルセット',
    doubleMeal: 'ダブルセット',
    thirdMeal: '3~4人分',
    fiveMeal: '5~10人分',
    tenMeal: '10人以上',
    haveMustData: '具体的な時間帯',
    common: '合わせて',
    species: '種類',
    dayBefore: '日前',
    applyToRefund: '(ローカル時間)前までに返金申請可',
    updateNotAudited: '審査失敗理由を編集',
    pleaseEnterAudited: '審査失敗の理由を入力してください',
    updateSuccess: '更新できました！',
    updateFliture: '更新に失敗しました！',
    submitError: '審査に送信する時にエラーが発生しました。もう一度お試しください。',
    letterCounter: '返却カウンター',
    car: '自動車',
    tram: '電車',
    cruise: 'クルーズ',
    tourDetailTemp: 'コース詳細',
    auditingProductNum: '審査待ちの商品数',
    productNum: '商品数',
    orderSum: '予約数',
    payBySupplierNum: '取引額',
    balanceNum: '残高',
    productOrderNum: '商品数',
    distritorNum: 'AGT数',
    supplierNum: '施設数',
    urgentNum: '緊急予約',
    confirmNum: '確認済み予約',
    unpassNum: '再度審査必要な商品',
    beConfirmNum: '確認待ち予約',
    cancelingNum: '取消待ち予約',
    unPaymentNum: '未支払い予約',
    cancelingOrder: 'キャンセル中予約',
    becancelOrder: 'キャンセル済み予約',
    auditingProduct: '審査待ち商品',
    supplierAuditing: '審査待ち施設',
    distributorAuditing: '審査待ちAGT',
    notice: '通知',
    releaseNotice: '通知発信',
    haveNotNotice: '新しい通知はありません！',
    unRead: '未読',
    readed: '既読',
    unReadNotice: '未読通知',
    noticeDetail: '通知詳細',
    messageStart: 'このメッセージは',
    messageMiddle: 'から有効になる。管理者は',
    messageEnd: 'からこのメッセージを発信しました。',
    country: '国',
    province: '都道府県',
    city: '市',
    area: '地域',
    year: '年',
    month: '月',
    one: '月',
    two: '火',
    three: '水',
    four: '木',
    five: '金',
    six: '土',
    seven: '日',
    buyPrice: '卸価格',
    selectSupplier: 'サプライヤーを選択する',
    updloadFiles: 'データアップロード：',
    pleaseChange: '選択してください',
    auditMessageEnter: '予約情報入力',
    auditMessageEnter1: '予約情報入力',
    enterAmount: '数',
    pleaseEnterProductAmount: '購入数を入力してください',
    endSlary: '清算金額(JPY)',
    endTotalAmount: '金額合計',
    ridePlace: '乗車位置',
    getOnTheTrain: '乗車地点',
    onTrainTime: '乗車時間',
    choseUpPlace: '乗車地点を選択してください。',
    choseDownPlace: '降車地点を選択してください。',
    getDownTheTrain: '降車地点',
    downTrainTime: '降車時間',
    orderMessageByMe: '予約内容',
    confirmEmail: '予約内容送信用E-mail',
    aboutTipMessage: '予約ご本人様、または貴社担当者様のメールアドレスをご記入ください。決済後予約内容とともに電子バウチャーが送信されます。',
    aboutOrderLanguageType: '確認メール用言語選択',
    aboutChangeData: '日付選択',
    travler: 'お客様',
    mainTravler: '代表者',
    travlerName: 'お客様名前',
    travlerPhone: 'お客様携帯電話',
    customerEmail: 'メールアドレス',
    customerWechat: 'Wechat',
    customerPassport: 'パスポート',
    customerSex: '性別',
    orderByMessage: 'その他',
    orderExplain: '予約説明',
    productUseData: '利用流れ',
    canBeTaken: '引換可能カウンター',
    mustBeComplate: 'パスポートチェックインが必要な施設様（ご予約の場合）では必ずフルネームをご入力ください',
    productCanBeReciveTo: 'この製品はお客様にSMSかメールを送付しますから、携帯番号又はメールアドレスをせめて一つ記入してください(中国大陸の携帯でない場合、メールアドレスをお願いします)。',
    submitOrder: '予約送信',
    nowPages: '現在の商品',
    travlerEmail: 'お客様のメールアドレス',
    travlerWebchat: 'お客様のWechat',
    travlerPassport: 'パスポート',
    travlerAddress: '宅便アドレス',
    travlerPostCode: '郵便番号',
    travlerCreditType: '証明書',
    travlerCreditNo: '証明書番号',
    travlerSex: 'お客様の性別',
    mustToWrite: '必須',
    notMustToWrite: '非必須',
    orderStatus0: '予約作成',
    orderStatus1: '予約送信',
    orderStatus2: '予約取消（AGT）',
    orderStatus3: '注文取消（サプライヤー）',
    orderStatus4: '予約確認',
    orderStatus5: '利用済み予約',
    orderStatus6: '未支払いで取消された予約',
    orderStatus7: '予約できない',
    orderStatus8: '予約の取消を確認',
    orderStatus9: '予約の取消を断る',
    orderStatus10: '自動で予約を確認',
    orderStatus11: '自動で予約を完成',
    orderStatus12: '自動で予約を取消',
    orderStatus13: 'タイムアウトで注文が自動的に取消します',
    orderStatus14: '返金申請',
    orderStatus15: '返金確認',
    orderStatus16: '返金拒む',
    orderStatus17: '予約認証済み',
    orderStatus18: '予約確認済み',
    orderStatus19: '管理者特殊キャンセル',
    orderStatus20: 'パス券片方キャンセル',
    orderStatus21: '自動で有効期切れ予約を処理',
    orderStatus22: '接続先APIキャンセル',
    orderStatus23: 'システム片方キャンセル',
    notPaymentTag: '未支払いで取消',
    travelsSelectData: 'お客様が指定した日付前',
    jtrOrderRefund0: '利用日付前',
    jtrOrderRefund1: '利用日付後',
    jtrOrderRefund2: '日返金可能',
    jtrOrderRefund3: '当日可退',
    jtrOrderRefund4: '日返金可能',
    day: '日',
    ticketPrice: '',
    refundPayment: '返金手数料率 :',
    cancelCannot: '取消の理由',
    refundCannot: '返金理由',
    cancelOrRefund: '拒否の理由',
    cancelReason: '取り消し理由',
    admin: '管理者',
    clerk: 'スタッフ',
    refuseCannot: '拒否の理由',
    updateTime: '更新時間',
    counterDetails: 'カウンター詳細',
    applyDate: '申請日時',
    pleaseIntoCancelReason: '拒否の理由を入力してください',
    pleaseIntoCancelCannot: '取消の理由を入力してください',
    pleaseIntoInfo: '文字を入力してください',
    applyType: {
      applyType0: 'AGT',
      applyType1: '施設',
      applyType2: '管理者',
      applyType3: 'スタッフ',
      applyType4: '其の他'
    },
    adminAccount: {
      createUser: '権限追加',
      roleName: '権限名',
      createRoleName: '権限名',
      account: '所属ID',
      applyType: '適用する種類',
      isEnable: '有効にするか',
      enable: '有効化',
      disable: '無効化',
      roleDistribution: '権限',
      roleManager: '権限追加',
      authMenu: '権限一覧',
      checkAll: '全て選択'
    }
  },
  viewMessage: {
    message1: '保存しますか？',
    message2: '観光地名を入力してください。',
    hotCity_message2: '目的地名を入力してください。',
    hotCity_message19: '1〜200文字以内で入力してください。',
    hotCity_remark_placeholder: '備考を入力してください。',
    banner_save_success: 'Banner saved successfully!',
    banner_save_error: 'Failed to save banner!',
    message3: '観光地の住所を入力してください。',
    message4: 'おすすめ',
    message5: '保存しますか？',
    message6: '保存しますか？',
    message7: '保存しますか？',
    message8: '観光地のロケーションを選択してください。',
    message9: '3から50文字以内。',
    sysError: 'システムエラー',
    revokeMessage: 'この操作により審査が撤回されますが、継続しますか？',
    revokeSuccess: '審査申請キャンセル済み',
    revokeHavePassed: 'この商品は既に審査に通過されたため申請キャンセルできません',
    revokeHaveNotPassed: 'この商品は審査に通過できなかったため、撤回操作はできません。新規申請を提出してください！',
    revokeOperationCanceled: '審査の撤回が取消されました！',
    offLineMessage: 'この操作により商品をオフラインされますが、継続しますか？',
    offLineSuccess: '販売停止できました',
    offLineOperationCanceled: '販売停止操作がキャンセルしました。',
    onLineSuccess: '販売開始できました',
    onLineMessage: 'この操作により商品をオンラインされますが、継続しますか？',
    deleteMessage: 'この操作により当該商品が完全に削除されますが、継続しますか？',
    deleteMessageOrder: 'この操作により当該注文が完全に削除されますが、継続しますか？',
    deleteSuccess: '削除できました！',
    deleteOperationCanceled: '削除が取消されました！',
    thisRangeNotEmpty: '当該指定範囲内では販売店が空白にしてはいけません！',
    thisPriceRangeNotEmpty: '販売店のAGT仕入価格授権は空白にしてはいけません！',
    thisPriceRangeNotNum: '数字を入力してください！',
    editSuccess: '編集ができました！',
    pleaseDeletePackageProduct: '先にパッケージ商品を削除してください。又はパッケージ商品の中から当該商品を削除してください！',
    upToLine: 'この操作が完了後に、商品はオンラインされますが、継続しますか？',
    newToUse1: 'この操作が完了後に、製品のバッチ状態が終了になりますが、続けますか?',
    newToUse0: 'この操作が完了後に、製品のバッチ状態が正常になりますが、続けますか?',
    fileToDelete: 'この操作が完了後に、このファイルベースは完全に削除されますが、継続しますか？',
    useSuccess: '操作が成功した',
    useFail: '操作が取消された',
    holdSuccess: '保存できました！',
    holdError: '保存は失敗しました！',
    maxDay: '一回の設定につき、上限は十年間のデータのみ',
    submitSuccess: '送信できました！',
    submitSuccessconfirmed: '送信成功！確認まで少々お待ちください！',
    submitError: '送信に失敗しました！',
    balanceNotDone: 'ご利用のアカウントの残高が足りませんので、チャージしてから今回の注文を完成させてください。',
    balanceDone: '支払完了。',
    cancelDone: 'ご注文の取消申請は送信されました。販売店の対応をお待ち下さい。',
    cancelDone2: '取消申請及び返金が成功しました!このページをリフレッシュしてご確認ください',
    cancelDone3: '返金申請は送信しました、処理完了までをお待ちください',
    cancelError: '残高が足りないため、現在注文を取消できません。',
    cancelError1: '系统异常，请联络管理员',
    message10: '編集した内容を保存しますか？',
    lable1: 'キャンセル',
    lable2: '保存しない',
    lable3: '保存',
    message11: '3から50文字以内。',
    message12: '国籍を選択してください',
    message13: '地区を選択してください',
    message14: '3から50文字以内。',
    message15: '基本情報に記入されていない必須項目があります',
    message16: '編集を廃棄しますか？',
    message17: '観光地は利用中ですから、削除できません！',
    confirmDone: '確認できました',
    tipMessage1: 'ユーザの備考を入力してください。',
    tipMessage2: '入力の長さは255ケタを超えないように',
    tipMessage3: 'ユーザ名を入力してください。',
    tipMessage4: '入力の長さは100ケタを超えないように',
    tipMessage5: 'コミッション比率は0から100の整数しか入力できません',
    messageNotCompleteIn: '記入されていない必須項目があります',
    orderStatusHadUpdate: '注文情報が更新済み',
    orderRefundFalse: '予約返金の申請が失敗しました',
    message18: '0から500文字以内。',
    message19: '3から500文字以内。',
    message20: '当該種類は期間中に既に存在しています',
    cleckOrder: '予約を認証しますか',
    cleckOrderCanceled: '認証をキャンセルしました',
    cleckSucc: '認証成功'
  },
  counterMessage: {
    counterName: 'カウンター名',
    counterAddress: 'カウンター住所',
    counterTelephone: 'カウンターの電話番号',
    busineTime: '営業時間',
    counterPic: 'カウンターの写真',
    lable1: 'キャンセル',
    lable2: '保存しない',
    lable3: '保存',
    message1: 'カウンター名を入力してください',
    message2: 'この操作により当該カウンターの内容はすべて削除されますが、継続しますか？',
    message3: '削除できました',
    message4: '利用中のため、削除できません',
    message5: 'カウンター写真をアップロード',
    message6: '編集内容を保存しますか？',
    message7: 'カウンター名前を入力してください',
    message8: 'カウンター住所を入力してください',
    message9: 'カウンターの電話番号を入力してください',
    message10: '正確なカウンターの電話番号をを入力してください',
    message11: '長さは6から500ケタまでにしてください',
    message12: 'カウンターの接待時間を入力してください',
    message13: '保存できませんでした',
    message14: '保存できました',
    message15: '編集内容を廃棄しますか？',
    message16: '長さは1から500ケタまでにしてください'
  },
  liaisonMessage: {
    liaisonName: '名前',
    liaisonTelephone: '連絡先',
    receptionTime: '対応時間',
    message1: '連絡先の名前を入力してください',
    message2: '連絡先の電話番号を入力してください',
    message3: '連絡先の接待時間を入力してください',
    message4: '削除しますか？',
    message5: '削除できました',
    message6: '利用中のため、削除できません',
    message7: '編集内容を保存しますか？',
    message8: 'キャンセル',
    message9: '保存しない',
    message10: '保存',
    message11: '保存できませんでした',
    message12: '編集内容を廃棄します？',
    message13: '保存できませんでした',
    message14: '保存できました'
  },
  registerMessage: {
    directorWechatComment: '弊社からの案内等をスピーディーにこなうため、こちらの利用を推薦しています。詳しくは別途配布しているマニュアルをご確認ください。',
    supplierRegister: '出店登録',
    distributorRegister: 'AGT登録',
    accountInfo: 'アカウント情報',
    companyInfo: '会社情報',
    mainBusiness: '主の業務内容（選択した業務内容によって、適合な商品をお勧めします）',
    mainBusiness1: '主の業務内容',
    saleType: '販売ルート',
    trafficCardTicket: '交通券',
    carFree: 'レンタカー/送迎バス',
    admissionToThePark: '電子チケット',
    foodAndBeverage: 'レストラン',
    oneDayTour: 'DAYツアー',
    daysTour: 'ツアー',
    characteristicExperience: '体験',
    hotel: 'ホテル',
    physicalShop: '実店舗',
    fzShop: 'Fliggy',
    mfwShop: 'マーフォンウォー',
    tbShop: '淘宝（タオバオ）',
    xcShop: 'CTRIP',
    tcShop: 'Tongcheng',
    qneShop: 'Qunar.com',
    tnShop: 'Tuniu',
    cupang: 'cupang',
    gmarket: 'gmarket',
    entry: '入力してください',
    directorInfo: '業務責任者情報',
    account: 'ログインID',
    password: 'パスワード',
    passwordConfirm: 'パスワード(再入力)',
    address: '所在地',
    companyName: '会社名',
    logo: '会社ロゴ',
    legalRepresentative: '法定代表者',
    companyAddress: '会社住所',
    companyTelephone: '会社電話番号',
    companyEmail: '会社E-mail',
    companyWebsite: '公式サイト/店舗リンク',
    bankCardNumber: '銀行口座',
    qualification: '登録認定',
    directorName: '名前',
    directorTelephone: '携帯番号',
    directorPosition: '役職',
    directorWechat: 'WechatID',
    directorCode: '招待コード',
    phDirectorCode: '招待コードを入力してください',
    directorCodeTip: '招待コードを入力すると、優先審査などの特典を受けられます',
    directorEmail: 'メールアドレス',
    directorCard: '名刺',
    phAccount: 'ログインIDを入力してください',
    phPassword: 'パスワードを入力してください',
    phPasswordConfirm: 'もう一度パスワードを入力してください',
    phCompanyName: '会社の正式な登録名を記入してください',
    phLogo: '会社のLogoをアップロード',
    phLegalRepresentative: '会社の法定代表者を入力してください',
    phCompanyAddress: '会社の住所を入力してください',
    phCompanyTelephone: '会社の電話番号を入力してください',
    phCompanyEmail: '会社のEメールを入力してください',
    phCompanyWebsite: '会社の公式サイト（又はその他プラットフォームにある店舗のリンク）を入力してください',
    phBankCardNumber: '会社の口座情報を入力してください',
    phQualification: '会社の登録書類（登記簿謄本など）をアップデート',
    phDirectorName: '業務責任者の名前を入力してください',
    phDirectorTelephone: '業務責任者の携帯番号を入力してください',
    phDirectorPosition: '業務責任者の職位を入力してください',
    phDirectorWechat: '業務責任者のWechat番号を入力してください',
    phDirectorEmail: '業務責任者のメールアドレスを入力してください',
    phDirectorCard: '業務担当者の名刺画像をアップロードしてください',
    submitResigt: '申请',
    message1: '6-16ケタの英文字(大、小)又は数字を入力してください',
    message2: 'ご記入の口座情報が間違えないように確認してください！',
    message3: 'パスワードを入力してください',
    message4: '正確なパスワードを入力してください',
    message5: '制限文字数は6文字から16文字まで',
    message6: 'もう一度パスワードを入力してください',
    message7: '二回入力されたパスワードが一致しません！',
    message8: '正確なパスワードを入力してください',
    message9: '国籍を選択してください',
    message10: '正式な登録会社名を入力してください',
    message11: '長さは6から200ケタまでにしてください',
    message12: '会社のLogoをアップロードしてください',
    message13: '会社の法定代表者を入力してください',
    message14: '長さは2から200ケタまでにしてください',
    message15: '詳細な会社の住所を入力してください',
    message16: '長さは10から200ケタまでにしてください',
    message17: '会社の電話番号を入力してください',
    message18: '正確な電話番号を入力してください',
    message19: '制限文字数は4文字から20文字まで',
    message20: '会社のEメールを入力してください',
    message21: '正確な会社のE－mailを入力してください',
    message22: '長さは7から50ケタまでにしてください',
    message23: '会社の資格・認定をアップロードしてください',
    message24: '制限文字数は4文字から300文字まで',
    message25: '会社の銀行口座を入力してください',
    message26: '正確な会社の銀行口座を入力してください',
    message27: '制限文字数は10文字から100文字まで',
    message28: '会社の資格・認定をアップロードしてください',
    message29: '業務責任者の名前を入力してください',
    message30: '制限文字数は2文字から50文字まで',
    message31: '携帯番号を入力してください',
    message32: '正しい携帯番号を入力してください',
    message33: '長さは6から20ケタまでにしてください',
    message34: '役職を入力してください',
    message35: '制限文字数は2文字から50文字まで',
    message36: 'Wechat番号を入力してください',
    message37: '長さは6から50ケタまでにしてください',
    message38: '業務担当者の名刺画像をアップロードしてください',
    message39: '登録に送信しますか？',
    message40: '登録できました',
    message41: '登録できませんでした',
    message42: 'IDを入力してください',
    message43: '制限文字数は6文字から30文字まで',
    message44: 'このIDは既に存在します',
    message45: 'メールアドレスを入力してください',
    message46: '長さは5から50ケタまでにしてください',
    message47: '正しいメールアドレスを入力してください',
    message48: 'このメールアドレスは既に登録されました',
    message49: '登録を廃棄しますか？',
    message50: '主の業務内容を選択してください、複数選択可能',
    message51: '販売ルートを選択してください、複数選択可能',
    message52: 'その他を選択された場合、内容を入力してください',
    message53: '制限文字数20文字まで'
  },
  menu: {
    sysHome: 'トップページ',
    product: '商品管理',
    productList: '商品管理',
    releaseProducts: '新規作成',
    releaseThirdProducts: '发布第三方产品',
    supplyManageProduct: '商品販売管理',
    importThirdSystemProduct: '商品導入管理',
    conciseEticket: '電子チケットを発売します',
    conciseTicket: 'チケットを発売します',
    conciseTravel: '旅行商品を発売します',
    conciseWifi: 'WiFi商品を発売します',
    conciseSIM: 'SIM商品を発売します',
    conciseDining: '食事商品を発売します',
    conciseTransport: '交通商品を発売します',
    conciseDiscount: 'パッケージ商品を発売します',
    conciseSetMeal: '新規作成（セット商品）',
    conciseExperience: '新規作成（入場/体験）',
    productAuditing: '商品審査',
    addBusFlag: '夜行バス商品新規作成',
    orderManagement: '予約管理',
    orderManagementC: 'C端子管理',
    operatorOrderManagement: '予約管理',
    operatorOrderMagnToC: 'ToC予約管理',
    operatorOrderManagement_chargeback: '予約取り消し権限',
    reserve: '商品予約',
    distriOrderMagn: '予約管理',
    disTocOrderManagement: 'ToC予約管理',
    bulkPurchaseList: '一括購入管理',
    tocDistributorManageProduct: 'ToC商品販売管理',
    distriOrderMagnToC: 'ToC予約管理',
    applyDistribution: 'ToC審査',
    revenueManagement: 'ToCエージェント管理',
    revenueDetail: 'ToC収益管理',
    applyCash: 'ToC現金引き出し管理',
    operatApplyCash: 'ToC現金引き出し管理',
    coupon: 'ToCクーポン管理',
    pinTicketMagn: '認証出庫管理',
    ticket: '実物券在庫管理',
    ticketDepot: 'チケット在庫管理',
    warehouse: '倉庫管理',
    userDepot: 'ユーザ倉庫管理',
    pinTicket: '認証出庫',
    pdfTicket: '電子チケット在庫管理',
    pdfFiles: 'PDFファイルベース管理',
    shopManage: 'ユーザー管理',
    distributor: 'AGT管理',
    supplier: '施設管理',
    scenicSpot: '観光地管理',
    scenicSpotList: '観光地管理',
    finance: '精算管理',
    financeStatement: '明細',
    financeDetail: '財務明細書の詳細情報',
    ActuarialManagement: '精算管理',
    withdrawals: 'チャージ/現金引出管理',
    operatorWithdrawal: 'チャージ/現金引出管理',
    trades: '取引明細',
    record: 'チャージ/現金引出履歴',
    withdrawal: 'チャージ/現金引出',
    recharge: 'チャージ/現金引出',
    sys: 'システム管理',
    merchantInfo: '店舗情報',
    clerk: 'スタッフ管理',
    adminAccount: '権限管理',
    secondaryAgent: '二次代理店管理',
    operator: '管理者管理',
    exportRules: 'エクスポート規則管理',
    noticeManager: '通知管理',
    liaisons: '連絡先管理',
    counter: 'カウンター管理',
    pwdSet: 'パスワード設定',
    payType: '支払い方法設定',
    newOrderEmail: '新規注文メール通知設定',
    ticketDepot_ticketDepotManager: 'チケット在庫管理者',
    ticketDepot_stockManager: '在庫管理者',
    pdfFiles_stockManager: '在庫管理者',
    operatorWithdrawal_operationAuth: '財務操作権限',
    operatorWithdrawal_auditAuth: '財務審査権限',
    auditFlag: 'レビューは要らない',
    loginNotice: 'システム機能アップグレード通知（20170621）',
    recover: '初期化',
    clear: 'クリア',
    pageSetting: 'ホームページ写真設置',
    productLogList: '商品变更記録',
    popularCities: '人気目的地管理',
    banner: 'バナー管理',
    recommendedAttractions: 'ホームページ推奨管理'
  },
  login: {
    userLogin: 'ユーザログイン',
    rememberLoginStatus: '次回から入力を省略',
    forgetPassword: 'パスワードを忘れた方',
    loginIn: 'ログイン',
    register: '新規登録',
    copyRight: 'Copyright © 2019 東瀛假日',
    recordInformation: '蜀ICP備18029410号-2',
    recordInformation2: '特定商取引法',
    message1: 'ユーザ名を入力してください',
    message2: 'パスワードを入力してください',
    message3: '正しいパスワードを入力してください'
  },
  selectMerchantType: {
    imSupplier: '施設：商品登録',
    imDistributor: '旅行会社：商品購入',
    selectType: '登録種類を選択してください'
  },
  notice: {
    noticeModify: '通知を編集',
    noticeAdd: '通知を追加',
    noticeTitle: '通知のタイトル：',
    noticeContent: '通知の内容',
    noticeTitlePlaceholder: '通知のタイトルを入力してください',
    validDate: '有効期限：',
    DateSelectRange: '日付の範囲を選択',
    publicationScope: '知らせる範囲：',
    all: '全般',
    distributor: 'AGT',
    supplier: '施設',
    pulicationConfirm: '確認',
    tip: 'メッセージ',
    saveOrNot: '保存しますか？',
    notSave: '保存しない',
    save: '保存',
    message1: '3から150文字以内。',
    message2: '有効期限を選択してください',
    message3: '範囲を選択してください',
    message4: '編集を廃棄しますか？',
    message5: '基本情報に記入されていない必須項目があります',
    message6: '保存できました',
    message7: '保存できませんでした',
    message8: '削除できませんでした！',
    message9: '削除できました！',
    message10: 'この操作により、当該ファイルは完全に削除されますが、継続しますか？',
    message11: '選択される店舗は空白にしてはいけません！',
    noticeManage: '通知管理',
    noticePublication: '通知を追加',
    noticeTitle1: '通知のタイトル',
    search: '検索',
    index: '番号',
    title: 'タイトル',
    publicationScope1: '通知範囲',
    validDate1: '有効期限'
  },
  exportRules: {
    exportRuleTitle: 'エクスポート規則の管理',
    newExportRule: 'エクスポート規則を追加',
    editExportRule: 'エクスポート規則を編集',
    lableBusinessType: 'ユーザー種類',
    pageType: 'ページ種類',
    exportRuleName: 'エクスポート規則の説明',
    exportRuleRemark: 'エクスポート規則の備考',
    search: '検索',
    ruleName: '規則の名称',
    ruleRemark: '規則の備考',
    modify: '編集',
    delete: '削除',
    lable1: '全部',
    lable2: 'AGT',
    lable3: '施設',
    lable4: '商品一覧',
    lable5: '予約一覧',
    lable6: '経営者',
    lable7: '未知',
    lable8: 'エクスポート項目設定',
    lable9: '削除',
    lable10: '追加',
    lable11: 'すべての項目',
    lable12: 'エクスポート項目',
    lable13: '認証一覧',
    message1: '本当に削除しますか？',
    message2: '削除できました',
    message3: '基本規則なので、削除できません',
    message4: '規則が利用中なので、削除できません',
    message5: 'エクスポート規則の名称を入力してください',
    message6: 'エクスポート規則の備考を入力してください',
    message7: '店舗種類を選択してください',
    message8: 'ページ種類を選択してください',
    message9: '長さは3から100ケタにしてください',
    message10: '長さは3から500ケタにしてください',
    message11: '本当にリセットしますか？',
    message12: '保存できました',
    message13: '本当に編集を廃棄しますか？',
    button1: '保存',
    button2: '新規作成',
    button3: 'リセット'
  },
  clerk: {
    clerkTitle: 'スタッフ管理',
    addClerk: 'スタッフ追加',
    editClerk: '事務員編集',
    account: 'ID',
    name: '名前',
    telphone: '電話番号',
    emailAddress: 'メールアドレス',
    clerkAccount: 'スタッフのアカウント',
    clerkName: 'スタッフの名前',
    clerkPwd: 'スタッフのパスワード',
    confirmPwd: 'パスワード確認',
    clerkTel: 'スタッフの携帯番号',
    message1: 'スタッフのアカウント/名前',
    message2: '権限を選択してください',
    message3: '本当に削除しますか？',
    message4: '削除できました',
    message5: '設定完了',
    message6: 'スタッフのアカウントを入力してください',
    message7: 'アルファベット、数字、アンダーバー又はデリミターのみ入力可能、最初の文字はアルファベットで入力してください',
    message8: 'スタッフの名前を入力してください',
    message9: 'スタッフの名前は空白にしてはいけません',
    message10: 'スタッフのパスワードを入力してください',
    message11: '6-16ケタの英文字(大、小)又は数字を入力してください',
    message12: '上記入力された内容と一致しないといけません',
    message13: 'スタッフの携帯番号を入力してください',
    message14: 'スタッフのメールアドレスを入力してください',
    message15: 'メールでシステムメッセージを受信できます',
    message16: '長さは1から50ケタまでにしてください',
    message17: '正確なパスワードを入力してください',
    message18: '制限文字数は6文字から16文字まで',
    message19: '正確なパスワードを入力してください',
    message20: '保存しますか？',
    message21: '保存できました',
    message22: 'IDを入力してください',
    message23: '制限文字数は6文字から30文字まで',
    message24: '正確なアカウントを入力してください',
    message25: 'ユーザ名は既に存在しています',
    message26: 'もう一度パスワードを入力してください',
    message27: '二回入力されたパスワードは一致しません！',
    message28: '長さは5から50ケタまでにしてください',
    message29: '正しいメールアドレスを入力してください',
    message30: 'このメールアドレスは既に登録されました',
    message31: '長さは6から20ケタまでにしてください',
    message32: '正しい携帯番号を入力してください',
    message33: '編集を廃棄しますか？',
    lable1: '権限',
    lable2: '削除',
    lable3: '追加',
    lable4: '権限リスト',
    lable5: '追加済みの権限'
  },
  merchant: {
    merchantInfo: '店舗情報',
    distributorManage: '販売店管理',
    supplierManege: 'サプライヤー管理',
    all: '全部',
    waitAudit: '審査待ち',
    auditPass: '審査通過',
    auditNG: '審査失敗',
    auditNG2: '審査失敗',
    auditNGReason: '審査失敗の理由を編集',
    searchContent: '店舗名/ID',
    businessName: 'AGT名',
    createDate: '申請時間',
    auditStatus: '状態',
    auditUserName: '審査係',
    lableTodo: '処理',
    lableWatch: '詳細',
    lableAuth: '権限',
    lableExpSet: 'エクスポート設定',
    accountInfo: 'アカウント情報',
    loginAccount: 'ログイン',
    companyName: '会社名 ',
    companyLogo: '会社ロゴ',
    legalRepresentative: '代表者',
    companyAddress: '会社住所',
    companyTelephone: '会社電話番号',
    companyWebsite: '公式サイト/店舗リンク',
    companyEmail: '会社E-mail',
    bankCardNumber: '銀行口座',
    qualificationPath: '会社登録書類',
    location: '所在地',
    baseInfo: '会社情報',
    directorInfo: '業務責任者情報',
    directorName: '名前',
    directorPosition: '役職',
    directorEmail: 'メールアドレス',
    directorTelephone: '携帯番号',
    directorWechat: 'WechatID',
    directorCardPath: '名刺',
    setAuthAuditPass: '権限を設定し、審査に通過',
    selectAuth: '権限を選択してください',
    message1: '権限を選択してください',
    message2: 'エクスポート設定',
    message3: 'エクスポートページの種類',
    message4: '商品のエクスポート項目の設定',
    message5: '注文のエクスポート項目の設定',
    message6: 'エクスポート規則',
    message7: 'エクスポート規則の名称を選択してください',
    message8: 'エクスポートページの種類を選択してください',
    message9: 'エクスポート規則を選択してください',
    message10: '設定完了',
    message11: '(店舗がシステム内にある唯一のコードであり、ユーザの身分を識別に使われます)',
    message12: '販売状況のまとめ',
    message13: '総予約数',
    message14: '総注文金額',
    message15: '総発券数',
    message16: 'Depo管理',
    message17: '残高',
    message18: 'アカウントの取引日誌を閲覧',
    message19: 'チャージ/現金引出履歴',
    message20: '操作できました',
    message21: '操作に失敗しました',
    message22: '審査を放棄しますか？',
    message23: '与信設定',
    message24: '認証のエクスポート項目の設定',
    lable1: '削除',
    lable2: '追加',
    lable3: '権限リスト',
    lable4: '追加済みの権限',
    yayaPaySet: '消去アカウントを設定する',
    easyGoUser: 'サプライヤーのアカウント',
    yayaPayUser: '消去アカウント',
    pleaseEnterYayaPayUser: '消去アカウントを入力してください',
    pleaseEnterLessTen: 'アカウント数は十まで！',
    lengthMustLess100: 'アカウントの長さは1から100まで！',
    yayaAccountHadExists: '同じアカウントが登録したので、追加できない',
    yayaAccountExists: '同じアカウントが登録したので、新しいアカウントを入力してください',
    enableSwitch: '実行設定',
    lineOfCredit: '与信金額',
    creditDate: '信書の期日'
  },
  merchantInfo: {
    merchantInfo: '店舗情報',
    merchantInfoEdit: '店舗情報を編集',
    auditNG: '審査失敗',
    accountInfo: 'アカウント情報',
    auditStatus: '審査状態',
    loginAccount: 'ログイン',
    location: '所在地',
    baseInfo: '会社情報',
    companyName: '会社名',
    companyLogo: '会社ロゴ',
    legalRepresentative: '法定代表者',
    companyAddress: '会社住所',
    companyTelephone: '会社電話番号',
    companyWebsite: '公式サイト/店舗リンク',
    companyEmail: '会社E-mail',
    bankCardNumber: '銀行口座',
    qualificationPath: '資格証明書',
    supplierSummary: '販売情報のまとめ',
    orderTotal: '総予約数',
    orderTotalPay: '総注文金額',
    ticketTotal: '総発券数',
    accountBalanceInfo: '残高状況',
    accountBalance: '残高',
    seeBusinessLog: 'アカウントの取引日誌を閲覧',
    seeRechargeLog0: 'チャージ/現金日誌を閲覧',
    seeRechargeLog1: '現金日誌を閲覧',
    directorInfo: '責任者の情報',
    directorName: '名前',
    directorPosition: '役職',
    directorEmail: 'メールアドレス',
    directorTelephone: '携帯番号',
    directorWechat: 'WechatID',
    directorCardPath: '名刺',
    submitAudit: '審査提出',
    submitEdit: '訂正を送信',
    notSave: '保存しない',
    save: '保存',
    message1: '(店舗がシステム内にある唯一のコードであり、ユーザの身分を識別に使われます)',
    message2: 'ご記入の口座情報が間違えないように確認してください！',
    message3: '編集を保存しますか？',
    message4: '国を選択してください',
    message5: '正式な会社登録名を入力してください',
    message6: '長さは6から200ケタまでにしてください',
    message7: '会社のLogoをアップロードしてください',
    message8: '会社の法定代表者を入力してください',
    message9: '長さを2から200ケタまでにしてください',
    message10: '詳細な会社の住所を入力してください',
    message11: '長さは10から200ケタまでにしてください',
    message12: '会社の電話番号を入力してください',
    message13: '正しい電話番号を入力してください',
    message14: '長さは6から20ケタまでにしてください',
    message15: '会社のEメールを入力してください',
    message16: '正しいメールアドレスを入力してください',
    message17: '制限文字数は7文字から50文字まで',
    message18: '会社の公式サイトをを入力してください',
    message19: '制限文字数は4文字から50文字まで',
    message20: '会社の銀行口座番号を入力してください',
    message21: '正しい口座番号を入力してください',
    message22: '制限文字数は10文字から100文字まで',
    message23: '会社の資格・認定をアップロードしてください',
    message24: '業務責任者の名前を入力してください',
    message25: '制限文字数は2文字から50文字まで',
    message26: '携帯番号を入力してください',
    message27: '正しい携帯番号を入力してください',
    message28: '役職を入力してください',
    message29: 'Wechat番号を入力してください',
    message30: '制限文字数は6文字から50文字まで',
    message31: '業務担当者の名刺画像をアップロードしてください',
    message32: '内容を変更しますか?',
    message33: '変更できました',
    message34: '変更できませんでした',
    message35: 'メールアドレスを入力してください',
    message36: '制限文字数は5文字から50文字まで',
    message37: '正しいメールアドレスを入力してください',
    message38: 'このメールアドレスは既に登録されました'
  },
  secondaryAgent: {
    secondaryAgentTitle: 'セカンダリーエージェントです',
    message1: '名前を入力してください',
    search: '検索',
    name: '名前',
    time: '登録日時',
    remark: '備考',
    label: '解綁',
    addCode: '招待コードを生成',
    copySuccess: 'コピー成功',
    copyError: 'コピー失敗',
    operator: '備考を編集',
    remarkTip: '備考を入力してください',
    message2: '編集成功しました',
    message3: '編集失敗しました',
    message4: '解綁成功しました',
    message5: '解綁失敗しました'
  },
  errorMsg: {
    user: {
      noAuth: 'ユーザ様の権限が足りません。スステム管理者に連絡してください',
      systemMsg: 'システムエラー',
      noUserOrPassword: 'IDまたはパスワードが正しくありません',
      setUsernameOrPassword: 'IDとパスワードを入力してください'
    }
  },
  operator: {
    jtrOrderReimburse: 'システム片方キャンセル',
    operatorManege: '管理者管理',
    addOperator: '管理者追加',
    updateOperator: '管理者変更',
    updatePwd: 'パスワード変更',
    updateInfo: '編集',
    auth: '権限',
    searchText: '管理者のID/名前',
    account: 'ID',
    name: '名前',
    opearate: '操作',
    opeAccount: '管理ユーザー',
    opeName: '管理者の名前',
    opePwd: 'パスワード',
    opeNewPwd: '管理者の新しいパスワード',
    checkPwd: 'パスワード確認',
    lable1: '削除',
    lable2: '追加',
    lable3: '権限リスト',
    lable4: '追加済みの権限',
    message1: '権限を選択してください',
    message2: '本当に削除しますか？',
    message3: '削除できました',
    message4: '設定完了',
    message5: '管理者ユーザーを入力してください',
    message6: 'アカウントはアルファベット、数字、アンダーバー又はデリミターのみにより構成され、しかも先頭文字はアルファベットにしないといけません',
    message7: '管理者の名前を入力してください',
    message8: '管理者の名前は空白にしてはいけません',
    message9: 'パスワードを入力してください',
    message10: '6-16ケタの英文字(大、小)又は数字を入力してください',
    message11: '上記入力された内容と一致しないといけません',
    message12: '制限文字数は1文字から50文字まで',
    message13: '制限文字数は6文字から16文字まで',
    message14: '正確なパスワードを入力してください',
    message15: '保存しますか？',
    message16: '保存できました',
    message17: 'IDを入力してください',
    message18: '制限文字数は6文字から30文字まで',
    message19: '正しいIDを入力してください',
    message20: 'このIDは既に存在します',
    message21: 'もう一度パスワードを入力してください',
    message22: '二回入力されたパスワードは一致しません！',
    message23: '編集を廃棄しますか？'
  },
  product: {
    rule_0_500: '制限文字数は0文字から500文字まで',
    rule_0_5000: '制限文字数は0文字から5000文字まで',
    rule_1_200: '制限文字数は1文字から200文字まで',
    rule_1_2000: '制限文字数は1文字から2000文字まで',
    rule_1_500: '制限文字数は1文字から500文字まで',
    rule_0_200: '制限文字数は0文字から200文字まで',
    rule_0_2000: '制限文字数は0文字から2000文字まで',
    rule_0_50: '制限文字数は0文字から50文字まで',
    rule_0_1_500: '制限文字数は0文字から500文字まで',
    rule_1_50: '制限文字数は1文字から50文字まで',
    rule_0_20: '制限文字数は0文字から20文字まで',
    rule_n1_2: '制限文字数は1文字から2文字まで',
    rule_n1_4: '制限文字数は1文字から4文字まで',
    rule_n1_6: '制限文字数は1文字から6文字まで',
    rule_n0_2: '制限文字数は0文字から2文字まで',
    rule_n0_5: '制限文字数は0文字から5文字まで',
    rule_n0_6: '制限文字数は0文字から6文字まで',
    rule_mail: 'メールの内容を入力してください',
    integer_1: '整数を入力してください',
    integer_2: '正の整数を入力してくだい',
    selDate: '日付を選択',
    back: '戻る',
    ticketType_1: '連携されたeチケット保有在庫から自動発行',
    ticketType_3: '各予約でバウチャーを手動アップロード',
    ticketType_4: 'EasyGoバウチャーをシステムで自動発行',
    choose_sys: 'システムを選択：',
    chooseDepot: '倉庫を選択',
    baseInfo: '基本情報',
    content: '商品の内容',
    priceSet: '価格設定',
    reserveSet: '予約設定',
    saveDraft: '下書きに保存',
    preview: 'プレビュー',
    submitCheck: '商品アップ申請',
    submitAuditAndPass: '確認',
    isExitProduct: '編集した内容を破棄してもよろしいですか',
    isSaveDraft: '下書きを保存しますか？',
    noSave: '保存しない',
    save: '保存',
    add: '追加',
    edit: '編集',
    product_0: '商品 (電子チケット)',
    product_1: '商品 (切符)',
    product_2: '商品 (体験)',
    product_3: '商品 (日帰り/数泊)',
    product_4: '商品 (WIFI)',
    product_5: '商品 (SIMカード)',
    product_6: '商品 (レストラン)',
    product_7: '商品 (交通)',
    product_8: '商品 (セット)',
    doNotSave: '内容がかわっていないため、保存する必要がありません',
    reqMsg_1: '審査に送信できました',
    reqMsg_2: '保存できました',
    reqMsg_3: '審査に送信できませんでした！',
    reqMsg_4: '保存できませんした！',
    reqMsg_5: '審査に送信する際にエラーが発生しました。もう一度お試しください。',
    reqMsg_6: '保存できませんでした。もう一度お試しください。',
    reqMsg_7: '当セットには子商品が追加されていません！',
    reqMsg_8: 'おめでとうございます，審査通過しました',
    reqMsg_9: '残念ですが，審査失敗しました！',
    reqMsg_10: '残念ですが，審査中にエラーが発生，もう一度お試してください！',
    reqMsg_11: '商品インポート失敗、再執行してください。',
    reqMsg_12: 'この製品番号はバインドされています！',
    reqMsg_13: 'この製品は現在在庫がなく、輸入することはできません！',
    fileDepot_no: 'ファイル倉庫を選択してください',
    baseInfo_no: '基本情報の中に、必須項目まだ記入されていません',
    content_no: '商品内容の中に、必須項目まだ記入されていません',
    reserveSet_no: '予約設定の中に、必須項目まだ記入されていません',
    explain01: '内容:地名+商品名+年齢区分+セールスポイント。例：京都着物体験　女性　大人（期間限定10％off !）',
    explain02: '商品タイトルの下にあるキーワード等',
    explain03: 'エージェントを非表示にして、サプライヤーが商品を検索するのに便利になる',
    explain04: '例：大人（*歳以上）、学生（*歳~*歳まで）、子供、幼児、シニアなど',
    productName01: 'セット名：',
    productName02: '商品名：',
    qrCodeName: '二维码名称',
    productName_placeholder: '商品名を入力してください',
    qrCodeName_placeholder: '请输入二维码名称',
    productPrice_placeholder: '商品特別価格を入力してください',
    productMin_Price_placeholder: '请输入产品最低价格',
    errorProductConfirmType1: '二次確認商品が含まれているため、セット商品の予約確認方法は二次確認のみ選択できます',
    errorProductConfirmType2: '二次確認商品が含まれていないため、セット商品の予約確認方法は自動確認のみ選択できます',
    errorProductConfirmType3: '当該商品はセット商品に含まれているため、予約確認方法が変更できません。',
    orderNum_placeholder: 'ソート順を入力してください',
    productHighlights01: 'セット商品のセールスポイント：',
    productHighlights02: 'セールスポイント：',
    productHighlights_placeholder: 'セールスポイントを入力してください',
    productInsideRemark: '内部備考：',
    productInsideRemark_placeholder: '内部備考を入力してください',
    scenicSpot: '該当スポット：',
    ticketType: 'チケットタイプ：',
    ticketType_placeholder: 'チケットタイプを入力してください',
    productSaleDate: '販売期間：',
    productSaleDate_placeholder: '販売期間を選択',
    categoryLabel: 'カテゴリーラベル：',
    categoryLabel_placeholder: 'カテゴリーラベルを入力し、Enterキーで確定',
    belongCity: '所属都市：',
    belongCity_placeholder: '所属都市を選択',
    chooseDepot_rule: '倉庫を選択してください',
    productName_rule: '商品名を入力してください',
    scenicSpotArr_rule: '少なくても一つの観光地を選択してください',
    scheduleDuration: 'スケジュール：',
    scheduleDuration_placeholder: 'スケジュールを入力してください',
    imageExplain: '商品関連画像：',
    uploadBtn: 'アップロード',
    videoExplain: '商品関連動画：',
    productPackageDetail: 'メニュー編集：',
    mealTimeInterval: '利用時間帯：',
    mealTime_1: '制限なし',
    mealTime_2: '朝食',
    mealTime_3: 'ランチ',
    mealTime_4: 'アフタヌーンティー',
    mealTime_5: 'ディナー',
    mealTime_6: '夜食',
    mealNumber: '食事人数：',
    mealNumber_1: 'シングルセット',
    mealNumber_2: 'ダブルセット',
    mealNumber_3: '3~4人前',
    mealNumber_4: '5~10人前',
    mealNumber_5: '10人以上',
    mealDetail01: 'コース名：',
    mealDetail01_placeholder: '商品名を入力してください',
    mealDetail02: '内容：',
    mealDetail03: '番号',
    mealDetail04: '料理名',
    mealDetail05: '数',
    mealDetail06: '写真',
    mealDetail07: '操作',
    mealDetail07_del: '削除',
    mealDetail07_up: '上へ',
    mealDetail07_down: '下へ',
    up_msg: '既にトップ行になりました',
    down_msg: '既に最後の行になりました',
    mealDetail07_add: '一行追加',
    md_delGroup: 'メニュー削除',
    md_addGroup: 'メニュー追加',
    md_validMsg: 'セット商品詳細のデータが不完全',
    md_addMsg: '最大20行追加可能！',
    md_addMsg1: '最大10グループ追加可能！',
    useTime: '利用時間：',
    useTime_1: '制限なし',
    useTime_2: '具体的な時間帯に限定',
    editorProductDetail: '詳しい説明：',
    viewAddress: '住所：',
    viewAddress_placeholder: '住所を入力してください',
    businessTime: '営業時間：',
    businessTime_placeholder: '営業時間を入力してください',
    productPeople_placeholder: '年齢制限などを入力してください',
    exclusive: '専用車標識：',
    exclusive_1: '専用車設定無し',
    exclusive_2: '男性専用車',
    exclusive_3: '女性専用車',
    lang: '言語対応：',
    lang_1: '中国語',
    lang_2: '英語',
    lang_3: '日本語',
    lang_4: '韓国語',
    productTraffic: '交通アクセス：',
    productTraffic_placeholder: '交通アクセスを入力してください',
    networkFlow4g: '4G高速通信量：',
    networkFlow4g_placeholder: '4G高速通信量を入力しくてださい',
    networkFlow3g: '3G通信量：',
    networkFlow3g_placeholder: '3G通信量を入力しくてださい',
    networkCoverage: 'カバー範囲：',
    networkCoverage_placeholder: 'カバー範囲を入力しくてださい',
    wifiAccessories: 'アクセサリー：',
    wifiAccessories_placeholder: 'アクセサリーを入力しくてださい',
    simSize: 'SIMカードのサイズ：',
    simSize_placeholder: 'SIMカードのサイズを入力しくてださい',
    pathType: '路線タイプ：',
    pathType_1: 'シェアカー',
    pathType_2: 'レンターカー',
    pathType_3: '空港送迎',
    traffic: '交通機関：',
    traffic_1: '自動車',
    traffic_2: '電車',
    traffic_3: 'クルーズ',
    groupNumber: '催行人数：',
    groupNumber_placeholder: '催行人数を入力してください',
    shoppingType: '買い物情報：',
    shoppingType_1: '買い物が含まない',
    shoppingType_2: '買い物が含む',
    scheduleInfo: '日程詳細：',
    productCostInclude: '料金に含まれる内容：',
    productCostInclude_placeholder: '料金に含まれる内容を入力してください。',
    productCostExclusive: '料金に含まれない内容：',
    productCostExclusive_placeholder: '料金に含まれない内容を入力してください',
    productUseFlow: '利用手順：',
    productUseFlow_placeholder: '利用手順を入力して下さい',
    productSupplementPath: '使用流程补充',
    userNote: '使用説明：',
    userNote_placeholder: '使用説明を入力して下さい',
    importantNote: 'ご注意：',
    importantNote_placeholder: 'ご注意を入力して下さい',
    editorFreeItem: 'サービス項目：',
    newProductPackageDtoList_rule: '一つのセット商品の詳細を記入してください',
    scheduleInfoDtoList_rule: '少なくても一つの日程が必要',
    reserveLimitDay: '予約締切設定：',
    rld01: '利用日の',
    rld02: '日前の',
    rld03_placeholder: '時',
    rld04: '前に予約する（日本時間）',
    confirmHour: '予約確認方法：',
    confirmHour_1: '自動確認',
    confirmHour_2: '二次確認',
    ch01: '二次確認の処理時間：',
    ch02: '時間内',
    ch03: '時間内',
    maxReserveNummber: '最大受け入れ人数：',
    minReserveNummber: '最少受け入れ人数：',
    mrn_explain: '無制限の場合は「0」を記入',
    orderValid: '予約の有効期間：',
    ov01: '指定される利用日当日に有効',
    ov02: '予約日から',
    ov03: '予約日から指定日',
    ov04: '指定日から',
    ov05: '指定利用日から指定日',
    ov06: '指定日',
    ov07: '指定の利用日を利用される場合',
    orderRefund: 'キャンセル規定：',
    orderRefund_1: 'キャンセル又は変更不可',
    orderRefund_2: '予約有効期間内にキャンセル可能',
    orderRefund_tip: '1. 締切時刻は当日の23時59分59秒です。\n2. 例：旅行日が1月3日の場合、1月2日より前のキャンセルは無料、\n 1月2日および1月3日のキャンセルはキャンセル料が100％となります。設定内容は以下のとおりです。\n注文有効期限の締切時刻の0日前（当日を含む）、返金手数料：100％\n注文有効期限の締切時刻の2日前（当日を含む）、返金手数料：100％\n注文有効期限の締切時刻の3日前（当日を含む）、返金手数料：0％',
    orderRefund_3: '利用する前キャンセル可能',
    refundDescription: '説明：',
    rdi_placeholder: 'キャンセル規定の説明を入力してください',
    customerData: '予約記入設定：',
    customerData_1: 'すべてのお客様の内容が必要',
    customerData_2: '代表者1名の内容のみ必要',
    mustFillInInf: '記入必須項目：',
    mustFillInInf_1: 'お名前',
    mustFillInInf_2: '携帯番号',
    mustFillInInf_3: 'WechatID',
    mustFillInInf_4: 'パスポート番号',
    mustFillInInf_5: '性別',
    mustFillInInf_6: '利用日',
    mustFillInInf_7: '受領日',
    mustFillInInf_8: 'お名前（姓）',
    mustFillInInf_9: 'お名前（名）',
    mustFillInInf_10: '電話番号',
    mustFillInInf_11: 'メールアドレス',
    mustFillInInf_12: '性別',
    mustFillInInf_13: '年齢',
    mustFillInInf_14: '緊急連絡先（電話番号）',
    mustFillInInf_15: '券種',
    mustFillInInf_16: '同行者',
    customItem: 'その他カスタマイズの記入項目',
    ci01: ' 項目名',
    ci01_placeholder: '項目の名称',
    ci02: '必須項目設定',
    ci02_placeholder: '選択してください',
    ci02_1: '必須項目ではない',
    ci02_2: '必須項目',
    ci03: '項目説明',
    ci03_placeholder: '説明',
    ci04: '操作',
    ci04_del: '削除',
    ci05: 'カスタマイズ項目を追加',
    editorNotice: '予約注意事項：',
    orderLiaison: '注文連絡：',
    emergencyLiaison: '緊急連絡：',
    validateAuthority: '認証権限：',
    receiveCounter01: '受領カウンター：',
    receiveCounter02: 'チケット受領カウンター：',
    returnCounter: '返却カウンター：',
    reserveLimitDay_rule: '予定時間の制限を入力してください',
    reserveLimitDay_rule1: '1から99日間以内',
    reserveLimitDay_rule2: '時間を入力してください',
    orderDayNotMore: '注文日からの日数は99日間を超えてはいけません',
    trip01: '第',
    trip02: '日目',
    trip03: 'スケジュール: ',
    trip04: '新しいスケジュールを追加',
    trip05: '一日追加',
    trip06: '時間帯：',
    trip06_placeholder: '時間範囲を選択',
    trip06_phBegin: '開始時間',
    trip06_phEnd: '終了時間',
    trip07: 'どこへ：',
    trip07_placeholder: 'いつどこへ行きますか？',
    trip08: '日程内容：',
    trip08_placeholder: '例えば：第　日目はどこへ行く？どうやって行く？何か特色がある？',
    trip09: '日程写真：',
    trip09_btn: 'アップロード',
    trip10: 'スケジュールを保存',
    trip_msg1: 'スケジュールが選択されていません',
    trip_msg2: '　日，スケジュール',
    tripRange_rule: '時間帯を入力してください',
    trip_interval_rule: '終了時間と開始時間を入力してください',
    groupContentTitle_rule: '目的地を入力してください',
    groupContent_rule: 'スケジュールの内容を入力してください',
    imageList_rule: 'スケジュールの写真を設定してください',
    trip_msg3: '先に一つのスケジュールを選択し、そして保存してください！',
    trip_msg4: '保存できました',
    price01: '在庫と価格',
    price02: '時間帯-',
    price03: '時間帯を追加',
    price04: '削除',
    price05: '時間帯',
    price06: '時間帯を選択',
    price061: '時間帯がかぶるのは不可能',
    price07: '卸価格',
    price08: '卸価格を入力してください',
    price09: 'AGT仕入価格',
    price10: 'AGT仕入価格を入力してください',
    price11: '市場価格',
    price12: '市場価格を入力してください',
    price13: '在庫数',
    price14: '在庫数を入力してください',
    price15: '件',
    price16: '保存',
    price17: 'リセット',
    price18: '日付範囲は空きにしてはいけない',
    price19: '時間帯は空きにしてはいけない',
    price20: '期間設定',
    price21: '円',
    price22: 'BtoB卸価格',
    price23: 'BtoB卸価格を入力してください。',
    price24: '小売価格',
    price25: '小売価格を入力してください',
    price26: '新しい種類を追加',
    price27: '種類名',
    price28: '種類名を入力してください',
    price29: '価額種類-',
    price30: '価額種類を選択してください',
    price31: '価額種類の総在庫数をご入力ください',
    price32: '総在庫数は使用数より大きいい数値をご入力ください',
    price33: '総在庫数は0より大きい数値をご入力ください',
    price34: '指定の価額種類を入力してください：大人、子供、身体障害者（大人）、身体障害者（子供）',
    price_msg1: '先に日付を選択してください',
    price_msg2: '時間帯-',
    price_msg3: '未保存',
    price_msg4: '先に日付と時間帯を選択してくださ',
    price_msg5: '保存できました',
    price_msg6: '保存に失敗しました',
    price_msg7: '削除できました',
    price_msg8: '削除に失敗しました',
    price_msg9: '最大50項目追加可',
    price_msg10: '選択項目は空っぽにならない',
    price_msg11: '保存したら当該時間帯の既存データがすべて上書きされます。保存しますか？',
    price_msg12: '確認したら “',
    price_msg13: '”内の既存データがすべて削除されます。確認しますか？',
    price_msg14: '当該価額種類の既存データがすべて上書きされます。保存しますか。',
    price_msg15: '当該価額種類の既存データがすべて削除されます。削除しますか。',
    price_msg16: '当該価額種類は使用させています。削除できません。',
    price_msg17: '当該商品に同じ価額種類が存在しているため、保存できません。',
    refund01: '注文有効期限の締切時刻の',
    refund02: '日前（当日を含む）、返金手数料：',
    refund03: '削除',
    refund04: 'カスタマイズ追加',
    refund05: '返金手数料：',
    counter01: 'カウンターを選択',
    counter02: 'カウンター',
    counter03: 'アドレス',
    counter04: '電話番号',
    counter05: '営業時間',
    liaison01: '連絡先を選択',
    clerk01: 'スタッフを選択',
    clerk02: 'ID',
    clerk03: 'スタッフ',
    clerk04: '連絡先電話番号',
    clerk05: 'メールアドレス',
    liaison02: '連絡先',
    liaison03: '連絡方法',
    liaison04: '対応時間',
    spot01: 'スポットを選択',
    spot02: 'スポットを選択',
    spot03: 'キャンセル',
    spot04: '確認',
    takeP01: '在庫から商品を選択',
    takeP02: '少なくとも一つの商品があれば、保存又は申請ができる',
    takeP03: '順番',
    takeP04: 'タイトル',
    takeP05: '卸価格',
    takeP06: 'AGT仕入価格',
    takeP07: '市場価格',
    takeP08: '数',
    takeP09: '操作',
    takeP10: '引用データ',
    takeP11: '在庫から商品を選択',
    takeP12: '削除',
    takeP13: '価額種類',
    takeP14: '専用車標識',
    stockNumber01: '在庫数',
    stockNumber02: '利用数',
    stockNumber03: '無効',
    stockNumber04: '有効',
    priceTypeHistory01: '在庫履歴',
    priceTypeHistory02: '在庫増加',
    priceTypeHistory03: '在庫減少',
    upload01: 'jpg/png/jpeg/gifのファイルのみアップロード可能、{0}MB以内のもの',
    upload02: '最大20MBの動画がアップロード可能',
    upload03: '最大アップロード可能な数は',
    upload04: '枚の画像！',
    upload05: '個の動画！',
    upload06: 'このファイルの画像書式は無効です！',
    upload07: 'アップロードされる画像のサイズは{0}MBを超えてはいけません！',
    upload08: 'ファイル名にはコンマが入ってはいけません！',
    upload09: 'この動画ファイルの書式は無効です！',
    upload10: 'アップロードされる動画のサイズは20MBを超えてはいけません！',
    upload11: 'アップロード失敗！',
    upload12: 'アップロードエラー！',
    upload13: '実物券・カウンター・受付・施設の外観も合わせてご提供下さい',
    upload14: '一つの書類',
    upload15: 'アップロードしたファイルサイズを超えてはいけない 5MB！',
    calendar01: '年',
    calendar02: '月',
    calendar03: '当月の在庫を全て選択',
    calendar04: '件',
    clerkTable01: '未指定の場合は全スタッフが認証可能',
    week_1: '月',
    week_2: '火',
    week_3: '水',
    week_4: '木',
    week_5: '金',
    week_6: '土',
    week_7: '日',
    explain_1: '卸価格：システムに卸す価格。契約書内容を基準に定期的にシステムに請求する料金の単価',
    explain_2: 'AGT仕入価格：システムが旅行会社AGTに販売する価格',
    explain_3: '二つの料金の差額はシステムのコミッションになります',
    explain_4: '説明：在庫がない場合、「0」を記入。',
    explain_5: 'BtoB卸価格：ほかのプラットフォームシステムに卸す価格。卸価格との差額はEASYGOシステムの利益。',
    explain_6: '市場価格：参考としての一般価格',
    explain_7: '小売価格：AGTに対し、参考としてのBtoC価格。特に制限がない場合、市場価格と同じ金額で設定してください。',
    explain_8: '価額種類(日本語)入力説明：',
    explain_9: '大人料金',
    explain_10: '小児料金',
    explain_11: '身障者大人料金',
    explain_12: '身障者小児料金',
    explain_13: '(以下の価額種類のみ有効：大人、小児、身障者大人、 身障者小児)',
    explain_14: '(利用可能の日付を参考し、在庫を設置してください。利用不可の日付の設置は無効です。)',
    explain_15: '利用可能の日付：',
    explain_16: '現在の価額種類で利用可能の日付はありません。',
    explain_17: '販売状態',
    explain_18: '価格設定説明：',
    explain_19: '乐天产品价格及日期填写说明：',
    explain_20: '请根据可用日期进行设置，设置不可用日期不生效，采购价不生效',
    isSale: '販売中',
    notSale: '販売停止',
    productDeleteMessage: '先にパッケージ商品を削除してください。又はパッケージ商品の中から当該商品を削除してください！',
    none: 'なし',
    sendMailSet: '発送日を早める：',
    mailContent: 'メールの内容：',
    noSend: '発送しない',
    mailTime: '期日指定まで',
    mailContent_placeholder: 'メールの内容を入力してください',
    mailsetTips: 'PDFなしの電子チケットのみ対応'
  },
  recharge: {
    depositWithdraw: 'チャージ/現金引出',
    depositWithdrawHistoryRecord: 'チャージ/現金引出履歴',
    searchStr: 'ユーザー名/ID：',
    placeholder1: '店舗名/IDを入力してください',
    businessType: 'ユーザー種類：',
    businessType1: 'ユーザー種類',
    placeholder2: '選択してください',
    search: '検索',
    businessName: 'ユーザー名',
    businessName1: 'ユーザー名：',
    balance: '残高',
    accountBalance: 'アカウントの残高：',
    operation: '操作',
    deposit: 'チャージ',
    depositAuto: 'オンラインでチャージ',
    automatic: '自動チャージ',
    withdraw: '現金引出',
    record: '詳細',
    withdrawAvail: '現金引出可能な金額：',
    withdrawAmount: '現金引出金額：',
    withdrawRemark: '現金引出備考：',
    cancel: 'キャンセル',
    submit: '審査に送信',
    depositAmount: 'チャージ金額：',
    depositRemark: 'チャージ備考：',
    all: '全部',
    supplier: 'サプライヤー',
    distributor: 'AGT',
    submitSuccess: '送信ができました',
    subimitFailed: '送信に失敗しました',
    message: '現金引出の金額は現金引出可能な金額より大きい！',
    goBack: '戻る',
    dateRange: '時間帯：',
    placeholder3: '日付範囲を選択',
    date: '日付',
    operator: 'オペレーター',
    type: '種類',
    supplierWithdraw: '店舗の現金引出申請',
    platformWithdraw: 'プラットフォーム現金引出',
    operationAmount: '金額',
    remark: '備考',
    lastWeek: '最近一週間',
    lastMonth: '最近一ヶ月間',
    lastThreeMonth: '最近三ヶ月間',
    message2: 'チャージ金額は正の整数で入力してください！',
    message3: '現金引出金額は正の整数で入力してください！',
    message4: 'チャージ金額を2000,000,000の正の整数で入力してください！'
  },
  order: {
    batchSummary: 'バッチ詳細',
    canBeUseStartDate: '有効開始日',
    canBeUseEndDate: '有効終了日時',
    createUserName: '作成者',
    bulkPurchase: '一括購入',
    remarks: '備考欄',
    orderSource0: 'ToB',
    orderSource1: '施設toC',
    orderSource2: '対外API',
    orderSource3: 'JTR',
    orderSource4: 'KLOOK',
    orderSource5: 'Easygo',
    orderSource6: 'KKday',
    orderSource7: 'CK地図',
    orderSource8: 'AGT ToC',
    orderSource9: 'LINK',
    toCDistributorName: 'EasyGo BtoC',
    submitTime: '予約日',
    sourceType: 'システム',
    sourceJtr: 'JTR',
    sourceJph: 'EASYGO',
    allDate: '日付',
    productPrice: '単価',
    totalPrice: '総金額',
    orderInfo: '予約詳細',
    newSourceJtr: '運営者予約',
    payTime: '支払い時間',
    productUseDate: '指定利用日',
    cancelTime: '取消日',
    keyWorld: ' キーワード',
    distributor: 'AGT名',
    secondAgentId: '二級エージェントID',
    secondAgentCommission: '二級エージェント収益',
    productArea: '所在地',
    supplier: '施設名',
    search: '検索',
    synchronousTime_01: '（データ更新時間：',
    synchronousTime_02: '）',
    synchronousOrder_01: '更新リスト',
    synchronousOrder_02: '(',
    synchronousOrder_03: 's)',
    validateTime: '認証日',
    validateDate: '有効期間',
    expirationTime: '有効期切れ日',
    timeSlot: '検索時間を選択か入力',
    searchMsg: '予約番号/商品名/お客様名前/お客様メールアドレス',
    channelOrderId: 'チャネル番号',
    searchDistributor: 'AGT名を入力',
    searchSupplier: '施設名を入力',
    orderExport: '予約一覧ダウンロード',
    ticketDepotExport: '倉庫一覧ダウンロード',
    ticketBatchDetailExport: 'パッチ明細一覧ダウンロード',
    productExport: '商品一覧ダウンロード',
    productExports: '商品一覧ダウンロード',
    orderId: '予約番号',
    sonOrderId: '分支予約番号',
    productName: '商品名',
    allBuyQuantity: '購入数',
    customerName: 'お客様名前',
    orderExplain: '備考欄',
    orderExplain1: '予約説明(AGTのみ表示の内部説明)',
    orderStatus: '予約状態',
    notPay: '未支払い',
    beConfirm: '確認待ち',
    beingCancel: 'キャンセル処理中',
    haveCanceled: 'キャンセル済',
    haveConfirmed: '予約済',
    beTicket: '確認待ち',
    batchHaveDone: '購入完了',
    haveDone: 'スキャン済',
    haveCancel: 'キャンセル済',
    haveRefundRequest: '返金申請済み',
    haveRefund: '返金済み',
    havePay: '支払い済み',
    failedPay: '支払い失敗',
    refuseRefund: '返金拒む',
    haveTicket: '予約済',
    notPayButCanceled: '未支払いで取消された予約',
    haveExpired: '有効期切れ',
    leftHandleTime: '予約処理期限',
    operation: '操作',
    addOrSub: '部分的にキャンセル',
    refund: '返金',
    beAdd: 'オーダー',
    addOrSubOrRefund: '部分取り消し/返金',
    source: 'QRコード',
    validateOrder1: '認証成功',
    validateOrder2: '当該予約の認証権限がございません',
    validateOrder3: '認証失敗',
    validateOrder4: '',
    date_empty: '日付形式が不正、もしくは過去の日付',
    myouji_kana_empty: '姓氏が不正、仮名か英文字を入力してください',
    namae_kana_empty: '名前が不正、仮名か英文字を入力してください',
    bin_key_id_empty: '便キーID パラメータが不正',
    sex_empty: '性別パラメータが不正',
    tel_empty: '電話番号が不正、10桁か11桁の数字を入力してください',
    email_empty: 'メールアドレスが不正、10桁か11桁の数字を入力してください',
    total_num_empty: '予約人数パラメータが不正',
    age_empty: '年齢が不正、数字を入力してください',
    emergency_phone_empty: '緊急時連絡先パラメータが不正',
    ctype_empty: '年齢区分・障害者区分パラメータが不正',
    recep_empty: '受付が終了している',
    num_over: '在庫不足のため予約できません',
    num_not_sale: 'ご選択の指定日はまだ販売開始していません',
    r_id_empty: '指定予約IDは既にキャンセル済み',
    r_id_already_cancel_ok: '',
    r_id_already_payment_ok: 'この予約は支払い済み',
    thirdMethodErr: '接続口異常、管理員にご連絡してください。',
    systemErr: 'システム異常、管理員にご連絡してください。'
  },
  jtrOrder: {},
  withdrawal: {
    withdrawalCash: 'チャージ/現金引出',
    withdrawalCashManager: 'チャージ/現金引出管理',
    withdrawalOnline: 'オンラインでチャージ',
    withdrawalOffline: '手動でチャージ',
    applyWithdraw: '現金引出を申請',
    beingHandel: '処理待ち',
    beingAudit: '審査待ち',
    notPass: '審査失敗',
    selectTimeSlot: '時間帯',
    selectDateSlot: '期間を選択',
    createTime: '作成時間',
    operationPeople: 'オペレーター',
    type: '種類',
    recharge: 'チャージ',
    withdraw: '現金引出',
    withdrawAmount: '現金引出金額',
    rechargeWithdrawAmount: '金額',
    rechargeWithdrawAmount2: '現金引出金額',
    remark: '備考',
    refundReason: '審査失敗理由',
    accountBalance: 'アカウントの残高',
    canWithdrawalBalance: '引き出し限度額',
    applyWithdrawalBalance: '申請する精算金額',
    applyWithdrawalBalance2: '申請する追加チャージ金額',
    selectWithdrawalAccount: '現金引出金額を入力してください',
    withdrawRemark: '現金引出備考',
    withdrawRemark2: 'チャージ備考',
    inputWithdrawRemark: '現金引出の備考情報を入力してください',
    cancel: 'キャンセル',
    sure: '確認',
    submitResigt: '申请を送信',
    oneWeek: '最近一週間',
    oneMonth: '最近一ヶ月間',
    threeMonth: '最近三ヶ月間',
    withdrawAmoutIsNotNull: '現金引出金額は空白にしてはいけません！',
    withdrawAmoutZS: '正の整数で入力してください！',
    withdrawAmoutMustNumber: '現金引出金額は数字でないといけません！',
    withdrawAmoutIsNot0: '現金引出金額は0以上でないといけません！',
    withdrawAmoutIsNotNegative: '現金引出金額はマイナスではいけません！',
    withdrawAmoutIsNotEnough: '現金引出可能な残高が足りません！',
    comformWithdrawMsg: '現金引出情報を確認してください。継続しますか？',
    comformWithdrawMsgIfGo: '現金引出情報を確認してください。継続しますか？',
    sureSubmit: '確認して送信',
    returnEdit: '戻る',
    submitSuccess: '送信できました。審査をお待ちください！',
    companyName: '店舗名',
    companyName2: '店舗名',
    companyType: '店舗種類',
    distributor: 'AGT',
    supplier: 'サプライヤー',
    inputCompanyNameAndId: '店舗名/IDを入力してください',
    handle: '処理',
    auditor: '審査',
    auditorPass: '審査通過',
    auditorNotPass: '審査不合格',
    withdrawHander: '現金引出処理',
    withDrawAuditor: '現金引出審査',
    withDrawAuditor2: 'チャージ審査',
    withdrawHander2: 'チャージ処理',
    refuseApply: '申请を拒否',
    refuseApplyReason: '審査に通らない理由を入力してください',
    handlingSubmittingAudits: '審査に送信',
    handelSuccess: '処理できました！',
    rechargeFail: 'チャージ失敗'
  },
  password: {
    getPassword: '「パスワード」をお忘れの方はこちら',
    pleaseInputMailAccount: 'メールアドレスを入力してください',
    sendPasswordToMail: 'パスワードをメールアドレスに送信',
    returnToIndex: '戻る',
    sendMsg: '業務責任者のメールアドレスを入力してください。システムより初期パスワードをお送りします。',
    mattersNeedingAttention: '注意事項',
    tips1: '「パスワードの初期化申請」機能を頻繁に利用しないでください。一日最大の利用回数は',
    tips2: '回です。',
    tipsMsg: '通知メッセージ',
    loginAtonce: 'ログイン',
    getUrlAgain: 'メール再送',
    mailCanNotBeEmpty: 'メールアドレスは空白ではいけません！',
    mailStyleNotRight: '有効なメールアドレスを入力してください！',
    mailHaveSendSuccess: 'メールはご利用のメールアドレスに送信されました。ご確認ください！',
    theMailInputNotExist: '入力されたメールアドレスは存在していません！',
    theMailNotHaveRight: '当該メールボックスはアクティブにならなかったか、無効化されました！',
    aboveOneDayPermit: '一日の最大操作回数を超えました！',
    mailSendFail: 'メールの送信は失敗しました！'
  },
  orderMessage: {
    pleaseIntoConfirmEmail: 'メールアドレスを入力してください。',
    emailError: 'メールボックスの入力フォーマットが不正です。',
    confirmEmailError: '確認用E－mailの書式は正しくありません。',
    pleaseIntoUseDate: '利用時間を選択してください',
    pleaseIntprodDate: '利用日を選択してください',
    pleaseIntoHandDate: '受領時間を選択してください',
    pleaseIntoReturnDate: '返却日付を選択してください',
    pleaseIntoLinkCounter: '受領カウンターを選択してください',
    pleaseIntoReturnCounter: '返却カウンターを選択してください请选择归还柜台',
    pleaseIntoCustomEmail: '観光客の名前を入力してください',
    pleaseSelectStock: '時間帯を選択してください',
    customEmailLength: 'お客様の名前の長さは20ケタ超えないように',
    pleaseIntoCustomTel: 'お客様の携帯番号を入力してください',
    pleaseIntoNationality: 'お客様の国籍を入力してください',
    pleaseIntoBirthday: 'お客様の诞生日を入力してください',
    customTelError: 'お客様の携帯番号の書式は正しくありません',
    customTelError1: '無効の電話番号、10桁或いは11桁有効の電話番号を入力してください。',
    customAgeError: '正しい年齢をご入力ください。',
    customSexError2: '女性専用車のため、性別を再選択してください。',
    customSexError1: '男性専用車のため、性別を再選択してください。',
    pleaseIntoCustomWechat: 'お客様のWechatアカウントを入力してください',
    customWechatError: 'お客様のWechatアカウントの書式は正しくありません',
    pleaseIntoCustomPass: 'パスポート番号を入力してください',
    customPassError: 'パスポート番号の書式は正しくありません',
    pleaseIntoCustomAddress: '宅便アドレスを入力してください',
    pleaseIntoCustomPostcode: '郵便番号を入力してください',
    customPostcodeError: '郵便番号の形式は不正確です',
    pleaseIntoCustomCreditType: '証明書類型を選択してください',
    pleaseIntoCustomCreditNo: '証明書番号を入力してください',
    customCreditNoError: '証明書番号の形式は不正確です',
    customSexMale: '男',
    customSexFalmale: '女',
    customCtype1: '大人',
    customCtype2: '小児',
    customCtype3: '身障者大人',
    customCtype4: '身障者小児',
    pleaseRechangeCtype: '購入希望の価額種類と券種は一致しません、改めて選択してください。',
    pleaseIntoCustomItem: 'お客様のカスタマイズ内容を入力してください',
    quotaPrompt: '0より大きい整数を入力してください。',
    orderOnceBeOne: '予約数は少なくとも1つです',
    orderNumberOnceBeOne: '单次订单预定人数至少为1',
    orderStockBeMax: '本产品场次库存数至多为',
    orderOnceBeMax: '一度に予約を受けられる数の上限は',
    orderNumOnceBeMax: '本产品单次订单预定人数至多为',
    orderOnceBeMin: '本商品の予約数は少なくとも',
    orderNumOnceBeMin: '本产品单次订单预定人数至少为',
    validateDateExpire: '有効期限切れのため、予約できません',
    productsNumError: '在庫不足のため、予約できません。',
    productsNumError1: '商品 ',
    productsNumError2: ' - :',
    productsNumError3: ' 在庫不足',
    productsNumError4: ' PDFファイル在庫不足',
    productPriceError: '价格已变化，请重新刷新',
    systemErrorMsg: 'システム異常,再度試みてください!',
    pleaseUploadPDF: 'PDFファイルをアップロードしてください！',
    pleaseIntoUseData: '指定の日付を入力してください',
    productUseDateBeNull: '注文の指定の日付は空白にしてはいけません',
    jtrordermessage: '数量上限は',
    jtrplayDate: '利用日を選択してください',
    jtrnum: '数量を選択してください',
    jtrphone: '携帯番号を入力してください',
    jtrphonefalse: '携帯番号は不正確です',
    linkCreditTypeErr: '証明書類型を選択してください',
    linkCreditNoErr: '証明書番号を入力してください',
    error: '予約は追加できません、上限になりました',
    limitedDate: '現時点が商品の予定可能時間を超えました、再予約をお願い致します。',
    limitBulking: '当該AGTは一括購入中です、購入完了の前に新しいバッチ予約を送信できません、しばらくお待ちください!',
    designatedDateNull: '指定日が空です'
  },
  actuary: {
    all: '全部',
    actuaryType: '内容',
    actuaryType1: '预存款进款',
    actuaryType2: '请款书支付',
    actuaryType3: '临时采购',
    actuaryType4: '采购待支付',
    actuaryType5: '采购支付',
    actuaryType6: '售卖',
    actuaryState: '状态',
    actuaryState1: '正常',
    actuaryState2: '取消',
    actuaryState3: '完成',
    actuaryState4: '待处理',
    depositStatus0: '待处理',
    depositStatus1: '待审核',
    depositStatus2: '已完成',
    depositStatus3: '已拒绝',
    jphOrderStatus0: '待支付',
    jphOrderStatus1: '待确认',
    jphOrderStatus2: '取消中',
    jphOrderStatus3: '已取消',
    jphOrderStatus4: '已确认',
    jphOrderStatus5: '已完成',
    jphOrderStatus6: '未支付取消',
    jtrOrderStatus0: '待确认',
    jtrOrderStatus1: '待支付',
    jtrOrderStatus2: '已完成',
    jtrOrderStatus3: '取消订单',
    jtrOrderStatus4: '已付款',
    jtrOrderStatus5: '已申请退款',
    jtrOrderStatus6: '已退款',
    jtrOrderStatus7: '支付失败',
    jtrOrderStatus8: '拒绝退款',
    jtrOrderStatus9: '已出票',
    searchTime: '日期',
    searchWords: '关键字',
    searchMsg: '分销商名称/产品名称/设施',
    search: '搜索',
    exportExcel: 'Excel下载',
    addNew: '新增',
    actuaryId: '号码',
    createTime: '日期',
    facilitiesName: '设施',
    distributorName: '分销商',
    productName: '商品名',
    productNum: '张数',
    depositAmount: '预存款',
    payoutAmount: '支出',
    incomeAmount: '进价',
    saleAmount: '销售额',
    distributorBalance: '分销商预存款余额',
    salableQuantity: '可售张数',
    stockQuantity: '实际在库',
    operation: '操作',
    viewNum: '张数',
    viewNumErr: '张数不能为空或负数',
    view: '景点',
    viewIdErr: '景点必选',
    viewIdErr1: '只能选择一个景点',
    amount: '金额',
    amountErr: '金額を入力してください',
    requestForm: '请求书',
    payDate: '支付日',
    payDateErr: '支付日不能为空',
    remark: '备考',
    remarkErr: '备考不能为空',
    validTime: '有效期',
    addAmount: '合计金额',
    money: '日元',
    confirm: '确认',
    timeSlot: '选择输入时间段',
    nameErr: '设施不能为空',
    validDateErr: '有效期不能为空',
    productInfo: '注 : 当前仅支持选择一种产品',
    productErr: '产品不能为空',
    productErr1: '当前只能选择一种产品',
    chooseActuaryType: '请选择新增精算类型',
    messageNotCompleteIn: '必要信息未输入完整',
    addSuccess: '追加成功',
    addError1: '追加失敗、商品が既に存在か未選択です',
    addError2: '追加失敗',
    submitPrice: '価格は空にしてはいけません!',
    submitMinPrice: '最低価額を入力してください',
    submitMinPrice0: '最低価額は正数しか設定できません',
    submitMinPrice1: '分销价格必须大于0!',
    submitOrderNum: 'ソート順は空にしてはいけません!',
    submitLength: 'ソート順と価格は数字10位以下にしてください',
    addFailed: '系统异常,请稍后重试',
    operatorBalance: '余款',
    actuaryDetail: '精算详情'
  },
  finance: {
    calculatePeriod: '精算期間：',
    calculatePeriod1: '精算期間',
    placeholderCalculatePeriod: '精算期間を選択してください',
    supplierNameAndId: '店舗名/ID：',
    placeholderSupplierNameAndId: '店舗名/IDを入力してください',
    search: '検索',
    supplierName: '店舗名',
    distributorPayoutAmount: '販売金額（JPY）',
    operatorIncomeAmount: 'システム手数料（JPY）',
    supplierIncomeAmount: '精算金額（JPY）',
    operation: '操作',
    detail: '詳細',
    downloadBill: '明細ダウンロード',
    lastSixMonth: '最近六ヶ月間',
    return: '戻る',
    distributorName: 'AGT名',
    distributorName1: 'AGT名',
    placeholderDistributorName: '販売店名/IDを入力してください',
    finishTime: '完成時間',
    orderId: '注文番号',
    productId: '商品番号',
    productName: '商品名',
    productType: '商品種類',
    elecTicket: '電子チケット',
    paperTicket: '実物券',
    experTicket: '体験',
    daysTicket: 'ツアー',
    wifi: 'Wi-Fi',
    sim: 'SIMカード',
    restTicket: 'レストラン',
    traffTicket: '交通',
    packTicket: 'お得セット商品',
    distributorPayoutAmount1: '支払い金額',
    operatorIncomeAmount1: 'コミッション金額',
    supplierIncomeAmount1: '精算金額(JPY)'
  },
  payOrder: {
    payMessageOne: '注文の詳細情報を最終確認してください、1時間内に支払わないとキャセルされてしまい、なるべく早く支払ってください。',
    payMessageOne1: '',
    payMessageOne2: '',
    payMessageOne3: '',
    jtrpayMessageOne: '注文書を確認して、注文書は',
    jtrcancel: '部分的に注文キャンセル',
    jtrAppend: '予約追加',
    jtrpayMessageTwo: 'もし　分以内に未払い状態で、キャンセルさせます',
    payMessageTwo: '出来るだけ早くお支払いください。もし製品が売れ切りになりましたら、購入できなくなります。',
    payMessageThree: '注文',
    payMessageFour: '分内に支払わないとキャセルされてしまい、なるべく早く支払ってください。',
    payMessageFive: 'タイムアウトでもう一回注文してください。',
    lineDownTicket: 'オフライン電子チケット',
    lineUpTicket: 'オンライン電子チケット',
    salaryByNow: 'プリペイドで支払う',
    thirdPayment: 'Eウォレット決済',
    canBeUseMoney: 'アカウントの利用可能な残高：',
    jtrcanBeUseMoney: '支払い金額',
    remainTimes: '有效时间',
    payMoney: '支払う：',
    applyCancel: '注文をキャンセル申し込み',
    payByNow: 'すぐに支払う',
    canBeUseMoneyError: '利用可能な残高が足りないため、予約できません',
    orderCanceled: '注文はキャンセル済み',
    consentRefund: '返金する',
    refuseRefund: '返金拒む',
    overTimeByPay: 'タイムアウトで注文が自動的に取消します',
    orderHaveUpdate: '支払い失敗、予約状態が更新しました',
    orderException: '予約異常，再度試みてください',
    productException: '商品異常,説明は編集できません',
    payerror: '支払い失敗',
    error: 'キャンセルの数量が間違いた',
    applyerror: '申請失敗'
  },
  supplyOrder: {
    confirmCancel: '取消を確認',
    refuseCancel: '取消を拒否',
    canceleOrder: '予約キャンセル',
    specialCanceleOrder: '特殊キャンセル',
    partnerCancleOrder: '接続先APIキャンセル',
    jtrSpecialCanceleChannel: 'パス券特殊キャンセル',
    writeFff: '認証',
    confirmSpecialRefund: '特殊返金する',
    refuseSpecialRefund: '特殊返金拒む',
    orderConfirmDetail: '予約内容確認',
    system: 'システム',
    checkedForNew: 'クリックして新しいメッセージを閲覧',
    orderRefuseMessage: '本商品は返金できない商品であり、もし取消を申請されれば、支払われた金額は返金できませんが、ご了承ください。',
    canBeTakeBackFree: '返金手数料率',
    canBeTakeBack: '返金手数料',
    exchangeRate: '汇率差额',
    takeMoney: '実際の返金額',
    orderDetailByDialog: '注文の詳細情報を確認',
    orderdetail1: '確認シート①',
    orderdetail2: '確認シート②',
    orderdetail3: '確認シート③',
    orderdetail4: '確認シート④',
    orderdetail5: '確認シート⑤',
    orderdetail6: '確認シート⑥',
    orderdetail7: '確認シート⑦',
    orderdetail8: '確認シート⑧',
    orderdetail9: '確認シート⑨',
    fileTypes: '当該ファイルは有効なPDFではありません！',
    reselectFile: '当該ファイルにPDFが含まれていません、再選択してください!',
    zipTypes: '当該ファイルは有効なZIPではありません！',
    fileSize: 'アップロードされるPDFのサイズは5MBを超えないように！',
    fileTypeBy: 'ファイル名にコンマを入れないでください！',
    canCancel: 'キャンセル',
    downFiles: 'ファイルをダウンロード',
    vailTimeMsg: '予約済み状態の予約しか変更できません',
    vailTimelaterMsg: '終了日は現在の日付より前にすることはできません',
    vailTimeFsjMsg: '富士急ハイランド商品の予約の有効期間は変更できません',
    vailTimeEmpty: '有効期間を選択してください'
  },
  productNumberPrice: {
    pleaseIntoTime: '時間を選択してください',
    pleaseIntoNumber: '在庫を記入してください',
    pleaseGetOneToSix: '1から6個の数字を入力してください',
    pleaseIntoPurchasePrice: '卸価格を入力してください',
    pleaseIntoDistorbutionPrice: 'AGT仕入価格を入力してください',
    pleaseIntoMarketPrice: '市場価格を入力してください',
    dateCanotBeNull: '日付の範囲は空白にしてはいけません',
    confirmDateCanotBeMax: '設定の時間帯は製品が有効時間帯範囲内にしないといけません！',
    distributorCanotBuyMessage: '当該商品の販売権がないため予約できません',
    distributorCanotBuyMessage2: '当該商品が販売中止であるため予約できません'
  },
  pwdSet: {
    pleaseIntoOldPwd: '現在のパスワードを入力してください',
    pleaseIntoNewPwd: '新しいパスワードを入力してください',
    pleaseConfirmPwd: '新しいパスワードを確認してください',
    pleaseIntoIntoSix: '6-16ケタの英文字(大、小)又は数字を入力してください',
    mustBeOne: '上記と一致しないといけません',
    pleaseIntoCorrectPwd: '正しいパスワードを入力してください',
    lengthMustOneToSix: '長さは６ケタから１6ケタまでにしてください',
    canotBeIntoNull: 'スペースやその他の特殊記号は入力してはいけません',
    updateNewPwdSuccess: 'パスワードは変更されました。ログインし直してください！',
    oldPwdError: '現在のパスワードは正しくありません、もう一度入力してください！',
    oldAndNewNotOne: '二回入力されたパスワードは一致していません！',
    pleaseIntoMustItem: '必須項目を入力してください',
    pleaseEnterPwd: 'パスワードを入力してください',
    pleaseEnterPwdAgain: 'もう一度パスワードを入力してください'
  },
  homeMessage: {
    urgnMessage: '操作の権限がありません！'
  },
  entityTicket: {
    pinTicketNo: '認証番号',
    selectDepot: '倉庫選択',
    pleaseSelect: '選択してください',
    selectProduct: '製品選択',
    relationProduct: '関連商品',
    selectPriceType: '種類選択',
    saveTicketDepot: 'チケット倉庫を保存',
    onlySelectOnePro: 'チケット倉庫を追加時に製品が一つだけ選べる!',
    onlySelectOnePriceType: 'チケット倉庫を追加時に種類が一つだけ選べる!',
    depotNameNotBeEmpty: '倉庫は空白にしてはいけません!',
    productNameNotBeEmpty: '製品は空白にしてはいけません!',
    productPriceTypeNotBeEmpty: '種類を選択してください!',
    addSuccess: '追加できました!',
    inDepotSuccess: '倉庫に入れました!',
    proHaveExist: '当該製品は既に存在!',
    selectDepotOut: 'エクスポート倉庫',
    selectDepotIn: 'インポート倉庫',
    depotProNum: '在庫数',
    validDate: '有効期限',
    selectDate: '日時を選択',
    starEndTicketNo: '両側チケット番号',
    starTicketNo: '最初のチケット番号',
    endTicketNo: '最後のチケット番号',
    inDepotTicketNo: 'インポートチケット番号',
    textArea: 'スキャンポータル-カーソルをここに移動し、スキャナーでチケット上のコードをスキャンしてください',
    saveToDepot: 'インポートを保存',
    pleaseInputStarTicketNo: '最初のチケット番号を入力してください!',
    pleaseInputEndTicketNo: '最後のチケット番号を入力してください!',
    errorMsg01: '最初のチケット番は10桁以下の数字!',
    errorMsg02: '最後のチケット番は10桁以下の数字!',
    errorMsg03: '最初のチケット番号は最後のほど大きくないように!',
    errorMsg04: 'インポートチケット数は2000枚以内!',
    errorMsg05: '下記のチケット番号の長さは10桁以上',
    errorMsg06: 'インポート倉庫を選択してください!',
    errorMsg07: 'エクスポート倉庫とインポート倉庫は一致してはいけません!',
    errorMsg08: '締切時間を選択してください!',
    errorMsg09: 'インポートチケット番号を入力してください!',
    errorMsg10: 'このインポート倉庫と当該製品はまだチケット倉庫がないので、まずチケット倉庫を作成してから製品をインポートしてください!',
    errorMsg11: 'インポート倉庫に下記のチケット番号が存在している',
    errorMsg12: 'エクスポート倉庫に下記のチケット番号が存在していない',
    errorMsg13: 'このエクスポート倉庫と当該製品はまだチケット倉庫がないので、まずチケット倉庫を作成してから製品をエクスポートしてください!',
    allBathList: 'バッチ一覧',
    batchDetailList: 'バッチ明細一覧',
    batchNO: 'バッチ番号',
    ticketNO: 'チケット番号',
    pleaseInputBatchNo: 'バッチ番号を入力してください',
    pleaseInputTicketNo: 'チケット番号を入力してください',
    inDepotTime: '入庫時間',
    inDepotUser: '入庫ユーザ',
    importNumber: '総数',
    userNumber: '利用数',
    invalidateNumber: '無効化数',
    leftNumber: '残りの数',
    exportNumber: '出庫数',
    thisBatchDetail: '明細',
    clearDepot: 'クリア',
    batchState: 'バッチ状態',
    ticketState: 'チケット状態',
    stateOne: '正常',
    stateTwo: '使用済',
    stateThree: '無効化',
    stateFour: '出庫済',
    stateFive: 'クリア済み',
    stateSix: 'ロック済',
    userOperationTime: '利用（無効化）時間',
    unUseRemark: '無効化説明',
    orderId: '予約番号',
    sureClearDepot: '本当にこのバッチの製品をクリアしますか?',
    sureClearDepot2: '本当にこの製品を倉庫クリアしますか?',
    clearDepotSuccess: '倉庫クリアに成功',
    haveCancelClearDepot: '倉庫クリア操作取消済!',
    invalidTicketSuccess: '全て無効化に成功!',
    addTicketDepot: 'チケット倉庫追加',
    depot: '倉庫',
    keyWorld: 'キーワード',
    inputProNameAndNo: '製品名/番号を入力してください',
    userTimeQuantum: '利用時間帯',
    inputSelectTimeQuantum: '検索時間帯を選択か入力',
    depotId: '倉庫ID',
    ticketDepotId: 'チケット倉庫ID',
    depotName: '倉庫名',
    productId: '製品ID',
    productName: '商品名',
    fileName: 'ファイル数',
    depotIn: '入庫',
    depotId2: '入庫',
    depotId3: '→',
    depotId4: '新規入庫',
    depotOut: '出庫',
    history: '履歴',
    zhang: '枚',
    operationUser: 'オペレーター',
    depotType: '倉庫種類',
    addDepot: '倉庫新規追加',
    inputDepotName: '倉庫名を入力',
    notAllDepot: '非ヘット倉庫',
    allDepot: 'ヘット倉庫',
    depotRemark: '倉庫備考',
    remarkMsg: '備考情報',
    inventoryNumber: '在庫数',
    ifIsAllDepot: 'ヘット倉庫か',
    yes: 'はい',
    no: 'いいえ',
    tips: '備考:ヘット倉庫は一つしかありません',
    depotEdit: '倉庫編集',
    deleteDepot: '本当にこの倉庫を削除しますか?',
    depotNameIsNotEmpty: '倉庫名は空白にしてはいけません!',
    allDepotOnlyOne: 'ヘット倉庫は一つだけ!',
    depotNameOnlyOne: '倉庫名は既に存在!',
    userDepotManager: 'ユーザ倉庫管理',
    addDepotToUser: '倉庫指定',
    addDepotToUserSuccess: '指定成功!',
    notHistory: '当該製品に履歴がありません!',
    pleaseSelectInvalidTicket: '無効化するチケット番号を選択してください!',
    invalidTicketFalid: '全て無効化に失敗!',
    someInvalidTicketFalid: '以下の票号は無効になりました',
    orderQuery: '注文の問い合わせ：',
    orderQueryPlac: '注文番号を入力、あるいはスキャンコードを示してください',
    orderInfo: '注文情報：',
    startStopNumber: '両側チケット番号：',
    startNumber: '最初のチケット番号',
    stopNumber: '最後のチケット番号',
    numberEditPlac: 'スキャンポータル-カーソルをここに移動し、スキャナーでチケット上のコードをスキャンしてください',
    confirmPin: '消去確認',
    formMsg1: '確認コードあるいは注文番号を入力、あるいはスキャンコードを示してください',
    rule_n1_10: '長さが1から10ケタの数字にしてください',
    querySuccess: 'クエリ成功',
    queryFailure: '注文は存在していません',
    queryMsg1: '始めの番号は終わりの番号より小さい、一回は100枚に限る',
    queryMsg2: '消去確認：',
    pinMsg1: '消去成功',
    pinMsg2: '消去失敗!',
    clearRemark: '清倉の備考'
  },
  ticketMessage: {
    pleaseEnterOrderId: '予約番号を入力してください',
    depotName: '倉庫名：',
    pleaseIntoDepotName: '倉庫名を入力してください',
    depotNameNotNull: '倉庫名は空白にしてはいけません',
    ticketRemark: '備考：',
    remarkNotNull: '備考は空白にしてはいけません',
    pleaseGetProduct: '製品を選択してください',
    fileDepotName: 'ファイル倉庫名：',
    batchStatus: 'バッチ状態：',
    batchId: 'バッチ番号',
    pleaseEnterBatchId: 'バッチ番号入力',
    enterDate: 'インポート時間',
    enterUser: 'インポートユーザ',
    close: '閉じる',
    Processing: '処理中',
    uploadFailure: 'アップロードに失敗しました',
    ticketDetail: '詳細',
    newToUse: '優先使用',
    fileStatus: 'ファイル状態：',
    fileName: 'ファイル名：',
    pleaseEnterFileName: 'PDFのファイル名を入力してください',
    fileId: 'ファイルID',
    fileNames: 'ファイル名',
    downPdf: 'PDFダウンロード',
    ticketMessageBy: '下記のチケット番号状態が異常なため、無効化失敗！',
    noUseMessage: '少なくても一つのファイルを選択！',
    ticketMessageBy2: '今回の操作には異常なチケットがあり、リフレッシュ後再度試してください！',
    operationSuccess: '操作成功!',
    getFile: 'ファイル選択',
    getZipFile: 'ZIP選択',
    getFilesOnlyFive: '*各PDFはページごとに複数の電子チケットに分割されます。アップロードPDFファイルの最大数は5，且つ1つのファイルの最大サイズは10MB',
    getZipOnlyOne: 'アップロードZIPファイルの最大数は1，ファイルの最大サイズは300MB',
    usedDate: '有効な締切：',
    usedDates: '有効な締切',
    ticketMessageBy3: '空白ならずっと有効。',
    intoNow: 'すぐにインポート',
    intoSuccess: 'インポート成功!',
    insertFileDepot: 'ファイル倉庫新規追加',
    choose: '選択',
    fileDepotNames: 'ファイル倉庫名',
    pleaseIntoFileName: 'ファイル倉庫名を入力してください',
    canBeUseDate: '利用（無効化）時間帯：',
    intoSearchDate: '検索時間帯を選択か入力',
    into: 'インポート',
    fivePdf: '部のPDF!',
    oneZip: '部のZIP!',
    ticketOpen: '開く',
    intoIng: '導入中，少々お待ちください...',
    fileHadExists: 'ファイルデータベースは既に存在しています！',
    uploadSize: 'アップロード写真の最大サイズは10MB！',
    uploadZipSize: 'アップロード写真の最大サイズは300MB！',
    fileNotFors: 'アップロードファイルは繰り返してはならない！',
    pleaseGetFile: 'ファイルを選択してください',
    fileBatchRemarkNotNull: '備考情報を入力してください'
  },
  remind: {
    remindId: '番号',
    title: 'メールによる注意喚起',
    date: '結団日',
    accessory: '添付ファイル',
    add: '新築の注意',
    upload: '添付ファイルをアップロードする',
    beforeDay: '発団日のN日前までに注意メールを送る',
    before: '発団日前',
    days: '日メールで注意喚起',
    download: '添付ファイルをダウンロードする',
    reminder: '提示',
    confirm: '確定',
    inputDate: '結団日を入力してください',
    uploadAccessory: '添付ファイルをアップロードしてください',
    inputbeforeDay: '繰り上げ発送日を入力してください',
    inputContent: 'メールの内容を入力してください',
    sendContent: '送信内',
    addRemind: 'メールによる注意喚起',
    existRemind: '当日注意はすでに存在している',
    set: 'メール設定'
  },
  trades: {
    platform: 'プラットフォーム',
    excel: 'エクスポート EXCEL',
    tradesTime: '取引時間帯',
    inputOrderId: '注文番号を入力してください',
    tradingTime: '取引日付',
    operatorUser: '作業員',
    expenditure: '支出',
    income: '収入',
    buyQuantity: '数量',
    customerName: 'お客様名前',
    orderExplain: '予約備考',
    content: '内容'
  },
  pinTicketMagn: {
    pinTicket: '認証出庫',
    shortcutOut: 'ショート消去',
    all: '全部',
    pinTime: '認証時間',
    validationType: '消去タイプ：',
    productName: '製品名：',
    placeholder1: '製品名を入力してください',
    validateTime: '消去日期：',
    placeholder2: '消去日期を選んでください',
    orderId: '注文ID：',
    placeholder3: '注文IDを入力してください',
    distributor: 'AGT：',
    placeholder4: '販売店を入力してください',
    validationUser: '消去人：',
    placeholder5: '消去人を入力してください',
    ticketNo: 'チケット番号：',
    placeholder6: 'チケット番号を入力してください',
    colOrderId: '注文ID',
    colOrderContent: '注文の内容',
    colValidateTime: '消去時間',
    colValidateType: '消去タイプ',
    colValidateUser: '消去人',
    colDistributor: 'AGT',
    colCustomerOrderNo: 'ショート番号',
    placeholder7: 'ショート消去番号を入力してください',
    colCustomerOperator: 'オペレーター',
    placeholder8: '担当者を入力してください',
    colticketNo: 'チケット番号',
    shortcutOutDepot: '消去倉庫',
    shortcutOutProduct: '消去制品',
    company: '会社',
    orderIdNo: '注文ID',
    distributorNameAndOrderNo: 'AGT名 (例：頭文字) ＋予約番号',
    pleaseInputOrderCustomer: '顧客の注文IDを入力してください',
    pleaseInputCustomerOperator: 'オペレーターを入力してください',
    shortcutOutSure: '消去確認',
    ticketCanNotBeCutOut: '以下は消せない',
    ticketCanNotBeCutOuts: '重複したチケット番号を入力することはできません',
    distributeOnlySelectOne: 'ディストリビューターは一つしか選ばない',
    ticketNumber100: 'チケット数は100まで!',
    pleaseInputDistribute: '販売店を選択してください!',
    pleaseInputOrder: '注文IDを入力してください!',
    orderLine100: '注文IDの長さは100ケタ超えないように!',
    inputOperation: 'オペレーターを入力してください!',
    operationLine100: 'オペレーターの長さは100ケタ超えないように',
    shortcutOutSuccess: '消去成功!'
  },
  errMsg: {
    errMsg100: '注文は存在していません',
    errMsg101: '一致する倉庫がない',
    errMsg102: 'オペレータだけ操作可能',
    errMsg103: '注文は有効期間外',
    errMsg104: '以下は消せない',
    errMsg105: '運営業者か特別権限のあるサプライヤーより直接審査通過の操作が失敗した',
    errMsg106: '製品IDは空白にしてはいけません',
    errMsg107: 'ファイルをアップロードは空白にしてはいけません',
    errMsg108: 'サーバー内部異常',
    errMsg109: '当該予約は既に認証済みです。',
    errMsg110: '注文は確認待ち',
    errMsg111: '切符消去数と実際の購入数が合わない',
    errMsg112: '一致する切符倉庫がない',
    errMsg113: '一致する切符がない',
    errMsg114: '接続先システムを選択してください',
    errMsg115: 'チケット番号を最少に一つを入力してから、確認してください。',
    errMsg116: '当該予約はキャンセルされました',
    errMsg117: '',
    errMsg118: '',
    errMsg119: '',
    errMsg120: '',
    errMsg121: '処理中のため、重複操作はおやめください。'
  },
  pay: {
    type: 'チャージ方法',
    success: '支払い完了',
    fail: '支払い未完成',
    toUrl: 'ご選択の支払いプラットフォームでお支払ください',
    toPay: '続けてチャージ',
    error01: '支払い失敗、再度お試しください',
    error02: '支払いは完了しました、重複操作しないでください',
    loading: '支払いデータは処理中…',
    message: '支払いが成功したら、振込はサービス方で遅れます。お待ちください。'
  },
  pageSetting: {
    upload01: 'jpg/png/jpegのみアップロード可能、1MB以内',
    upload02: 'サイズは1920x500画素であり、ホームページ写真は左側との距離が430画素を必要',
    pageImg: 'ホームページ写真：',
    errorByPage01: 'ホームページ写真が変化無し',
    errorByPage02: 'ホームページ写真は空であることができない！'
  },
  barCode: {
    urlError: 'アドレスリンク異常!',
    getInfoError: 'QRコード読み込み異常!',
    productTextDescription: '予約内容',
    customerReceiveDate: '受領日付：',
    returnDate: '返却日付：',
    productUseDate: '指定利用日：',
    buyQuantity: '購入数：',
    productUseFlow: '利用手順：',
    productUseName: '名前：',
    validityDate: '有効時間：'
  },
  supplementInfo: {
    urlError: '地址链接异常!',
    getSupplementInfo: '内容获取失败!',
    supplementOfUseFlow: '使用流程补充详细说明'
  },
  qrCode: {
    qrCodeSource: 'QRコード名',
    isDistribution: '販売店',
    scale: 'コミッション比率',
    YES: 'オン',
    NO: 'オフ',
    noValue: 'なし',
    distributionRange: '販売権設定',
    distributionRangeAll: '全てのQRコードが販売可能',
    distributionRangeYes: '指定QRコードのみ販売可能',
    distributionRangeNo: '指定QRコード以外は販売可能',
    selectDistributor: '商品選択',
    tipMessage1: 'QRコード名を入力してください',
    tipMessage2: '販売権を選択してください',
    tipMessage3: 'コミッション比率を入力してください',
    addError1: 'QRコード名が既に存在しているため、再度入力してください',
    prompt: 'QRコードを削除しますか？',
    searchMore: '商品一覧',
    choseCode: 'QRコードを選択',
    choseCodeError: 'QRコードを選択してください',
    nickName: 'ニックネーム',
    auditStatus: '審査状態',
    submitAudit: '審査を同意します？',
    submitAudit1: 'この現金引き出しを同意しますか？',
    cannotSale: 'ユーザーを無効後、QRコードを通じて購入した商品は、手数料の分配は行いません',
    canSale: 'ユーザーを有効後、QRコードを通じて購入した商品は、手数料の分配は行います',
    remark: '備考',
    agree: '同意',
    handle: '処理',
    notAgree: '却下',
    applyMoney: '引き出し金額',
    applyMoney1: '引き出し金額(手数料抜き)',
    chargeMoney: '手数料',
    chargeMoney2: '手数料込み',
    aduitTime: '審査時間',
    aduitName: '審査人',
    remittanceExport: '振込みデータダウンロード',
    realName: '口座名義',
    bankNo: '口座番号',
    bankName: '銀行名',
    branchName: '支店名',
    accountType: '口座種類',
    tocDistributor: '所属エージェント',
    distributorName: '二級エージェントニックネーム',
    twoDistributor: '二級エージェント',
    oneDistributor: 'エージェント',
    drawaltip1: '引き出し金額が残高を超えてます',
    drawaltip2: '引き出し金額が手数料より少ない',
    drawaltip3: '引き出し金額を入力して下さい',
    drawaltip4: '処理中の現金引き出し申請が御座います、処理完了までお待ちください',
    saleName: 'ユーザー',
    saleMoney: '二級エージェント収益',
    distributorMoney: 'エージェント収益',
    isHasMoney: '入金状態',
    isPay: '入金済み',
    notPay: '未入金',
    handleStatus: '処理状態',
    handleStatus1: '処理待ち',
    handleStatus2: '処理済',
    handleStatus3: '却下済',
    handleBy: '処理人',
    handleTime: '処理時間',
    setCharge: '手数料設置',
    chargeConfirm: '引き出し手数料の変更を確定しますか？',
    accountStatus: 'アカウント状態',
    canUse: '有効にする',
    cannotUse: '無効にする',
    cannotUse1: '連携解除済み',
    incomeAmount: '収益金額',
    tocIncomeAmount: 'C端アカウント残高',
    withdrawalError1: '口座名義を入力して下さい',
    withdrawalError2: '口座番号を入力して下さい',
    withdrawalError3: '銀行名を入力して下さい',
    withdrawalError4: '支店名を入力して下さい',
    withdrawalError5: '預金種目を入力して下さい',
    handleError1: '当ユーザー残高不足、引き出し処理できません',
    handleError2: '引き出し処理は運営ユーザーのみ操作可能',
    handleError3: '残高不足、引き出し処理できません',
    withdrawalTips: '日本円一万円以上（一万円も含む）の場合は無手数料;日本円一万円以下、固定手数料が発生します',
    withdrawalTips1: '日本円一万円以上（一万円も含む）の場合は無手数料',
    withdrawalTips2: '日本円一万円以下、固定手数料が発生します',
    applyCash: '引き出し申請',
    applyBy: '申請者タイプ',
    applyUser: '申請者',
    twoApplyName: '二級エージェント',
    cannotCharge: '金額は整数しか設定できません',
    name: '名称',
    Unbundling: '連携解除',
    UnbundTips: '連携解除後、このユーザーには販売コミッションが発生しなくなります。',
    cannotUnbund: '振込未完了のコミッションが御座います。連携解除できません。',
    twoApplyNameID: '二級エージェントID',
    inputScale: '分配するコミッション率を入力して下さい',
    keyTips: '二級エージェントID/二級エージェントニックネーム',
    saleLog: '直販記録',
    withdrawalTips4: '残高不足、引き出しを申請できません。'
  },
  payWay: {
    balance: '残高',
    weChat: 'Wechat',
    alipay: 'アリペイ',
    creditCard: 'クレジットカード',
    unionPay: '銀聯',
    weChatWay: 'ウィチャットペイ',
    payedId: '決済番号',
    alipayWay: 'アリペイ',
    linePay: 'Line決済',
    grabPay: 'Grab決済',
    zaloPay: 'Zalo決済',
    aliPayHK: 'アリペイ香港',
    isPay: '予約決済中',
    codeTips: 'QRコード有効期切れ、再取得してください',
    codeTips1: 'QRコード再取得',
    codeTips2: 'ウィチャットで',
    codeTips3: 'QRコードをスキャン',
    codeTips4: 'アリペイで',
    codeTips5: 'QRコードをスキャン',
    codeTips6: 'カメラで',
    refundTips: '予約はキャンセルされました、お支払いの全額はお支払元に返金致します。ご査収の程よろしくお願いします。',
    refundTips1: '予約は既に支払い済み、お支払いの全額はお支払元に返金致します。ご査収の程よろしくお願いします。',
    refundTips2: '予約の支払い方法により、支払い30日お超えた場合に返金できません、ご了承ください。',
    refundTips3: '予約のお支払いが失敗しました、既にお支払いした場合、お支払元に全額を返金致します。ご査収の程よろしくお願いします。',
    errorTips: '決済情報を取得できませんでした、再取得してください。',
    partialRefundTips: '一部返金の場合、手数料は返金されません',
    payTitle: '接続先商品予約決済'
  },
  newHome: {
    priceFormat: 'JPY {0} <span class="price-format">き</span>',
    expired: 'ログインが期限切れです。再度ログインしてください。',
    searchPlaceholder: '行き先・アクティビティを入力',
    searchButton: '検索',
    searchResults: '件の結果が見つかりました',
    category: {
      transport: '交通',
      themePark: 'チケット',
      wifi: ' Wi-Fiレンタル・SIMカード',
      carRental: 'お得なセット商品',
      dayTrip: 'ツアー・観光',
      hotel: '体験 & レストラン'
    },
    productSaleLabel: {
      osakaSalesOffice: '大阪営業所',
      tokyoSalesOffice: '東京営業所',
      fukuokaSalesOffice: '福岡営業所',
      kyotoSalesOffice: '沖縄営業所',
      nagoyaSalesOffice: '名古屋営業所',
      hokkaidoSalesOffice: '北海道営業所'
    },
    popularCities: '人気のスポット',
    popularCitiesEn: '人気スポット＆季節限定イベント特集',
    activeNumber: 'アクティビティ数',
    balance: '残高',
    switchToOldVersion: '旧版に切り替え',
    switchToNewVersion: '新版に切り替え',
    viewMore: 'もっと見る',
    all: 'すべて',
    sortBy: '並び替え',
    easyGoRecommend: 'EasyGoおすすめ',
    allDates: '日付',
    priceRange: '価格帯',
    other: 'その他',
    selectedExperiences: 'おすすめアクティビティ',
    topActivities: '日本の人気アクティビティ',
    sales: '予約数',
    price: '価格',
    stockQuery: '空き状況を確認',
    noProducts: '該当する商品がありません',
    salesLessThan1k: '予約数1,000未満',
    sortOptions: {
      new: '新着順',
      sales: '人気順'
    },
    autoConfirm: '即時予約',
    secondConfirm: 'リクエスト予約'

  }
};

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.default = {
  common: {
    zh: '简体中文',
    tw: '繫体中文',
    ja: '日本語',
    en: 'English',
    ko: '한국어',
    title: '백오피스',
    exit: '나가기',
    search: '상품이름/번호',
    tel: '전화',
    address: '주소',
    scenicSpotAreaSelection: '명소지역선택',
    inputRequiredTip: '명소이름을 입력하세요',
    edit: '편집',
    delete: '삭제',
    recommend: '추천설정',
    pay: '결제',
    printOrder: '주문프린트',
    download: '다운로드',
    cancelRecommend: '추천취소',
    cancel: '취소',
    confirm: '확인',
    submit: '변경',
    searchMore: '더보기',
    prompt: '안내',
    basicInfo: '기본정보',
    day: '일',
    hour: '시간',
    minute: '분',
    second: '초'
  },
  title: {
    supplement: '사용 프로세스 보충',
    addDining: '제품(식당)추가',
    balanceSetting: '库存价格',
    productPriceNumber: '재고가격',
    productState: '제품심사',
    productAll: '전체보기',
    productStated: '심사대기',
    productNotState: '심사 미통과',
    orderReport: '주문관리',
    orderDetail: '주문상세정보',
    scenicSpotList: '명소관리',
    addScenicSpot: '명소추가',
    editScenicSpot: '명소편집',
    scenicSpotDetail: '명소정보',
    popularCities: '인기 목적지 관리',
    addHotCity: '인기 목적지 추가',
    editHotCity: '인기 목적지 편집',
    productManager: '제품관리',
    pdfFilesManage: 'PDF파일창고관리',
    supplyManageProduct: '상품 판매 관리',
    tocDistributorManageProduct: 'TOC 상품 판매 관리',
    pdfBatchList: '차수목록',
    bulkPurchaseList: '대량 구매 목록',
    bulkPurchaseDetail: '대량 구매 정보',
    submitAndPayOrderBatch: '대량으로 구입하다',
    batchPdfFilesList: '차수파일목록',
    addPdfFiles: 'PDF파일창고추가',
    importPdf: 'PDF파일삽입',
    pdfFiles: 'PDF파일',
    DiningDetail: '식당제품정보',
    financeStatement: '재무제표 자동생성',
    statementDetail: '제표상세정보',
    warehouse: '창고관리',
    ticketDepot: '티켓창고관리',
    addTicketDepot: '새로추가된 티켓창고',
    importTicket: '입고',
    pinTicket: '끊은티켓 인증',
    pinTicketMagn: '인증티켓관리',
    trades: '거래명세',
    record: '인출기록',
    counter: '카운터관리',
    addCounter: '카운터추가',
    editCounter: '카운터편집',
    liaison: '연락인관리',
    addLiaison: '연락인추가',
    editLiaison: '연락인편집',
    updatePDFfiles: 'PDF파일창고수정',
    importThirdSystemProduct: '제품 소개 관리',
    productLogList: '제품 수정 기록',
    productLogDetail: '제품 변경 상황',
    productLanguageLogList: '제품 수정 기록',
    productLanguageLogDetail: '제품 다언어 변경 정보',
    bannerManage: '배너 관리'
  },
  lable: {
    translation: 'AI 번역',
    translationing: 'AI 번역 중...',
    translationTip: '번역할 데이터가 없습니다',
    isOnline: '상장 여부',
    hotCity: '인기 목적지',
    cityName: '목적지 이름',
    cityPicture: '목적지 이미지',
    languageType: '언어',
    sort: '정렬',
    sortTip: '값이 작을수록 상위에 표시됩니다',
    onlineTip: '오프라인으로 설정하면 클라이언트에 표시되지 않습니다',
    hotType: '인기 유형',
    type1: '인기 지역',
    type2: '인기 목적지',
    type3: '인기 랜드마크',
    addProduct: '제품 추가',
    productInformation: '제품 정보',
    price: '가격',
    tags: '태그',
    productList: '제품 목록',
    bannerTitle: '배너 메인 타이틀',
    bannerSubTitle: '배너 서브 타이틀',
    bannerImages: '배너 이미지',
    selectLogType: '찾기 종류 선택',
    selectLogType_1: '기본 필드',
    selectLogType_2: '다중 언어 필드',
    inputProductId: '제품 ID를 입력',
    inputProductId_placeholder: '제품 ID를 입력',
    customerDataType: '고객 정보 유형',
    customerDataInfo: '고객 정보',
    chooseProductLanguage: '제품 언어를 선택하십시오',
    noDataForLanguage: '아직 데이터가 없습니다. 다른 언어를 선택하세요.',
    newOrderEmail: '주문 알림 메 일 박스',
    batchStatus: '차수상태',
    proofPath: '인증서 링크',
    pinTicketNum: '인증 수',
    KlookTicketCanbeUsedDateTBList: ' 6개월 이내',
    KlookTicketCanbeUsedDate: ' 같은 가격의 하루 유효 기간은 6개월이다',
    QuantityMismatch: '판매 표수가 실제 구매 수량과 일치하지 않으면 계속 판매 여부를 확인한다.',
    importProduct: '제품 가져오기',
    system: '도킹 시스템',
    chooseSystem: '도킹 시스템을 선택하십시오',
    klook: '커런트 시스템',
    link: 'LINK',
    thirdNum: '제3자 제품 번호',
    enterThirdNum: '제3자 제품 번호를 입력하십시오.',
    thirdProductTime: '시간대：',
    timeTips: '시간대를 입력해 주세요(1-24)',
    haveInventory: '재고가 있다',
    noInventory: '재고 없음',
    travlerFirstName: '관광객 이름',
    travlerFamilyName: '여행객 성',
    travlerCall: '호칭',
    enterGolfCourseCode: '请输入高尔夫场地编号',
    enterPrefecture: '请输入行政区域编号',
    Mr: '선생',
    Ms: '여사',
    Miss: '아가씨',
    Mrs: '부인',
    duration: '지속 시간',
    travellers: '승객 수를 표시하다.',
    voucherUsage: '인증서 사용방법',
    voucherTypeDesc: '인증서 형식',
    voucherValidity: '인증서 유효기간',
    redemptionProcess: '확인 절차',
    transportation: '교통 수단',
    insiderTips: '따스한 풍선 도움말',
    joinAstrict: '참가 제한',
    demand: '요구 사항',
    packageOptions: '패키지 설명',
    itinerary: '진행 설명',
    additionalInformation: '부가 정보',
    meetUpLocation: '집합 설명',
    pickUpLocation: '주소를 수령하다.',
    surcharge: '시간외비용',
    location: '주소',
    submitOrderTip: '이 제품은 특수 제품으로 주문서 제출시 자동으로 지불됩니다. 제출하시겠습니까?',
    submitOrderBatch: '구매 내용을 확인하시기 바랍니다. 예약 보낼 경우에는 구매 총 금액이 자동으로 AGT의 잔액에서 차감됩니다. 주의하시기 바랍니다?',
    location_placeholder: '주소를 입력하십시오',
    duration_placeholder: '활성 시간 입력',
    productConfirmType_placeholder: '확인 종류를 입력하십시오',
    transportation_placeholder: '교통편을 입력하십시오.',
    voucherTypeDesc_placeholder: '인증서 형식을 입력하십시오.',
    voucherUsage_placeholder: '인증서 사용 방법을 입력하십시오.',
    voucherValidity_placeholder: '인증서 유효기간을 입력하십시오.',
    pickUpLocation_placeholder: '수령할 주소를 입력하십시오',
    redemptionProcess_placeholder: '주소를 입력하십시오',
    packageOptions_placeholder: '패키지설명을 입력하십시오',
    itinerary_placeholder: '진행 설명을 입력하십시오',
    additionalInformation_placeholder: '첨부 정보를 입력하십시오',
    surcharge_placeholder: '시간 초과분을 입력하십시오',
    insiderTips_placeholder: '포근한 풍선 도움말을 입력하십시오.',
    updateType: '유형 수정',
    updateFloatPrice: '가변 가격',
    shareQrCode: '2차원 코드',
    setQrCode: 'QR코드 설정',
    addCoupon: '쿠폰 신규 추가',
    couponName: '쿠폰 명칭',
    couponAmount: '쿠폰 금액',
    couponOrder: '쿠폰 거래',
    couponCode: '쿠폰 코드',
    addCouponCode: '쿠폰 코드 신규 추가',
    downloadCouponCode: '쿠폰 코드 다운로드',
    batchDelete: '일괄 삭제',
    downloadNow: '{cnt}장을 신규 추가했습니다. 다운로드하시겠습니까?',
    tipMessage1: '이름을 입력하십시오',
    examine: '판매점 심사',
    revenueManagement: '수익관리',
    revenueDetail: '수익관리',
    cashManager: '현금인출관리',
    productState: '状态选择',
    orderNum1: '정렬',
    netError: '해당 제품은 공급업체에서 이미 단종되었습니다.',
    updateProduct: '更新',
    addQrCode: 'QRコードを追加',
    pleasechoice: '골라 주세요',
    identity: '신분증, 신분증, 신분증',
    studentId: '학생증',
    officerId: '장교증',
    passport: '여권 3.',
    residence: '호구본 (아동 선택하십시오)',
    hongKongandMacaopass: '홍콩 마카오 통행증',
    cellsyndrome: '대포증',
    identificationNumber: '번호',
    children: '(아동 입력 생년월일)',
    addressinformation: '주소 정보',
    expressaddress: '택배 주소',
    postalCode: '우편 번호',
    suborderinformation: '주문서 주문서 ID',
    subordersId: 'JTR주문 확인',
    qxzfbcplx: '등록할 제품유형을 선택하세요',
    selectTreeId: '请选择产品类型',
    ticketType: '상품종류',
    jtrticketType: '类型',
    productPriceTypeSetting: '가격 카테고리 설정',
    batchPriceRuleSetting: '차수가격규정설정',
    specificDatePriceSetting: '특정날짜 가격설정',
    currentProducts: '현재제품：',
    currentProducts_saleDate: '현재제품 등록시간대：',
    unlimited: '무제한',
    setProductInventoryAndPrice: '제품재고·가격 대량설정',
    setProductPriceType: '제품 가격 카테고리 설정',
    serialNumber: 'No.',
    period: '시간대',
    timelimit: '시간범위',
    selectDateRange: '날짜범위선택',
    selectTimeRange: '시간범위선택',
    inventory: '재고',
    purchasePrice: '구매가격',
    jtrDistributionPrice: '分销平台采购价',
    stockNum: '장차 재고',
    distributionPrice: '유통가격',
    marketPrice: '시장가격',
    retailPrice: '구매추천가격',
    operating: '실행',
    delete: '삭제',
    chargeback: '退单',
    addTimePeriod: '시간대추가',
    reset: '초기화',
    save: '저장',
    goBack: '뒤로',
    confirm: '확인',
    confirmOrder: '주문확인',
    confirmOrder1: '北海道确认订单',
    jtrconfirmOrder: 'JTR주문 확인',
    refuse: '주문거절',
    cancelOrder: '取消订单',
    requestCancel: '신청취소',
    specialRequestRefund: '特殊申请退款',
    requestRefund: '申请退款',
    makeSure: '확인',
    cancel: '취소',
    productName: '상품명',
    scene: '场次',
    dataSource: '데이터 원본',
    selectDistributor: '유통사선택',
    authorizedMerchant: '승인업체',
    businessName: '업체이름',
    priceFloatRange: '업체가격승인',
    distributorNameOrNumber: '업체이름/번호',
    distributorNumber: '유통사번호',
    distributorName: '업체이름',
    changeValidTime: '유효기간 변경',
    // suoCountry: '所属城市',
    suoCountry: '키워드입력',
    suoCountrys: '키워드입력',
    productNameOrId: '제품이름/번호',
    productNameOrIds: '제품이름/번호',
    productNameOrIdRemark: '제품이름/번호/비고/태그',
    productDiff: '상품종류',
    productDiffs: '상품종류',
    confirmMethod: '확인방법',
    managerArea: '관리지역',
    productCode: '상품번호',
    golfCourseCode: '高尔夫场地编号',
    prefecture: '地方行政区域',
    suoCity: '인기여행지',
    confirmMethods: '확인방법(결제,취소)',
    confirmMethodss: '확인방법(결제,취소)',
    managerAreas: '관리지역',
    different: '상품종류',
    number: '人数',
    status: '상태',
    ticketType0: 'E티켓',
    ticketType1: '종이티켓',
    ticketType2: '체험',
    ticketType22: '체험',
    ticketType3: '일일투어/장기투어',
    ticketType33: '일일투어/장기투어',
    ticketType4: '와이파이',
    ticketType5: '심카드',
    ticketType6: '음식점',
    ticketType66: '음식점',
    ticketType7: '교통',
    ticketType77: '교통',
    ticketType8: '패키지상품',
    ticketType88: '패키지상품',
    ticketType9: '야간버스',
    ticketType99: '야간버스',
    jtrticketType0: '입장권',
    jtrticketType1: '세트 또는 포장 제품',
    jtrticketType2: '自由行',
    jtrticketType3: '线路',
    jtrticketType12: '预售',
    isOnlinePay0: '线下',
    isOnlinePay1: '线上',
    isOnlinePay2: '在线支付（预付）',
    isOnlinePay3: '酒店前台现付（返佣）',
    confirmType0: '자동확인',
    confirmType00: '자동확인',
    confirmType1: '수동확인',
    confirmType11: '수동확인',
    confirmType12: '수동확인',
    confirmType2: '',
    productSource0: 'JPH상품',
    productSource1: '접속처 상품',
    status0: '심사 대기',
    status1: '심사 통과',
    status2: '심사 미통과',
    status3: '다운로드',
    status4: '초고',
    online: '온라인',
    checkAll: '취소완료',
    faverite0: '추천상품',
    faverite1: '비추천',
    toldAllLeft: '안내：사용날짜의',
    toldAllMiddle: '일전의',
    toldAllMiddles: '일전의',
    toldAllRight: '전 예약',
    orderEmergentTag: '긴급처리주문',
    orderUncertainTag: '결제확인중',
    orderConfirmedTag: '결제완료',
    orderCancellingTag: '취소대기',
    orderCanceledTag: '취소완료',
    orderCompletedTag: '새로운소식',
    orderExpiredTag: '만료됨',
    orderPaymentTag: '已支付（JTR）',
    orderRefundedRequestTag: '已申请退款（JTR）',
    orderRefundedTag: '환불완료',
    orderUnpaidTag: '결제대기',
    otherSelection: '기타옵션',
    remark: '비고',
    createRoleRemark: '비고',
    productHighlights: '특점',
    currentState: '현재상태',
    youHave: '아직 있습니다',
    processOrder: '이 주문을 처리하러 왔습니다',
    toPayOrder: '이 주문을 결제하러 왔습니다',
    OrderHistory: '주문내역',
    orderDisExplain: '주문 지침 (리셀러만 표시)',
    orderDisExplains: '중복 표 를 입력하지 마시오',
    CustomersInvisible: '고객열람불가',
    SupplierInvisible: '고객 메모',
    addRemark: '비고추가',
    addMessage: '메시지 추가',
    addExplain: '编辑说明',
    confirmation: '정말 이 주문을 확인하시겠습니까',
    confirmationPdf: '确认作废此PDF吗',
    confirmationticket: '确认作废此实体票吗',
    specialRefundConfirm: '确认退款后钱款将会全额返还给分销商,是否确认',
    specialRefundCancel: '拒绝退款则订单会继续进行下去',
    DeleteConfirmation: '정말 삭제하시겠습니까',
    refusal: '정말 이 주문을 거절하시겠습니까',
    voucherPath: '인증서 링크',
    messageInfo: '订单预订信息',
    orderID: '주문ID',
    sonOrderID: '주문ID',
    jtrOrderId: '渠道单号',
    orderSource: '주문 소스',
    useDate: '지정날짜',
    sonProduct: '자산품',
    useDate1: '지정날짜',
    useDates: '지정날짜',
    travelDate: '놀이기구',
    createTime: '생성시간',
    endTravelDate: '종료 시간',
    arrivedTime: '到达时间',
    touristRemarks: '游客备注',
    reserveNum: '预定数量',
    linkMan: '대화 상대 이름',
    warnning1: '必须真实姓名，用于景区验证',
    linkPhone: '연락처',
    linkEmail: '연락처 사서함',
    linkAddress: '快递地址',
    linkCode: '邮政编码',
    linkCreditType: '연락처 형식',
    linkoptionA: '身份证',
    linkoptionB: '护照',
    linkCreditNo: '联系人证件号码',
    customerUseDate: '사용날짜',
    customerTravelDate: '游玩日期',
    customerEndTravelDate: '游玩结束日期',
    customerArriveTime: '到达日期',
    customerGetTicType: '取票方式',
    customerGetTicType0: '免费',
    customerGetTicType1: '快递费',
    distributor: '유통사',
    PDFSendingMode: 'PDF전자티켓 발송방식',
    productPrice: '제품가격',
    Purchase: '구매',
    distributionPriceToc: '분배 가격',
    distributionPriceSum: '분배 가격 총화',
    productSalePrice: '상품의 부동 가격',
    productMinPrice: '최소 가격(디스플레이용)',
    productTcPrice: '제품 오프셋 가격',
    buyNum: '구매수량',
    seatName: '장소 이름',
    jtrAppendNum: '수량 을 늘리다',
    primarynum: '원정 수량',
    cancelNum: '수량을 취소하다',
    orderCnt: '성공 갯수',
    totalAmount: '결제총액',
    customerInfo: '고객정보',
    customerName: '성함',
    cusEmail: '이메일',
    Email: '이메일',
    receiveDate: '수령날짜',
    returnDate: '归还日期',
    FileImport: '파일삽입',
    upload: '업로드',
    onlyUpload: '업로드만 가능',
    noMoreThan: '파일，초과안함',
    generateOrder: '주문생성',
    thisOrder: '이 주문은',
    hasConsumed: '회원이 이미 소비함',
    noData: '데이터없음',
    viewName: '명소이름',
    viewLocal: '소재지',
    viewAddress: '명소주소',
    viewPicture: '명소사진',
    viewRemark: '명소비고',
    viewTelephone: '명소전화',
    payOrder: '주문결제',
    jtrpayOrder: 'jtr주문서 지불',
    jtrAppend: '추가 주문',
    operated: '실행',
    productSource: '상품 소속사',
    searchType: '검색 형식 선택',
    searchType1: '예약번호',
    searchType2: '상품명',
    searchType3: '고객성함',
    searchType4: '',
    searchType5: '고객이메일',
    searchType6: '채널 번호',
    searchType7: '태그',
    system1: 'EASYGO시스템',
    system2: '2cycle시스템',
    system3: '乐天系统',
    productConfirmType: '확인방법(결제,취소)',
    reserve: '예약',
    isOnlinePay: '지불 방식',
    startDate: '제일 먼저 노는 날.',
    maxNum: '최대 예정 수',
    minNum: '최소 예약 수',
    startNum: '최소 제품 예약 수량',
    isExpress: '택배 배송 지원 여부',
    yesExpress: '支持',
    noExpress: '不支持',
    expressPrice: '배송비',
    priceStartDate: '价格开始时间',
    priceEndDate: '价格结束时间',
    priceDate: '가격 시작 / 종료 시간',
    soldNum: '판매량',
    soldNumSort: '판매수',
    ticketCount: '销量',
    sourceType: '출처',
    sourceType1: 'JPH供应商',
    sourceType2: 'JTR供应商',
    sourceType3: 'KLOOK供应商',
    supplySourceType1: 'JPH产品',
    supplySourceType2: 'JTR产品',
    supplySourceType3: 'KLOOK产品',
    supplySourceType4: '2CYCLE产品',
    supplySourceType5: 'LINK',
    haveNoReserve: '품절',
    upTime: '등록시간',
    productReserve: '상품예약',
    pictureDown: '사진소재 다운로드',
    voideDown: '영상소재 다운로드',
    fileDepot: '文件仓库',
    takeView: '경치',
    productNumber: '제품코드',
    supplier: '협력사',
    operator: '운영상',
    useFate: '사용프로세스',
    supplement: '사용 프로세스 보충',
    supplements: '사용 프로세스 보충',
    ticketTypeName: '표',
    isOnlinepay: '지불 방식',
    num: '건',
    nums: '건',
    num01: '건',
    money: '￥',
    serviceLanguage: '서비스언어',
    productPeople: '소비자요구',
    takeTimeDesc: '영업시간설명',
    productUpTime: '제품상가기간',
    diningTime: '식사시간',
    diningPeople: '식사인원수',
    useTime: '사용시간',
    trafficMethod: '교통방식',
    moneyContant: '비용포함',
    moneyNotContant: '비용미포함',
    priceOrFloat: '가격/재고',
    diningDescription: '제품디테일',
    picture: '포토',
    titles: '타이틀',
    numberBuy: '수량(분)',
    reserveDescription: '예약설명',
    beforeDay: '사전일',
    minteBefore: '분전에예약',
    usingDate: '이팩티브시간',
    canBeUseDate: '유효일기',
    canBeUseDate1: '유효일기',
    returnMethod: '환불설정',
    returnDescription: '환불설명',
    reserveNotice: '예약사항',
    importantNote: '重要提示',
    userNote: '使用说明',
    changeMethod: '티켓교환방식과카운터',
    comnicationPeople: '연락자',
    contionMen: '연락자',
    telphone: '연락방식',
    welcomeData: '접대시간',
    productDescription: '제품묘사',
    dangerConcationMen: '긴급연락자',
    productPackageContainDetail: '세트포함제품디테일',
    productPackageDetail: '세트제품디테일',
    productContainDetail: '제품포함디테일',
    SIMSize: 'SIM카드크기',
    netCover: '네트워크커버',
    threeGNetCover: '3G네트워크데이터',
    fourGNetCover: '4G고속네트워크데이터',
    parts: '부품',
    SIMProductDetail: 'SIM카드제품디테일',
    WIFIProductDetail: 'wifi产品详情',
    tourProductDetail: '일일행/다일행제품디테일',
    ticketProductDetail: '门票详情',
    packageProductDetail: '套餐或打包产品详情',
    freeTourDetail: '自由行详情',
    routeDetail: '路线详情',
    advanceDetail: '预售详情',
    toursTime: '스케쥴시간',
    travelStyle: '노선스타일',
    trafficStyle: '교통도구',
    startCourtyOrEnd: '출발도시/목적지',
    jtrPeopleNum: '产品包含成人数 ',
    jtrChildrenNum: '产品包含儿童数',
    peopleNum: '팀인원수',
    buyMessage: '쇼핑정보',
    tourDetail: '스케쥴디테일',
    giveClass: '증정항목',
    trafficProductDetail: '교통제품디테일',
    ybProductDetail: '야간버스제품 설명',
    // takePomStyle: '1.티켓교환방식',
    takePomStyle: '',
    longWord: '예약성공，플랫폼은 남거둔이메일에 예약성공메일을 보낸다，받은 검증코드 혹은 이차원코드를  아래 환전 카운터에 제시하여 실체표를 수령한다。',
    // canBeTakePom: '2.카운터교환가능',
    canBeTakePom: '',
    counterLink: '수령카운터',
    orderMessages: '새연락',
    saleTimes: '영업시간',
    telphoneCommicta: '연락번호：',
    jtrOrderVaildType0: '游客选定的游玩日期当天有效',
    jtrOrderVaildType1: '游客预订日期延后',
    jtrOrderVaildType2: '游客预订日期截止到',
    jtrOrderVaildType3: '游客选定日期延后',
    jtrOrderVaildType4: '游客选定日期截止到',
    orderVaildType0: '사용일 당일 유효성을 지정 ',
    ordervaildType12: '주문일부터',
    ordervaildType1: '일내유효',
    ordervaildType2: '주문일부터지정일까지',
    ordervaildType3: '유효',
    ordervaildType4: '지정사용일부터',
    ordervaildType5: '지정사용일부터 지정일까지',
    ordervaildType55: '지정사용일부터 지정일까지',
    ordervaildType6: '지정일',
    ordervaildType7: '까지',
    ordervaildType8: '내유효',
    ordervaildType9: '지정한사용일',
    ordervaildType10: '일전부터지정사용일까지',
    ordervaildType11: '일후까지유호',
    ordervaildType13: '天内有效',
    ordervaildType14: '有效',
    ordervaildType15: '内有效',
    orderRefundType0: '환불불가',
    orderRefundType1: '소비전 수시로 환불가능',
    orderRefundType4: '游玩日期',
    orderRefundType5: '天前可以退款',
    orderRefundType3: '주문기한이 지나 시스템은 환불 서비스를 제공하지 않음!',
    orderRefundType7: '您的订单产品属于不可退款类型，无法提供退款服务！',
    orderRefundType6: '此订单您尚未支付，无法退款',
    eleDetail: '전자티켓제품디테일',
    jtrticketDetail: '门票产品详情',
    entityDetail: '실체표제품디테일',
    experienceDetail: '제품디테일체험',
    detail3: '一日游/多日游产品详情',
    detail4: 'WI-FI产品详情',
    detail5: 'SIM卡产品详情',
    detail6: '美食产品详情',
    detail7: '交通产品详情',
    detail8: '优惠套票产品详情',
    eleDetailPreview: '전자티켓제품미리보기',
    entityDetailPreview: '실체표제품미리보기',
    experienceDetailPreview: '제품미리보기체험',
    tourPreview: '일일행/다일행제품미리보기',
    wifiPreview: 'WIFI제품미리보기',
    simPreview: 'SIM카드제품미리보기',
    diningPreview: '식당제품미리보기',
    trafficPreview: '교통제품미리보기',
    packagePreview: '세트제품미리보기',
    spread: '장',
    diningDetail: '식당디테일',
    diningDetailPreview: '식당미리보기',
    orderStatus: '오더상태',
    floatPrice: '浮动价格',
    ifOnLine: '온라인여부',
    onLine: '온라인',
    isEdit: '待上线',
    offLine: '오프라인',
    SalesSituation: '판매상황',
    orderNum: '단',
    copyOperating: '코피',
    graphicEditing: '图文编辑',
    revoke: '심사취소',
    modify: '수정',
    jtrModifylanguage: '多语言编辑',
    more: '더',
    distributionAuthorization: '대리위임',
    specialPrice: '특별가격',
    specialPriceSet: '대리특별가격설정',
    distributionRange: '대리상가범위위임',
    distributionRangeAll: '전부상가대리가능',
    distributionRangeYes: '지정된상가만대리가능',
    distributionRangeNo: '지정된상가이외의상가대리가능',
    merchantRangeAll: '전부상가',
    merchantRangeYes: '지정상가',
    merchantRangeNo: '지정상가이외',
    specifiedRange: '지정범위',
    account: '계좌',
    PDFSendWay: 'PDF전송방식',
    PDFOnLine: '온라인',
    PDFOffLine: '오프라인',
    connectInformation: '연락정보',
    dialogCancel: '취소',
    dialogSure: '확정',
    dialogSave: '수정보존',
    selectProCategory: '첨가제품의유형을선택',
    ticketsMessage: 'QRコードにより直接入場/利用する施設のチケット。',
    ticketsMessage2: 'QR코드로 종이티켓과 이용하는 명소, 오락시설 입장권을 교환하세요.',
    ticketsMessage3: 'QR코드로 현장 교환하거나 바로 소비하는 오락시설 입장권으로 교환하세요.',
    ticketsMessage4: '일일여행, 1일이상여행, 렌트카투어 상품',
    ticketsMessage5: 'Wi-Fi임대',
    ticketsMessage6: '유심칩',
    ticketsMessage7: '좌석예약, 코스예약 상품',
    ticketsMessage8: '교통권, 픽업샌딩, 렌터카 상품',
    ticketsMessage9: '혜택가격 세트 패키지상품',
    ticketsMessage10: '야간버스 상품',
    serialNumbers: 'No.',
    belongArea: '소재지역',
    connectWay: '연락방식',
    purchasingSituation: '구매상황',
    proStatus: '제품상태',
    ifOnlineStatus: '온라인상태',
    today: '오늘이용예약가능',
    tomorrow: '내일이용예약가능',
    oldPassword: '기존 비밀번호',
    newPassword: '새로운 비밀번호',
    checkPassword: '비밀번호 재확인',
    limitDay: '기타',
    limitDays: '기타',
    auditCannot: '심사불통과이유：',
    notMust: '불제한',
    breakfast: '아침식사',
    lunch: '점심식사',
    afternoonTea: '오후차',
    dinner: '저녘식사',
    buffet: '自助餐',
    bus: '班车',
    caddie: '球童',
    cart: '高尔夫球具车',
    overnight_accommodation: '住宿一晚',
    play_early: '提前玩',
    play_through: '优先玩',
    play_through_am: '上午优先玩',
    play_through_pm: '下午优先玩',
    nightSnack: '야식',
    singleMeal: '일인용식사',
    doubleMeal: '2인용식사',
    thirdMeal: '3~4인용식사',
    fiveMeal: '5~10인용식사',
    tenMeal: '10인시상',
    haveMustData: '구체적시간있음',
    common: '총',
    species: '종',
    dayBefore: '일전',
    applyToRefund: '(현지시간)전환불신청가능',
    updateNotAudited: '심사불통과이유를수정',
    pleaseEnterAudited: '심사불통과이유를입력하세요',
    updateSuccess: '업데이트성공！',
    updateFliture: '업데이트실패！',
    submitError: '유감스럼게 심사제시오류로 제도시 부탁드립니다',
    letterCounter: '반환카운터',
    car: '자동차',
    tram: '전차',
    cruise: '크루즈',
    tourDetailTemp: '스케쥴디테일',
    auditingProductNum: '대기심사제품수랑',
    productNum: '제품수량',
    orderSum: '오더량',
    payBySupplierNum: '거래액',
    balanceNum: '잔액',
    productOrderNum: '플랫폼제품수',
    distritorNum: '대리점수량',
    supplierNum: '협력사수량',
    urgentNum: '긴급처리주문내역',
    confirmNum: '결제완료내역',
    unpassNum: '심사불통과제품',
    beConfirmNum: '결제확인중내역',
    cancelingNum: '취소오더대기처리',
    unPaymentNum: '결제대기내역',
    cancelingOrder: '취소대기내역',
    becancelOrder: '취소완료내역',
    auditingProduct: '심사대기제품',
    supplierAuditing: '협력사심사대기',
    distributorAuditing: '대리점심사대기',
    notice: '알림',
    releaseNotice: '공고발포',
    haveNotNotice: '새로운 소식이 없습니다！',
    unRead: '읽지않았다',
    readed: '읽었다',
    unReadNotice: '읽지않은 알림',
    noticeDetail: '통고디테일',
    messageStart: '본정보부터',
    messageMiddle: '부터효력。 관리원은',
    messageEnd: '본정보발포',
    country: '국가',
    province: '성',
    city: '도시',
    area: '지역',
    year: '년',
    month: '월',
    one: '1',
    two: '2',
    three: '3',
    four: '4',
    five: '5',
    six: '6',
    seven: '7',
    buyPrice: '구매가격',
    selectSupplier: '공급사선택',
    updloadFiles: '파일업로드：',
    pleaseChange: '선택하세요',
    auditMessageEnter: '예약정보입력',
    auditMessageEnter1: '예약정보입력',
    enterAmount: '수량',
    pleaseEnterProductAmount: '제품수량을 선택하세요',
    endSlary: '결제금액(JPY)',
    endTotalAmount: '총 제품 금액',
    ridePlace: '승차위치',
    getOnTheTrain: '승차지점',
    onTrainTime: '승차시간',
    choseUpPlace: '승차지점을 선택해 주세요.',
    choseDownPlace: '하차지점을 선택해 주세요.',
    getDownTheTrain: '하차지점',
    downTrainTime: '하차시간',
    orderMessageByMe: '주문정보',
    confirmEmail: '주문확인메일',
    aboutTipMessage: '접수된 주문를 상세하게 확인해야 하며 반드시 정확해야 합니다.',
    aboutOrderLanguageType: '주문확인 사용언어',
    aboutChangeData: '날짜선택',
    travler: '여행객',
    mainTravler: '대표자',
    travlerName: '여행객이름',
    travlerPhone: '여행객휴대폰',
    customerEmail: '이메일',
    customerWechat: '위챗',
    customerPassport: '여권',
    customerSex: '성별',
    orderByMessage: '주문추가정보',
    orderExplain: '비고',
    productUseData: '사용과정',
    canBeTaken: '환전가능 카운터',
    mustBeComplate: '반드시 전체이름을 적어야 합니다. 인증 시 필요.',
    productCanBeReciveTo: '이 제품은 고객에게 메시지나 이메일을 발송해야 합니다. 전화번호 또는 이메일을 꼭 남겨주세요(비중국대륙 전화번호는 이메일을 적어주세요).',
    submitOrder: '주문제출',
    nowPages: '현재제품',
    travlerEmail: '여행객메일',
    travlerWebchat: '여행객위챗',
    travlerPassport: '여행객여권',
    travlerAddress: '邮寄地址',
    travlerPostCode: '邮政编码',
    travlerCreditType: '证件类型',
    travlerCreditNo: '证件号码',
    travlerSex: '여행객성별',
    mustToWrite: '필수입력사항',
    notMustToWrite: '선택입력사항',
    orderStatus0: '주문생성',
    orderStatus1: '주문제출',
    orderStatus2: '주문취소(유통사)',
    orderStatus3: '주문취소(공급사)',
    orderStatus4: '주문확인',
    orderStatus5: '주문완성',
    orderStatus6: '미결제주문취소',
    orderStatus7: '주문거절',
    orderStatus8: '주문취소 확인',
    orderStatus9: '주문취소 거절',
    orderStatus10: '주문 자동확인',
    orderStatus11: '주문 자동완성',
    orderStatus12: '주문 자동취소',
    orderStatus13: '결제 시간초과, 주문 자동취소',
    orderStatus14: '申请退款',
    orderStatus15: '确认退款',
    orderStatus16: '拒绝退款',
    orderStatus17: '订单已核销',
    orderStatus18: '订单已出票',
    orderStatus19: '运营商特殊取消',
    orderStatus20: '패스 항공권 특별 취소',
    orderStatus21: '유효 주문서 자동처리',
    orderStatus22: '연결 API 취소',
    orderStatus23: '시스템 한쪽 취소',
    notPaymentTag: '미결제취소',
    travelsSelectData: '주문유효기간 마감일 전',
    jtrOrderRefund0: '游玩日期前',
    jtrOrderRefund1: '游玩日期后',
    jtrOrderRefund2: '天可以退款',
    jtrOrderRefund3: '当日可退',
    jtrOrderRefund4: '天可以退款',
    day: '일',
    ticketPrice: '',
    refundPayment: '환불수수료 :',
    cancelCannot: '취소이유',
    refundCannot: '환불 이유',
    cancelOrRefund: '거절이유',
    cancelReason: '取消理由',
    admin: '관리자',
    clerk: '업무원',
    refuseCannot: '거절이유',
    updateTime: '업데이트시간',
    counterDetails: '카운터',
    applyDate: '신청시간',
    pleaseIntoCancelReason: '거절이유를 입력하세요',
    pleaseIntoCancelCannot: '취소이유를 입력하세요',
    pleaseIntoInfo: '请输入文字',
    applyType: {
      applyType0: '유통사',
      applyType1: '공급사',
      applyType2: '관리자',
      applyType3: '사무원',
      applyType4: '기타'
    },
    adminAccount: {
      createUser: '캐릭터 만들기',
      roleName: '캐릭터이름',
      createRoleName: '캐릭터이름',
      account: '소속계정',
      applyType: '적용 유형',
      isEnable: '활성화 여부',
      enable: '활성화',
      disable: '비활성화',
      roleDistribution: '권한',
      roleManager: '캐릭터 만들기',
      authMenu: '권한 메뉴',
      checkAll: '모두선택'
    }
  },
  viewMessage: {
    message1: '정말 저장하시겠습니까?',
    message2: '명소이름을 입력하세요',
    hotCity_message2: '목적지 이름을 입력하세요',
    hotCity_message19: '1에서 200자 사이로 입력하세요',
    hotCity_remark_placeholder: '비고를 입력하세요',
    banner_save_success: 'Banner saved successfully!',
    banner_save_error: 'Failed to save banner!',
    message3: '명소주소를 입력하세요',
    message4: '사용추천',
    message5: '정말 저장하시겠습니까?',
    message6: '정말 저장하시겠습니까?',
    message7: '정말 저장하시겠습니까?',
    message8: '명소지역을 선택하세요',
    message9: '3~50자',
    sysError: '시스템 오류!',
    revokeMessage: '이 실행은 심사를 철회합니다. 계속하시겠습니까?',
    revokeSuccess: '심사철회 성공!',
    revokeHavePassed: '이 제품은 이미 심사를 통과했으며 철회할 수 없습니다!',
    revokeHaveNotPassed: '이 제품은 심사를 통과하지 못했으며 철회를 진행할 수 없습니다. 다시 신청해주세요!',
    revokeOperationCanceled: '심사철회가 취소됐습니다!',
    offLineMessage: '이 실행은 제품을 내립니다. 계속하시겠습니까?',
    offLineSuccess: '내리기 성공!',
    offLineOperationCanceled: '내리기 실행취소됨',
    onLineSuccess: '올리기 성공!',
    onLineMessage: '이 실행은 제품을 올립니다. 계속하시겠습니까?',
    deleteMessage: '이 실행은 본 제품을 영구적으로 삭제합니다. 계속하시겠습니까?',
    deleteMessageOrder: '이 실행은 본 주문을 영구적으로 삭제합니다. 계속하시겠습니까?',
    deleteSuccess: '삭제성공!',
    deleteOperationCanceled: '삭제가 취소됐습니다!',
    thisRangeNotEmpty: '이 지정범위 내 업체를 입력해야 합니다!',
    thisPriceRangeNotEmpty: '업체유통가격승인을 입력해야 합니다!',
    thisPriceRangeNotNum: '숫자를 입력하세요!',
    editSuccess: '편집성공!',
    pleaseDeletePackageProduct: '포장제품을 먼저 삭제하거나 포장제품에서 이 제품을 제거하세요.',
    upToLine: '이 작업을 실행하면 제품이 등록됩니다. 계속하시겠습니까?',
    newToUse1: '이 작업을 실행하면 차수상태가 꺼짐으로 변경됩니다. 계속하시겠습니까?',
    newToUse0: '이 작업을 실행하면 차수상태가 정상으로 변경됩니다. 계속하시겠습니까?',
    fileToDelete: '이 작업을 실행하면 본 파일창고가 영구적으로 삭제됩니다. 계속하시겠습니까?',
    useSuccess: '실행성공',
    useFail: '실행실패',
    holdSuccess: '저장성공!',
    holdError: '저장실패!',
    maxDay: '한번에 최대 10년 데이터 설정가능',
    submitSuccess: '제출성공!',
    submitSuccessconfirmed: '提交成功！等待确认！',
    submitError: '제출실패!',
    balanceNotDone: '계정잔액이 부족합니다. 충전 후 이 주문을 완성해주세요',
    balanceDone: '축하합니다. 결제 성공',
    cancelDone: '취소신청이 발송됐습니다. 업체의 처리를 기다려주세요',
    cancelDone2: '취소 및 환불 처리됐습니다. 페이지를 새로고침하여 확인하세요',
    cancelDone3: '您的退款申请已发送，请等候商户处理',
    cancelError: '업체가 잔액이 부족하므로 현재 주문을 취소할 수 없습니다',
    cancelError1: '系统异常，请联络管理员',
    message10: '편집을 저장하시겠습니까?',
    lable1: '취소',
    lable2: '저장 안함',
    lable3: '저장',
    message11: '3~50자',
    message12: '국가를 선택하세요',
    message13: '지역을 선택하세요',
    message14: '3~50자',
    message15: '기본정보를 모두 기입해주세요',
    message16: '편집을 그만두시겠습니까?',
    message17: '명소를 사용 중이므로 삭제할 수 없습니다!',
    confirmDone: '확인성공',
    tipMessage1: '캐릭터 비고를 입력하세요',
    tipMessage2: '255자를 초과하지 마세요',
    tipMessage3: '캐릭터이름을 입력하세요',
    tipMessage4: '100자를 초과하지 마세요',
    tipMessage5: '커미션 비율을 0에서 100까지밖에 입력할수 없습니다.',
    messageNotCompleteIn: '모든 필수정보를 기입해주세요',
    orderStatusHadUpdate: '오더상태가 업데이트됨',
    orderRefundFalse: '订单退款申请失败',
    message18: '长度在 0 到 500 个字符',
    message19: '长度在 3 到 500 个字符',
    message20: '当前种类在该时间段内已存在',
    cleckOrder: '确认核销订单',
    cleckOrderCanceled: '取消核销',
    cleckSucc: '核销成功'
  },
  counterMessage: {
    counterName: '카운터이름',
    counterAddress: '카운터주소',
    counterTelephone: '카운터전화',
    busineTime: '영업시간',
    counterPic: '카운터사진',
    lable1: '취소',
    lable2: '저장 안함',
    lable3: '저장',
    message1: '카운터이름을 입력하세요',
    message2: '이 실행은 본 카운터를 영구적으로 삭제합니다. 계속하시겠습니까?',
    message3: '삭제성공',
    message4: '사용 중이므로 삭제할 수 없습니다',
    message5: '카운터사진 업로드',
    message6: '편집을 저장하시겠습니까',
    message7: '카운터이름을 입력하세요',
    message8: '카운터주소를 입력하세요',
    message9: '카운터전화를 입력하세요',
    message10: '올바른 카운터전화를 입력하세요',
    message11: '6~20자',
    message12: '카운터 접수시간을 입력하세요',
    message13: '저장실패',
    message14: '저장성공',
    message15: '편집을 그만두시겠습니까？',
    message16: '长度在 1 到 500 个字符'
  },
  liaisonMessage: {
    liaisonName: '이름',
    liaisonTelephone: '연락방식',
    receptionTime: '접수시간',
    message1: '연락인 이름을 입력하세요',
    message2: '연락인 전화를 입력하세요',
    message3: '연락인 접수시간을 입력하세요',
    message4: '정말 이 연락처를 삭제하겠습니까?',
    message5: '삭제성공',
    message6: '사용 중이므로 삭제할 수 없습니다',
    message7: '편집을 저장하겠습니까?',
    message8: '취소',
    message9: '저장 안함',
    message10: '저장',
    message11: '저장실패',
    message12: '편집을 그만두시겠습니까?',
    message13: '저장실패',
    message14: '저장성공'
  },
  registerMessage: {
    directorWechatComment: '당사에서 정보 등을 신속 하 게 알아볼 수 기 때문에 여기를 추천 합니다.자세한 내용은 별도로 제공 되는 설명서를 확인 하시기 바랍니다.',
    supplierRegister: '공급사등록',
    distributorRegister: '유통사등록',
    accountInfo: '계정정보',
    companyInfo: '회사정보',
    mainBusiness: '주요업무내용(업무내용에 맞는 항목을 추천해 드립니다)',
    mainBusiness1: '주영 업무',
    saleType: '판매수단',
    trafficCardTicket: '교통패스권',
    carFree: '송영서비스',
    admissionToThePark: '테마파크',
    foodAndBeverage: '레스토랑예약',
    oneDayTour: '1DAY투어',
    daysTour: '장박투어',
    characteristicExperience: '체험프로그램',
    hotel: '호텔',
    physicalShop: '점포',
    fzShop: '쿠팡',
    mfwShop: '인터파크',
    tbShop: '옥션',
    xcShop: '11번가',
    tcShop: 'G마켓',
    qneShop: 'GS샵 롯데닷컴',
    tnShop: 'CJ몰',
    cupang: '신세계몰',
    gmarket: '롯데홈쇼핑',
    entry: '입력란',
    directorInfo: '업무담당자정보',
    account: '계정',
    password: '비밀번호입력',
    passwordConfirm: '비밀번호 확인',
    address: '소재지',
    companyName: '회사이름',
    logo: '회사로고',
    legalRepresentative: '법정대리인',
    companyAddress: '회사주소',
    companyTelephone: '회사전화',
    companyEmail: '회사이메일',
    companyWebsite: '홈페이지/점포링크',
    bankCardNumber: '은행계좌',
    qualification: '자격증명',
    directorName: '이름',
    directorTelephone: '연락전화',
    directorPosition: '직무',
    directorWechat: '위챗',
    directorCode: '초대 코드',
    phDirectorCode: '초대 코드를 입력하세요',
    directorCodeTip: '초대 코드를 입력하시면 우선 심사 및 다양한 혜택을 받으실 수 있습니다',
    directorEmail: '이메일',
    directorCard: '명함',
    phAccount: '로그인 계정을 입력하세요',
    phPassword: '로그인 비밀번호를 입력하세요',
    phPasswordConfirm: '로그인 비밀번호를 확인하세요',
    phCompanyName: '회사 정식등기명을 입력하세요',
    phLogo: '회사로고 업로드',
    phLegalRepresentative: '회사 법정대리인을 입력하세요',
    phCompanyAddress: '회사 상세주소를 입력하세요',
    phCompanyTelephone: '회사전화를 입력하세요',
    phCompanyEmail: '회사 이메일주소를 입력하세요',
    phCompanyWebsite: '회사홈페이지(또는 다른 플랫폼 점포링크)를 입력하세요',
    phBankCardNumber: '회사 은행계좌를 입력하세요',
    phQualification: '회사정식증록 관련자격증명 스캔',
    phDirectorName: '업무담당자 이름을 입력하세요',
    phDirectorTelephone: '업무담당자 전화번호를 입력하세요',
    phDirectorPosition: '업무담당자 직무를 입력하세요',
    phDirectorWechat: '업무담당자 위챗을 입력하세요',
    phDirectorEmail: '업무담당자 이메일을 입력하세요',
    phDirectorCard: '업무담당자 명함 업로드',
    submitResigt: '신청제출',
    message1: '6~16자리 영문 대소문자나 숫자를 입력하세요',
    message2: '기입된 계좌정보가 정확한지 확인해주세요!',
    message3: '비밀번호를 입력하세요',
    message4: '올바른 비밀번호를 입력하세요',
    message5: '6~16자',
    message6: '비밀번호를 한번 더 입력하세요',
    message7: '두번 입력한 비밀번호가 일치하지 않습니다!',
    message8: '올바른 비밀번호를 입력하세요',
    message9: '국가를 선택하세요',
    message10: '회사 정식등기명을 입력하세요',
    message11: '6~200자',
    message12: '회사로고를 업로드하세요',
    message13: '회사 법정대리인을 입력하세요',
    message14: '2~200자',
    message15: '회사상세주소를 입력하세요',
    message16: '10~200자',
    message17: '회사전화를 입력하세요',
    message18: '올바른 전화번호를 입력하세요',
    message19: '6~20자',
    message20: '회사 이메일주소를 입력하세요',
    message21: '올바른 이메일주소를 입력하세요',
    message22: '7~50자',
    message23: '회사홈페이지를 입력하세요',
    message24: '4~300자',
    message25: '회사은행계좌를 입력하세요',
    message26: '올바른 은행계좌를 입력하세요',
    message27: '10~100자',
    message28: '회사 정식자격증명을 업로드하세요',
    message29: '업무담당자 이름을 입력하세요',
    message30: '2~50자',
    message31: '연락전화를 입력하세요',
    message32: '올바른 전화번호를 입력하세요',
    message33: '6~20자',
    message34: '직무를 입력하세요',
    message35: '2~50자',
    message36: '위챗을 입력하세요',
    message37: '6~50자',
    message38: '업무담당자 명함을 입력하세요',
    message39: '회원가입을 제출하시겠습니까?',
    message40: '가입성공',
    message41: '가입실패',
    message42: '계정을 입력하세요',
    message43: '6~30자',
    message44: '이미 존재하는 계정',
    message45: '이메일주소를 입력하세요',
    message46: '5~50자',
    message47: '올바른 이메일을 입력하세요',
    message48: '이미 가입된 이메일',
    message49: '회원가입을 그만두시겠습니까?',
    message50: '주영 업무는 적어도 하나를 뽑아 선발할 수 있다',
    message51: '판매 방식은 적어도 하나를 골라 선택하면, 다선할 수 있다.',
    message52: '다른 옵션을 선택할 때, 이 정보는 반드시 기입해야 한다',
    message53: '입력 최대 길이 20'
  },
  menu: {
    sysHome: '시스템 홈페이지',
    product: '제품관리',
    productList: '내 제품',
    releaseProducts: '제품게시',
    releaseThirdProducts: '发布第三方产品',
    supplyManageProduct: '상품 판매 관리',
    importThirdSystemProduct: '제품 소개 관리',
    conciseEticket: '전자티켓 제품을 발표하다',
    conciseTicket: '티켓 제품을 발표하다',
    conciseTravel: ' 여행제품게시',
    conciseWifi: 'WiFi 제품을 발표하다',
    conciseSIM: 'SIM 제품을 발표하다',
    conciseDining: '식당제품게시',
    conciseTransport: '교통제품게시',
    conciseDiscount: '할인제품게시',
    conciseSetMeal: '신규 포장 제품',
    conciseExperience: '체험제품게시',
    productAuditing: '제품심사',
    addBusFlag: '야간버스상품 신규작성',
    orderManagement: '주문관리',
    orderManagementC: 'C端管理',
    operatorOrderManagement: '주문관리',
    operatorOrderMagnToC: 'ToC주문관리',
    operatorOrderManagement_chargeback: '订单退单权限',
    reserve: '제품예약',
    distriOrderMagn: '주문관리',
    disTocOrderManagement: 'ToC주문관리',
    bulkPurchaseList: '대량 구매 목록',
    tocDistributorManageProduct: 'ToC 상품 판매 관리',
    distriOrderMagnToC: 'ToC주문관리',
    applyDistribution: 'ToC심사',
    revenueManagement: 'ToC에이전트관리',
    revenueDetail: 'TOC수입관리',
    applyCash: 'TOC현금인출관리',
    operatApplyCash: 'ToC출금 관리',
    coupon: 'ToC쿠폰 관리',
    pinTicketMagn: '인증티켓관리',
    ticket: '종이티켓재고관리',
    ticketDepot: '티켓창고관리',
    warehouse: '창고관리',
    userDepot: '회원창고관리',
    pinTicket: '인증티켓',
    pdfTicket: 'e티켓재고관리',
    pdfFiles: 'PDF파일창고관리',
    shopManage: '업체관리',
    distributor: '유통사관리',
    supplier: '공급사관리',
    scenicSpot: '명소관리',
    scenicSpotList: '명소관리',
    finance: '재무통계',
    financeStatement: '재무제표',
    financeDetail: '재무제표상세정보',
    ActuarialManagement: '보험 계리 관리',
    withdrawals: '충전/인출관리',
    operatorWithdrawal: '충전/인출관리',
    trades: '거래명세',
    record: '충전/인출기록',
    withdrawal: '충전/인출',
    recharge: '충전/인출',
    sys: '시스템관리',
    merchantInfo: '업체정보',
    clerk: '업무원관리',
    adminAccount: '권한관리',
    secondaryAgent: '2차 대리',
    operator: '관리자관리',
    exportRules: '도출규정관리',
    noticeManager: '공지관리',
    liaisons: '연락인관리',
    counter: '카운터관리',
    pwdSet: '비밀번호설정',
    payType: '결제방법설정',
    newOrderEmail: '새 주문서 메일 알림 설정',
    ticketDepot_ticketDepotManager: '티켓창고관리자',
    ticketDepot_stockManager: '재고관리자',
    pdfFiles_stockManager: '재고관리자',
    operatorWithdrawal_operationAuth: '재무실행권한',
    operatorWithdrawal_auditAuth: '재무심사권한',
    auditFlag: '심사가 필요하지 않습니다',
    loginNotice: '쯔워유시스템기능 업데이트공지(20170621)',
    recover: '복구',
    clear: '비우기',
    pageSetting: '홈 페이지 사진 설정',
    productLogList: '제품 수정 기록',
    popularCities: '인기 목적지 관리',
    banner: '배너 관리',
    recommendedAttractions: '홈페이지 추천 관리'
  },
  login: {
    userLogin: '계정로그인',
    rememberLoginStatus: '로그인상태 유지',
    forgetPassword: '비밀번호를 잊으셨습니까?',
    loginIn: '로그인',
    register: '회원가입',
    copyRight: '저작권소유 © 2019 东瀛假日',
    recordInformation: '蜀ICP备18029410号-2',
    recordInformation2: '特定商取引法',
    message1: '계정이름을 입력하세요',
    message2: '비밀번호를 입력하세요',
    message3: '올바른 비밀번호를 입력하세요'
  },
  selectMerchantType: {
    imSupplier: '저는 공급사입니다',
    imDistributor: '저는 유통사입니다',
    selectType: '업체유형을 선택하세요'
  },
  notice: {
    noticeModify: '공지수정',
    noticeAdd: '공지추가',
    noticeTitle: '공지제목：',
    noticeContent: '공지내용',
    noticeTitlePlaceholder: '공지제목을 입력하세요',
    validDate: '유효날짜：',
    DateSelectRange: '날짜범위를 선택하세요',
    publicationScope: '범위선택：',
    all: '보통',
    distributor: '유통사',
    supplier: '공급사',
    pulicationConfirm: '발표하기',
    tip: '안내',
    saveOrNot: '저장하시겠습니까?',
    notSave: '저장 안함',
    save: '저장',
    message1: '3~150자',
    message2: '유효날짜를 선택하세요',
    message3: '범위를 선택하세요',
    message4: '편집을 그만두시겠습니까?',
    message5: '기본정보 미완성',
    message6: '저장성공',
    message7: '저장실패',
    message8: '삭제실패!',
    message9: '삭제성공!',
    message10: '이 실행은 본 파일을 영구적으로 삭제합니다. 계속하시겠습니까?',
    message11: '선택업체를 입력해야 합니다!',
    noticeManage: '공지관리',
    noticePublication: '공지발표',
    noticeTitle1: '공지제목',
    search: '검색',
    index: 'No.',
    title: '제목',
    publicationScope1: '발표범위',
    validDate1: '유효날짜'
  },
  exportRules: {
    exportRuleTitle: '도출규정관리',
    newExportRule: '새도출규정',
    editExportRule: '도출규정편집',
    lableBusinessType: '업체유형',
    pageType: '페이지유형',
    exportRuleName: '도출규정이름',
    exportRuleRemark: '도출규정비고',
    search: '찾기',
    ruleName: '규정이름',
    ruleRemark: '규정비고',
    modify: '수정',
    delete: '삭제',
    lable1: '전부',
    lable2: '유통사',
    lable3: '공급사',
    lable4: '제품일람',
    lable5: '주문일람',
    lable6: '운영사',
    lable7: '알수없음',
    lable8: '도출항목설정',
    lable9: '체거',
    lable10: '추가',
    lable11: '모든항목',
    lable12: '도출항목',
    lable13: '체크 북',
    message1: '정말 삭제하시겠습니까?',
    message2: '삭제성공',
    message3: '기초규정은 삭제할 수 없습니다',
    message4: '규정을 사용 중이므로 삭제할 수 없습니다',
    message5: '도출규정이름을 입력하세요',
    message6: '도출규정비고를 입력하세요',
    message7: '업체유형을 선택하세요',
    message8: '페이지유형을 선택하세요',
    message9: '3~100자',
    message10: '3~500자',
    message11: '정말 재설정하시겠습니까?',
    message12: '저장성공',
    message13: '편집을 그만두시겠습니까?',
    button1: '저장하기',
    button2: '즉시 만들기',
    button3: '재설정'
  },
  clerk: {
    clerkTitle: '업무원관리',
    addClerk: '업무원추가',
    editClerk: '업무원변경',
    account: '계정',
    name: '이름',
    telphone: '전화',
    emailAddress: '이메일주소',
    clerkAccount: '업무원계정',
    clerkName: '업무원이름',
    clerkPwd: '업무원비밀번호',
    confirmPwd: '비밀번호확인',
    clerkTel: '업무원휴대폰번호',
    message1: '업무원계정/이름',
    message2: '권한을 선택하세요',
    message3: '정말 삭제하시겠습니까?',
    message4: '삭제성공',
    message5: '설정성공',
    message6: '업무원계정을 입력하세요',
    message7: '계정은 영문, 숫자, 밑줄, 특수문자로만 구성되며 첫자리는 영문이어야 합니다',
    message8: '업무원이름을 입력하세요',
    message9: '업무원이름을 입력해야 합니다',
    message10: '업무원 비밀번호를 입력하세요',
    message11: '6~16자리 영문 대소문자나 숫자를 입력하세요',
    message12: '위에 입력한 것과 일치해야 합니다',
    message13: '업무원 휴대폰번호를 입력하세요',
    message14: '업무원 이메일주소를 입력하세요',
    message15: '이메일로 시스템정보를 받을 수 있습니다',
    message16: '1~50자',
    message17: '올바른 비밀번호를 입력하세요',
    message18: '6~16자',
    message19: '올바른 비밀번호를 입력하세요',
    message20: '저장하시겠습니까?',
    message21: '저장성공',
    message22: '계정을 입력하세요',
    message23: '6~30자',
    message24: '올바른 계정을 입력하세요',
    message25: '이미 존재하는 계정',
    message26: '비밀번호를 한번 더 입력하세요',
    message27: '두번 입력한 비밀번호가 일치하지 않습니다!',
    message28: '5~50자',
    message29: '올바른 이메일을 입력하세요',
    message30: '이미 가입된 이메일',
    message31: '6~20자',
    message32: '올바른 휴대폰번호를 입력하세요',
    message33: '편집을 그만두시겠습니까?',
    lable1: '권한',
    lable2: '제거',
    lable3: '추가',
    lable4: '역할목록',
    lable5: '추가된 역할'
  },
  merchant: {
    merchantInfo: '업체정보',
    distributorManage: '유통사관리',
    supplierManege: '공급사관리',
    all: '전부',
    waitAudit: '심사대기',
    auditPass: '심사통과',
    auditNG: '심사 탈락',
    auditNG2: '심사 미통과',
    auditNGReason: '심사 탈락이유 수정',
    searchContent: '업체이름/ID',
    businessName: '업체이름',
    createDate: '신청시간',
    auditStatus: '상태',
    auditUserName: '심사원',
    lableTodo: '처리',
    lableWatch: '보기',
    lableAuth: '권한',
    lableExpSet: '도출설정',
    accountInfo: '계정정보',
    loginAccount: '로그인계정',
    companyName: '회사이름 ',
    companyLogo: '회사로고',
    legalRepresentative: '법적대리인',
    companyAddress: '회사주소',
    companyTelephone: '회사전화',
    companyWebsite: '홈페이지/점포링크',
    companyEmail: '회사이메일',
    bankCardNumber: '은행계좌',
    qualificationPath: '자격증명',
    location: '소재지',
    baseInfo: '기본정보',
    directorInfo: '업무담당자정보',
    directorName: '이름',
    directorPosition: '직무',
    directorEmail: '이메일',
    directorTelephone: '연락처',
    directorWechat: '위챗',
    directorCardPath: '명함',
    setAuthAuditPass: '권한설정 및 심사통과',
    selectAuth: '권한을 선택하세요',
    message1: '권한을 선택하세요',
    message2: '도출설정',
    message3: '도출페이지 유형',
    message4: '제품도출항목 설정',
    message5: '주문도출항목 설정',
    message6: '도출규정',
    message7: '도출규정이름을 입력하세요',
    message8: '도출페이지 유형을 입력하세요',
    message9: '도출규정을 입력하세요',
    message10: '설정성공',
    message11: '(시스템에 있는 업체의 유일한 번호는 회원님의 신분을 식별하는 데 쓰입니다)',
    message12: '유통정황총결',
    message13: '총주문량',
    message14: '총주문금액',
    message15: '총티켓발행량',
    message16: '계정잔액상황',
    message17: '계정잔액',
    message18: '계정 거래일지 보기',
    message19: '충전/인출기록',
    message20: '실행성공',
    message21: '실행실패',
    message22: '심사를 그만두시겠습니까?',
    message23: '한도 설정',
    message24: '항목 내 보 내기',
    lable1: '제거',
    lable2: '추가',
    lable3: '역할목록',
    lable4: '추가된 역할',
    yayaPaySet: '티켓계정설정',
    easyGoUser: '공급사계정',
    yayaPayUser: '티켓계정',
    pleaseEnterYayaPayUser: '티켓계정을 입력하세요',
    pleaseEnterLessTen: '최대 10개 계정을 연동할 수 있습니다!',
    lengthMustLess100: '계정은 100자보다 적거나 같아야 합니다!',
    yayaAccountHadExists: '중복된 티켓계정이 있으므로 추가에 실패했습니다',
    yayaAccountExists: '티켓계정이 중복되었습니다 다시 입력하세요',
    enableSwitch: '스위치 사용하기',
    lineOfCredit: '신임 한도',
    creditDate: '수신 날짜'
  },
  merchantInfo: {
    merchantInfo: '업체정보',
    merchantInfoEdit: '업체정보변경',
    auditNG: '심사 미통과',
    accountInfo: '계정정보',
    auditStatus: '심사상태',
    loginAccount: '로그인계정',
    location: '소재지',
    baseInfo: '기본정보',
    companyName: '회사이름',
    companyLogo: '회사로고',
    legalRepresentative: '법정대리인',
    companyAddress: '회사주소',
    companyTelephone: '회사전화',
    companyWebsite: '홈페이지/점포링크',
    companyEmail: '회사이메일',
    bankCardNumber: '은행계좌',
    qualificationPath: '자격증명',
    supplierSummary: '유통정황총결',
    orderTotal: '총주문량',
    orderTotalPay: '총주문금액',
    ticketTotal: '총티켓발행량',
    accountBalanceInfo: '계정잔액상황',
    accountBalance: '계정잔액',
    seeBusinessLog: '계정 거래일지 보기',
    seeRechargeLog0: '충전/인출일지 보기',
    seeRechargeLog1: '인출일지 보기',
    directorInfo: '업무담당자정보',
    directorName: '이름',
    directorPosition: '직무',
    directorEmail: '이메일',
    directorTelephone: '연락전화',
    directorWechat: '위챗',
    directorCardPath: '명함',
    submitAudit: '심사제출',
    submitEdit: '변경제출',
    notSave: '저장 안함',
    save: '저장',
    message1: '(시스템에 있는 업체의 유일한 번호는 회원님의 신분을 식별하는 데 쓰입니다)',
    message2: '기입한 계정정보가 정확한지 확인해보세요!',
    message3: '편집을 저장하시겠습니까?',
    message4: '국가를 선택하세요',
    message5: '회사 정식등록명을 입력하세요',
    message6: '6~200자',
    message7: '회사로고를 업로드하세요',
    message8: '회사 법정대리인을 입력하세요',
    message9: '2~200자',
    message10: '회사상세주소를 입력하세요',
    message11: '10~200자',
    message12: '회사전화를 입력하세요',
    message13: '올바른 전화번호를 입력하세요',
    message14: '6~20자',
    message15: '회사 이메일주소를 입력하세요',
    message16: '올바른 이메일주소를 입력하세요',
    message17: '7~50자',
    message18: '회사 홈페이지를 입력하세요',
    message19: '4~50자',
    message20: '회사은행계좌를 입력하세요',
    message21: '올바른 은행계좌를 입력하세요',
    message22: '10~100자',
    message23: '회사 정식자격증명을 업로드하세요',
    message24: '업무담당자이름을 입력하세요',
    message25: '2~50자',
    message26: '휴대폰 연락처를 입력하세요',
    message27: '올바른 휴대폰번호를 입력하세요',
    message28: '직무를 입력하세요',
    message29: '위챗을 입력하세요',
    message30: '6~50자',
    message31: '업무담당자 명함을 입력하세요',
    message32: '수정하시겠습니까?',
    message33: '수정성공',
    message34: '수정실패',
    message35: '이메일주소를 입력하세요',
    message36: '5~50자',
    message37: '올바른 이메일을 입력하세요',
    message38: '이미 가입된 이메일'
  },
  secondaryAgent: {
    secondaryAgentTitle: '2차 대리',
    message1: '이름을 입력하세요',
    search: '검색',
    name: '이름',
    time: '등록일',
    remark: '비고',
    label: '해제',
    addCode: '招待코드 생성하기',
    copySuccess: '복사 성공',
    copyError: '복사 실패했습니다',
    operator: '비고를 수정하세요',
    remarkTip: '비고를 입력하세요',
    message2: '수정 성공했습니다',
    message3: '수정 실패했습니다',
    message4: '해제 성공했습니다',
    message5: '해제 실패했습니다'
  },
  errorMsg: {
    user: {
      noAuth: '회원 권한이 부족합니다. 관리자에게 연락하세요',
      systemMsg: '시스템오류',
      noUserOrPassword: '계정이 존재하지 않거나 비밀번호가 틀렸습니다',
      setUsernameOrPassword: '계정 혹은 비밀번호를 입력하세요'
    }
  },
  operator: {
    jtrOrderReimburse: '시스템 한쪽 취소',
    operatorManege: '관리자관리',
    addOperator: '관리자추가',
    updateOperator: '관리자변경',
    updatePwd: '비밀변호변경',
    updateInfo: '정보변경',
    auth: '권한',
    searchText: '관리자계정/이름',
    account: '계정',
    name: '이름',
    opearate: '실행',
    opeAccount: '관리자계정',
    opeName: '관리자이름',
    opePwd: '관리자 비밀번호',
    opeNewPwd: '관리자 새비밀번호',
    checkPwd: '비밀번호확인',
    lable1: '제거',
    lable2: '추가',
    lable3: '역할목록',
    lable4: '추가된 역할',
    message1: '권한선택',
    message2: '정말 삭제하시겠습니까?',
    message3: '삭제성공',
    message4: '설정성공',
    message5: '관리자계정을 입력하세요',
    message6: '계정은 영문, 숫자, 밑줄, 특수문자로만 구성되며 첫자리는 영문이어야 합니다',
    message7: '관리자 이름을 입력하세요',
    message8: '관리자 이름을 입력해야 합니다',
    message9: '관리자 비밀번호를 입력하세요',
    message10: '6~16자리 영문 대소문자나 숫자를 입력하세요',
    message11: '위에 입력한 것과 일치해야 합니다',
    message12: '1~50자',
    message13: '6~16자',
    message14: '올바른 비밀번호를 입력하세요',
    message15: '저장하시겠습니까? ',
    message16: '저장성공',
    message17: '계정을 입력하세요',
    message18: '6~20자',
    message19: '올바른 계정을 입력하세요',
    message20: '이미 존재하는 계정',
    message21: '비밀번호를 한번 더 입력하세요',
    message22: '두번 입력한 비밀번호가 일치하지 않습니다!',
    message23: '편집을 그만두시겠습니까?'
  },
  product: {
    rule_0_500: '0~500자',
    rule_0_5000: '0~5000자',
    rule_1_200: '1~200자',
    rule_1_2000: '0~2000자',
    rule_1_500: '0~500자',
    rule_0_200: '0~200자',
    rule_0_2000: '0~2000자',
    rule_0_50: '0~50자',
    rule_0_1_500: '0~500자',
    rule_1_50: '1~50자',
    rule_0_20: '0~20자',
    rule_n1_2: '1~2자리 숫자',
    rule_n1_4: '1~4자리 숫자',
    rule_n1_6: '1~6자리 숫자',
    rule_n0_2: '0~2자리 숫자',
    rule_n0_5: '0~5자리 숫자',
    rule_n0_6: '0~6자리 숫자',
    rule_mail: '메일 내용을 입력해 주세요',
    integer_1: '정수를 입력하세요',
    integer_2: '자연수를 입력하세요',
    selDate: '날짜 선택',
    back: '뒤로',
    ticketType_1: '연동된 티켓 보관함에서 자동 발행',
    ticketType_3: '주문 내 바우처 수동 업로드',
    ticketType_4: '시스템 생성 EasyGo 바우처',
    choose_sys: '시스템을 선택：',
    chooseDepot: '选择仓库',
    baseInfo: '기본정보',
    content: '제품내용',
    priceSet: '가격설정',
    reserveSet: '예약설정',
    saveDraft: '임시저장함에 저장',
    preview: '미리보기',
    submitCheck: '심사제출',
    submitAuditAndPass: '심사를 제출 및 통과했습니다',
    isExitProduct: '제품입력을 그만두시겠습니까?',
    isSaveDraft: '임시저장하시겠습니까?',
    noSave: '저장 안함',
    save: '저장',
    add: '추가',
    edit: '편집',
    product_0: '제품(e티켓)',
    product_1: '제품(종이티켓)',
    product_2: '제품(체험)',
    product_3: '제품(일일여행/1일이상여행)',
    product_4: '제품(WIFI)',
    product_5: '제품(유심)',
    product_6: '제품(식당)',
    product_7: '제품(교통)',
    product_8: '제품(패키지)',
    doNotSave: '내용이 업데이트되지 않았으므로 중복 저장할 필요가 없습니다.',
    reqMsg_1: '축하합니다. 심사를 제출했습니다',
    reqMsg_2: '축하합니다. 저장에 성공하였습니다',
    reqMsg_3: '죄송합니다. 심사제출에 실패하였습니다!',
    reqMsg_4: '죄송합니다. 저장에 실패하였습니다!',
    reqMsg_5: '죄송합니다. 심사제출 오류. 다시 시도해주세요',
    reqMsg_6: '죄송합니다. 저장 오류. 다시 시도해주세요',
    reqMsg_7: '이 패키지에 자제품이 추가되지 않았습니다!',
    reqMsg_8: '축하합니다. 심사를 통과했습니다',
    reqMsg_9: '죄송합니다. 심사를 통과하지 못했습니다!',
    reqMsg_10: '죄송합니다. 심사 오류. 다시 시도해주세요!',
    reqMsg_11: '안타깝게도 제품을 가져오는 동안 오류가 발생했습니다. 다시 시도해 주세요！',
    reqMsg_12: '이 제품 번호는 바인딩되었습니다. 다시 입력하세요！',
    reqMsg_13: '이 제품은 현재 재고가 없으며 수입할 수 없습니다！',
    fileDepot_no: '파일 리포지토리를 선택하세요',
    baseInfo_no: '기본정보 일부 미기입',
    content_no: '제품내용 일부 미기입',
    reserveSet_no: '예약설정 일부 미기입',
    explain01: '이름구성: 지명+제품명++수량+특색, 예시: 북경순경온천(피쉬스파 포함) 2장+남산스키장(E티켓) 2장',
    explain02: '제품제목 하단의 키워드등',
    explain03: '공급사가 편리하게 제품을 검색하도록 유통사는 볼 수 없습니다.',
    explain04: '성인(만18세 이상), 학생(만12~17세), 어린이, 유아, 커플',
    productName01: '패키지이름：',
    productName02: '제품이름：',
    qrCodeName: 'QR코드 이름',
    productName_placeholder: '제품이름을 입력하세요',
    qrCodeName_placeholder: 'QR코드 이름을 입력하십시오',
    productPrice_placeholder: '请输入产品偏移价格',
    productMin_Price_placeholder: '请输入产品最低价格',
    errorProductConfirmType1: '자켓 제품은 2차 확인 제품, 주문 확인 방식만 인공 확인 가능',
    errorProductConfirmType2: '자켓 제품은 2차 확인 제품을 포함하지 않고 주문 확인 방식은 자동으로 확인할 수 있다',
    errorProductConfirmType3: '해당 상품은 세트 상품에 포함되어 있기 때문에 예약 확인 방법을 변경할 수 없습니다.',
    orderNum_placeholder: '请输入排序',
    productHighlights01: '패키지특점：',
    productHighlights02: '제품특점：',
    productHighlights_placeholder: '제품특점을 입력하세요',
    productInsideRemark: '내부비고：',
    productInsideRemark_placeholder: '내부비고를 입력하세요',
    scenicSpot: '해당명소：',
    ticketType: '티켓종류：',
    ticketType_placeholder: '티켓종류를 입력하세요',
    productSaleDate: '등록시간대：',
    productSaleDate_placeholder: '등록시간대를 선택하세요',
    categoryLabel: '카테고리라벨：',
    categoryLabel_placeholder: '카테고리라벨을 입력하고 Enter 키를 눌러 확인',
    belongCity: '소속도시：',
    belongCity_placeholder: '소속도시를 선택하세요',
    chooseDepot_rule: '请选择仓库',
    productName_rule: '제품이름을 입력하세요',
    scenicSpotArr_rule: '최소 1개의 명소를 선택하세요',
    scheduleDuration: '일정시간：',
    scheduleDuration_placeholder: '일정시간을 입력하세요',
    imageExplain: '이미지묘사：',
    uploadBtn: '업로드하기',
    videoExplain: '영상자료：',
    productPackageDetail: '패키지제품상세정보：',
    mealTimeInterval: '식사시간대：',
    mealTime_1: '제한없음',
    mealTime_2: '아침',
    mealTime_3: '점심',
    mealTime_4: '애프터눈티',
    mealTime_5: '저녁',
    mealTime_6: '야식',
    mealNumber: '식사인원：',
    mealNumber_1: '1인식사',
    mealNumber_2: '2인식사',
    mealNumber_3: '3~4인식사',
    mealNumber_4: '5~10인식사',
    mealNumber_5: '10인이상',
    mealDetail01: '이름：',
    mealDetail01_placeholder: '패키지그룹명을 입력하세요',
    mealDetail02: '내용：',
    mealDetail03: 'No.',
    mealDetail04: '이름',
    mealDetail05: '수량',
    mealDetail06: '사진',
    mealDetail07: '실행',
    mealDetail07_del: '삭제',
    mealDetail07_up: '위로 이동',
    mealDetail07_down: '아래로 이동',
    up_msg: '이미 맨 위입니다',
    down_msg: '이미 맨 아래입니다',
    mealDetail07_add: '1행추가',
    md_delGroup: '그룹삭제',
    md_addGroup: '그룹추가',
    md_validMsg: '패키지상세정보 데이터가 완전하지 않습니다',
    md_addMsg: '최대 20항 추가 가능!',
    md_addMsg1: '최대 10그룹 추가 가능!',
    useTime: '사용시간：',
    useTime_1: '제한없음',
    useTime_2: '구제적인 시간대 있음',
    editorProductDetail: '상세문자묘사：',
    viewAddress: '주소：',
    viewAddress_placeholder: '명소주소를 입력하세요',
    businessTime: '영업시간：',
    businessTime_placeholder: '영업시간을 입력하세요',
    productPeople_placeholder: '请输入产品人群要求',
    exclusive: '차량 전용 표식：',
    exclusive_1: '비 전용 차',
    exclusive_2: '남성 전용 차량.',
    exclusive_3: '여성 전용 차량.',
    lang: '서비스언어：',
    lang_1: '중문',
    lang_2: '영문',
    lang_3: '일문',
    lang_4: '한국어',
    productTraffic: '교통방식：',
    productTraffic_placeholder: '교통방식을 입력하세요',
    networkFlow4g: '4G고속데이터：',
    networkFlow4g_placeholder: '4G고속데이터를 입력하세요',
    networkFlow3g: '3G데이터：',
    networkFlow3g_placeholder: '3G데이터를 입력하세요',
    networkCoverage: '네트워크 적용범위：',
    networkCoverage_placeholder: '네트워크 적용범위를 입력하세요',
    wifiAccessories: '부품：',
    wifiAccessories_placeholder: '부품을 입력하세요',
    simSize: '유심크기：',
    simSize_placeholder: '유심크기를 입력하세요',
    pathType: '노선유형：',
    pathType_1: '합승차여행',
    pathType_2: '렌터카여행',
    pathType_3: '픽업샌딩',
    traffic: '교통수단：',
    traffic_1: '자동차',
    traffic_2: '전차',
    traffic_3: '크루즈',
    groupNumber: '그룹인원：',
    groupNumber_placeholder: '그룹인원을 입력하세요',
    shoppingType: '쇼핑정보',
    shoppingType_1: '쇼핑 비포함',
    shoppingType_2: '쇼핑 포함',
    scheduleInfo: '구체적인 일정：',
    productCostInclude: '비용포함：',
    productCostInclude_placeholder: '비용포함 내용을 입력하세요',
    productCostExclusive: '비용 비포함：',
    productCostExclusive_placeholder: '비용 비포함 내용을 입력하세요',
    productUseFlow: '이용과정：',
    productUseFlow_placeholder: '이용과정을 입력하세요',
    productSupplementPath: '使用流程补充',
    userNote: '使用说明：',
    userNote_placeholder: '请输入使用说明',
    importantNote: '重要提示：',
    importantNote_placeholder: '请输入重要提示',
    editorFreeItem: '증정항목：',
    newProductPackageDtoList_rule: '최소 1개의 패키지상세정보를 입력하세요',
    scheduleInfoDtoList_rule: '최소 1개의 일정이 있어야 합니다',
    reserveLimitDay: '예약시간제한：',
    rld01: '사용날짜의',
    rld02: '일전의',
    rld03_placeholder: '시간',
    rld04: '전예약（일본시간）',
    confirmHour: '주문확인방식：',
    confirmHour_1: '자동확인',
    confirmHour_2: '인공확인',
    ch01: '2차확인 처리시간：',
    ch02: '일본영업일 근무시간',
    ch03: '小时（自然时长）',
    maxReserveNummber: '최대 예약수：',
    minReserveNummber: '최소 예약수：',
    mrn_explain: '\'0\'데이터 제한하지 않음을 표시',
    orderValid: '주문유효기간설정：',
    ov01: '지정사용일 당일 유효',
    ov02: '주문한 날부터',
    ov03: '주문한 날부터 지정일까지',
    ov04: '지정사용일부터',
    ov05: '지정사용일부터 지정일까지',
    ov06: '지정날짜',
    ov07: '지정사용일의',
    orderRefund: '주문환불변경：',
    orderRefund_1: '환불변경불가',
    orderRefund_2: '주문유효기간 마감일 전 환불신청가능',
    orderRefund_tip: '1. 마감 시간은 해당 날짜의 23:59:59입니다.\n2. 예시: 여행일이 1월 3일인 경우, 1월 2일 이전에는 무료 취소가 가능하며,\n 1월 2일과 1월 3일에 취소할 경우 취소 수수료가 100% 부과됩니다. 설정 방법은 다음과 같습니다.\n주문 유효기간 마감 시간 전 0일(당일 포함), 환불 수수료: 100%\n주문 유효기간 마감 시간 전 2일(당일 포함), 환불 수수료: 100%\n주문 유효기간 마감 시간 전 3일(당일 포함), 환불 수수료: 0%',
    orderRefund_3: '소비 전 언제든지 환불가능',
    refundDescription: '환불안내：',
    rdi_placeholder: '환불안내를 입력하세요',
    customerData: '예약기입요구：',
    customerData_1: '모든 고객의 자료를 입력해야 합니다',
    customerData_2: '고객 한분의 자료만 입력하면 됩니다',
    mustFillInInf: '고객필수입력정보：',
    mustFillInInf_1: '이름',
    mustFillInInf_2: '전화',
    mustFillInInf_3: '위챗',
    mustFillInInf_4: '여권',
    mustFillInInf_5: '성별',
    mustFillInInf_6: '사용날짜',
    mustFillInInf_7: '수령날짜',
    mustFillInInf_8: '이름(성)',
    mustFillInInf_9: '이름(명)',
    mustFillInInf_10: '연락번호',
    mustFillInInf_11: '메일주소',
    mustFillInInf_12: '성별',
    mustFillInInf_13: '연락번호',
    mustFillInInf_14: '긴급연락번호',
    mustFillInInf_15: '티켓종류',
    mustFillInInf_16: '同行者',
    customItem: '사용자정의 고객 입력사항',
    ci01: '항목이름입력',
    ci01_placeholder: '항목이름',
    ci02: '기입 여부',
    ci02_placeholder: '선택하세요',
    ci02_1: '선택기입',
    ci02_2: '필수기입',
    ci03: '안내(주문 페이지의 입력창 하단에 노출)',
    ci03_placeholder: '안내',
    ci04: '실행',
    ci04_del: '삭제',
    ci05: '사용자정의 항목 추가',
    editorNotice: '예약안내사항：',
    orderLiaison: '주문연락：',
    emergencyLiaison: '긴급연락：',
    validateAuthority: '권한 확인：',
    receiveCounter01: '수령카운터：',
    receiveCounter02: '종이티켓수령카운터：',
    returnCounter: '반환카운터：',
    reserveLimitDay_rule: '예약시간제한을 입력하세요',
    reserveLimitDay_rule1: '1부터 99일 이내',
    reserveLimitDay_rule2: '시간을 입력하세요',
    orderDayNotMore: '주문일부터 일수는 2자리수보다 크면 안됩니다',
    trip01: '제',
    trip02: '일',
    trip03: '일정: ',
    trip04: '새일정추가',
    trip05: '1일추가',
    trip06: '시간대：',
    trip06_placeholder: '시간범위선택',
    trip06_phBegin: '시작시간',
    trip06_phEnd: '종료시간',
    trip07: '어디로가세요：',
    trip07_placeholder: '언제 어디로 가세요?',
    trip08: '일정내용：',
    trip08_placeholder: '예시: 몇번째 날에 어디로 가세요? 어떻게 가요? 어떤 특색이 있어요?',
    trip09: '일정이미지：',
    trip09_btn: '업로드 클릭',
    trip10: '일정저장',
    trip_msg1: '일정 미선택',
    trip_msg2: '일, 일정',
    tripRange_rule: '시간대를 입력하세요',
    trip_interval_rule: '종료시간과 시작시간을 입력하세요',
    groupContentTitle_rule: '어디로 가는지 입력하세요',
    groupContent_rule: '일정내용을 입력하세요',
    imageList_rule: '일정이미지를 설정하세요',
    trip_msg3: '먼저 일정을 선택한 뒤 일정을 저장하세요!',
    trip_msg4: '축하합니다. 저장에 성공했습니다',
    price01: '재고와 가격',
    price02: '시간대-',
    price03: '새로 추가된 시간대',
    price04: '삭제',
    price05: '시간대',
    price06: '시간범위 선택',
    price061: '시간대가 중복되면 안 됩니다',
    price07: '구매가격',
    price08: '구매가격을 입력하세요',
    price09: '유통가격',
    price10: '유통가격을 입력하세요',
    price11: '시장가격',
    price12: '시장가격을 입력하세요',
    price13: '재고량',
    price14: '재고량을 입력하세요',
    price15: '건',
    price16: '저장',
    price17: '재설정',
    price18: '날짜범위를 입력해야 합니다',
    price19: '시간대를 입력해야 합니다',
    price20: '날짜범위',
    price21: '円',
    price22: '플랫폼 구매 가격',
    price23: '분산 판매 플랫폼 구매 가격을 입력하십시오',
    price24: '소매가',
    price25: '소매가격을 입력하십시오',
    price26: '새 종류',
    price27: '종류 이름',
    price28: '종류명을 입력하십시오',
    price29: '가격 종류-',
    price30: '가격 종류 선택하세요',
    price31: '가격 종류의 총 재고를 입력하십시오',
    price32: '총 재고는 사용수보다 많아야 합니다',
    price33: '총 재고는 0 이상이어야 한다',
    price34: '지정된 가격종류를 입력해주세요 : 성인,아동, 신체장애인(성인), 신체장애인(아동)',
    price_msg1: '날짜를 선택하세요',
    price_msg2: '시간대-',
    price_msg3: '미저장',
    price_msg4: '날짜와 시간대를 선택하세요',
    price_msg5: '저장성공',
    price_msg6: '저장실패',
    price_msg7: '삭제성공',
    price_msg8: '삭제실패',
    price_msg9: '최대 50개 데이터 추가 가능',
    price_msg10: '선택한 사항을 입력해야 합니다',
    price_msg11: '정말 이 시간대의 모든 존재하는 데이터를 덮어쓰기하여 저장하시겠습니까?',
    price_msg12: '정말 시간대를 삭제하시겠습니까?.',
    price_msg13: '"의 모든 데이터를 정말 삭제하시겠습니까?',
    price_msg14: '이 가격종류 모든 존재하는 데이터를 덮어쓸 것입니다. 저장하시겠습니까?',
    price_msg15: '이 가격종류의 모든 데이터를 삭제합니다. 삭제하시겠습니까?',
    price_msg16: '이 가격종은 사용 중이므로 삭제할 수 없습니다.',
    price_msg17: '이 제품은 이미 같은 가격 종류가 있어서 저장하는데 실패했습니다',
    refund01: '주문 유효기간 마감 시간 전',
    refund02: '일(당일 포함), 환불 수수료: ',
    refund03: '제거',
    refund04: '사용자정의 추가',
    refund05: '환불수수료：',
    counter01: '카운터선택',
    counter02: '카운터',
    counter03: '주소',
    counter04: '전화',
    counter05: '영업시간',
    liaison01: '연락인선택',
    clerk01: '영업 담당자 선택',
    clerk02: '账号',
    clerk03: '业务员',
    clerk04: '전화 번호',
    clerk05: '邮箱',
    liaison02: '연락인',
    liaison03: '연락방법',
    liaison04: '접수시간',
    spot01: '해당명소선택',
    spot02: '명소선택',
    spot03: '취소',
    spot04: '확인',
    takeP01: '제품창고에서 제품 선택',
    takeP02: '최소 1개 자제품이 있어야 저장하거나 패키지를 제출할 수 있습니다',
    takeP03: 'No.',
    takeP04: '제목',
    takeP05: '구매가격',
    takeP06: '유통가격',
    takeP07: '시장가격',
    takeP08: '수량',
    takeP09: '실행',
    takeP10: '데이터인용',
    takeP11: '제품창고에서 제품 선택',
    takeP12: '삭제',
    takeP13: '가격 종류',
    takeP14: '차량 전용 표식',
    stockNumber01: '재고량',
    stockNumber02: '사용 갯수',
    stockNumber03: '사용 안 함',
    stockNumber04: '사용 하기',
    priceTypeHistory01: '이력을 확인하다',
    priceTypeHistory02: '재고가 늘다',
    priceTypeHistory03: '재고가 줄어들다',
    upload01: '{0}MB를 초과하지 않는 jpg/png/jpeg/gif파일만 업로드 가능',
    upload02: '최대 20MB 영상 업로드 가능',
    upload03: '업로드 최대',
    upload04: '장 이미지!',
    upload05: '개 영상!',
    upload06: '이 파일은 유효한 이미지포맷이 아닙니다!',
    upload07: '업로드할 이미지 크기가 {0}MB를 초과하면 안 됩니다!',
    upload08: '파일명에 쉼표가 있으면 안 됩니다!',
    upload09: '이 파일은 유효한 영상포맷이 아닙니다!',
    upload10: '업로드할 영상 크기가 20MB를 초과하면 안 됩니다!',
    upload11: '업로드실패!',
    upload12: '업로드오류!',
    upload13: '请提供实体票·柜台·接待设施外观的照片',
    upload14: '하나의 파일',
    upload15: '업로드 파일 크기를 초과할 수 없습니다 5MB！',
    calendar01: '년',
    calendar02: '월',
    calendar03: '당월재고 모두선택',
    calendar04: '건',
    clerkTable01: '모든 영업 담당자가 기본적으로 티켓을 유효성 검사할 수 있습니다',
    week_1: '월',
    week_2: '화',
    week_3: '수',
    week_4: '목',
    week_5: '금',
    week_6: '토',
    week_7: '일',
    explain_1: '구매가격: 플랫폼에 판매하는 가격(플랫폼 매입가), 공급사가 정기적으로 플랫폼에게 청구하는 단가',
    explain_2: '유통가격: 플랫폼이 여행사(유통사)에게 판매하는 가격',
    explain_3: '구매가격과 유통가격의 차액이 플랫폼의 이윤입니다',
    explain_4: '说明："0"代表无库存',
    explain_5: '分销平台采购价：EASYGO系统售卖给其他分销平台的价格，与采购价的差额是平台的利润。',
    explain_6: '市场价：一般市场参考售价',
    explain_7: '零售价：建议分销商设定的BtoC售价',
    explain_8: '가격종류 (일본어) 입력설명：',
    explain_9: '성인 비',
    explain_10: '어린이 관람 료.',
    explain_11: '장애인 성인 관람료',
    explain_12: '장애 아동 관람 료',
    explain_13: '(이하의 가격종류만 유효 : 성인, 아동, 신체장애인(성인), 신체장애인(아동))',
    explain_14: '(이용가능날짜를 참고하여, 재고를 설정해 주세요. 이용불가날짜설정은 무효처리됩니다.)',
    explain_15: '이용가능날짜：',
    explain_16: '현재의 가격종류로는 이용가능한 날짜가 존재하지 않습니다.',
    explain_17: '판매 합 니까',
    explain_18: '가격 규칙 설정 설명：',
    explain_19: '乐天产品价格及日期填写说明：',
    explain_20: '请根据可用日期进行设置，设置不可用日期不生效，采购价不生效',
    isSale: '판매 하 다.',
    notSale: '비재판매',
    productDeleteMessage: '포장제품을 먼저 삭제하거나 포장제품에서 이 제품을 제거하세요!!',
    none: '없다',
    sendMailSet: '발송일을 앞당기다：',
    mailContent: '메시지 내용：',
    noSend: '보내지 않음',
    mailTime: '지정한 날짜 이전',
    mailContent_placeholder: '메일 내용을 입력해 주세요',
    mailsetTips: 'pdf 가 없는 전자 티켓만 지원합니다'
  },
  recharge: {
    depositWithdraw: '충전/인출',
    depositWithdrawHistoryRecord: '충전/인출기록',
    searchStr: '업체명/ID：',
    placeholder1: '업체명/ID를 입력하세요',
    businessType: '업체유형：',
    businessType1: '업체유형',
    placeholder2: '선택하세요',
    search: '검색',
    businessName: '업체이름',
    businessName1: '업체이름：',
    balance: '잔액',
    accountBalance: '계정잔액：',
    operation: '실행',
    deposit: '오프라인충전',
    depositAuto: '온라인충전',
    automatic: '자동 충전',
    withdraw: '인출',
    record: '기록',
    withdrawAvail: '인출가능금액：',
    withdrawAmount: '인출금액：',
    withdrawRemark: '인출비고：',
    cancel: '취소',
    submit: '심사제출',
    depositAmount: '충전금액：',
    depositRemark: '충전비고：',
    all: '전부',
    supplier: '공급사',
    distributor: '유통사',
    submitSuccess: '제출성공',
    subimitFailed: '제출실패',
    message: '인출금액이 인출가능금액보다 크면 안됩니다!',
    goBack: '뒤로',
    dateRange: '시간대선택：',
    placeholder3: '날짜범위선택',
    date: '날짜',
    operator: '실행자',
    type: '유형',
    supplierWithdraw: '업체인출요청',
    platformWithdraw: '운영사인출',
    operationAmount: '충전/인출금액',
    remark: '비고',
    lastWeek: '최근 일주일',
    lastMonth: '최근 한달',
    lastThreeMonth: '최근 3개월',
    message2: '충전금액은 자연수를 입력하세요!',
    message3: '인출금액은 자연수를 입력하세요!',
    message4: '충전금액은 2000,000,000보다 작은 자연수를 입력하세요!'
  },
  order: {
    batchSummary: '배치 상세',
    canBeUseStartDate: '유효한 시작 날짜',
    canBeUseEndDate: '유효종료 날짜',
    createUserName: '저자',
    bulkPurchase: '대량으로 구매하다',
    remarks: '내부 비고',
    orderSource0: '이 시스템',
    orderSource1: '공급업체 C측',
    orderSource2: '对外API',
    orderSource3: 'JTR',
    orderSource4: 'KLOOK',
    orderSource5: '易去',
    orderSource6: 'KKday',
    orderSource7: '稀客地图',
    orderSource8: '유통업체 C측',
    orderSource9: 'LINK',
    toCDistributorName: 'EasyGo BtoC',
    submitTime: '상품예약일',
    sourceType: '주문원',
    sourceJtr: '공급자',
    sourceJph: 'JPH공급자',
    allDate: '일시',
    productPrice: '단가',
    totalPrice: '총 가격',
    orderInfo: '주문수량,성함',
    newSourceJtr: '运营者订单',
    payTime: '지불시간',
    productUseDate: '상품이용날짜',
    cancelTime: '취소일',
    keyWorld: '키워드입력 ',
    distributor: '유통사',
    secondAgentId: '2급 에이전트ID',
    secondAgentCommission: '2급 에이전트 수익',
    productArea: '소재지',
    supplier: '공급사',
    search: '검색',
    synchronousTime_01: '（데이터 갱신 시간：',
    synchronousTime_02: '）',
    synchronousOrder_01: '업 데이트',
    synchronousOrder_02: '(',
    synchronousOrder_03: 's)',
    validateTime: '상품유효기간',
    validateDate: '상품유효기간',
    expirationTime: '기간 이 지나다',
    timeSlot: '날짜를 선택해주세요',
    searchMsg: '예약번호/상품명/고객성함/고객이메일',
    channelOrderId: '타사 예약번호',
    searchDistributor: '총판 이름을 입력하세요',
    searchSupplier: '공급업체 이름을 입력하세요',
    orderExport: '주문도출',
    ticketDepotExport: '창고 목록 다운로드',
    ticketBatchDetailExport: '패치 내역 목록 다운로드',
    productExport: '전체상품보기',
    productExports: '전체상품보기',
    orderId: '예약번호',
    sonOrderId: '子订单号',
    productName: '상품명',
    allBuyQuantity: '구매수량',
    customerName: '고객이름',
    orderExplain: '비고',
    orderExplain1: '주문서 비고 설명 (내부 비고, 판매상 내부만 보이기)',
    orderStatus: '상품상태',
    notPay: '결제대기중',
    beConfirm: '확인대기',
    beingCancel: '취소중',
    haveCanceled: '취소완료',
    haveConfirmed: '예약완료',
    beTicket: '待出票',
    batchHaveDone: '구입 한',
    haveDone: '상품사용완료',
    haveCancel: '취소완료',
    haveRefundRequest: '已申请退款',
    haveRefund: '已退款',
    havePay: '已付款',
    failedPay: '支付失败',
    refuseRefund: '拒绝退款',
    haveTicket: '已出票',
    notPayButCanceled: '미결제취소',
    haveExpired: '만료됨',
    leftHandleTime: '예약처리기간',
    operation: '실행',
    addOrSub: '부분',
    refund: '환불하다',
    beAdd: '추가 주문 추가',
    addOrSubOrRefund: '부분 취소 / 환불',
    source: '원천',
    validateOrder1: '인증 성공',
    validateOrder2: '이 오더 인증할 권한이 없습니다.',
    validateOrder3: '인증 실패',
    validateOrder4: '',
    date_empty: '날짜가 정확하지 않습니다. ',
    myouji_kana_empty: '성(family name)의 포맷이 정확하지 않습니다.',
    namae_kana_empty: '이름(first name)의 포맷이 정확하지 않습니다.',
    bin_key_id_empty: '제품 번호 가 잘못 되 었 습 니 다. 다시 입력 해 주세요.',
    sex_empty: '성별의 포맷이 정확하지 않습니다.',
    tel_empty: '핸드폰 양식 이 잘못 되 었 습 니 다. 10 - 11 자리 숫자 를 입력 하 십시오.',
    email_empty: '잘못된 메 일 박스 입 니 다. 메 일 박스 를 정확하게 입력 하 십시오.',
    total_num_empty: '예약인수의 포맷이 정확하지 않습니다.',
    age_empty: '나이 형식 이 올 바 르 지 않 습 니 다. 숫자 를 입력 하 십시오.',
    emergency_phone_empty: '긴급연락번호의 포맷이 정확하지 않습니다.',
    ctype_empty: '연령구분・장애인구분의 포맷이 정확하지 않습니다.',
    recep_empty: '접수가 완료되었습니다.',
    num_over: '잔량(남은양)이 불충분합니다.',
    num_not_sale: '선택 한 지정 날짜 가 아직 발매 되 지 않 았 습 니 다.',
    r_id_empty: '지정예약ID는 이미 취소가 완료되었습니다.',
    r_id_already_cancel_ok: '예약 이 취소 되 었 습 니 다.',
    r_id_already_payment_ok: '이 예약은 금액지불이 완료되었습니다.',
    thirdMethodErr: '접속연결 오류, 관리인에게 연락해 주세요.',
    systemErr: '시스템 오류, 관리인에게 연락해 주세요.'
  },
  jtrOrder: {},
  withdrawal: {
    withdrawalCash: '충전/인출',
    withdrawalCashManager: '충전/인출관리',
    withdrawalOnline: '온라인충전',
    withdrawalOffline: '오프라인충전',
    applyWithdraw: '인출신청',
    beingHandel: '처리대기',
    beingAudit: '심사대기',
    notPass: '심사 미통과',
    selectTimeSlot: '시간대를 선택하세요',
    selectDateSlot: '날짜범위를 선택하세요',
    createTime: '생성시간',
    operationPeople: '실행자',
    type: '유형',
    recharge: '충전',
    withdraw: '인출',
    withdrawAmount: '인출금액',
    rechargeWithdrawAmount: '금액',
    rechargeWithdrawAmount2: '인출금액',
    remark: '비고',
    refundReason: '미통과 이유',
    accountBalance: '계정잔액',
    canWithdrawalBalance: '인출가능금액',
    applyWithdrawalBalance: '인출금액신청',
    applyWithdrawalBalance2: '충전금액신청',
    selectWithdrawalAccount: '인출금액을 선택하여 입력하세요',
    withdrawRemark: '인출비고',
    withdrawRemark2: '충전비고',
    inputWithdrawRemark: '인출비고메세지를 선택하여 입력하세요',
    cancel: '취소',
    sure: '확인',
    submitResigt: '신청제출',
    oneWeek: '최근 일주일',
    oneMonth: '최근 한달',
    threeMonth: '최근 3개월',
    withdrawAmoutIsNotNull: '인출금액을 입력해야 합니다!',
    withdrawAmoutZS: '자연수를 입력하세요!',
    withdrawAmoutMustNumber: '인출금액은 숫자여야 합니다!',
    withdrawAmoutIsNot0: '인출금액은 0보다 커야 합니다!',
    withdrawAmoutIsNotNegative: '인출금액이 음수면 안 됩니다!',
    withdrawAmoutIsNotEnough: '인출가능잔액이 부족합니다!',
    comformWithdrawMsg: '인출 정보를 확인하세요. 계속하시겠습니까?',
    comformWithdrawMsgIfGo: '인출 정보를 확인하세요. 계속하시겠습니까?',
    sureSubmit: '제출하기',
    returnEdit: '돌아가기',
    submitSuccess: '제출되었습니다. 심사를 기다려주세요!',
    companyName: '업체이름',
    companyName2: '업체명',
    companyType: '업체유형',
    distributor: '유통사：',
    supplier: '협력사',
    inputCompanyNameAndId: '업체이름/ID를 입력하세요',
    handle: '처리',
    auditor: '심사',
    auditorPass: '심사통과',
    auditorNotPass: '심사 미통과',
    withdrawHander: '인출처리',
    withDrawAuditor: '인출심사',
    withDrawAuditor2: '충전심사',
    withdrawHander2: '충전처리',
    refuseApply: '신청거절',
    refuseApplyReason: '미통과 이유를 입력하세요',
    handlingSubmittingAudits: '처리 및 심사제출',
    handelSuccess: '처리성공!',
    rechargeFail: '충전실패'
  },
  password: {
    getPassword: '비밀번호 찾기',
    pleaseInputMailAccount: '이메일계정을 입력하세요',
    sendPasswordToMail: '비밀번호 이메일로 발송',
    returnToIndex: '뒤로',
    sendMsg: '업무담당자 이메일을 입력하세요. 시스템이 비밀번호를 초기화하여 해당 이메일로 보낼 것입니다.',
    mattersNeedingAttention: '주의사항',
    tips1: '빈번하게 비밀번호를 찾기 마세요. 하루 최대',
    tips2: '번 찾기기능 사용가능.',
    tipsMsg: '안내정보',
    loginAtonce: '즉시 로그인',
    getUrlAgain: '다시 획득',
    mailCanNotBeEmpty: '이메일을 입력해야 합니다!',
    mailStyleNotRight: '올바른 이메일 형식을 입력하세요!',
    mailHaveSendSuccess: '이메일이 발송되었습니다. 이메일을 확인하세요!',
    theMailInputNotExist: '입력된 이메일이 존재하지 않습니다!',
    theMailNotHaveRight: '활성화되지 않았거나 금지된 이메일주소입니다!',
    aboveOneDayPermit: '하루 최대 허용 시도횟수를 초과했습니다!',
    mailSendFail: '이메일 발송 실패!'
  },
  orderMessage: {
    pleaseIntoConfirmEmail: '이메일을 입력하세요',
    emailError: '잘못된 입력 메 일 박스',
    confirmEmailError: '주문확인 이메일 형식이 올바르지 않습니다',
    pleaseIntoUseDate: '사용시간을 선택하세요',
    pleaseIntprodDate: '请选择游玩时间',
    pleaseIntoHandDate: '수령시간을 선택하세요',
    pleaseIntoReturnDate: '请选择归还时间',
    pleaseIntoLinkCounter: '请选择领取柜台',
    pleaseIntoReturnCounter: '请选择归还柜台',
    pleaseIntoCustomEmail: '여행객 이름을 입력하세요',
    pleaseSelectStock: '장소 선택',
    customEmailLength: '여행객 이름은 20자 이내여야 합니다',
    pleaseIntoCustomTel: '여행객 휴대폰번호를 입력하세요',
    pleaseIntoNationality: '국적을 입력하십시오',
    pleaseIntoBirthday: '생일을 입력하십시오',
    customTelError: '여행객 휴대폰번호 형식이 올바르지 않습니다',
    customTelError1: '연락번호가 정확하지 않습니다. 10자리 혹은 11자리의 전화번호를 입력해 주세요.',
    customAgeError: '연령의 포맷이 정확하지 않습니다.',
    customSexError2: '여성 전용 차량 때문에 성별을 다시 선택해 주세요.',
    customSexError1: '남자 전용 차량 때문에 성별을 다시 선택해 주세요.',
    pleaseIntoCustomWechat: '여행객 위챗을 입력하세요',
    customWechatError: '여행객 위챗 형식이 올바르지 않습니다',
    pleaseIntoCustomPass: '여행객 여권을 입력하세요',
    customPassError: '여행객 여권 형식이 올바르지 않습니다',
    pleaseIntoCustomAddress: '请输入快递地址',
    pleaseIntoCustomPostcode: '请输入邮政编码',
    customPostcodeError: '邮政编码格式不正确',
    pleaseIntoCustomCreditType: '请选择游客证件类型',
    pleaseIntoCustomCreditNo: '请输入游客证件号',
    customCreditNoError: '游客证件号格式不正确',
    customSexMale: '남',
    customSexFalmale: '여',
    customCtype1: '大人',
    customCtype2: '小児',
    customCtype3: '身障者大人',
    customCtype4: '身障者小児',
    pleaseRechangeCtype: '예약하신 상품의종류와 기입하신 티켓의종류가 다릅니다. 티켓의 종류를 다시 선택해 주세요.',
    pleaseIntoCustomItem: '여행객 사용자정의 내용을 입력하세요',
    quotaPrompt: '0 이상의 정수를 입력하십시오',
    orderOnceBeOne: '주문당 예약수량 최소 1개',
    orderNumberOnceBeOne: '单次订单预定人数至少为1',
    orderStockBeMax: '本产品场次库存数至多为',
    orderOnceBeMax: '본 제품 주문당 예약수량 최대',
    orderNumOnceBeMax: '本产品单次订单预定人数至多为',
    orderOnceBeMin: '본 제품 주문당 예약수량 최소',
    orderNumOnceBeMin: '本产品单次订单预定人数至少为',
    validateDateExpire: '유효기간이 만료됨',
    productsNumError: '재고가 부족하여 주문서를 생성할 수 없습니다',
    productsNumError1: '제품 ',
    productsNumError2: ' - ',
    productsNumError3: ' 재고 부족',
    productsNumError4: ' PDF 전자표 재고 부족',
    productPriceError: '价格已变化，请重新刷新',
    systemErrorMsg: '系统异常,请稍后再试!',
    pleaseUploadPDF: '需先上传PDF文件才能确认！',
    pleaseIntoUseData: '지정날짜를 입력하세요',
    productUseDateBeNull: '오더의 지정일은 비워서는 않된다',
    jtrordermessage: '数量最多为',
    jtrplayDate: '请先选择游玩时间',
    jtrnum: '请选择数量',
    jtrphone: '请输入手机号',
    jtrphonefalse: '手机号不正确',
    linkCreditTypeErr: '请选择证件类型',
    linkCreditNoErr: '请输入证件号码',
    error: '订单无法追加、或已达到上限',
    limitedDate: '현재 시간이 이미 제품의 예정 시간 범위를 초과했으니, 다시 계산해 주세요',
    limitBulking: '유통 업체가 대량 구매 중이므로 구매가 완료되기 전에 새로운 배치 예약을 제출할 수 없습니다. 잠시만 기다려주십시오!',
    designatedDateNull: '날짜를 비우다'
  },
  actuary: {
    all: '全部',
    actuaryType: '内容',
    actuaryType1: '预存款进款',
    actuaryType2: '请款书支付',
    actuaryType3: '临时采购',
    actuaryType4: '采购待支付',
    actuaryType5: '采购支付',
    actuaryType6: '售卖',
    actuaryState: '状态',
    actuaryState1: '正常',
    actuaryState2: '取消',
    actuaryState3: '完成',
    actuaryState4: '待处理',
    depositStatus0: '待处理',
    depositStatus1: '待审核',
    depositStatus2: '已完成',
    depositStatus3: '已拒绝',
    jphOrderStatus0: '待支付',
    jphOrderStatus1: '待确认',
    jphOrderStatus2: '取消中',
    jphOrderStatus3: '已取消',
    jphOrderStatus4: '已确认',
    jphOrderStatus5: '已完成',
    jphOrderStatus6: '未支付取消',
    jtrOrderStatus0: '待确认',
    jtrOrderStatus1: '待支付',
    jtrOrderStatus2: '已完成',
    jtrOrderStatus3: '取消订单',
    jtrOrderStatus4: '已付款',
    jtrOrderStatus5: '已申请退款',
    jtrOrderStatus6: '已退款',
    jtrOrderStatus7: '支付失败',
    jtrOrderStatus8: '拒绝退款',
    jtrOrderStatus9: '已出票',
    searchTime: '日期',
    searchWords: '关键字',
    searchMsg: '分销商名称/产品名称/设施',
    search: '搜索',
    exportExcel: 'Excel下载',
    addNew: '新增',
    actuaryId: '号码',
    createTime: '日期',
    facilitiesName: '设施',
    distributorName: '分销商',
    productName: '商品名',
    productNum: '张数',
    depositAmount: '预存款',
    payoutAmount: '支出',
    incomeAmount: '进价',
    saleAmount: '销售额',
    distributorBalance: '分销商预存款余额',
    salableQuantity: '可售张数',
    stockQuantity: '实际在库',
    operation: '操作',
    viewNum: '张数',
    viewNumErr: '张数不能为空或负数',
    view: '景点',
    viewIdErr: '景点必选',
    viewIdErr1: '只能选择一个景点',
    amount: '金额',
    amountErr: '금액을 입력해주세요',
    requestForm: '请求书',
    payDate: '支付日',
    payDateErr: '支付日不能为空',
    remark: '备考',
    remarkErr: '备考不能为空',
    validTime: '有效期',
    addAmount: '合计金额',
    money: '日元',
    confirm: '确认',
    timeSlot: '选择输入时间段',
    nameErr: '设施不能为空',
    validDateErr: '有效期不能为空',
    productInfo: '注 : 当前仅支持选择一种产品',
    productErr: '产品不能为空',
    productErr1: '当前只能选择一种产品',
    chooseActuaryType: '请选择新增精算类型',
    messageNotCompleteIn: '必要信息未输入完整',
    addSuccess: '添加成功',
    addError1: '添加失败,产品已存在或未选择产品',
    addError2: '添加失败',
    submitPrice: '价格不能为空!',
    submitMinPrice: '最低价格不能为空!',
    submitMinPrice0: '最低价格必须大于0!',
    submitMinPrice1: '分销价格必须大于0!',
    submitOrderNum: '排序不能为空!',
    submitLength: '价格及排序必须小于等于10位数字',
    addFailed: '系统异常,请稍后重试',
    operatorBalance: '余款',
    actuaryDetail: '精算详情'
  },
  finance: {
    calculatePeriod: '정산주기：',
    calculatePeriod1: '정산주기',
    placeholderCalculatePeriod: '정산주기를 선택하세요',
    supplierNameAndId: '공급사/ID：',
    placeholderSupplierNameAndId: '공급사이름/ID를 입력하세요',
    search: '검색',
    supplierName: '공급사이름',
    distributorPayoutAmount: '내야할 금액（JPY）',
    operatorIncomeAmount: '커미션금액（JPY）',
    supplierIncomeAmount: '결제금액（JPY）',
    operation: '실행',
    detail: '상세보기',
    downloadBill: '내역서다운로드',
    lastSixMonth: '최근 6개월',
    return: '뒤로',
    distributorName: '공급사이름：',
    distributorName1: '유통사이름',
    placeholderDistributorName: '유통사이름/ID를 입력하세요',
    finishTime: '완료시간',
    orderId: '주문ID',
    productId: '제품번호',
    productName: '제품이름',
    productType: '제품유형',
    elecTicket: 'E티켓',
    paperTicket: '종이티켓',
    experTicket: '체험',
    daysTicket: '일일여행/1일이상여행',
    wifi: 'Wi-Fi',
    sim: '유심',
    restTicket: '식당',
    traffTicket: '교통',
    packTicket: '혜택패키지상품',
    distributorPayoutAmount1: '받을커미션',
    operatorIncomeAmount1: '커미션금액',
    supplierIncomeAmount1: '결제금액'
  },
  payOrder: {
    payMessageOne: '주문 상세내용을 최종 확인해주세요. 주문은 1시간 내로 결제하지 않으면 취소되므로 빨리 결제해주세요.',
    payMessageOne1: '',
    payMessageOne2: '',
    payMessageOne3: '',
    jtrpayMessageOne: '최종 확인 주문서',
    jtrcancel: '주문 취소',
    jtrAppend: '追加订单',
    jtrpayMessageTwo: '분당 내에 지불하지 않은 것은 취소될 것이다.',
    payMessageTwo: '되도록 빨리 결제해주세요. 제품이 품절되면 구매할 수 없습니다.',
    payMessageThree: '주문',
    payMessageFour: '분 내로 결제하지 않으면 취소됩니다. 빨리 결제해주세요.',
    payMessageFive: '결제 시간초과, 다시 주문해주세요.',
    lineDownTicket: '오프라인 e티켓',
    lineUpTicket: '온라인 e티켓',
    salaryByNow: '선불금결제',
    thirdPayment: '전자지갑 결제',
    canBeUseMoney: '사용가능잔액：',
    jtrcanBeUseMoney: '지불 금액',
    remainTimes: '유효 기간',
    payMoney: '결제：',
    applyCancel: '취소 신청',
    payByNow: '즉시결제',
    canBeUseMoneyError: '잔액이 부족하므로 주문을 생성할 수 없습니다',
    orderCanceled: '주문취소됨',
    consentRefund: '已同意退款',
    refuseRefund: '已拒绝退款',
    overTimeByPay: '주문 결제 시간초과, 자동 취소됨',
    orderHaveUpdate: '支付失败，订单状态已更新',
    orderException: '订单异常，请重试',
    productException: '产品异常,无法编辑说明',
    payerror: '支付失败',
    error: '개수의 오류 취소하기',
    applyerror: '신청이 실패하다'
  },
  supplyOrder: {
    confirmCancel: '취소확인',
    refuseCancel: '취소거절',
    canceleOrder: '주문취소',
    specialCanceleOrder: '特殊取消',
    partnerCancleOrder: '연결 API 취소',
    jtrSpecialCanceleChannel: '패스 항공권 특별 취소',
    writeFff: '点击核销',
    confirmSpecialRefund: '确认特殊退款',
    refuseSpecialRefund: '拒绝特殊退款',
    orderConfirmDetail: '주문상세정보확인',
    system: '시스템',
    checkedForNew: '새소식 보기',
    orderRefuseMessage: '본 제품은 환불불가 제품이며 환불신청 시 결제한 금액은 반환되지 않으니 이점 유의하시기 바랍니다.',
    canBeTakeBackFree: '환불수수료비율',
    canBeTakeBack: '환불수수료',
    exchangeRate: '汇率差额',
    takeMoney: '실제환불금액',
    orderDetailByDialog: '주문상세확인',
    orderdetail1: '주문①확인',
    orderdetail2: '주문②확인',
    orderdetail3: '주문③확인',
    orderdetail4: '주문④확인',
    orderdetail5: '주문⑤확인',
    orderdetail6: '주문⑥확인',
    orderdetail7: '주문⑦확인',
    orderdetail8: '주문⑧확인',
    orderdetail9: '주문⑨확인',
    fileTypes: '이 파일은 올바르지 않는 pdf형식입니다!',
    reselectFile: '이 파일에 PDF 파일이 포함되지 않았으니 다시 선택하십시오!',
    zipTypes: '이 파일은 올바르지 않는 zip형식입니다!',
    fileSize: '업로드할 pdf는 5MB를 초과하면 안됩니다!',
    fileTypeBy: '파일명에 쉼표가 있으면 안 됩니다!',
    canCancel: '취소',
    downFiles: '파일 다운로드',
    vailTimeMsg: '주문 상태는 유효 기간 수정을 지원하지 않습니다',
    vailTimelaterMsg: '종료 날짜는 현재 날짜보다 이전일 수 없습니다.',
    vailTimeFsjMsg: '후지큐 제품은 유효 기간 변경을 지원하지 않습니다',
    vailTimeEmpty: '유효기간을 선택해주세요'
  },
  productNumberPrice: {
    pleaseIntoTime: '시간을 선택하세요',
    pleaseIntoNumber: '재고를 기입하세요',
    pleaseGetOneToSix: '1~6자리 숫자를 입력하세요',
    pleaseIntoPurchasePrice: '구매가격을 기입하세요',
    pleaseIntoDistorbutionPrice: '유통가격을 기입하세요',
    pleaseIntoMarketPrice: '시장가격을 기입하세요',
    dateCanotBeNull: '날짜범위를 입력해야 합니다',
    confirmDateCanotBeMax: '설정할 시간대는 반드시 제품 등록 시간대 범위 내에 있어야 합니다!',
    distributorCanotBuyMessage: '해당 상품의 판매 권한이 없기 때문에 예약 수 없습니다',
    distributorCanotBuyMessage2: '이 제품은 이미 하선되었으니 이 제품을 구매할 수 없다'
  },
  pwdSet: {
    pleaseIntoOldPwd: '기존 비밀번호를 입력하세요',
    pleaseIntoNewPwd: '새비밀번호를 입력하세요',
    pleaseConfirmPwd: '새비밀번호를 확인하세요',
    pleaseIntoIntoSix: '6~16자리 영문 대소문자나 숫자를 입력하세요',
    mustBeOne: '위에 입력한 것과 일치해야 합니다',
    pleaseIntoCorrectPwd: '올바른 비밀번호를 입력하세요',
    lengthMustOneToSix: '6~16자',
    canotBeIntoNull: '스페이스나 다른 문자를 입력하면 안 됩니다',
    updateNewPwdSuccess: '비밀번호 변경성공, 다시 로그인하세요!',
    oldPwdError: '기존 비밀번호가 틀렸습니다. 다시 입력하세요!',
    oldAndNewNotOne: '두번 입력한 비밀번호가 일치하지 않습니다!',
    pleaseIntoMustItem: '필수입력사항을 입력하세요',
    pleaseEnterPwd: '비밀번호를 입력하세요',
    pleaseEnterPwdAgain: '비밀번호를 한번 더 입력하세요'
  },
  homeMessage: {
    urgnMessage: '이 기능을 실행할 권한이 없습니다!'
  },
  entityTicket: {
    pinTicketNo: '핀 티켓 번호',
    selectDepot: '창고선택',
    pleaseSelect: '선택하세요',
    selectProduct: '제품선택',
    relationProduct: '관련 제품',
    selectPriceType: '选择产品种类',
    saveTicketDepot: '티켓창고저장',
    onlySelectOnePro: '한번 티켓창고 추가 시 1개 제품만 허용됩니다!',
    onlySelectOnePriceType: '添加票仓一次只允许择一个产品种类!',
    depotNameNotBeEmpty: '창고를 입력해야 합니다!',
    productNameNotBeEmpty: '제품을 입력해야 합니다!',
    productPriceTypeNotBeEmpty: '种类不能为空!',
    addSuccess: '추가성공!',
    inDepotSuccess: '입고성공!',
    proHaveExist: '이미 존재하는 제품입니다!',
    selectDepotOut: '출고창고',
    selectDepotIn: '입고창고',
    depotProNum: '재고수량',
    validDate: '유효날짜',
    selectDate: '날짜시간을 선택하세요',
    starEndTicketNo: '시작·종료티켓번호',
    starTicketNo: '시작티켓번호',
    endTicketNo: '종료티켓번호',
    inDepotTicketNo: '입고티켓번호',
    textArea: '단독스캔입구-커셔를 이곳으로 이동시킨 뒤 스캐너로 종이티켓의 바코드를 스캔하세요',
    saveToDepot: '입고저장',
    pleaseInputStarTicketNo: '시작티켓번호를 입력하세요!',
    pleaseInputEndTicketNo: '종료티켓번호를 입력하세요!',
    errorMsg01: '시작티켓번호는 10자리 숫자를 초과하면 안 됩니다!',
    errorMsg02: '종료티켓번호는 10자리 숫자를 초과하면 안 됩니다!',
    errorMsg03: '시작티켓번호는 종료티켓번호보다 크면 안 됩니다!',
    errorMsg04: '입고티켓수량은 2000장을 초과하면 안 됩니다!',
    errorMsg05: '아래 티켓번호는 10자를 초과하면 안 됩니다',
    errorMsg06: '입고창고를 선택하세요',
    errorMsg07: '출고창고와 입고창고가 같으면 안 됩니다!',
    errorMsg08: '만기시간을 선택하세요!',
    errorMsg09: '입고티켓번호를 입력하세요!',
    errorMsg10: '이 입고창고와 이 제품은 티켓창고가 없는 상태입니다. 먼저 티켓창고를 만들고 제품입고를 진행하세요!',
    errorMsg11: '입고창고에 아래 티켓번호가 존재합니다',
    errorMsg12: '출고창고에 아래 티켓번호가 존재하지 않습니다',
    errorMsg13: '이 출고창고와 이 제품은 티켓창고가 없는 상태입니다. 먼저 티켓창고를 만들고 제품출고를 진행하세요!',
    allBathList: '모든 차수 일람',
    batchDetailList: '차수 상세 일람',
    batchNO: '차수번호',
    ticketNO: '티켓번호',
    pleaseInputBatchNo: '차수번호를 입력하세요',
    pleaseInputTicketNo: '티켓번호를 입력하세요',
    inDepotTime: '입고시간',
    inDepotUser: '입고회원',
    importNumber: '삽입수량',
    userNumber: '사용수량',
    invalidateNumber: '폐기수량',
    leftNumber: '남은수량',
    exportNumber: '출고수량',
    thisBatchDetail: '상세',
    clearDepot: '창고정리',
    batchState: '차수상태',
    ticketState: '티켓상태',
    stateOne: '정상',
    stateTwo: '사용됨',
    stateThree: '폐기',
    stateFour: '출고됨',
    stateFive: '정리 한',
    stateSix: '잠긴',
    userOperationTime: '사용(폐기)시간',
    unUseRemark: '비활성화 설명',
    orderId: '주문ID',
    sureClearDepot: '이번 차수 제품에 대하여 정말 창고정리를 하시겠습니까?',
    sureClearDepot2: '이 제품에 대하여 정말 창고정리를 하시겠습니까? ',
    clearDepotSuccess: '창고정리 성공',
    haveCancelClearDepot: '창고정리를 취소했습니다!',
    invalidTicketSuccess: '전부폐기성공!',
    addTicketDepot: '새로 추가된 티켓창고',
    depot: '창고',
    keyWorld: '키워드입력',
    inputProNameAndNo: '제품이름/번호를 입력하세요',
    userTimeQuantum: '사용시간대',
    inputSelectTimeQuantum: '조회시간대를 입력하세요',
    depotId: '창고ID',
    ticketDepotId: '티켓창고ID',
    depotName: '창고이름',
    productId: '제품ID',
    productName: '제품이름',
    fileName: '파일총량',
    depotIn: '입고',
    depotId2: '입고',
    depotId3: '→',
    depotId4: '初始入库',
    depotOut: '출고',
    history: '이력',
    zhang: '장',
    operationUser: '실행자',
    depotType: '창고유형',
    addDepot: '새로 추가된 창고',
    inputDepotName: '창고이름을 입력하세요',
    notAllDepot: '총창고 아님',
    allDepot: '총창고',
    depotRemark: '창고비고',
    remarkMsg: '비고메시지',
    inventoryNumber: '재고량',
    ifIsAllDepot: '총창고 여부',
    yes: '네',
    no: '아니오',
    tips: '주의: 총창고는 하나만 있습니다',
    depotEdit: '창고편집',
    deleteDepot: '정말 이 창고를 삭제하시겠습니까?',
    depotNameIsNotEmpty: '창고이름을 입력해야 합니다!',
    allDepotOnlyOne: '총창고는 하나만 허용됩니다!',
    depotNameOnlyOne: '이미 존재하는 창고이름입니다!',
    userDepotManager: '회원창고관리',
    addDepotToUser: '창고지정',
    addDepotToUserSuccess: '지정성공!',
    notHistory: '이 제품은 이력이 없습니다!',
    pleaseSelectInvalidTicket: '폐기할 티켓번호를 선택하세요!',
    invalidTicketFalid: '전부 폐기실패!',
    someInvalidTicketFalid: '아래 티켓번호 폐기 실패',
    orderQuery: '주문조회：',
    orderQueryPlac: '주문ID를 입력하거나 스캔하세요',
    orderInfo: '주문정보：',
    startStopNumber: '시작종료티켓번호：',
    startNumber: '시작티켓번호',
    stopNumber: '종료티켓번호',
    numberEditPlac: '단독스캔입구-커셔를 이곳으로 이동시킨 뒤 스캐너로 종이티켓의 바코드를 스캔하세요',
    confirmPin: '티켓끊기확인',
    formMsg1: '인증코드, 주문번호를 입력하거나 스캔하세요',
    rule_n1_10: '1~10자리 숫자',
    querySuccess: '조회성공',
    queryFailure: '주문호마가 존재하지 않다',
    queryMsg1: '티켓시작일은 티켓종료일 보다 커서는 않된다，그리고 한번에 많아서 100장만 판매할수있다 ',
    queryMsg2: '끊은티켓 확인：',
    pinMsg1: '티켓끊기성공',
    pinMsg2: '티켓 판매 실패!',
    clearRemark: '창고 비고'
  },
  ticketMessage: {
    pleaseEnterOrderId: '예약 번호를 입력 하십시오.',
    depotName: '창고이름：',
    pleaseIntoDepotName: '창고이름을 입력하세요',
    depotNameNotNull: '창고이름을 입력해야 합니다',
    ticketRemark: '비고메시지：',
    remarkNotNull: '비고메시지를 입력해야 합니다',
    pleaseGetProduct: '제품을 선택하세요',
    fileDepotName: '파일창고이름：',
    batchStatus: '차수상태：',
    batchId: '차수번호',
    pleaseEnterBatchId: '차수번호를 입력하세요',
    enterDate: '시간삽입',
    enterUser: '회원삽입',
    close: '닫기',
    Processing: '처리 중',
    uploadFailure: '업로드 실패',
    ticketDetail: '상세보기',
    newToUse: '우선사용',
    fileStatus: '파일상태：',
    fileName: '파일명：',
    pleaseEnterFileName: 'PDF파일명을 입력하세요',
    fileId: '파일ID',
    fileNames: '파일이름',
    downPdf: 'PDF다운로드',
    ticketMessageBy: '아래 티켓번호 상태가 비정상이므로 폐기에 실패했습니다!',
    noUseMessage: '최소 1개의 파일을 선택하세요!',
    ticketMessageBy2: '이번 실행에 상태가 비정상적인 티켓이 존재합니다. 새로고침 후 다시 시도하세요!',
    operationSuccess: '실행성공!',
    getFile: '파일선택',
    getZipFile: 'ZIP선택',
    getFilesOnlyFive: '*각 PDF는 페이지별로 여러 전자 티켓으로 분할됩니다. PDF파일 업도드수량을 5로 제한하며 파일당 10MB로 제한합니다',
    getZipOnlyOne: 'ZIP파일 업도드수량을 1로 제한하며 파일당 300MB로 제한합니다',
    usedDate: '유효마감날짜：',
    usedDates: '유효마감날짜',
    ticketMessageBy3: '비었지만 항상 효력이 있습니다.',
    intoNow: '즉시삽입',
    intoSuccess: '삽입성공!',
    insertFileDepot: '새로 추가된 파일창고',
    choose: '选择',
    fileDepotNames: '파일창고이름',
    pleaseIntoFileName: '창고명을 입력하세요',
    canBeUseDate: '사용(폐기)시간대：',
    intoSearchDate: '조회시간대를 선택하여 입력하세요',
    into: '삽입',
    fivePdf: '개PDF!',
    oneZip: '개ZIP!',
    ticketOpen: '열기',
    intoIng: '삽입 중, 잠시만 기다리세요...',
    fileHadExists: '파일이 창고에 이미 존재합니다!',
    uploadSize: '업로드할 이미지 크기가 10MB를 초과하면 안 됩니다!',
    uploadZipSize: '업로드할 이미지 크기가 300MB를 초과하면 안 됩니다!',
    fileNotFors: '파일 업로드 중복 불가!！',
    pleaseGetFile: '파일을 선택하세요',
    fileBatchRemarkNotNull: '비고메시지를 입력하세요'
  },
  remind: {
    remindId: '번호',
    title: '이메일 알림',
    date: '단체 발급일',
    accessory: '부속 서',
    add: '새 알람',
    upload: '첨부 파일 업로드',
    beforeDay: '단체 발송일 n 일 전에 이메일을 발송하여 주의사항을 알리다',
    before: '단체 출발일 전',
    days: '매일 알람 메일을 보냅니다',
    download: '첨부 파일을 다운로드하다',
    reminder: '제시',
    confirm: '확정',
    inputDate: '단체 발송일을 입력해 주세요',
    uploadAccessory: '첨부 파일을 업로드하십시오.',
    inputbeforeDay: '사전 발송일을 입력해주세요',
    inputContent: '메일 내용을 입력해 주세요',
    sendContent: '내용 보내기',
    addRemind: '이메일 알림',
    existRemind: '당일 알림이 이미 존재합니다',
    set: '메일 설정'
  },
  trades: {
    platform: '플랫폼',
    excel: '엑셀도출',
    tradesTime: '거래시간대',
    inputOrderId: '주문번호를 입력하세요',
    tradingTime: '거래날짜',
    operatorUser: '실행자',
    expenditure: '지출',
    income: '수입',
    buyQuantity: '수량',
    customerName: '손님 이름',
    orderExplain: '주문 노트 설명',
    content: '내용'
  },
  pinTicketMagn: {
    pinTicket: '끊은티켓 인증',
    shortcutOut: '빠르게 티켓 끊기',
    all: '전부',
    pinTime: '인증 시간',
    validationType: '끊은 티켓 유형：',
    productName: '제품이름：',
    placeholder1: '제품이름을 입력하세요',
    validateTime: '티켓 끊은 날짜: ',
    placeholder2: '티켓 끊은 날짜를 입력하세요',
    orderId: '주문ID：',
    placeholder3: 'ID를 입력하세요',
    distributor: '유통사：',
    placeholder4: '유통사를 입력하세요',
    validationUser: '티켓소유자: ',
    placeholder5: '티켓소유자를 입력하세요',
    ticketNo: '티켓번호：',
    placeholder6: '티켓번호를 입력하세요',
    colOrderId: '주문ID',
    colOrderContent: '주문내용',
    colValidateTime: '티켓 끊 은시간',
    colValidateType: '끊은 티켓 유형',
    colValidateUser: '티켓소유자',
    colDistributor: '유통사',
    colCustomerOrderNo: '끊은 티켓번호',
    placeholder7: '빠 른 취소 표 번 호 를 입력 하 세 요.',
    colCustomerOperator: '실행자',
    placeholder8: '조작 자 를 입력 하 세 요',
    colticketNo: '티켓번호',
    shortcutOutDepot: '끊은티켓창고',
    shortcutOutProduct: '판매티켓 제품',
    company: '회사',
    orderIdNo: '주문번호',
    distributorNameAndOrderNo: '판매자명 (건의:이니셜) +단일번호',
    pleaseInputOrderCustomer: '고객 주문번호를 입력하세요',
    pleaseInputCustomerOperator: '실행자를 입력하세요',
    shortcutOutSure: '티켓끊기확인',
    ticketCanNotBeCutOut: '아래 티켓번호는 티켓을 끊을 수 없습니다',
    ticketCanNotBeCutOuts: '가격의 종류는 중복된 표를 입력할 수 없다',
    distributeOnlySelectOne: '유통사는 하나만 선택가능',
    ticketNumber100: '들어온 티켓량이 100을 초과하면 안 됩니다!',
    pleaseInputDistribute: '유통사를 입력하세요!',
    pleaseInputOrder: '주문번호를 입력하세요!',
    orderLine100: '주문번호는 100자를 초과하면 안됩니다!',
    inputOperation: '실행자를 입력하세요!',
    operationLine100: '실행자는 100자를 초과하면 안 됩니다',
    shortcutOutSuccess: '티켓끊기성공!'
  },
  errMsg: {
    errMsg100: '주문호마가 존재하지 않다',
    errMsg101: '대응이없는 창고',
    errMsg102: '엄무원만 티켓판매 가능',
    errMsg103: '오더가 유효기한내에 없다',
    errMsg104: '아래 티켓번호는 판매할수 없다',
    errMsg105: '사업자 혹은 특수권함인 협력사는 심사통과의 조작실패를 직접 선택한다',
    errMsg106: '제품ID는 비워서는 않된다',
    errMsg107: '파일 업로드는 비워서는 않된다',
    errMsg108: '서비스내부 이상',
    errMsg109: '오더 이미 완성',
    errMsg110: '오더 미확인',
    errMsg111: '판미한 티켓수와 실제 구매수가 일치하지 않다',
    errMsg112: '대응되는 티켓창이 없다',
    errMsg113: '대응되는 티켓이 없다',
    errMsg114: '请选择产品来源',
    errMsg115: '',
    errMsg116: '이 주문서는 이미 취소되었습니다',
    errMsg117: '',
    errMsg118: '',
    errMsg119: '',
    errMsg120: '',
    errMsg121: '正在处理中，请勿重复提交'
  },
  pay: {
    type: '충전방식',
    success: '결제완료',
    fail: '결제미완료',
    toUrl: '결제플랫폼으로 가서 결제를 진행해주세요 ',
    toPay: '계속 충전하기',
    error01: '결제에 실패했습니다. 다시 시도해주세요',
    error02: '결제가 완료되었습니다. 중복하여 새로고침하지 마세요',
    loading: '결제 데이터 처리 중...',
    message: '支払いが成功したら、振込はサービス方で遅れます。お待ちください。'
  },
  pageSetting: {
    upload01: '1MB를 초과하지 않는 jpg/png/jpeg 파일만 업로드 가능',
    upload02: '홈 페이지 사진 사이즈 1920 x 500 화소, 홈 페이지 사진의 요소 패턴은 왼쪽과의 거리가 430 화소 필요해요.',
    pageImg: '홈 페이지 사진：',
    errorByPage01: '홈 페이지 사진에 변화가 없습니다',
    errorByPage02: '홈 페이지 사진은 공백일 수 없습니다！'
  },
  barCode: {
    urlError: 'URL 오류!',
    getInfoError: 'QR코드 불러오기 오류!',
    productTextDescription: '상세문자묘사',
    customerReceiveDate: '수령카날짜：',
    returnDate: '반환카날짜：',
    productUseDate: '지정날짜：',
    buyQuantity: '구매 수량：',
    productUseFlow: '이용과정：',
    productUseName: '성함：',
    validityDate: '성함：'
  },
  supplementInfo: {
    urlError: '地址链接异常!',
    getSupplementInfo: '内容获取失败!',
    supplementOfUseFlow: '使用流程补充详细说明'
  },
  qrCode: {
    qrCodeSource: '이름',
    isDistribution: '판매',
    scale: '커미션 비율',
    YES: '예.',
    NO: '아니.',
    noValue: '없음',
    distributionRange: '제품의 범위를 나누어 권한을 주다.',
    distributionRangeAll: '모두 2차원 부호',
    distributionRangeYes: '지정된 QR코드만 분할 수 있다',
    distributionRangeNo: '지정한 QR코드 이외의 QR코드 제외',
    selectDistributor: '제품 선택',
    tipMessage1: '이름을 입력하십시오',
    tipMessage2: '권한을 선택하십시오',
    tipMessage3: '커미션비율을 입력해 주세요',
    addError1: 'QR코드 소스가 이미 존재하였으니 다시 입력하십시오',
    prompt: '이 막대 QR코드를 삭제하시겠습니까?？',
    searchMore: '제품',
    choseCode: 'QR코드 선택',
    choseCodeError: 'QR코드 선택',
    nickName: '닉네임',
    auditStatus: '심사상태',
    submitAudit: '심사에 동의합니다?',
    submitAudit1: '현금인출에 동의하십니까?',
    cannotSale: '유저를 무효후, QR코드를 통해 구입한 상품은 수수료의 분배는 없습니다.',
    canSale: '유저를 무효후, QR코드를 통해 구입한 상품은 수수료의 분배가 있습니다.',
    remark: '비고',
    agree: '동의',
    handle: '처리',
    notAgree: '기각',
    applyMoney: '인출금액',
    applyMoney1: '인출금액(수수료 별도)',
    chargeMoney: '수수료',
    chargeMoney2: '수수료 포함',
    aduitTime: '심사시간',
    aduitName: '심사인',
    remittanceExport: '송금데이터다운로드',
    realName: '계좌명의',
    bankNo: '계자번호',
    bankName: '은행명',
    branchName: '지점명',
    accountType: '계좌종류',
    tocDistributor: '소속 에이전트',
    distributorName: '2급 에이전트 닉네임',
    twoDistributor: '2급 에이전트 닉네임',
    oneDistributor: '에이전트',
    drawaltip1: '인출금액이 잔고의 금액을 초과하고 있습니다.',
    drawaltip2: '인출금액이 수수료금액보다 낮습니다.',
    drawaltip3: '인출금액을 입력해 주세요.',
    drawaltip4: '현금인출신청 처리중입니다. 처리완료까지 잠시만 기다려주세요',
    saleName: '유저',
    saleMoney: '2급 에이전트 수익',
    distributorMoney: '에이전트 수익',
    isHasMoney: '입금상태',
    isPay: '입금완료',
    notPay: '미입금',
    handleStatus: '처리상태',
    handleStatus1: '처리대기',
    handleStatus2: '처리완료',
    handleStatus3: '기각완료',
    handleBy: '처리인',
    handleTime: '처리시간',
    setCharge: '수수료설치',
    chargeConfirm: '인출 수수료의 변경을 확정하시겠습니까?',
    accountStatus: '계정상태',
    canUse: '유효로 합니다',
    cannotUse: '무효로 합니다',
    cannotUse1: '연계해제완료',
    incomeAmount: '수익금액',
    tocIncomeAmount: 'C단 계정 잔고',
    withdrawalError1: '계좌명의를 입력해 주세요',
    withdrawalError2: '계좌번호를 입력해 주세요',
    withdrawalError3: '은행명을 입력해 주세요',
    withdrawalError4: '지점명을 입력해주세요',
    withdrawalError5: '예금종목를 입력해 주세요',
    handleError1: '본 유저의 잔고부족으로, 인출처리를 할수 없습니다',
    handleError2: '인출처리는 운영자만 조작가능！',
    handleError3: '잔고부족으로, 인출처리를 할수 없습니다',
    withdrawalTips: '일본엔 1만엔이상(1만엔포함)의 경우에는 수수료가 없습니다.;일본엔 1만엔이하, 고정수수료가 발생합니다',
    withdrawalTips1: '일본엔 1만엔이상(1만엔포함)의 경우에는 수수료가 없습니다.',
    withdrawalTips2: '일본엔 1만엔이하, 고정수수료가 발생합니다',
    applyCash: '현금인출신청',
    applyBy: '신청자 유형',
    applyUser: '신청자',
    twoApplyName: '2급 에이전트',
    cannotCharge: '설정 금액은 양의 정수 여야합니다',
    name: '명칭.',
    Unbundling: '연계해제',
    UnbundTips: '연계해제후, 이 사용자에는 판매커미션이 발생하지 않습니다.',
    cannotUnbund: '송금미완료인 커미션이 있습니다. 연계해제할수 없습니다.',
    twoApplyNameID: '2급 에이전트ID',
    inputScale: '분배하는 커미션율을 입력해주세요.',
    keyTips: '2급 에이전트ID/2급 에이전트 닉네임',
    saleLog: '직판 기록',
    withdrawalTips4: '잔액 부족, 일시적으로 현금 인출 불가'
  },
  payWay: {
    balance: '계정잔액',
    weChat: '위챗',
    alipay: '알리 페이',
    creditCard: '카드',
    unionPay: '은 련',
    weChatWay: '위 채팅 페이',
    payedId: '지불 번호',
    alipayWay: '알리 페이',
    linePay: 'Line페이',
    grabPay: 'Grab페이',
    zaloPay: 'Zalo페이',
    aliPayHK: '알리페이 홍콩',
    isPay: '예약 결제 중',
    codeTips: 'QR 코드 유효 기간 만료 다시 검색하십시오',
    codeTips1: 'QR 코드 재 취득',
    codeTips2: '위 채팅',
    codeTips3: 'QR 코드를 스캔',
    codeTips4: '알리 페이로',
    codeTips5: 'QR 코드를 스캔',
    codeTips6: '카메라를 켭니다',
    refundTips: '예약은 취소되었습니다 지불 전액은 결제 업체에 환불합니다. 숙박 사수 부탁합니다.',
    refundTips1: '예약은 이미 지불 된 결제 금액은 결제 업체에 환불합니다. 숙박 사수 부탁합니다.',
    refundTips2: '예약 지불 방법으로 지불 삼십일 초과 한 경우 환불되지 않습니다, 양해 바랍니다.',
    refundTips3: '예약 결제가 실패했습니다 이미 지불 한 경우, 지불 원래 전액을 환불합니다. 숙박 사수 부탁합니다.',
    errorTips: '결제 정 보 를 가 져 오 는 데 실 패 했 습 니 다. 다시 가 져 오 세 요.',
    partialRefundTips: '부분 환불의 경우, 수수료는 환불되지 않습니다',
    payTitle: '접속처 대량으로 구입하다'
  },
  newHome: {
    priceFormat: 'JPY {0} <span class="price-format">부터</span>',
    expired: '로그인이 만료되었습니다. 다시 로그인해 주세요.',
    searchPlaceholder: '목적지 또는 액티비티 검색',
    searchButton: '검색',
    searchResults: '개의 예약 가능한 상품',
    category: {
      transport: '교통',
      themePark: '입장권',
      wifi: 'WiFi & 유심',
      carRental: '특가 패키지',
      dayTrip: '당일 투어 / 숙박 투어',
      hotel: '체험 / 맛집'
    },
    productSaleLabel: {
      osakaSalesOffice: '오사카 영업소',
      tokyoSalesOffice: '도쿄 영업소',
      fukuokaSalesOffice: '후쿠오카 영업소',
      kyotoSalesOffice: '오키나와 영업소',
      nagoyaSalesOffice: '나고야 영업소',
      hokkaidoSalesOffice: '홋카이도 영업소'
    },
    popularCities: '인기 여행지',
    popularCitiesEn: '인기 여행지 & 시즌 한정 액티비티 모음',
    activeNumber: '가지 활동',
    balance: '잔액',
    switchToOldVersion: '이전 버전으로 전환',
    switchToNewVersion: '새 버전으로 전환',
    viewMore: '더 보기',
    all: '전체',
    sortBy: '정렬',
    easyGoRecommend: 'EasyGo 추천',
    allDates: '전체 날짜',
    priceRange: '가격대',
    other: '기타',
    selectedExperiences: '엄선 체험',
    topActivities: '일본 인기 액티비티',
    sales: '예약 수',
    price: '가격',
    stockQuery: '예약 가능 여부 확인',
    noProducts: '상품이 없습니다',
    salesLessThan1k: '예약 1,000건 미만',
    sortOptions: {
      new: '최신순',
      sales: '인기순'
    },
    autoConfirm: '즉시 확정',
    secondConfirm: '수동 확정'
  }
};

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.default = {
  common: {
    zh: '简体中文',
    tw: '繁體中文',
    ja: '日本語',
    en: 'English',
    ko: '한국어',
    title: '后台管理系统',
    exit: '退出',
    search: '搜索',
    tel: '电话',
    address: '地址',
    scenicSpotAreaSelection: '景点地区选择',
    inputRequiredTip: '请输入景点名称',
    edit: '编辑',
    delete: '删除',
    recommend: '设为推荐',
    pay: '支付',
    printOrder: '打印订单',
    download: '下载',
    cancelRecommend: '取消推荐',
    cancel: '取消',
    confirm: '确定',
    submit: '提交',
    searchMore: '查看更多',
    prompt: '提示',
    basicInfo: '基本信息',
    day: '天',
    hour: '小时',
    minute: '分',
    second: '秒'
  },
  title: {
    supplement: '使用流程补充',
    addDining: '添加产品 (餐厅)',
    balanceSetting: '余额管理',
    productPriceNumber: '库存价格',
    productState: '产品审核',
    productAll: '全部',
    productStated: '待审核',
    productNotState: '审核不通过',
    orderReport: '订单管理',
    orderDetail: '订单详情',
    scenicSpotList: '景点管理',
    addScenicSpot: '添加景点',
    editScenicSpot: '编辑景点',
    scenicSpotDetail: '景点详情',
    popularCities: '热门目的地管理',
    addHotCity: '添加热门目的地',
    editHotCity: '编辑热门目的地',
    productManager: '产品管理',
    pdfFilesManage: 'PDF文件库管理',
    supplyManageProduct: '产品售卖管理',
    tocDistributorManageProduct: 'TOC产品售卖管理',
    pdfBatchList: '批次列表',
    bulkPurchaseList: '批量采购列表',
    bulkPurchaseDetail: '批量采购详情',
    submitAndPayOrderBatch: '批量采购',
    batchPdfFilesList: '批次文件列表',
    addPdfFiles: '添加PDF文件库',
    importPdf: 'PDF文件导入',
    pdfFiles: 'PDF文件',
    DiningDetail: '餐厅产品详情',
    financeStatement: '自动生成财务报表',
    statementDetail: '报表详情',
    warehouse: '仓库管理',
    ticketDepot: '票仓管理',
    addTicketDepot: '新增票仓',
    importTicket: '入仓',
    pinTicket: '验证销票',
    pinTicketMagn: '验证销票管理',
    trades: '交易明细',
    record: '历史提现记录',
    counter: '柜台管理',
    addCounter: '添加柜台',
    editCounter: '编辑柜台',
    liaison: '联络人管理',
    addLiaison: '添加联络人',
    editLiaison: '编辑联络人',
    updatePDFfiles: '编辑PDF文件库',
    importThirdSystemProduct: '产品导入管理',
    productLogList: '产品修改记录',
    productLogDetail: '产品变更详情',
    productLanguageLogList: '产品修改记录',
    productLanguageLogDetail: '产品多语言变更详情',
    bannerManage: '横幅管理'
  },
  lable: {
    translation: 'AI翻译',
    translationing: 'AI翻译中...',
    translationTip: '无可翻译数据',
    ifOnline: '是否上架',
    hotCity: '热门目的地',
    cityName: '目的地名称',
    cityPicture: '目的地图片',
    picture: '图片',
    languageType: '语言',
    sort: '排序',
    sortTip: '数值越小越靠前',
    onlineTip: '下架后不显示客户端',
    hotType: '热门类型',
    type1: '热门地区',
    type2: '热门目的地',
    type3: '热门地标',
    addProduct: '添加商品',
    productInformation: '产品信息',
    price: '价格',
    tags: '标签',
    productList: '产品列表',
    selectLogType: '选择查找类型',
    selectLogType_1: '基础字段',
    selectLogType_2: '多语言字段',
    inputProductId: '请输入产品ID',
    inputProductId_placeholder: '请输入产品ID',
    customerDataType: '客人资料类型',
    customerDataInfo: '客人资料信息',
    chooseProductLanguage: '请选择产品语言',
    noDataForLanguage: '暂无数据，请选择其他语言',
    newOrderEmail: '订单通知邮箱',
    batchStatus: '批次状态',
    proofPath: '凭证链接',
    pinTicketNum: '核销数量',
    KlookTicketCanbeUsedDateTBList: ' 起6个月内',
    KlookTicketCanbeUsedDate: ' 起6个月以内，相同价格梯度的日期有效',
    QuantityMismatch: '销票数与实际购买数量不符，是否继续销票',
    importProduct: '导入产品',
    system: '对接系统',
    chooseSystem: '请选择对接系统',
    klook: '客路系统',
    link: 'LINK',
    thirdNum: '第三方产品编号',
    enterThirdNum: '请输入第三方产品编号',
    thirdProductTime: '时间：',
    timeTips: '请输入时间段（1～24）',
    haveInventory: '有库存',
    noInventory: '无库存',
    travlerFirstName: '游客名',
    travlerFamilyName: '游客姓',
    travlerCall: '称呼',
    enterGolfCourseCode: '请输入高尔夫场地编号',
    enterPrefecture: '请输入行政区域编号',
    Mr: '先生',
    Ms: '女士',
    Miss: '小姐',
    Mrs: '夫人',
    duration: '持续时间',
    travellers: '提示旅客人数',
    voucherUsage: '凭证使用方法',
    voucherTypeDesc: '凭证类型',
    voucherValidity: '凭证有效期限',
    redemptionProcess: '验证流程',
    transportation: '交通方式',
    insiderTips: '温馨提示',
    packageOptions: '套餐说明',
    itinerary: '行程说明',
    joinAstrict: '参加限制',
    demand: '要求',
    additionalInformation: '附加信息',
    meetUpLocation: '集合说明',
    pickUpLocation: '领取地址',
    surcharge: '超时费用',
    location: '地址',
    submitOrderTip: '该产品为特殊产品,提交订单后将自动支付,是否提交?',
    submitOrderBatch: '请确认采购内容无误，提交订单后将自动扣除分销商余额，是否提交?',
    location_placeholder: '请输入地址',
    duration_placeholder: '请输入活动时长',
    productConfirmType_placeholder: '请输入确认类型',
    transportation_placeholder: '请输入交通方式',
    voucherTypeDesc_placeholder: '请输入凭证类型',
    voucherUsage_placeholder: '请输入凭证使用方法',
    voucherValidity_placeholder: '请输入凭证有效期',
    pickUpLocation_placeholder: '请输入领取地址',
    redemptionProcess_placeholder: '请输入地址',
    packageOptions_placeholder: '请输入套餐说明',
    itinerary_placeholder: '请输入行程说明',
    additionalInformation_placeholder: '请输入附加信息',
    surcharge_placeholder: '请输入超时费用',
    insiderTips_placeholder: '请输入温馨提示',
    updateType: '类型修改',
    updateFloatPrice: '统一浮动价',
    shareQrCode: '分享二维码',
    setQrCode: '设置二维码',
    addCoupon: '添加优惠券',
    couponName: '优惠券名称',
    couponAmount: '优惠金额',
    couponOrder: '优惠券订单',
    couponCode: '优惠码',
    addCouponCode: '添加优惠码',
    downloadCouponCode: '优惠码下载',
    batchDelete: '批量删除',
    downloadNow: '{cnt}条记录添加成功，是否立即下载?',
    tipMessage1: '请输入名称',
    examine: '分销审核',
    revenueManagement: '分销管理',
    revenueDetail: '收益管理',
    cashManager: '提现管理',
    productState: '状态选择',
    orderNum1: '排序',
    netError: '该产品已在供应商处下线',
    updateProduct: '更新',
    addQrCode: '添加二维码',
    pleasechoice: '请选择',
    identity: '身份证',
    studentId: '学生证',
    officerId: '军官证',
    passport: '护照',
    residence: '户口本(儿童请选择此项)',
    hongKongandMacaopass: '港澳通行证',
    cellsyndrome: '台胞证',
    identificationNumber: '证件号码',
    children: '（儿童输入出生年月日）',
    addressinformation: '地址信息',
    expressaddress: '快递地址',
    postalCode: '邮政编码',
    suborderinformation: '子订单信息',
    subordersId: '子订单ID',
    qxzfbcplx: '请选择发布产品类型',
    selectTreeId: '请选择产品类型',
    ticketType: '类型',
    jtrticketType: '类型',
    productPriceTypeSetting: '价格种类设置',
    batchPriceRuleSetting: '批量价格规则设置',
    specificDatePriceSetting: '特定日期价格设置',
    currentProducts: '当前产品：',
    currentProducts_saleDate: '当前产品上架时间段：',
    unlimited: '无限制',
    setProductInventoryAndPrice: '批量设置产品库存和价格',
    setProductPriceType: '设置产品价格种类',
    serialNumber: '序号',
    period: '时间段',
    timelimit: '时间范围',
    selectDateRange: '选择日期范围',
    selectTimeRange: '选择时间范围',
    inventory: '库存',
    purchasePrice: '采购价',
    jtrDistributionPrice: '分销平台采购价',
    stockNum: '场次库存',
    distributionPrice: '分销价',
    marketPrice: '市场价',
    retailPrice: '零售价',
    operating: '操作',
    delete: '删除',
    chargeback: '退单',
    addTimePeriod: '添加时间段',
    reset: '重置',
    save: '保存',
    goBack: '返回',
    confirm: '确认',
    confirmOrder: '确认订单',
    confirmOrder1: '北海道确认订单',
    jtrconfirmOrder: 'JTR确认订单',
    refuse: '拒绝订单',
    cancelOrder: '取消订单',
    requestCancel: '申请取消',
    specialRequestRefund: '特殊申请退款',
    requestRefund: '申请退款',
    makeSure: '确定',
    cancel: '取消',
    productName: '产品名称',
    scene: '场次',
    dataSource: '数据源',
    selectDistributor: '选择分销商',
    authorizedMerchant: '已授权商户',
    businessName: '商户名称',
    priceFloatRange: '分销价授权',
    distributorNameOrNumber: '商户名称/编号',
    distributorNumber: '分销商编号',
    distributorName: '商户名称',
    changeValidTime: '变更有效期',
    // suoCountry: '所属城市',
    bannerTitle: '横幅主标题',
    bannerSubTitle: '横幅副标题',
    bannerImages: '横幅图片',
    suoCountry: '关键字',
    suoCountrys: '关键字',
    productNameOrId: '产品名称/编号',
    productNameOrIds: '产品名称/编号',
    productNameOrIdRemark: '产品名称/编号/备注/标签',
    productDiff: '产品类别',
    productDiffs: '产品类别',
    confirmMethod: '确认方法',
    managerArea: '管理地区',
    productCode: '产品编号',
    golfCourseCode: '高尔夫场地编号',
    prefecture: '地方行政区域',
    suoCity: '热门目的地',
    confirmMethods: '确认方法',
    confirmMethodss: '确认方法',
    managerAreas: '管理地区',
    different: '类别',
    number: '人数',
    status: '状态',
    ticketType0: '电子票',
    ticketType1: '实体票',
    ticketType2: '体验',
    ticketType22: '体验',
    ticketType3: '一日游/多日游',
    ticketType33: '一日游/多日游',
    ticketType4: 'Wi-Fi',
    ticketType5: 'SIM卡',
    ticketType6: '美食',
    ticketType66: '美食',
    ticketType7: '交通',
    ticketType77: '交通',
    ticketType8: '优惠套票',
    ticketType88: '优惠套票',
    ticketType9: '夜间巴士',
    ticketType99: '夜间巴士',
    jtrticketType0: '门票',
    jtrticketType1: '套餐或打包产品',
    jtrticketType2: '自由行',
    jtrticketType3: '线路',
    jtrticketType12: '预售',
    isOnlinePay0: '线下',
    isOnlinePay1: '线上',
    isOnlinePay2: '在线支付（预付）',
    isOnlinePay3: '酒店前台现付（返佣）',
    confirmType0: '自动确认',
    confirmType00: '自动确认',
    confirmType1: '二次确认',
    confirmType11: '二次确认',
    confirmType12: '二次确认',
    confirmType2: '',
    productSource0: 'JPH产品',
    productSource1: '合作商产品',
    status0: '待审核',
    status1: '审核通过',
    status2: '审核不通过',
    status3: '下线',
    status4: '草稿',
    online: '上线',
    checkAll: '查看',
    faverite0: '推荐',
    faverite1: '不推荐',
    toldAllLeft: '说明：使用日期的',
    toldAllMiddle: '天前的',
    toldAllMiddles: '天前的',
    toldAllRight: '之前预定',
    orderEmergentTag: '紧急处理',
    orderUncertainTag: '待确认',
    orderConfirmedTag: '已确认',
    orderCancellingTag: '取消中',
    orderCanceledTag: '已取消',
    orderCompletedTag: '已完成',
    orderExpiredTag: '已过期',
    orderPaymentTag: '已支付（JTR）',
    orderRefundedRequestTag: '已申请退款（JTR）',
    orderRefundedTag: '已退款',
    orderUnpaidTag: '未支付',
    otherSelection: '其它筛选',
    remark: '备注',
    createRoleRemark: '备注',
    productHighlights: '亮点',
    currentState: '当前状态',
    youHave: '您还有',
    processOrder: '来处理此订单',
    toPayOrder: '来支付此订单',
    OrderHistory: '订单历史',
    orderDisExplain: '订单说明(仅分销商自己可见)',
    orderDisExplains: '备注(仅供应商自己可见)',
    CustomersInvisible: '备注（与供应商沟通用）',
    SupplierInvisible: '顾客留言',
    addRemark: '添加备注',
    addMessage: '添加留言',
    addExplain: '编辑说明',
    confirmation: '确定确认此订单吗',
    confirmationPdf: '确认作废此PDF吗',
    confirmationticket: '确认作废此实体票吗',
    specialRefundConfirm: '确认退款后钱款将会全额返还给分销商,是否确认',
    specialRefundCancel: '拒绝退款则订单会继续进行下去',
    DeleteConfirmation: '确定删除吗',
    refusal: '确定拒绝此订单吗',
    voucherPath: '凭证链接',
    messageInfo: '订单预订信息',
    orderID: '订单ID',
    sonOrderID: '订单号',
    jtrOrderId: '渠道单号',
    orderSource: '订单来源',
    useDate: '指定日期',
    sonProduct: '子产品',
    useDate1: '指定日期',
    useDates: '指定日期',
    travelDate: '游玩日期',
    createTime: '下单时间',
    endTravelDate: '结束时间',
    arrivedTime: '到达时间',
    touristRemarks: '游客备注',
    reserveNum: '预定数量',
    linkMan: '联系人姓名',
    warnning1: '必须真实姓名，用于景区验证',
    linkPhone: '联系人电话',
    linkEmail: '联系人邮箱',
    linkAddress: '快递地址',
    linkCode: '邮政编码',
    linkCreditType: '联系人证件类型',
    linkoptionA: '身份证',
    linkoptionB: '护照',
    linkCreditNo: '联系人证件号码',
    customerUseDate: '使用日期',
    customerTravelDate: '游玩日期',
    customerEndTravelDate: '游玩结束日期',
    customerArriveTime: '到达日期',
    customerGetTicType: '取票方式',
    customerGetTicType0: '免费',
    customerGetTicType1: '快递费',
    distributor: '分销商',
    PDFSendingMode: 'PDF电子票发送方式',
    productPrice: '产品价格',
    Purchase: '采购价格',
    distributionPriceToc: 'C端单价',
    distributionPriceSum: 'C端总价',
    productSalePrice: '产品浮动价',
    productMinPrice: '最低价格(显示用)',
    productTcPrice: '产品偏移价格',
    buyNum: '购买数量',
    orderCnt: '成功数量',
    seatName: '场次名称',
    jtrAppendNum: '追加数量',
    primarynum: '原订数量',
    cancelNum: '取消数量',
    totalAmount: '支付总额',
    customerInfo: '顾客信息',
    customerName: '姓名',
    cusEmail: '客户邮箱',
    Email: '邮箱',
    receiveDate: '领取日期',
    returnDate: '归还日期',
    FileImport: '文件导入',
    upload: '上传',
    onlyUpload: '只能上传',
    noMoreThan: '文件，且不超过',
    generateOrder: '生成订单',
    thisOrder: '此订单在',
    hasConsumed: '用户已消费',
    noData: '暂无数据',
    viewName: '景点名称',
    viewLocal: '所在地',
    viewAddress: '景点地址',
    viewPicture: '景点图片',
    viewRemark: '景点备注',
    viewTelephone: '景点电话',
    payOrder: '支付订单',
    jtrpayOrder: 'jtr支付订单',
    jtrAppend: 'jtr追加订单',
    operated: '操作',
    productSource: '产品来源',
    searchType: '请选择搜索类型',
    searchType1: '订单ID',
    searchType2: '产品名称',
    searchType3: '客人姓名',
    searchType4: '',
    searchType5: '客人邮箱',
    searchType6: '渠道单号',
    searchType7: '标签',
    system1: '本系统',
    system2: '2cycle系统',
    system3: '乐天系统',
    productConfirmType: '确认方式',
    reserve: '预定',
    isOnlinePay: '支付方式',
    startDate: '最早游玩日期',
    maxNum: '最大预定数',
    minNum: '最小预定数',
    startNum: '最低产品预定数量',
    isExpress: '是否支持快递配送',
    yesExpress: '支持',
    noExpress: '不支持',
    expressPrice: '配送费用',
    priceStartDate: '价格开始时间',
    priceEndDate: '价格结束时间',
    priceDate: '价格开始/结束时间',
    soldNum: '销量',
    soldNumSort: '销量',
    ticketCount: '销量',
    sourceType: '来源',
    sourceType1: 'JPH供应商',
    sourceType2: 'JTR供应商',
    sourceType3: 'KLOOK供应商',
    supplySourceType1: 'JPH产品',
    supplySourceType2: 'JTR产品',
    supplySourceType3: 'KLOOK产品',
    supplySourceType4: '2CYCLE产品',
    haveNoReserve: '已售罄',
    upTime: '上线时间',
    productReserve: '产品预定',
    pictureDown: '图片素材下载',
    voideDown: '视频素材下载',
    fileDepot: '文件仓库',
    takeView: '景点',
    productNumber: '产品编码',
    supplier: '供应商',
    operator: '运营商',
    useFate: '使用流程',
    supplement: '使用流程补充',
    supplements: '使用流程补充',
    ticketTypeName: '票种',
    isOnlinepay: '支付方式',
    num: '件',
    nums: '件',
    num01: '件',
    money: '￥',
    serviceLanguage: '服务语言',
    productPeople: '产品人群要求',
    takeTimeDesc: '营业时间说明',
    productUpTime: '产品上架时间段',
    diningTime: '用餐时段',
    diningPeople: '用餐人数',
    useTime: '使用时间',
    trafficMethod: '交通方式',
    moneyContant: '费用包含',
    moneyNotContant: '费用不包含',
    priceOrFloat: '价格/库存',
    diningDescription: '产品详情',
    titles: '标题',
    numberBuy: '数量(份)',
    reserveDescription: '预订说明',
    beforeDay: '提前天数',
    minteBefore: '分之前预定',
    usingDate: '生效时间',
    canBeUseDate: '有效日期',
    canBeUseDate1: '有效日期',
    returnMethod: '退款设置',
    returnDescription: '退款说明',
    reserveNotice: '预订须知',
    importantNote: '重要提示',
    userNote: '使用说明',
    changeMethod: '兑票柜台',
    comnicationPeople: '联络人',
    contionMen: '联络人',
    telphone: '联络方式',
    welcomeData: '接待时间',
    productDescription: '产品描述',
    dangerConcationMen: '紧急联络人',
    productPackageContainDetail: '套餐包含产品详情',
    productPackageDetail: '套餐产品详情',
    productContainDetail: '产品包含详情',
    SIMSize: 'SIM卡大小',
    netCover: '网络覆盖',
    threeGNetCover: '3G网络流量',
    fourGNetCover: '4G高速网络流量',
    parts: '配件',
    SIMProductDetail: 'SIM卡产品详情',
    WIFIProductDetail: 'wifi产品详情',
    tourProductDetail: '一日游/多日游产品详情',
    ticketProductDetail: '门票详情',
    packageProductDetail: '套餐或打包产品详情',
    freeTourDetail: '自由行详情',
    routeDetail: '路线详情',
    advanceDetail: '预售详情',
    toursTime: '行程时长',
    travelStyle: '线路类型',
    trafficStyle: '交通工具',
    startCourtyOrEnd: '出发城市/目的地',
    jtrPeopleNum: '产品包含成人数 ',
    jtrChildrenNum: '产品包含儿童数',
    peopleNum: '成团人数',
    buyMessage: '购物信息',
    tourDetail: '行程详情',
    giveClass: '赠送项目',
    trafficProductDetail: '交通产品详情',
    ybProductDetail: '夜间巴士产品详情',
    // takePomStyle: '1.兑票方式',
    takePomStyle: '',
    longWord: '预定成功，平台会给预留邮箱发送预定成功邮件，请凭收到的验证码或是二维码，至下面可兑换柜台出示领取实体票。',
    // canBeTakePom: '1.可兑换柜台',
    canBeTakePom: '',
    counterLink: '领取柜台',
    orderMessages: '新联络',
    saleTimes: '营业时间',
    telphoneCommicta: '联系电话：',
    jtrOrderVaildType0: '游客选定的游玩日期当天有效',
    jtrOrderVaildType1: '游客预订日期延后',
    jtrOrderVaildType2: '游客预订日期截止到',
    jtrOrderVaildType3: '游客选定日期延后',
    jtrOrderVaildType4: '游客选定日期截止到',
    orderVaildType0: '指定使用日当天有效',
    ordervaildType12: '下单日开始',
    ordervaildType1: '天内有效',
    ordervaildType2: '下单日开始至指定日期',
    ordervaildType3: '有效',
    ordervaildType4: '指定使用日开始',
    ordervaildType5: '指定使用日开始至指定日期',
    ordervaildType55: '指定使用日开始至指定日期',
    ordervaildType6: '指定日期',
    ordervaildType7: '到',
    ordervaildType8: '内有效',
    ordervaildType9: '指定使用日的',
    ordervaildType10: '天前到指定使用日的',
    ordervaildType11: '天后为止有效',
    ordervaildType13: '天内有效',
    ordervaildType14: '有效',
    ordervaildType15: '内有效',
    orderRefundType0: '不可退款',
    orderRefundType1: '消费前随时可退',
    orderRefundType4: '游玩日期',
    orderRefundType5: '天前可以退款',
    orderRefundType3: '您的订单已过期,系统不提供退款服务！',
    orderRefundType7: '您的订单产品属于不可退款类型，无法提供退款服务！',
    orderRefundType6: '此订单您尚未支付，无法退款',
    eleDetail: '电子票产品详情',
    jtrticketDetail: '门票产品详情',
    entityDetail: '实体票产品详情',
    experienceDetail: '体验产品详情',
    detail3: '一日游/多日游产品详情',
    detail4: 'WI-FI产品详情',
    detail5: 'SIM卡产品详情',
    detail6: '美食产品详情',
    detail7: '交通产品详情',
    detail8: '优惠套票产品详情',
    eleDetailPreview: '电子票产品预览',
    entityDetailPreview: '实体票产品预览',
    experienceDetailPreview: '体验产品预览',
    tourPreview: '一日游/多日游产品预览',
    wifiPreview: 'WIFI产品预览',
    simPreview: 'SIM卡产品预览',
    diningPreview: '餐厅产品预览',
    trafficPreview: '交通产品预览',
    packagePreview: '套餐产品预览',
    spread: '张',
    diningDetail: '餐厅详情',
    diningDetailPreview: '餐厅预览',
    orderStatus: '订单状态',
    floatPrice: '浮动价格',
    ifOnLine: '是否在线',
    onLine: '在线',
    isEdit: '待上线',
    offLine: '已下线',
    SalesSituation: '销售情况',
    orderNum: '单',
    copyOperating: '复制',
    graphicEditing: '图文编辑',
    revoke: '撤销审核',
    modify: '编辑',
    jtrModifylanguage: '多语言编辑',
    more: '更多',
    distributionAuthorization: '分销授权',
    specialPrice: '特殊价格',
    specialPriceSet: '分销商特别价格设定',
    distributionRange: '分销商户范围授权',
    distributionRangeAll: '全部商户可分销',
    distributionRangeYes: '只有指定的商户可分销',
    distributionRangeNo: '除指定的商户以外商户可分销',
    merchantRangeAll: '全部商户',
    merchantRangeYes: '指定商户',
    merchantRangeNo: '指定商户以外',
    specifiedRange: '指定范围',
    account: '账户',
    PDFSendWay: 'PDF发送方式',
    PDFOnLine: '线上',
    PDFOffLine: '线下',
    connectInformation: '联系信息',
    dialogCancel: '取 消',
    dialogSure: '确 定',
    dialogSave: '保存编辑',
    selectProCategory: '请选择添加产品的类型',
    ticketsMessage: '使用二维码电子票在现场换票或直接消费的门票。',
    ticketsMessage2: '使用二维码换取实体票并使用的景点、娱乐设施门票。',
    ticketsMessage3: '使用二维码在现场换票或直接消费的娱乐设施门票。',
    ticketsMessage4: '一日游、多日游、包车游产品',
    ticketsMessage5: 'Wi-Fi租借',
    ticketsMessage6: 'SIM上网卡',
    ticketsMessage7: '用餐位预订，套餐预订',
    ticketsMessage8: '交通票，接送机，包车产品',
    ticketsMessage9: '优惠价格组合套票产品',
    ticketsMessage10: '夜间巴士产品',
    serialNumbers: '编号',
    belongArea: '所在区域',
    connectWay: '联系方式',
    purchasingSituation: '采购情况',
    proStatus: '产品状态',
    ifOnlineStatus: '在线状态',
    today: '可订今日',
    tomorrow: '可订明日',
    oldPassword: '原密码',
    newPassword: '新密码',
    checkPassword: '确认密码',
    limitDay: '其他',
    limitDays: '其他',
    auditCannot: '审核不通过理由：',
    notMust: '不限',
    breakfast: '早餐',
    lunch: '午餐',
    afternoonTea: '下午茶',
    dinner: '晚餐',
    buffet: '自助餐',
    bus: '班车',
    caddie: '球童',
    cart: '高尔夫球具车',
    overnight_accommodation: '住宿一晚',
    play_early: '提前玩',
    play_through: '优先玩',
    play_through_am: '上午优先玩',
    play_through_pm: '下午优先玩',
    nightSnack: '宵夜',
    singleMeal: '单人餐',
    doubleMeal: '双人餐',
    thirdMeal: '3~4人餐',
    fiveMeal: '5~10人餐',
    tenMeal: '10人以上',
    haveMustData: '有具体时间段',
    common: '共',
    species: '种',
    dayBefore: '天前',
    applyToRefund: '(当地时间)前可申请退款',
    updateNotAudited: '编辑审核不通过理由',
    pleaseEnterAudited: '请输入审核不通过理由',
    updateSuccess: '更新成功！',
    updateFliture: '更新失败！',
    submitError: '很遗憾，提交审核错误，请重试',
    letterCounter: '归还柜台',
    car: '汽车',
    tram: '电车',
    cruise: '游轮',
    tourDetailTemp: '行程详细',
    auditingProductNum: '待审核产品数量',
    productNum: '产品数量',
    orderSum: '订单量',
    payBySupplierNum: '成交额',
    balanceNum: '余额',
    productOrderNum: '平台产品数',
    distritorNum: '分销商数量',
    supplierNum: '供应商数量',
    urgentNum: '紧急处理',
    confirmNum: '已确认订单',
    unpassNum: '审核不通过产品',
    beConfirmNum: '待确认订单',
    cancelingNum: '待处理取消订单',
    unPaymentNum: '未支付订单',
    cancelingOrder: '取消中订单',
    becancelOrder: '已取消订单',
    auditingProduct: '待审核产品',
    supplierAuditing: '待审核供应商',
    distributorAuditing: '待审核分销商',
    notice: '通告',
    releaseNotice: '发布公告',
    haveNotNotice: '暂无通告！',
    unRead: '未读',
    readed: '已读',
    unReadNotice: '未读通告',
    noticeDetail: '通告详情',
    messageStart: '本信息从',
    messageMiddle: '起生效。 管理员于',
    messageEnd: '发布本信息',
    country: '国家',
    province: '省份',
    city: '城市',
    area: '地区',
    year: '年',
    month: '月',
    one: '一',
    two: '二',
    three: '三',
    four: '四',
    five: '五',
    six: '六',
    seven: '日',
    buyPrice: '采购价',
    selectSupplier: '选择供应商',
    updloadFiles: '上传文件：',
    pleaseChange: '请选择',
    auditMessageEnter: '预订信息录入',
    auditMessageEnter1: '预订信息录入',
    enterAmount: '数量',
    pleaseEnterProductAmount: '请输入产品数量',
    endSlary: '结算金额(JPY)',
    endTotalAmount: '产品金额总计',
    ridePlace: '乘车位置',
    getOnTheTrain: '上车地点',
    onTrainTime: '上车时间',
    choseUpPlace: '请选择上车地点',
    choseDownPlace: '请选择下车地点',
    getDownTheTrain: '下车地点',
    downTrainTime: '下车时间',
    orderMessageByMe: '订单信息',
    confirmEmail: '确认单接收邮箱',
    aboutTipMessage: '需要接收订单确认详细，务必正确。',
    aboutOrderLanguageType: '确认订单使用语言',
    aboutChangeData: '选择日期',
    travler: '游客',
    mainTravler: '乘车人代表',
    travlerName: '游客姓名',
    travlerPhone: '游客手机',
    customerEmail: '邮箱',
    customerWechat: '微信',
    customerPassport: '护照',
    customerSex: '性别',
    orderByMessage: '订单附加信息',
    orderExplain: '订单备注说明',
    productUseData: '使用流程',
    canBeTaken: '可兑换柜台',
    mustBeComplate: '必须填写全名，在验证时候需要。',
    productCanBeReciveTo: '此产品需要给客人发送短信或邮件，手机号或者邮件必填一个(非中国大陆手机请填写邮件地址)。',
    submitOrder: '提交订单',
    nowPages: '当前产品',
    travlerEmail: '游客邮箱',
    travlerWebchat: '游客微信',
    travlerPassport: '游客护照',
    travlerAddress: '邮寄地址',
    travlerPostCode: '邮政编码',
    travlerCreditType: '证件类型',
    travlerCreditNo: '证件号码',
    travlerSex: '游客性别',
    mustToWrite: '必填',
    notMustToWrite: '非必填',
    orderStatus0: '生成订单',
    orderStatus1: '提交订单',
    orderStatus2: '取消订单（分销商）',
    orderStatus3: '取消订单（供应商）',
    orderStatus4: '确认订单',
    orderStatus5: '完成订单',
    orderStatus6: '未支付取消订单',
    orderStatus7: '拒绝订单',
    orderStatus8: '确认取消订单',
    orderStatus9: '拒绝取消订单',
    orderStatus10: '自动确认订单',
    orderStatus11: '自动完成订单',
    orderStatus12: '自动取消订单',
    orderStatus13: '支付超时自动取消订单',
    orderStatus14: '申请退款',
    orderStatus15: '确认退款',
    orderStatus16: '拒绝退款',
    orderStatus17: '订单已核销',
    orderStatus18: '订单已出票',
    orderStatus19: '运营商特殊取消',
    orderStatus20: '快速票单方取消',
    orderStatus21: '自动处理过期订单',
    orderStatus22: '合作商接口取消',
    orderStatus23: '系统内单方取消',
    notPaymentTag: '未支付取消',
    travelsSelectData: '订单有效期截止日前',
    jtrOrderRefund0: '游玩日期前',
    jtrOrderRefund1: '游玩日期后',
    jtrOrderRefund2: '天可以退款',
    jtrOrderRefund3: '当日可退',
    jtrOrderRefund4: '天可以退款',
    day: '天',
    ticketPrice: '',
    refundPayment: '退款手续费 :',
    cancelCannot: '取消理由',
    refundCannot: '退款理由',
    cancelOrRefund: '拒绝理由',
    cancelReason: '取消理由',
    admin: '管理员',
    clerk: '业务员',
    refuseCannot: '拒绝理由',
    updateTime: '更新时间',
    counterDetails: '柜台',
    applyDate: '申请日时',
    pleaseIntoCancelReason: '请输入拒绝理由',
    pleaseIntoCancelCannot: '请输入取消理由',
    pleaseIntoInfo: '请输入文字',
    applyType: {
      applyType0: '分销商',
      applyType1: '供应商',
      applyType2: '管理员',
      applyType3: '业务员',
      applyType4: '其他'
    },
    adminAccount: {
      createUser: '添加角色',
      roleName: '角色名',
      createRoleName: '角色名',
      account: '所属账号',
      applyType: '适用类型',
      isEnable: '是否启用',
      enable: '启用',
      disable: '禁用',
      roleDistribution: '权限',
      roleManager: '添加角色',
      authMenu: '权限菜单',
      checkAll: '全选'
    }
  },
  viewMessage: {
    message1: '是否确定保存?',
    message2: '请输入景点名称',
    /** 热门城市 专用提示（避免复用景点的提示） */
    hotCity_message2: '请输入目的地名称',
    hotCity_message19: '长度在 1 到 200 个字符',
    hotCity_remark_placeholder: '请输入备注',
    message3: '请输入景点地址',
    message4: '推荐使用',
    message5: '是否确定保存?',
    message6: '是否确定保存?',
    message7: '是否确定保存?',
    message8: '请选择景点所在地',
    message9: '长度在 3 到 50 个字符',
    sysError: '系统错误！',
    revokeMessage: '此操作将撤销审核, 是否继续?',
    revokeSuccess: '已撤销审核！',
    revokeHavePassed: '该产品审核已经通过不能撤销！',
    revokeHaveNotPassed: '该产品审核没有通过,无法进行撤销操作,请重新提交申请！',
    revokeOperationCanceled: '撤销审核已取消！',
    offLineMessage: '此操作将下线产品, 是否继续?',
    offLineSuccess: '已下线成功！',
    offLineOperationCanceled: '下线操作已取消',
    onLineSuccess: '已上线成功！',
    onLineMessage: '此操作将上线产品, 是否继续?',
    deleteMessage: '此操作将永久删除该产品, 是否继续?',
    deleteMessageOrder: '此操作将永久删除该订单, 是否继续?',
    deleteSuccess: '删除成功！',
    deleteOperationCanceled: '已取消删除！',
    thisRangeNotEmpty: '该指定范围内商户不能为空！',
    thisPriceRangeNotEmpty: '商户分销价授权不能为空！',
    thisPriceRangeNotNum: '请输入数字！',
    editSuccess: '编辑成功！',
    pleaseDeletePackageProduct: '请先删除打包产品,或在打包产品中移除该产品！',
    upToLine: '此操作后,产品将上线,是否继续?',
    newToUse1: '此操作后,产品将更改批次状态为关闭,是否继续?',
    newToUse0: '此操作后,产品将更改批次状态为正常,是否继续?',
    fileToDelete: '此操作后,此文件库将被永久删除,是否继续?',
    useSuccess: '操作成功',
    useFail: '操作取消',
    holdSuccess: '保存成功！',
    holdError: '保存失败！',
    banner_save_success: '保存横幅成功！',
    banner_save_error: '保存横幅失败！',
    maxDay: '一次最多设置10年数据',
    submitSuccess: '提交成功！',
    submitSuccessconfirmed: '提交成功！等待确认！',
    submitError: '提交失败！',
    balanceNotDone: '您的账户余额不足,请充值后完成本次订单',
    balanceDone: '恭喜您,支付成功',
    cancelDone: '您的取消申请已发送，请等候商户处理',
    cancelDone2: '已取消成功并退款！请刷新页面确认',
    cancelDone3: '您的退款申请已发送，请等候商户处理',
    cancelError: '商户余额不足，订单暂时无法取消',
    cancelError1: '系统异常，请联络管理员',
    message10: '是否保存编辑？',
    lable1: '取消',
    lable2: '不保存',
    lable3: '保存',
    message11: '长度在 3 到 50 个字符',
    message12: '请选择国家',
    message13: '请选择地区',
    message14: '长度在 3 到 50 个字符',
    message15: '基本信息未填完整',
    message16: '是否放弃编辑？',
    message17: '景点正在使用中，不能删除！',
    confirmDone: '确认成功',
    tipMessage1: '请输入角色备注',
    tipMessage2: '输入长度不超过255位',
    tipMessage3: '请输入角色名称',
    tipMessage4: '输入长度不超过100位',
    tipMessage5: '分佣比例只能为0-100的正整数',
    messageNotCompleteIn: '必要信息未输入完整',
    orderStatusHadUpdate: '订单状态已更新',
    orderRefundFalse: '订单退款申请失败',
    message18: '长度在 0 到 500 个字符',
    message19: '长度在 3 到 500 个字符',
    message20: '当前种类在该时间段内已存在',
    cleckOrder: '确认核销订单',
    cleckOrderCanceled: '取消核销',
    cleckSucc: '核销成功'
  },
  counterMessage: {
    counterName: '柜台名称',
    counterAddress: '柜台地址',
    counterTelephone: '柜台电话',
    busineTime: '营业时间',
    counterPic: '柜台图片',
    lable1: '取消',
    lable2: '不保存',
    lable3: '保存',
    message1: '请输入柜台名称',
    message2: '此操作将永久删除该柜台, 是否继续?',
    message3: '删除成功',
    message4: '正在使用，无法删除',
    message5: '上传柜台图片',
    message6: '是否保存编辑？',
    message7: '请输入柜台名称',
    message8: '请输入柜台地址',
    message9: '请输入柜台电话',
    message10: '请输入正确的柜台电话',
    message11: '长度在 6 到 500 个字符',
    message12: '请输入柜台接待时间',
    message13: '保存失败',
    message14: '保存成功',
    message15: '是否放弃编辑？',
    message16: '长度在 1 到 500 个字符'
  },
  liaisonMessage: {
    liaisonName: '姓名',
    liaisonTelephone: '联络方式',
    receptionTime: '接待时间',
    message1: '请输入联络人姓名',
    message2: '请输入联络人电话',
    message3: '请输入联络人接待时间',
    message4: '确定删除此联络人?',
    message5: '删除成功',
    message6: '正在使用，无法删除',
    message7: '是否保存编辑？',
    message8: '取 消',
    message9: '不保存',
    message10: '保 存',
    message11: '保存失败',
    message12: '是否放弃编辑？',
    message13: '保存失败',
    message14: '保存成功'
  },
  registerMessage: {
    directorWechatComment: '推荐您使用微信，便于敝公司与您沟通。详情请参照另行发放的操作手册。',
    supplierRegister: '供应商注册',
    distributorRegister: '分销商注册',
    accountInfo: '账号信息',
    companyInfo: '公司信息',
    mainBusiness: '主营业务（根据勾选的主营业务，我们会针对性的推荐最适合的产品）',
    mainBusiness1: '主营业务',
    saleType: '销售方式',
    trafficCardTicket: '交通卡券',
    carFree: '包车',
    admissionToThePark: '乐园景点门票',
    foodAndBeverage: '餐饮美食',
    oneDayTour: '一日游',
    daysTour: '多日游',
    characteristicExperience: '特色体验',
    hotel: '酒店',
    physicalShop: '实体店铺',
    fzShop: '飞猪店铺',
    mfwShop: '马蜂窝店铺',
    tbShop: '淘宝店铺',
    xcShop: '携程店铺',
    tcShop: '同程店铺',
    qneShop: '去哪儿店铺',
    tnShop: '途牛店铺',
    cupang: 'cupang',
    gmarket: 'gmarket',
    entry: '请输入',
    directorInfo: '业务负责人信息',
    account: '登录账号',
    password: '输入密码',
    passwordConfirm: '确认密码',
    address: '所在地',
    companyName: '公司名称',
    logo: '公司Logo',
    legalRepresentative: '法定代表人',
    companyAddress: '公司地址',
    companyTelephone: '公司电话',
    companyEmail: '公司邮箱',
    companyWebsite: '官网/店铺链接',
    bankCardNumber: '银行账户',
    qualification: '资质证明',
    directorName: '姓名',
    directorTelephone: '联系手机',
    directorPosition: '职位',
    directorWechat: '微信号',
    directorEmail: '邮箱',
    directorCode: '邀请码',
    phDirectorCode: '请输入邀请码',
    directorCodeTip: '请输入邀请码，即可享受优先审核诸多福利',
    directorCard: '名片',
    phAccount: '请输入登陆账户',
    phPassword: '请输入登录密码',
    phPasswordConfirm: '请确认登录密码',
    phCompanyName: '请输入公司正式注册名称',
    phLogo: '上传公司Logo',
    phLegalRepresentative: '请输入公司法定代表人',
    phCompanyAddress: '请输入公司详细地址',
    phCompanyTelephone: '请输入公司电话',
    phCompanyEmail: '请输入公司邮箱地址',
    phCompanyWebsite: '请输入公司官网(或其他平台店铺链接)',
    phBankCardNumber: '请输入公司银行账户',
    phQualification: '扫描公司正式注册相关资质证明',
    phDirectorName: '请输入业务负责人姓名',
    phDirectorTelephone: '请输入业务负责人手机号码',
    phDirectorPosition: '请输入业务负责人职位',
    phDirectorWechat: '请输入业务负责人微信号',
    phDirectorEmail: '请输入业务负责人邮箱',
    phDirectorCard: '上传业务负责人名片',
    submitResigt: '提交申请',
    message1: '请输入6-16位大小写英文字母或数字',
    message2: '请确保所填写的账号信息准确无误！',
    message3: '请输入密码',
    message4: '请输入正确的密码',
    message5: '长度在 6 到 16个字符',
    message6: '请再次输入密码',
    message7: '两次输入密码不一致！',
    message8: '请输入正确的密码',
    message9: '请选择国家',
    message10: '请输入公司正式注册名',
    message11: '长度在 6 到 200 个字符',
    message12: '请上传公司Logo',
    message13: '请输入公司法定代表人',
    message14: '长度在 2 到 200 个字符',
    message15: '请输入公司详细地址',
    message16: '长度在 10 到 200 个字符',
    message17: '请输入公司电话',
    message18: '请输入正确的电话',
    message19: '长度在 6 到 20 个字符',
    message20: '请输入公司邮箱地址',
    message21: '请输入正确的邮箱地址',
    message22: '长度在 7 到 50 个字符',
    message23: '请输入公司官网',
    message24: '长度在 4 到 300 个字符',
    message25: '请输入公司银行账户',
    message26: '请输入正确的银行账户',
    message27: '长度在 10 到 100 个字符',
    message28: '请上传公司正式资质证明',
    message29: '请输入业务负责人姓名',
    message30: '长度在 2 到 50个字符',
    message31: '请输入联系手机',
    message32: '请输入正确的手机号码',
    message33: '长度在 6 到 20 个字符',
    message34: '请输入职位',
    message35: '长度在 2 到 50 个字符',
    message36: '请输入微信号',
    message37: '长度在 6 到 50 个字符',
    message38: '请输入业务负责人名片',
    message39: '是否提交注册？',
    message40: '注册成功',
    message41: '注册失败',
    message42: '请输入账号',
    message43: '长度在 6 到 30 个字符',
    message44: '用户名已存在',
    message45: '请输入邮箱地址',
    message46: '长度在 5 到 50 个字符',
    message47: '请输入正确的邮箱',
    message48: '邮箱已注册',
    message49: '是否放弃注册？',
    message50: '主营业务至少勾选一个，可多选',
    message51: '销售方式至少勾选一个，可多选',
    message52: '选择其他选项时,该信息必填',
    message53: '输入的最大长度为20'
  },
  menu: {
    sysHome: '系统首页',
    product: '产品管理',
    productList: '我的产品',
    releaseProducts: '发布产品',
    releaseThirdProducts: '发布第三方产品',
    supplyManageProduct: '产品售卖管理',
    importThirdSystemProduct: '产品导入管理',
    conciseEticket: '发布电子票产品',
    conciseTicket: '发布实体票产品',
    conciseTravel: '发布一日游/多日游产品',
    conciseWifi: '发布WiFi产品',
    conciseSIM: '发布SIM卡产品',
    conciseDining: '发布美食产品',
    conciseTransport: '发布交通产品',
    conciseDiscount: '发布优惠套票产品',
    conciseSetMeal: '新增打包产品',
    conciseExperience: '发布体验产品',
    productAuditing: '产品审核',
    addBusFlag: '发布夜间巴士产品',
    orderManagement: '订单管理',
    orderManagementC: 'C端管理',
    operatorOrderManagement: '订单管理',
    operatorOrderMagnToC: 'ToC订单管理',
    operatorOrderManagement_chargeback: '订单退单权限',
    reserve: '产品预定',
    distriOrderMagn: '订单管理',
    disTocOrderManagement: 'ToC订单管理',
    bulkPurchaseList: '批量采购管理',
    tocDistributorManageProduct: 'ToC产品售卖管理',
    distriOrderMagnToC: 'ToC订单管理',
    applyDistribution: 'ToC分销审核',
    revenueManagement: 'ToC分销管理',
    revenueDetail: 'ToC收益管理',
    applyCash: 'ToC提现管理',
    operatApplyCash: 'ToC提现管理',
    coupon: 'ToC优惠券管理',
    pinTicketMagn: '验证销票管理',
    ticket: '实体票在库管理',
    ticketDepot: '票仓管理',
    warehouse: '仓库管理',
    userDepot: '用户仓库管理',
    pinTicket: '验证销票',
    pdfTicket: '电子票在库管理',
    pdfFiles: 'PDF文件库管理',
    shopManage: '商户管理',
    distributor: '分销商管理',
    supplier: '供应商管理',
    scenicSpot: '景点管理',
    scenicSpotList: '景点管理',
    finance: '财务统计',
    financeStatement: '财务报表',
    financeDetail: '财务报表详情',
    ActuarialManagement: '精算管理',
    withdrawals: '充值/提现管理',
    operatorWithdrawal: '充值/提现管理',
    trades: '交易明细',
    record: '充值/提现记录',
    withdrawal: '充值/提现',
    recharge: '充值/提现',
    sys: '系统管理',
    merchantInfo: '商户信息',
    clerk: '业务员管理',
    adminAccount: '权限管理',
    secondaryAgent: '二级代理',
    operator: '管理员管理',
    exportRules: '导出规则管理',
    noticeManager: '通告管理',
    liaisons: '联络人管理',
    counter: '柜台管理',
    pwdSet: '密码设置',
    payType: '支付方式设置',
    newOrderEmail: '订单通知管理',
    ticketDepot_ticketDepotManager: '票仓管理员',
    ticketDepot_stockManager: '库存管理员',
    pdfFiles_stockManager: '库存管理员',
    operatorWithdrawal_operationAuth: '财务操作权限',
    operatorWithdrawal_auditAuth: '财务审核权限',
    auditFlag: '不需要审核',
    loginNotice: '自我游系统功能升级通告（20170621）',
    recover: '还原',
    clear: '清空',
    pageSetting: '首页图片设置',
    productLogList: '产品修改记录',
    popularCities: '热门目的地管理',
    banner: '横幅管理',
    recommendedAttractions: '首页推荐管理'
  },
  login: {
    userLogin: '用户登录',
    rememberLoginStatus: '记住登录状态',
    forgetPassword: '忘记密码？',
    loginIn: '登录',
    register: '注册',
    copyRight: '版权所有 © 2019 东瀛假日',
    recordInformation: '蜀ICP备18029410号-2',
    rrecordInformation2: '特定商取引法',
    message1: '请输入用户名',
    message2: '请输入密码',
    message3: '请输入正确的密码'
  },
  selectMerchantType: {
    imSupplier: '我是供应商',
    imDistributor: '我是分销商',
    selectType: '请选择商户类型'
  },
  notice: {
    noticeModify: '编辑通告',
    noticeAdd: '添加通告',
    noticeTitle: '通告标题：',
    noticeContent: '通告内容',
    noticeTitlePlaceholder: '请输入通告标题',
    validDate: '有效日期：',
    DateSelectRange: '选择日期范围',
    publicationScope: '选择范围：',
    all: '一般',
    distributor: '分销商',
    supplier: '供应商',
    pulicationConfirm: '确认发布',
    tip: '提示',
    saveOrNot: '是否保存？',
    notSave: '不保存',
    save: '保 存',
    message1: '长度在 3 到 150 个字符',
    message2: '请选择有效日期',
    message3: '请选择范围',
    message4: '是否放弃编辑？',
    message5: '基本信息未填完整',
    message6: '保存成功',
    message7: '保存失败',
    message8: '删除失败！',
    message9: '删除成功！',
    message10: '此操作将永久删除该文件, 是否继续?',
    message11: '选择商户不能为空！',
    noticeManage: '通告管理',
    noticePublication: '添加通告',
    noticeTitle1: '通告标题',
    search: '搜索',
    index: '序号',
    title: '标题',
    publicationScope1: '发布范围',
    validDate1: '有效日期'
  },
  exportRules: {
    exportRuleTitle: '导出规则管理',
    newExportRule: '新建导出规则',
    editExportRule: '编辑导出规则',
    lableBusinessType: '商户类型',
    pageType: '页面类型',
    exportRuleName: '导出规则名称',
    exportRuleRemark: '导出规则备注',
    search: '查询',
    ruleName: '规则名称',
    ruleRemark: '规则备注',
    modify: '编辑',
    delete: '删除',
    lable1: '全部',
    lable2: '分销商',
    lable3: '供应商',
    lable4: '产品一览',
    lable5: '订单一览',
    lable6: '运营商',
    lable7: '未知',
    lable8: '导出项设置',
    lable9: '移除',
    lable10: '添加',
    lable11: '所有项目',
    lable12: '导出项',
    lable13: '核销一览',
    message1: '是否确定删除？',
    message2: '删除成功',
    message3: '基础规则，不能删除',
    message4: '规则使用中，不能删除',
    message5: '请输入导出规则名称',
    message6: '请输入导出规则备注',
    message7: '请选择商户类型',
    message8: '请选择页面类型',
    message9: '长度在 3 到 100 个字符',
    message10: '长度在 3 到 500 个字符',
    message11: '是否确定重置？',
    message12: '保存成功',
    message13: '是否放弃编辑？',
    button1: '提交保存',
    button2: '立即创建',
    button3: '重置'
  },
  clerk: {
    clerkTitle: '业务员管理',
    addClerk: '添加业务员',
    editClerk: '编辑业务员',
    account: '账号',
    name: '姓名',
    telphone: '电话',
    emailAddress: '邮箱地址',
    clerkAccount: '业务员账号',
    clerkName: '业务员姓名',
    clerkPwd: '业务员密码',
    confirmPwd: '确认密码',
    clerkTel: '业务员手机号',
    message1: '业务员账号/姓名',
    message2: '请选择权限',
    message3: '是否确定删除？',
    message4: '删除成功',
    message5: '设置成功',
    message6: '请输入业务员账号',
    message7: '账号只能由字母、数字、下划线、分隔符组成，字母开头',
    message8: '请输入业务员姓名',
    message9: '业务员姓名不能为空',
    message10: '请输入业务员密码',
    message11: '请输入6-16位大小写英文字母或数字',
    message12: '必须跟上面输入的一致',
    message13: '请输入业务员手机号',
    message14: '请输入业务员邮件地址',
    message15: '可以通过邮件来接收系统信息',
    message16: '长度在 1 到 50 个字符',
    message17: '请输入正确的密码',
    message18: '长度在 6 到 16 个字符',
    message19: '请输入正确的密码',
    message20: '是否提交保存？',
    message21: '保存成功',
    message22: '请输入账号',
    message23: '长度在 6 到 30 个字符',
    message24: '请输入正确的账号',
    message25: '用户名已存在',
    message26: '请再次输入密码',
    message27: '两次输入的密码不一致！',
    message28: '长度在 5 到 50 个字符',
    message29: '请输入正确的邮箱',
    message30: '邮箱已注册',
    message31: '长度在 6 到 20 个字符',
    message32: '请输入正确的手机号',
    message33: '是否放弃编辑？',
    lable1: '权限',
    lable2: '移除',
    lable3: '添加',
    lable4: '角色列表',
    lable5: '已添加角色'
  },
  merchant: {
    merchantInfo: '商户信息',
    distributorManage: '分销商管理',
    supplierManege: '供应商管理',
    all: '全部',
    waitAudit: '待审核',
    auditPass: '审核通过',
    auditNG: '审核不通过',
    auditNG2: '审核未通过',
    auditNGReason: '编辑审核不通过理由',
    searchContent: '商户名称/ID',
    businessName: '商户名称',
    createDate: '申请时间',
    auditStatus: '状态',
    auditUserName: '审核人',
    lableTodo: '处理',
    lableWatch: '查看',
    lableAuth: '权限',
    lableExpSet: '导出设置',
    accountInfo: '账号信息',
    loginAccount: '登录账号',
    companyName: '公司名称 ',
    companyLogo: '公司logo',
    legalRepresentative: '法定代表人',
    companyAddress: '公司地址',
    companyTelephone: '公司电话',
    companyWebsite: '官网/店铺链接',
    companyEmail: '公司邮箱',
    bankCardNumber: '银行账户',
    qualificationPath: '资质证明',
    location: '所在地',
    baseInfo: '基本信息',
    directorInfo: '业务负责人信息',
    directorName: '姓名',
    directorPosition: '职位',
    directorEmail: '邮箱',
    directorTelephone: '联系手机',
    directorWechat: '微信号',
    directorCardPath: '名片',
    setAuthAuditPass: '设定权限并审核通过',
    selectAuth: '请选择权限',
    message1: '请选择权限',
    message2: '导出设置',
    message3: '导出页面类型',
    message4: '产品导出项目设定',
    message5: '订单导出项目设定',
    message6: '导出规则',
    message7: '请选择导出规则名称',
    message8: '请选择导出页面类型',
    message9: '请选择导出规则',
    message10: '设置成功',
    message11: '(商户在系统的唯一编号，用于识别用户身份)',
    message12: '分销情况汇总',
    message13: '总订单量',
    message14: '总订单金额',
    message15: '总出票量',
    message16: '帐户余额情况',
    message17: '账户余额',
    message18: '查看账户交易日志',
    message19: '充值/提现历史记录',
    message20: '操作成功',
    message21: '操作失败',
    message22: '是否放弃审核？',
    message23: '授信设置',
    message24: '核销导出项目设定',
    lable1: '移除',
    lable2: '添加',
    lable3: '角色列表',
    lable4: '已添加角色',
    yayaPaySet: '销票账户设定',
    easyGoUser: '供应商账户',
    yayaPayUser: '销票账户',
    pleaseEnterYayaPayUser: '请输入销票账户',
    pleaseEnterLessTen: '最多绑定10个账号！',
    lengthMustLess100: '账号长度应该小于或等于100！',
    yayaAccountHadExists: '存在重复销票账户，添加失败',
    yayaAccountExists: '销票账户重复，请重新输入',
    enableSwitch: '启用开关',
    lineOfCredit: '授信额度',
    creditDate: '授信日期'
  },
  merchantInfo: {
    merchantInfo: '商户信息',
    merchantInfoEdit: '商户信息编辑',
    auditNG: '审核未通过',
    accountInfo: '账号信息',
    auditStatus: '审核状态',
    loginAccount: '登录账号',
    location: '所在地',
    baseInfo: '基本信息',
    companyName: '公司名称',
    companyLogo: '公司logo',
    legalRepresentative: '法定代表人',
    companyAddress: '公司地址',
    companyTelephone: '公司电话',
    companyWebsite: '官网/店铺链接',
    companyEmail: '公司邮箱',
    bankCardNumber: '银行账户',
    qualificationPath: '资质证明',
    supplierSummary: '分销情况汇总',
    orderTotal: '总订单量',
    orderTotalPay: '总订单金额',
    ticketTotal: '总出票量',
    accountBalanceInfo: '帐户余额情况',
    accountBalance: '账户余额',
    seeBusinessLog: '查看账户交易日志',
    seeRechargeLog0: '查看充值/提现日志',
    seeRechargeLog1: '查看提现日志',
    directorInfo: '业务负责人信息',
    directorName: '姓名',
    directorPosition: '职位',
    directorEmail: '邮箱',
    directorTelephone: '联系手机',
    directorWechat: '微信号',
    directorCardPath: '名片',
    submitAudit: '提交审核',
    submitEdit: '提交编辑',
    notSave: '不保存',
    save: '保 存',
    message1: '(商户在系统的唯一编号，用于识别用户身份)',
    message2: '请确保所填写的账号信息准确无误！',
    message3: '是否保存编辑？',
    message4: '请选择国家',
    message5: '请输入公司正式注册名',
    message6: '长度在 6 到 200 个字符',
    message7: '请上传公司Logo',
    message8: '请输入公司法定代表人',
    message9: '长度在 2 到 200 个字符',
    message10: '请输入公司详细地址',
    message11: '长度在 10 到 200 个字符',
    message12: '请输入公司电话',
    message13: '请输入正确的电话',
    message14: '长度在 6 到 20 个字符',
    message15: '请输入公司邮箱地址',
    message16: '请输入正确的邮箱地址',
    message17: '长度在 7 到 50 个字符',
    message18: '请输入公司官网',
    message19: '长度在 4 到 50 个字符',
    message20: '请输入公司银行账户',
    message21: '请输入正确的银行账户',
    message22: '长度在 10 到 100 个字符',
    message23: '请上传公司正式资质证明',
    message24: '请输入业务负责人姓名',
    message25: '长度在 2 到 50个字符',
    message26: '请输入联系手机',
    message27: '请输入正确的手机号码',
    message28: '请输入职位',
    message29: '请输入微信号',
    message30: '长度在 6 到 50 个字符',
    message31: '请输入业务负责人名片',
    message32: '是否提交更改？',
    message33: '编辑成功',
    message34: '编辑失败',
    message35: '请输入邮箱地址',
    message36: '长度在 5 到 50 个字符',
    message37: '请输入正确的邮箱',
    message38: '邮箱已注册'
  },
  secondaryAgent: {
    secondaryAgentTitle: '二级代理',
    message1: '请输入名称',
    search: '搜索',
    name: '名称',
    time: '注册时间',
    remark: '备注',
    label: '解除绑定',
    addCode: '生成招待码',
    copySuccess: '复制成功',
    copyError: '复制失败',
    operator: '修改备注',
    remarkTip: '请输入备注',
    message2: '修改成功',
    message3: '修改失败',
    message4: '解绑成功',
    message5: '解绑失败'
  },
  errorMsg: {
    user: {
      noAuth: '用户权限不足,请联系管理员',
      systemMsg: '系统错误',
      noUserOrPassword: '账号不存在或密码错误',
      setUsernameOrPassword: '请输入账号或密码'
    }
  },
  operator: {
    jtrOrderReimburse: '系统内单方取消',
    operatorManege: '管理员管理',
    addOperator: '添加管理员',
    updateOperator: '编辑管理员',
    updatePwd: '密码编辑',
    updateInfo: '信息编辑',
    auth: '权限',
    searchText: '管理员账号/姓名',
    account: '账号',
    name: '姓名',
    opearate: '操作',
    opeAccount: '管理员账号',
    opeName: '管理员姓名',
    opePwd: '管理员密码',
    opeNewPwd: '管理员新密码',
    checkPwd: '确认密码',
    lable1: '移除',
    lable2: '添加',
    lable3: '角色列表',
    lable4: '已添加角色',
    message1: '请选择权限',
    message2: '是否确定删除？',
    message3: '删除成功',
    message4: '设置成功',
    message5: '请输入管理员账号',
    message6: '账号只能由字母、数字、下划线、分割符组成，首位字母',
    message7: '请输入管理员姓名',
    message8: '管理员姓名不能为空',
    message9: '请输入管理员密码',
    message10: '请输入6-16位大小写英文字母或数字',
    message11: '必须跟上面输入的一致',
    message12: '长度在 1 到 50 个字符',
    message13: '长度在 6 到 16 个字符',
    message14: '请输入正确的密码',
    message15: '是否提交保存？',
    message16: '保存成功',
    message17: '请输入账号',
    message18: '长度在 6 到 30 个字符',
    message19: '请输入正确的账号',
    message20: '用户名已存在',
    message21: '请再次输入密码',
    message22: '两次输入的密码不一致！',
    message23: '是否放弃编辑？'
  },
  product: {
    rule_0_500: '长度在 0 到 500 个字符',
    rule_0_5000: '长度在 0 到 5000 个字符',
    rule_1_200: '长度在 1 到 200 个字符',
    rule_1_2000: '长度在 1 到 2000 个字符',
    rule_1_500: '长度在 1 到 500 个字符',
    rule_0_200: '长度在 0 到 200 个字符',
    rule_0_2000: '长度在 0 到 2000 个字符',
    rule_0_50: '长度在 0 到 50 个字符',
    rule_0_1_500: '长度在 0 到 500 个字符',
    rule_1_50: '长度在 1 到 50 个字符',
    rule_0_20: '长度在 0 到 20 个字符',
    rule_n1_2: '长度在 1 到 2 位数字',
    rule_n1_4: '长度在 1 到 4 位数字',
    rule_n1_6: '长度在 1 到 6 位数字',
    rule_n0_2: '长度在 0 到 2 位数字',
    rule_n0_5: '长度在 0 到 5 位数字',
    rule_n0_6: '长度在 0 到 6 位数字',
    rule_mail: '请输入邮件内容',
    integer_1: '请输入整数值',
    integer_2: '请输入正整数值',
    selDate: '选择日期',
    back: '返回',
    ticketType_1: '从关联的电子票仓自动出凭证',
    ticketType_3: '从订单内手动上传凭证',
    ticketType_4: '由系统自动生成EasyGo凭证',
    choose_sys: '选择系统：',
    chooseDepot: '选择仓库',
    baseInfo: '基本信息',
    content: '产品内容',
    priceSet: '价格设定',
    reserveSet: '预定设置',
    saveDraft: '保存到草稿箱',
    preview: '预览',
    submitCheck: '提交审核',
    submitAuditAndPass: '提交审核并通过',
    isExitProduct: '是否退出产品录入',
    isSaveDraft: '是否保存草稿？',
    noSave: '不保存',
    save: '保存',
    add: '添加',
    edit: '编辑',
    product_0: '产品 (电子票)',
    product_1: '产品 (实体票)',
    product_2: '产品 (体验)',
    product_3: '产品 (一日游/多日游)',
    product_4: '产品 (WIFI)',
    product_5: '产品 (SIM卡)',
    product_6: '产品 (餐厅)',
    product_7: '产品 (交通)',
    product_8: '产品 (套餐)',
    doNotSave: '内容没有更新，无须重复保存',
    reqMsg_1: '恭喜，已提交审核',
    reqMsg_2: '恭喜，保存成功',
    reqMsg_3: '很遗憾，提交审核失败！',
    reqMsg_4: '很遗憾，保存失败！',
    reqMsg_5: '很遗憾，提交审核错误，请重试',
    reqMsg_6: '很遗憾，保存错误，请重试',
    reqMsg_7: '该套餐未添加子产品！',
    reqMsg_8: '恭喜，已审核通过',
    reqMsg_9: '很遗憾，审核失败！',
    reqMsg_10: '很遗憾，审核错误，请重试！',
    reqMsg_11: '很遗憾，导入产品错误，请重试！',
    reqMsg_12: '该产品编号已被绑定，请重新输入！',
    reqMsg_13: '该产品暂无价格库存，无法导入！',
    fileDepot_no: '请选择文件仓库',
    baseInfo_no: '基本信息未填完整',
    content_no: '产品内容未填完整',
    reserveSet_no: '预定设置未填完整',
    explain01: '名称构成:地名+产品名称+数量+另一产品名称+数量+特色，例如“北京顺景温泉(含鱼疗)2张+南山滑雪(电子票)2张”',
    explain02: '产品标题下方的关键字等',
    explain03: '分销商不可见，方便供应商搜索产品',
    explain04: '大人（18周岁以上），学生（12~17周岁），小孩，幼儿，情侣',
    productName01: '套餐名称：',
    productName02: '产品名称：',
    qrCodeName: '二维码名称',
    productName_placeholder: '请输入产品名称',
    qrCodeName_placeholder: '请输入二维码名称',
    productPrice_placeholder: '请输入产品偏移价格',
    productMin_Price_placeholder: '请输入产品最低价格',
    errorProductConfirmType1: '子产品包含二次确认产品，订单确认方式只可以选择人工确认',
    errorProductConfirmType2: '子产品不包含二次确认产品，订单确认方式只可以选择自动确认',
    errorProductConfirmType3: '当前产品为优惠套票子产品，暂时无法修改订单确认类型',
    orderNum_placeholder: '请输入排序',
    productHighlights01: '套餐亮点：',
    productHighlights02: '产品亮点：',
    productHighlights_placeholder: '请输入产品亮点',
    productInsideRemark: '内部备注：',
    productInsideRemark_placeholder: '请输入内部备注',
    scenicSpot: '对应景点：',
    ticketType: '票种：',
    ticketType_placeholder: '请输入票种',
    productSaleDate: '上架时间段：',
    productSaleDate_placeholder: '请选择上架时间段',
    categoryLabel: '分类标签：',
    categoryLabel_placeholder: '请输入分类标签，回车确定新增',
    belongCity: '所属城市：',
    belongCity_placeholder: '请选择所属城市',
    chooseDepot_rule: '请选择仓库',
    productName_rule: '请输入产品名称',
    scenicSpotArr_rule: '请至少选择一个景点',
    scheduleDuration: '行程时长：',
    scheduleDuration_placeholder: '请输入行程时长',
    imageExplain: '图片描述：',
    uploadBtn: '点击上传',
    videoExplain: '视频资料：',
    productPackageDetail: '套餐产品详情：',
    mealTimeInterval: '用餐时段：',
    mealTime_1: '不限',
    mealTime_2: '早餐',
    mealTime_3: '午餐',
    mealTime_4: '下午茶',
    mealTime_5: '晚餐',
    mealTime_6: '夜宵',
    mealNumber: '用餐人数：',
    mealNumber_1: '单人餐',
    mealNumber_2: '双人餐',
    mealNumber_3: '3~4人餐',
    mealNumber_4: '5~10人餐',
    mealNumber_5: '10人以上',
    mealDetail01: '组名：',
    mealDetail01_placeholder: '请输入套餐组名',
    mealDetail02: '内容：',
    mealDetail03: '序号',
    mealDetail04: '名称',
    mealDetail05: '数量',
    mealDetail06: '照片',
    mealDetail07: '操作',
    mealDetail07_del: '删除',
    mealDetail07_up: '上移',
    mealDetail07_down: '下移',
    up_msg: '已经是最顶行了',
    down_msg: '已到最尾部了',
    mealDetail07_add: '添加一行',
    md_delGroup: '删除组',
    md_addGroup: '添加组',
    md_validMsg: '套餐详情数据不完整',
    md_addMsg: '最多添加20行！',
    md_addMsg1: '最多添加10组！',
    useTime: '使用时间：',
    useTime_1: '不限',
    useTime_2: '有具体时间段',
    editorProductDetail: '详细文字描述：',
    viewAddress: '地址：',
    viewAddress_placeholder: '请输入景点地址',
    businessTime: '营业时间：',
    businessTime_placeholder: '请输入营业时间',
    productPeople_placeholder: '请输入产品人群要求',
    exclusive: '车辆专用标识：',
    exclusive_1: '无',
    exclusive_2: '男性专用车辆',
    exclusive_3: '女性专用车辆',
    lang: '服务语言：',
    lang_1: '中文',
    lang_2: '英文',
    lang_3: '日文',
    lang_4: '韩文',
    productTraffic: '交通方式：',
    productTraffic_placeholder: '请输入交通方式',
    networkFlow4g: '4G高速网络流量：',
    networkFlow4g_placeholder: '请输入4G高速网络流量',
    networkFlow3g: '3G网络流量：',
    networkFlow3g_placeholder: '请输入3G网络流量',
    networkCoverage: '网络覆盖：',
    networkCoverage_placeholder: '请输入网络覆盖',
    wifiAccessories: '配件：',
    wifiAccessories_placeholder: '请输入配件',
    simSize: 'SIM卡大小：',
    simSize_placeholder: '请输入SIM卡大小',
    pathType: '线路类型：',
    pathType_1: '拼车游',
    pathType_2: '包车游',
    pathType_3: '接送机',
    traffic: '交通工具：',
    traffic_1: '汽车',
    traffic_2: '电车',
    traffic_3: '游轮',
    groupNumber: '成团人数：',
    groupNumber_placeholder: '请输入成团人数',
    shoppingType: '购物信息：',
    shoppingType_1: '不含购物',
    shoppingType_2: '含购物',
    scheduleInfo: '具体行程：',
    productCostInclude: '费用包含：',
    productCostInclude_placeholder: '请输入费用包含内容',
    productCostExclusive: '费用不含：',
    productCostExclusive_placeholder: '请输入费用不包含内容',
    productUseFlow: '使用流程：',
    productUseFlow_placeholder: '请输入使用流程',
    productSupplementPath: '使用流程补充',
    userNote: '使用说明：',
    userNote_placeholder: '请输入使用说明',
    importantNote: '重要提示：',
    importantNote_placeholder: '请输入重要提示',
    editorFreeItem: '赠送项目：',
    newProductPackageDtoList_rule: '请至少写一个套餐详情',
    scheduleInfoDtoList_rule: '最少有一个行程',
    reserveLimitDay: '预定时间限制：',
    rld01: '使用日期的',
    rld02: '天前的',
    rld03_placeholder: '时间点',
    rld04: '之前预定（日本时间）',
    confirmHour: '订单确认方式：',
    confirmHour_1: '自动确认',
    confirmHour_2: '人工确认',
    ch01: '二次确认处理时间：',
    ch02: '日本营业日工作小时',
    ch03: '小时（自然时长）',
    maxReserveNummber: '最大预定数：',
    minReserveNummber: '最小预定数：',
    mrn_explain: '\'0\'表示不限制数据',
    orderValid: '订单有效期设置：',
    ov01: '指定使用日当天有效',
    ov02: '下单日开始',
    ov03: '下单日开始至指定日期',
    ov04: '指定使用日开始',
    ov05: '指定使用日开始至指定日期',
    ov06: '指定日期',
    ov07: '指定使用日的',
    orderRefund: '订单退改：',
    orderRefund_1: '不可退改',
    orderRefund_2: '订单有效期截止日前可申请退款',
    orderRefund_tip: '1.【订单有效期截止时间】截止时间为当天的23:59:59\n2. 出行日为1/3；1/2之前免费退，1/2和1/3取消全损的情况如下\n订单有效期截止时间前 0 天（含当天），退款手续费：100%\n订单有效期截止时间前 2 天（含当天），退款手续费：100%\n订单有效期截止时间前 3 天（含当天），退款手续费：0%',
    orderRefund_3: '消费前随时可退',
    refundDescription: '退款说明：',
    rdi_placeholder: '请输入退款说明',
    customerData: '预订填写要求：',
    customerData_1: '要求输入每个客人资料',
    customerData_2: '只需要输入一个客人资料',
    mustFillInInf: '客人必填信息：',
    mustFillInInf_1: '姓名',
    mustFillInInf_2: '手机',
    mustFillInInf_3: '微信号',
    mustFillInInf_4: '护照',
    mustFillInInf_5: '性别',
    mustFillInInf_6: '使用日期',
    mustFillInInf_7: '领取日期',
    mustFillInInf_8: '乘车人姓氏',
    mustFillInInf_9: '乘车人名字',
    mustFillInInf_10: '乘车人电话',
    mustFillInInf_11: '乘车人邮箱',
    mustFillInInf_12: '乘车人性别',
    mustFillInInf_13: '乘车人年龄',
    mustFillInInf_14: '紧急联系电话',
    mustFillInInf_15: '乘车人类别',
    mustFillInInf_16: '同行者',
    customItem: '自定义客人输入项',
    ci01: '输入项目名称',
    ci01_placeholder: '项目名称',
    ci02: '是否为空',
    ci02_placeholder: '请选择',
    ci02_1: '可以为空',
    ci02_2: '不可为空',
    ci03: '说明(在下单界面的输入框下部显示)',
    ci03_placeholder: '说明',
    ci04: '操作',
    ci04_del: '删除',
    ci05: '增加自定义项',
    editorNotice: '预定须知：',
    orderLiaison: '订单联络：',
    emergencyLiaison: '紧急联络：',
    validateAuthority: '核销权限：',
    receiveCounter01: '领取柜台：',
    receiveCounter02: '实体票领取柜台：',
    returnCounter: '归还柜台：',
    reserveLimitDay_rule: '请输入预定时间限制',
    reserveLimitDay_rule1: '1到99天之内',
    reserveLimitDay_rule2: '请输入时间点',
    orderDayNotMore: '下单日开始天数不能大于2位数',
    trip01: '第',
    trip02: '天',
    trip03: '行程: ',
    trip04: '添加新行程',
    trip05: '添加一天',
    trip06: '时间段：',
    trip06_placeholder: '选择时间范围',
    trip06_phBegin: '开始时间',
    trip06_phEnd: '结束时间',
    trip07: '去哪儿：',
    trip07_placeholder: '什么时间去哪儿？',
    trip08: '行程内容：',
    trip08_placeholder: '例如：第几天去哪里？怎么去？有什么特色？',
    trip09: '行程图片：',
    trip09_btn: '点击上传',
    trip10: '保存行程',
    trip_msg1: '未选择行程',
    trip_msg2: '天，行程',
    tripRange_rule: '请输入时间段',
    trip_interval_rule: '请结束时间和开始时间都输入',
    groupContentTitle_rule: '请输入去哪儿',
    groupContent_rule: '请输入行程内容',
    imageList_rule: '请设置行程图片',
    trip_msg3: '请先选择一个行程,然后保存行程！',
    trip_msg4: '恭喜，保存成功',
    price01: '库存和价格',
    price02: '时间段-',
    price03: '新增时间段',
    price04: '删   除',
    price05: '时间段',
    price06: '选择时间范围',
    price061: '时间段不能重合',
    price07: '采购价',
    price08: '请输入采购价',
    price09: '分销价',
    price10: '请输入分销价',
    price11: '市场价',
    price12: '请输入市场价',
    price13: '库存量',
    price14: '请输入库存量',
    price15: '件',
    price16: '保   存',
    price17: '重   置',
    price18: '日期范围不能为空',
    price19: '时间段不能为空',
    price20: '日期范围',
    price21: '円',
    price22: '分销平台采购价',
    price23: '请输入分销平台采购价',
    price24: '零售价',
    price25: '请输入零售价',
    price26: '新增种类',
    price27: '种类名称',
    price28: '请输入种类名称',
    price29: '价格种类-',
    price30: '请选择价格种类',
    price31: '请输入价格种类的总库存',
    price32: '总库存应大于使用数',
    price33: '总库存应大于0',
    price34: '请输入指定的价格种类(日本語)：大人、小児、身障者大人、 身障者小児',
    price_msg1: '请先选择日期',
    price_msg2: '时间段-',
    price_msg3: '未保存',
    price_msg4: '请先选择日期和价格种类',
    price_msg5: '保存成功',
    price_msg6: '保存失败',
    price_msg7: '删除成功',
    price_msg8: '删除失败',
    price_msg9: '最多添加50条数据',
    price_msg10: '选中项不能为空',
    price_msg11: '确定将覆盖该时间段的所有已存在数据，是否确认保存？',
    price_msg12: '确定将删除时间段“',
    price_msg13: '”的所有数据，是否确认删除？',
    price_msg14: '将覆盖该价格种类所有已存在数据,请确认是否保存?',
    price_msg15: '确定将删除该价格种类所有数据,请确认是否删除?',
    price_msg16: '该价格种类正在被使用,无法删除',
    price_msg17: '该产品已存在相同的价格种类,保存失败',
    refund01: '订单有效期截止时间前',
    refund02: '天（含当天），退款手续费：',
    refund03: '移除',
    refund04: '自定义追加',
    refund05: '退款手续费：',
    counter01: '选择柜台',
    counter02: '柜台',
    counter03: '地址',
    counter04: '电话',
    counter05: '营业时间',
    liaison01: '选择联络人',
    clerk01: '选择业务员',
    clerk02: '账号',
    clerk03: '业务员',
    clerk04: '联系电话',
    clerk05: '邮箱',
    liaison02: '联络人',
    liaison03: '联络方式',
    liaison04: '接待时间',
    spot01: '选择对应景点',
    spot02: '选择景点',
    spot03: '取 消',
    spot04: '确 定',
    takeP01: '从产品库中选择产品',
    takeP02: '至少有一个子产品才能保存或提交套餐',
    takeP03: '序号',
    takeP04: '标题',
    takeP05: '采购价',
    takeP06: '分销价',
    takeP07: '市场价',
    takeP08: '数量',
    takeP09: '操作',
    takeP10: '引用数据',
    takeP11: '从产品库中选择产品',
    takeP12: '删除',
    takeP13: '价格种类',
    takeP14: '车辆专用标识',
    stockNumber01: '库存数',
    stockNumber02: '使用数',
    stockNumber03: '禁用',
    stockNumber04: '启用',
    priceTypeHistory01: '查看履历',
    priceTypeHistory02: '库存增加',
    priceTypeHistory03: '库存减少',
    upload01: '只能上传jpg/png/jpeg/gif文件，且不超过{0}MB',
    upload02: '最大上传20MB视频',
    upload03: '最多上传',
    upload04: '张图片！',
    upload05: '个视频！',
    upload06: '该文件非有效图片格式！',
    upload07: '上传图片大小不能超过 {0}MB！',
    upload08: '文件名不能有逗号！',
    upload09: '该文件非有效视频格式！',
    upload10: '上传视频大小不能超过 20MB！',
    upload11: '上传失败！',
    upload12: '上传错误！',
    upload13: '请提供实体票·柜台·接待设施外观的照片',
    upload14: '个文件',
    upload15: '上传文件大小不能超过 5MB！',
    calendar01: '年',
    calendar02: '月',
    calendar03: '全选当月库存',
    calendar04: '件',
    clerkTable01: '默认所有业务员均可核销',
    week_1: '一',
    week_2: '二',
    week_3: '三',
    week_4: '四',
    week_5: '五',
    week_6: '六',
    week_7: '日',
    explain_1: '采购价：售卖给平台的价格（平台的进价），供应商定期向平台请款的单价',
    explain_2: '分销价：平台售卖给旅行社（分销商）的价格',
    explain_3: '分销价和采购价的差额是平台的利润',
    explain_4: '说明："0"代表无库存',
    explain_5: '分销平台采购价：EASYGO系统售卖给其他分销平台的价格，与采购价的差额是平台的利润。',
    explain_6: '市场价：一般市场参考售价',
    explain_7: '零售价：建议分销商设定的BtoC售价',
    explain_8: '价格种类(日本語)填写说明：',
    explain_9: '价格(大人)',
    explain_10: '价格(小児)',
    explain_11: '价格(身障者大人)',
    explain_12: '价格(身障者小児)',
    explain_13: '(仅支持：大人、小児、身障者大人、 身障者小児，填写其他价格种类不生效)',
    explain_14: '(请参照价格种类可用日期设置产品库存，设置不可用日期不生效，采购价不生效)',
    explain_15: '可用日期：',
    explain_16: '当前价格种类无可用日期',
    explain_17: '是否在售',
    explain_18: '价格规则设置说明：',
    explain_19: '乐天产品价格及日期填写说明：',
    explain_20: '请根据可用日期进行设置，设置不可用日期不生效，采购价不生效',
    isSale: '在售',
    notSale: '非在售',
    productDeleteMessage: '请先删除打包产品,或在打包产品中移除该产品!',
    none: '无',
    sendMailSet: '发团日前：',
    mailContent: '邮件内容：',
    noSend: '不发送',
    mailTime: '指定日期前',
    mailContent_placeholder: '请输入邮件内容',
    mailsetTips: '仅支持 无PDF电子票'
  },
  recharge: {
    depositWithdraw: '充值/提现',
    depositWithdrawHistoryRecord: '充值/提现历史记录',
    searchStr: '商户名/ID：',
    placeholder1: '请输入商户名/ID',
    businessType: '商户类型：',
    businessType1: '商户类型',
    placeholder2: '请选择',
    search: '搜索',
    businessName: '商户名称',
    businessName1: '商户名称：',
    balance: '余额',
    accountBalance: '账户余额：',
    operation: '操作',
    deposit: '手动充值',
    depositAuto: '在线充值',
    automatic: '自动充值',
    withdraw: '提现',
    record: '记录',
    withdrawAvail: '可提现金额：',
    withdrawAmount: '提现金额：',
    withdrawRemark: '提现备注：',
    cancel: '取 消',
    submit: '提交审核',
    depositAmount: '充值金额：',
    depositRemark: '充值备注：',
    all: '全部',
    supplier: '供应商',
    distributor: '分销商',
    submitSuccess: '提交成功',
    subimitFailed: '提交失败',
    message: '提现金额不能大于可提现金额！',
    goBack: '返回',
    dateRange: '选择时间段：',
    placeholder3: '选择日期范围',
    date: '日期',
    operator: '操作人',
    type: '类型',
    supplierWithdraw: '商户提现请求',
    platformWithdraw: '运营商提现',
    operationAmount: '充值/提现金额',
    remark: '备注',
    lastWeek: '最近一周',
    lastMonth: '最近一个月',
    lastThreeMonth: '最近三个月',
    message2: '充值金额请输入正整数！',
    message3: '提现金额请输入正整数！',
    message4: '充值金额请输入小于2000,000,000的正整数！'
  },
  order: {
    batchSummary: '批次概要',
    canBeUseStartDate: '有效开始日期 ',
    canBeUseEndDate: '有效结束日期 ',
    createUserName: '采购者',
    bulkPurchase: '批量采购',
    remarks: '内部备注',
    orderSource0: '本系统',
    orderSource1: '供应商C端',
    orderSource2: '对外API',
    orderSource3: 'JTR',
    orderSource4: 'KLOOK',
    orderSource5: '易去',
    orderSource6: 'KKday',
    orderSource7: '稀客地图',
    orderSource8: '分销商C端',
    orderSource9: 'LINK',
    toCDistributorName: 'EasyGo BtoC',
    submitTime: '下单时间',
    sourceType: '订单来源',
    sourceJtr: 'JTR供应商',
    sourceJph: 'JPH供应商',
    allDate: '日期',
    productPrice: '单价',
    totalPrice: '总价',
    orderInfo: '订单信息',
    newSourceJtr: '运营者订单',
    payTime: '支付时间',
    productUseDate: '指定日期',
    cancelTime: '取消日期',
    keyWorld: ' 关  键  字',
    distributor: '分销商',
    secondAgentId: '二级代理商',
    secondAgentCommission: '二级代理商佣金',
    productArea: '商品所在地',
    supplier: '供应商',
    search: '搜索',
    synchronousTime_01: '（数据更新时间：',
    synchronousTime_02: '）',
    synchronousOrder_01: '同步订单',
    synchronousOrder_02: '(',
    synchronousOrder_03: 's)',
    validateTime: '验证日期',
    validateDate: '有效日期',
    expirationTime: '过期时间',
    timeSlot: '选择输入查询时间段',
    searchMsg: '订单ID/产品名称/客人姓名/客人邮箱/渠道单号',
    channelOrderId: '渠道单号',
    searchDistributor: '请输入分销商名称',
    searchSupplier: '请输入供应商名称',
    orderExport: '订单导出',
    ticketDepotExport: '票仓导出',
    ticketBatchDetailExport: '批次导出',
    productExport: '产品导出',
    productExports: '产品导出',
    orderId: '订单号',
    sonOrderId: '子订单号',
    productName: '产品名称',
    allBuyQuantity: '数量',
    customerName: '客户姓名',
    orderExplain: '订单备注说明',
    orderExplain1: '订单备注说明(此为内部备注，仅分销商内部可见)',
    orderStatus: '订单状态',
    notPay: '未支付',
    beConfirm: '待确认',
    beingCancel: '取消中',
    haveCanceled: '已取消',
    haveConfirmed: '已确认',
    beTicket: '待出票',
    batchHaveDone: '已完成',
    haveDone: '已完成',
    haveCancel: '已取消',
    haveRefundRequest: '已申请退款',
    haveRefund: '已退款',
    havePay: '已付款',
    failedPay: '支付失败',
    refuseRefund: '拒绝退款',
    haveTicket: '已出票',
    notPayButCanceled: '未支付取消',
    haveExpired: '已过期',
    leftHandleTime: '剩余处理时间',
    operation: '操作',
    addOrSub: '部分取消',
    refund: '退款',
    beAdd: '订单追加',
    addOrSubOrRefund: '部分取消/退款',
    source: '来源',
    validateOrder1: '核销成功',
    validateOrder2: '您没有核销此订单权限',
    validateOrder3: '核销失败',
    validateOrder4: '',
    date_empty: '日期错误，请重新选择',
    myouji_kana_empty: '姓氏格式不正确，请输入片假名或英文姓氏',
    namae_kana_empty: '名字格式不正确，请输入片假名或英文姓氏',
    bin_key_id_empty: '产品编号错误，请重新输入',
    sex_empty: '性别错误',
    tel_empty: '手机格式不正确，请输入10-11位数字',
    email_empty: '邮箱格式不正确，请输入正确的邮箱',
    total_num_empty: '预约人数错误',
    age_empty: '年龄格式不正确，请输入数字',
    emergency_phone_empty: '紧急连络电话错误',
    ctype_empty: '年龄、身障者分类错误',
    recep_empty: '预约已截止受理',
    num_over: '暂无可预订库存',
    num_not_sale: '选择的指定日期尚未开售',
    r_id_empty: '订单已取消',
    r_id_already_cancel_ok: '订单已取消',
    r_id_already_payment_ok: '订单已付款',
    thirdMethodErr: '合作商接口异常，请联络管理员',
    systemErr: '系统异常，请联络管理员'
  },
  jtrOrder: {},
  withdrawal: {
    withdrawalCash: '充值/提现',
    withdrawalCashManager: '充值/提现管理',
    withdrawalOnline: '在线充值',
    withdrawalOffline: '手动充值',
    applyWithdraw: '申请提现',
    beingHandel: '待处理',
    beingAudit: '待审核',
    notPass: '审核不通过',
    selectTimeSlot: '选择时间段',
    selectDateSlot: '选择日期范围',
    createTime: '创建时间',
    operationPeople: '操作人',
    type: '类型',
    recharge: '充值',
    withdraw: '提现',
    withdrawAmount: '提现金额',
    rechargeWithdrawAmount: '金额',
    rechargeWithdrawAmount2: '提现金额',
    remark: '备注',
    refundReason: '不通过理由',
    accountBalance: '账户余额',
    canWithdrawalBalance: '可提现金额',
    applyWithdrawalBalance: '申请提现金额',
    applyWithdrawalBalance2: '申请充值金额',
    selectWithdrawalAccount: '选择输入提现金额',
    withdrawRemark: '提现备注',
    withdrawRemark2: '充值备注',
    inputWithdrawRemark: '选择输入提现备注信息',
    cancel: '取  消',
    sure: '确  定',
    submitResigt: '提交申请',
    oneWeek: '最近一周',
    oneMonth: '最近一个月',
    threeMonth: '最近三个月',
    withdrawAmoutIsNotNull: '提现金额不能为空！',
    withdrawAmoutZS: '请输入正整数！',
    withdrawAmoutMustNumber: '提现金额必须是数字！',
    withdrawAmoutIsNot0: '提现金额必须大于0！',
    withdrawAmoutIsNotNegative: '提现金额不能为负数！',
    withdrawAmoutIsNotEnough: '可提现余额不足！',
    comformWithdrawMsg: '请确认提现信息,是否继续?',
    comformWithdrawMsgIfGo: '请确认提现信息,是否继续?',
    sureSubmit: '确认提交',
    returnEdit: '返回编辑',
    submitSuccess: '提交成功，等待审核！',
    companyName: '商户名称',
    companyName2: '商户名',
    companyType: '商户类型',
    distributor: '分销商',
    supplier: '供应商',
    inputCompanyNameAndId: '请输入商户名称/ID',
    handle: '处理',
    auditor: '审核',
    auditorPass: '审核通过',
    auditorNotPass: '审核不通过',
    withdrawHander: '提现处理',
    withDrawAuditor: '提现审核',
    withDrawAuditor2: '充值审核',
    withdrawHander2: '充值处理',
    refuseApply: '拒绝申请',
    refuseApplyReason: '请输入不通过理由',
    handlingSubmittingAudits: '处理并提交审核',
    handelSuccess: '处理成功！',
    rechargeFail: '充值失败'
  },
  password: {
    getPassword: '找回密码',
    pleaseInputMailAccount: '请输入邮箱账号',
    sendPasswordToMail: '发送密码到邮箱',
    returnToIndex: '返回',
    sendMsg: '输入您注册的业务负责人邮箱号，系统将初始化一个密码发送到对应的邮箱中。',
    mattersNeedingAttention: '注意事项',
    tips1: '请不要频繁的找回密码，一天最多使用',
    tips2: '次找回功能。',
    tipsMsg: '提示信息',
    loginAtonce: '马上登录',
    getUrlAgain: '重新获取',
    mailCanNotBeEmpty: '邮箱不能为空！',
    mailStyleNotRight: '请输入合法的邮箱格式！',
    mailHaveSendSuccess: '邮件发送成功,请去邮箱验证！',
    theMailInputNotExist: '输入的邮箱不存在！',
    theMailNotHaveRight: '该邮箱未激活或者被禁用！',
    aboveOneDayPermit: '超过一天允许操作的最大次数！',
    mailSendFail: '邮件发送失败！'
  },
  orderMessage: {
    pleaseIntoConfirmEmail: '请输入邮箱',
    emailError: '邮箱输入格式不正确',
    confirmEmailError: '确认单邮箱输入格式不正确',
    pleaseIntoUseDate: '请选择使用时间',
    pleaseIntprodDate: '请选择游玩时间',
    pleaseIntoHandDate: '请选择领取时间',
    pleaseIntoReturnDate: '请选择归还时间',
    pleaseIntoLinkCounter: '请选择领取柜台',
    pleaseIntoReturnCounter: '请选择归还柜台',
    pleaseIntoCustomEmail: '请输入游客姓名',
    pleaseSelectStock: '请选择场次',
    customEmailLength: '游客姓名长度不超过20',
    pleaseIntoCustomTel: '请输入游客手机号',
    pleaseIntoNationality: '请输入国籍',
    pleaseIntoBirthday: '请输入生日',
    customTelError: '游客手机号格式不正确',
    customTelError1: '游客手机号格式不正确,请输入10位或11位有效号码',
    customAgeError: '年龄格式不正确',
    customSexError2: '本产品为女性专用车辆，请重新选择性别',
    customSexError1: '本产品为男性专用车辆，请重新选择性别',
    pleaseIntoCustomWechat: '请输入游客微信',
    customWechatError: '游客微信格式不正确',
    pleaseIntoCustomPass: '请输入游客护照',
    customPassError: '游客护照格式不正确',
    pleaseIntoCustomAddress: '请输入快递地址',
    pleaseIntoCustomPostcode: '请输入邮政编码',
    customPostcodeError: '邮政编码格式不正确',
    pleaseIntoCustomCreditType: '请选择游客证件类型',
    pleaseIntoCustomCreditNo: '请输入游客证件号',
    customCreditNoError: '游客证件号格式不正确',
    customSexMale: '男',
    customSexFalmale: '女',
    customCtype1: '大人',
    customCtype2: '小児',
    customCtype3: '身障者大人',
    customCtype4: '身障者小児',
    pleaseRechangeCtype: '购买数量与乘车人类别不一致，请重新选择！',
    pleaseIntoCustomItem: '请输入游客自定义内容',
    quotaPrompt: '请输入大于0的整数',
    orderOnceBeOne: '单次订单预定数量至少为1',
    orderNumberOnceBeOne: '单次订单预定人数至少为1',
    orderStockBeMax: '本产品场次库存数至多为',
    orderOnceBeMax: '本产品单次订单预定数至多为',
    orderNumOnceBeMax: '本产品单次订单预定人数至多为',
    orderOnceBeMin: '本产品单次订单预定数量至少为',
    orderNumOnceBeMin: '本产品单次订单预定人数至少为',
    validateDateExpire: '有效日期已过期',
    productsNumError: '库存不足，订单无法生成',
    productsNumError1: '产品 ',
    productsNumError2: ' - ',
    productsNumError3: ' 库存不足',
    productsNumError4: ' PDF电子票库存不足',
    productPriceError: '价格已变化，请重新刷新',
    systemErrorMsg: '系统异常,请稍后再试!',
    pleaseUploadPDF: '需先上传PDF文件才能确认！',
    pleaseIntoUseData: '请输入指定日期',
    productUseDateBeNull: '订单的指定日期不能为空',
    jtrordermessage: '数量最多为',
    jtrplayDate: '请先选择游玩时间',
    jtrnum: '请选择数量',
    jtrphone: '请输入手机号',
    jtrphonefalse: '手机号不正确',
    linkCreditTypeErr: '请选择证件类型',
    linkCreditNoErr: '请输入证件号码',
    error: '订单无法追加、或已达到上限',
    limitedDate: '当前时间已超出产品预定时间范围,请重新下单!',
    limitBulking: '当前分销商正在批量采购中，暂时无法提交新的批次，请稍后再试!',
    designatedDateNull: '指定日期为空'
  },
  actuary: {
    all: '全部',
    actuaryType: '内容',
    actuaryType1: '预存款进款',
    actuaryType2: '请款书支付',
    actuaryType3: '临时采购',
    actuaryType4: '采购待支付',
    actuaryType5: '采购支付',
    actuaryType6: '售卖',
    actuaryState: '状态',
    actuaryState1: '正常',
    actuaryState2: '取消',
    actuaryState3: '完成',
    actuaryState4: '待处理',
    depositStatus0: '待处理',
    depositStatus1: '待审核',
    depositStatus2: '已完成',
    depositStatus3: '已拒绝',
    jphOrderStatus0: '待支付',
    jphOrderStatus1: '待确认',
    jphOrderStatus2: '取消中',
    jphOrderStatus3: '已取消',
    jphOrderStatus4: '已确认',
    jphOrderStatus5: '已完成',
    jphOrderStatus6: '未支付取消',
    jtrOrderStatus0: '待确认',
    jtrOrderStatus1: '待支付',
    jtrOrderStatus2: '已完成',
    jtrOrderStatus3: '取消订单',
    jtrOrderStatus4: '已付款',
    jtrOrderStatus5: '已申请退款',
    jtrOrderStatus6: '已退款',
    jtrOrderStatus7: '支付失败',
    jtrOrderStatus8: '拒绝退款',
    jtrOrderStatus9: '已出票',
    searchTime: '日期',
    searchWords: '关键字',
    searchMsg: '分销商名称/产品名称/设施',
    search: '搜索',
    exportExcel: 'Excel下载',
    addNew: '新增',
    actuaryId: '号码',
    createTime: '日期',
    facilitiesName: '设施',
    distributorName: '分销商',
    productName: '商品名',
    productNum: '张数',
    depositAmount: '预存款',
    payoutAmount: '支出',
    incomeAmount: '进价',
    saleAmount: '销售额',
    distributorBalance: '分销商预存款余额',
    salableQuantity: '可售张数',
    stockQuantity: '实际在库',
    operation: '操作',
    viewNum: '张数',
    viewNumErr: '张数不能为空或负数',
    view: '景点',
    viewIdErr: '景点必选',
    viewIdErr1: '只能选择一个景点',
    amount: '金额',
    amountErr: '金额不能为空',
    requestForm: '请求书',
    payDate: '支付日',
    payDateErr: '支付日不能为空',
    remark: '备考',
    remarkErr: '备考不能为空',
    validTime: '有效期',
    addAmount: '合计金额',
    money: '日元',
    confirm: '确认',
    timeSlot: '选择输入时间段',
    nameErr: '设施不能为空',
    validDateErr: '有效期不能为空',
    productInfo: '注 : 当前仅支持选择一种产品',
    productErr: '产品不能为空',
    productErr1: '当前只能选择一种产品',
    chooseActuaryType: '请选择新增精算类型',
    messageNotCompleteIn: '必要信息未输入完整',
    addSuccess: '添加成功',
    addError1: '添加失败,产品已存在或未选择产品',
    addError2: '添加失败',
    submitPrice: '价格不能为空!',
    submitMinPrice: '最低价格不能为空!',
    submitMinPrice0: '最低价格必须大于0!',
    submitMinPrice1: '分销价格必须大于0!',
    submitOrderNum: '排序不能为空!',
    submitLength: '价格及排序必须小于等于10位数字',
    addFailed: '系统异常,请稍后重试',
    operatorBalance: '余款',
    actuaryDetail: '精算详情'
  },
  finance: {
    calculatePeriod: '结算周期：',
    calculatePeriod1: '结算周期',
    placeholderCalculatePeriod: '选择结算周期',
    supplierNameAndId: '供应商名称/ID：',
    placeholderSupplierNameAndId: '请输入供应商名称/ID',
    search: '搜索',
    supplierName: '供应商名称',
    distributorPayoutAmount: '应付金额（JPY）',
    operatorIncomeAmount: '佣金金额（JPY）',
    supplierIncomeAmount: '结算金额（JPY）',
    operation: '操作',
    detail: '详情',
    downloadBill: '下载对账单',
    lastSixMonth: '近六个月',
    return: '返回',
    distributorName: '分销商名称：',
    distributorName1: '分销商名称',
    placeholderDistributorName: '请输入分销商名称/ID',
    finishTime: '完成时间',
    orderId: '订单号',
    productId: '产品编号',
    productName: '产品名称',
    productType: '产品类型',
    elecTicket: '电子票',
    paperTicket: '实体票',
    experTicket: '体验',
    daysTicket: '一日游/多日游',
    wifi: 'Wi-Fi',
    sim: 'SIM卡',
    restTicket: '美食',
    traffTicket: '交通',
    packTicket: '优惠套票',
    distributorPayoutAmount1: '应收佣金',
    operatorIncomeAmount1: '佣金金额',
    supplierIncomeAmount1: '结算金额'
  },
  payOrder: {
    payMessageOne: '请最终确认订单详情，订单在1小时内未支付将被取消。',
    payMessageOne1: '',
    payMessageOne2: '',
    payMessageOne3: '',
    jtrpayMessageOne: '请最终确认订单详情，订单在',
    jtrcancel: '取消部分订单',
    jtrAppend: '追加订单',
    jtrpayMessageTwo: '分钟内未支付将被取消。',
    payMessageTwo: '请尽快付款，否则产品售罄，订单无法购买。',
    payMessageThree: '订单在',
    payMessageFour: '分钟内未支付将被取消。',
    payMessageFive: '支付超时,请重新下单。',
    lineDownTicket: '线下电子票',
    lineUpTicket: '线上电子票',
    salaryByNow: '预付款支付',
    thirdPayment: '电子钱包支付',
    canBeUseMoney: '账户可用余额：',
    jtrcanBeUseMoney: '支付金额',
    remainTimes: '有效时间',
    payMoney: '支付：',
    applyCancel: '申请取消',
    payByNow: '立即支付',
    canBeUseMoneyError: '可用余额不足，订单无法生成',
    orderCanceled: '订单已取消',
    consentRefund: '已同意退款',
    refuseRefund: '已拒绝退款',
    overTimeByPay: '订单支付超时，自动取消',
    orderHaveUpdate: '支付失败，订单状态已更新',
    orderException: '订单异常，请重试',
    productException: '产品异常,无法编辑说明',
    payerror: '支付失败',
    error: '取消数量错误',
    applyerror: '申请失败'
  },
  supplyOrder: {
    confirmCancel: '确认取消',
    refuseCancel: '拒绝取消',
    canceleOrder: '取消订单',
    specialCanceleOrder: '特殊取消',
    partnerCancleOrder: '合作商接口取消',
    jtrSpecialCanceleChannel: '快速票单方取消',
    writeFff: '点击核销',
    confirmSpecialRefund: '确认特殊退款',
    refuseSpecialRefund: '拒绝特殊退款',
    orderConfirmDetail: '订单确认详情',
    system: '系统',
    checkedForNew: '点击查看新消息',
    orderRefuseMessage: '本产品属于不可退款产品,若申请取消，则支付款项不会退回，敬请知晓',
    canBeTakeBackFree: '退款手续费百分比',
    canBeTakeBack: '退款手续费',
    exchangeRate: '汇率差额',
    takeMoney: '实退金额',
    orderDetailByDialog: '订单确认详细',
    orderdetail1: '确认单①',
    orderdetail2: '确认单②',
    orderdetail3: '确认单③',
    orderdetail4: '确认单④',
    orderdetail5: '确认单⑤',
    orderdetail6: '确认单⑥',
    orderdetail7: '确认单⑦',
    orderdetail8: '确认单⑧',
    orderdetail9: '确认单⑨',
    fileTypes: '该文件非有效pdf格式！',
    reselectFile: '该文件内未包含PDF文件，请重新选择!',
    zipTypes: '该文件非有效zip格式！',
    fileSize: '上传pdf大小不能超过 5MB！',
    fileTypeBy: '文件名不能有逗号！',
    canCancel: '取消',
    downFiles: '下载文件',
    vailTimeMsg: '订单状态不支持修改有效期',
    vailTimelaterMsg: '结束日期不能小于当前日期',
    vailTimeFsjMsg: '富士急产品不支持修改有效期',
    vailTimeEmpty: '请选择有效期'
  },
  productNumberPrice: {
    pleaseIntoTime: '请选择时间',
    pleaseIntoNumber: '请填写库存',
    pleaseGetOneToSix: '请输入 1 到 6 个数字',
    pleaseIntoPurchasePrice: '请填写采购价',
    pleaseIntoDistorbutionPrice: '请填写分销价',
    pleaseIntoMarketPrice: '请填写市场价',
    dateCanotBeNull: '日期范围不能为空',
    confirmDateCanotBeMax: '设定时间段必须在产品上架时间段范围内！',
    distributorCanotBuyMessage: '暂时没有分销权限，不能购买此产品',
    distributorCanotBuyMessage2: '该产品已下线，不能购买此产品'
  },
  pwdSet: {
    pleaseIntoOldPwd: '请输入原密码',
    pleaseIntoNewPwd: '请输入新密码',
    pleaseConfirmPwd: '请确认新密码',
    pleaseIntoIntoSix: '请输入6-16位大小写英文字母或数字',
    mustBeOne: '必须跟上面输入的一致',
    pleaseIntoCorrectPwd: '请输入正确的密码',
    lengthMustOneToSix: '长度在 6 到 16 个字符',
    canotBeIntoNull: '不可输入空格和其他字符',
    updateNewPwdSuccess: '修改密码成功,请重新登录！',
    oldPwdError: '原密码错误，请重新输入！',
    oldAndNewNotOne: '两次输入密码不一致！',
    pleaseIntoMustItem: '请输入必输项',
    pleaseEnterPwd: '请输入密码',
    pleaseEnterPwdAgain: '请再次输入密码'
  },
  homeMessage: {
    urgnMessage: '您没有操作本功能的权限！'
  },
  entityTicket: {
    pinTicketNo: '核销票号',
    selectDepot: '选择仓库',
    pleaseSelect: '请选择',
    selectProduct: '选择产品',
    relationProduct: '关联产品',
    selectPriceType: '选择产品种类',
    saveTicketDepot: '保存票仓',
    onlySelectOnePro: '添加票仓一次只允许择一个产品!',
    onlySelectOnePriceType: '添加票仓一次只允许择一个产品种类!',
    depotNameNotBeEmpty: '仓库不能为空!',
    productNameNotBeEmpty: '产品不能为空!',
    productPriceTypeNotBeEmpty: '种类不能为空!',
    addSuccess: '添加成功!',
    inDepotSuccess: '入仓成功!',
    proHaveExist: '已经存在该产品!',
    selectDepotOut: '出仓仓库',
    selectDepotIn: '入仓仓库',
    depotProNum: '库存数量',
    validDate: '有效日期',
    selectDate: '选择日期时间',
    starEndTicketNo: '起止票号',
    starTicketNo: '起始票号',
    endTicketNo: '结束票号',
    inDepotTicketNo: '入仓票号',
    textArea: '单独扫码入口-将光标移到此处，然后用扫码枪扫实体票上的一维码',
    saveToDepot: '保存入仓',
    pleaseInputStarTicketNo: '请输入起始票号!',
    pleaseInputEndTicketNo: '请输入结束票号!',
    errorMsg01: '开始票号必须小于等于10位数字!',
    errorMsg02: '结束票号必须小于等于10位数字!',
    errorMsg03: '开始票号不能大于结束票号!',
    errorMsg04: '入仓票数量不能大于2000张!',
    errorMsg05: '以下票号长度大于10位',
    errorMsg06: '请选择入仓仓库!',
    errorMsg07: '出仓仓库和入仓仓库不能相同!',
    errorMsg08: '请选择到期时间!',
    errorMsg09: '请输入入仓票号!',
    errorMsg10: '该入仓仓库和该产品还没有建立票仓,请先建立票仓再进行产品入仓!',
    errorMsg11: '入仓仓库中存在以下票号',
    errorMsg12: '出仓仓库中以下票号不存在',
    errorMsg13: '该出仓仓库和该产品还没有建立票仓,请先建立票仓再进行产品出仓!',
    allBathList: '所有批次一览',
    batchDetailList: '批次详细一览',
    batchNO: '批次号',
    ticketNO: '票号',
    pleaseInputBatchNo: '请输入批次号',
    pleaseInputTicketNo: '请输入票号',
    inDepotTime: '入仓时间',
    inDepotUser: '入仓用户',
    importNumber: '导入数量',
    userNumber: '使用数',
    invalidateNumber: '作废数',
    leftNumber: '剩余数',
    exportNumber: '出库数',
    thisBatchDetail: '详细',
    clearDepot: '清仓',
    batchState: '批次状态',
    ticketState: '票状态',
    stateOne: '正常',
    stateTwo: '已使用',
    stateThree: '作废',
    stateFour: '已出库',
    stateFive: '已清仓',
    stateSix: '已锁定',
    userOperationTime: '使用（作废）时间',
    unUseRemark: '作废说明',
    orderId: '订单号',
    sureClearDepot: '确定对该批产品清仓吗?',
    sureClearDepot2: '确定对该产品清仓吗?',
    clearDepotSuccess: '清仓成功',
    haveCancelClearDepot: '已取消清仓操作!',
    invalidTicketSuccess: '全部作废成功!',
    addTicketDepot: '新增票仓',
    depot: '仓库',
    keyWorld: '关键字',
    inputProNameAndNo: '请输入产品名称/编号',
    userTimeQuantum: '使用时间段',
    inputSelectTimeQuantum: '选择输入查询时间段',
    depotId: '仓库ID',
    ticketDepotId: '票仓ID',
    depotName: '仓库名称',
    productId: '产品ID',
    productName: '产品名称',
    fileName: '文件总量',
    depotIn: '入仓',
    depotId2: '入库',
    depotId3: '→',
    depotId4: '初始入库',
    depotOut: '出库',
    history: '履历',
    zhang: '张',
    operationUser: '操作员',
    depotType: '仓库类型',
    addDepot: '新增仓库',
    inputDepotName: '请输入仓库名称',
    notAllDepot: '非总仓',
    allDepot: '总仓',
    depotRemark: '仓库备注',
    remarkMsg: '备注信息',
    inventoryNumber: '库存量',
    ifIsAllDepot: '是否为总仓',
    yes: '是',
    no: '否',
    tips: '注：总仓有且仅有一个',
    depotEdit: '编辑仓库',
    deleteDepot: '确定删除该仓库吗?',
    depotNameIsNotEmpty: '仓库名称不能为空!',
    allDepotOnlyOne: '总仓只允许有一个!',
    depotNameOnlyOne: '仓库名称已经存在!',
    userDepotManager: '用户仓库管理',
    addDepotToUser: '指定仓库',
    addDepotToUserSuccess: '指定成功!',
    notHistory: '该产品暂无履历!',
    pleaseSelectInvalidTicket: '请选择作废票号!',
    invalidTicketFalid: '全部作废失败!',
    someInvalidTicketFalid: '以下票号作废失败',
    orderQuery: '订单查询：',
    orderQueryPlac: '请输入订单号或扫码',
    orderInfo: '订单信息：',
    startStopNumber: '起止票号：',
    startNumber: '起始票号',
    stopNumber: '结束票号',
    numberEditPlac: '单独扫码入口-将光标移到此处，然后用扫码枪扫实体票上的一维码',
    confirmPin: '确认销票',
    formMsg1: '请输入验证码，订单号或扫码',
    rule_n1_10: '长度在 1 到 10 位数字',
    querySuccess: '查询成功',
    queryFailure: '该订单号不存在',
    queryMsg1: '起始票号不能大于结束票号，且最多一次只能销票100张',
    queryMsg2: '确认销票：',
    pinMsg1: '销票成功',
    pinMsg2: '销票失败!',
    clearRemark: '清仓备注'
  },
  ticketMessage: {
    pleaseEnterOrderId: '请输入订单ID',
    depotName: '仓库名称：',
    pleaseIntoDepotName: '请输入仓库名称',
    depotNameNotNull: '仓库名称不能为空',
    ticketRemark: '备注信息：',
    remarkNotNull: '备注信息不能为空',
    pleaseGetProduct: '请选择产品',
    fileDepotName: '文件库名称：',
    batchStatus: '批次状态：',
    batchId: '批次号',
    pleaseEnterBatchId: '请输入批次号',
    enterDate: '导入时间',
    enterUser: '导入用户',
    close: '关闭',
    Processing: '处理中',
    uploadFailure: '上传失败',
    ticketDetail: '详细',
    newToUse: '优先使用',
    fileStatus: '文件状态：',
    fileName: '文件名：',
    pleaseEnterFileName: '请输入PDF文件名',
    fileId: '文件ID',
    fileNames: '文件名称',
    downPdf: '下载PDF',
    ticketMessageBy: '以下票号的状态非正常，作废失败！',
    noUseMessage: '至少选择一个文件！',
    ticketMessageBy2: '本次操作存在状态为非正常的票，请刷新后重试！',
    operationSuccess: '操作成功!',
    getFile: '选取文件',
    getZipFile: '选取ZIP',
    getFilesOnlyFive: '*注：每个PDF将按页拆分为多个电子票；限制上传PDF文件数量为5且单个文件大小限制10MB',
    getZipOnlyOne: '限制上传ZIP文件数量为1且单个文件大小限制300MB',
    usedDate: '有效截止日期：',
    usedDates: '有效截止日期',
    ticketMessageBy3: '为空则一直有效。',
    intoNow: '立即导入',
    intoSuccess: '导入成功!',
    insertFileDepot: '新增文件仓库',
    choose: '选择',
    fileDepotNames: '文件仓库名称',
    pleaseIntoFileName: '请输入仓库名',
    canBeUseDate: '使用（作废）时间段：',
    intoSearchDate: '选择输入查询时间段',
    into: '导入',
    fivePdf: '份PDF!',
    oneZip: '份ZIP!',
    ticketOpen: '打开',
    intoIng: '导入中,请稍候...',
    fileHadExists: '文件在仓库中已存在！',
    uploadSize: '上传图片大小不能超过 10MB！',
    uploadZipSize: '上传文件大小不能超过 300MB！',
    fileNotFors: '文件上传不可重复！',
    pleaseGetFile: '请选取文件',
    fileBatchRemarkNotNull: '请输入备注信息'
  },
  remind: {
    remindId: '序号',
    title: '邮件提醒',
    date: '发团日期',
    accessory: '附件',
    add: '新建提醒',
    upload: '上传邮件附件',
    beforeDay: '发团日前N天发送邮件提醒',
    before: '发团日前',
    days: '天发送邮件提醒',
    download: '下载附件',
    reminder: '提示',
    confirm: '确定',
    inputDate: '请输入发团日期',
    uploadAccessory: '请上传附件',
    inputbeforeDay: '请输入提前发送日',
    inputContent: '请输入邮件内容',
    sendContent: '发送内容',
    addRemind: '邮件提醒',
    existRemind: '当日提醒已存在',
    set: '邮件设置'
  },
  trades: {
    platform: '平台',
    excel: '导出EXCEL',
    tradesTime: '交易时间段',
    inputOrderId: '请输入订单号',
    tradingTime: '交易日期',
    operatorUser: '操作员',
    expenditure: '支出',
    income: '收入',
    buyQuantity: '数量',
    customerName: '客人姓名',
    orderExplain: '订单备注说明',
    content: '内容'
  },
  pinTicketMagn: {
    pinTime: '核销时间',
    pinTicket: '验证销票',
    shortcutOut: '快捷销票',
    all: '全部',
    validationType: '销票类型：',
    productName: '产品名称：',
    placeholder1: '请输入产品名称',
    validateTime: '销票日期：',
    placeholder2: '请选择销票日期',
    orderId: '订单ID：',
    placeholder3: '请输入ID',
    distributor: '分销商：',
    placeholder4: '请输入分销商',
    validationUser: '销票人：',
    placeholder5: '请输入销票人',
    ticketNo: '票号：',
    placeholder6: '请输入票号',
    colOrderId: '订单ID',
    colOrderContent: '订单内容',
    colValidateTime: '销票时间',
    colValidateType: '销票类型',
    colValidateUser: '销票人',
    colDistributor: '分销商',
    colCustomerOrderNo: '快捷销票单号',
    placeholder7: '请输入快捷销票单号',
    colCustomerOperator: '操作人',
    placeholder8: '请输入操作人',
    colticketNo: '票号',
    shortcutOutDepot: '销票仓库',
    shortcutOutProduct: '销票产品',
    company: '公司',
    orderIdNo: '单号',
    distributorNameAndOrderNo: '分销商名 (建议:可首字母) +单号',
    pleaseInputOrderCustomer: '请输入客户单号',
    pleaseInputCustomerOperator: '请输入操作人',
    shortcutOutSure: '确认销票',
    ticketCanNotBeCutOut: '以下票号不能被销票',
    ticketCanNotBeCutOuts: '请勿输入重复的票号',
    distributeOnlySelectOne: '分销商只能选择一个',
    ticketNumber100: '入票数量不能大于100!',
    pleaseInputDistribute: '请选择分销商!',
    pleaseInputOrder: '请输入单号!',
    orderLine100: '单号长度不能大于100个字符!',
    inputOperation: '请输入操作人!',
    operationLine100: '操作人长度不能大于100个字符',
    shortcutOutSuccess: '销票成功!'
  },
  errMsg: {
    errMsg100: '订单号不存在',
    errMsg101: '无对应的仓库',
    errMsg102: '仅业务员可销票',
    errMsg103: '订单不在有效期',
    errMsg104: '以下票号不能销票',
    errMsg105: '运营商或特殊权限的供应商直接选择审核通过操作失败',
    errMsg106: '产品ID不能为空',
    errMsg107: '上传文件不能为空',
    errMsg108: '服务器内部异常',
    errMsg109: '订单已经完成',
    errMsg110: '订单未确认',
    errMsg111: '销票数量与实际购买数量不符合',
    errMsg112: '无对应的票仓',
    errMsg113: '无对应的票',
    errMsg114: '请选择产品来源',
    errMsg115: '最少输入一个起止票号并确认',
    errMsg116: '该订单已取消',
    errMsg117: '该订单已过期',
    errMsg118: '',
    errMsg119: '',
    errMsg120: '',
    errMsg121: '正在处理中，请勿重复提交'
  },
  pay: {
    type: '充值方式',
    success: '支付已完成',
    fail: '支付未完成',
    toUrl: '请前往对应支付平台进行支付',
    toPay: '继续充值',
    error01: '支付拉起失败,请重试',
    error02: '支付已完成.请勿重复刷新.',
    loading: '支付数据处理中...',
    message: '支付成功后,入账因服务方会有些许延迟,请耐心等待'
  },
  pageSetting: {
    upload01: '只能上传jpg/png/jpeg文件，且不超过1MB',
    upload02: '首页图片尺寸1920x500像素，首页图片的元素图案需距左边430像素。',
    pageImg: '首页图片：',
    errorByPage01: '首页图片无变化',
    errorByPage02: '首页图片不能为空！'
  },
  barCode: {
    urlError: '地址链接异常!',
    getInfoError: '二维码获取异常!',
    productTextDescription: '详细说明',
    customerReceiveDate: '领取日期：',
    returnDate: '归还日期：',
    productUseDate: '指定日期：',
    buyQuantity: '购买数量：',
    productUseFlow: '使用流程：',
    productUseName: '姓名：',
    validityDate: '有效期限：'
  },
  supplementInfo: {
    urlError: '地址链接异常!',
    getSupplementInfo: '内容获取失败!',
    supplementOfUseFlow: '使用流程补充详细说明'
  },
  qrCode: {
    qrCodeSource: '名称',
    isDistribution: '分销',
    scale: '分佣比例',
    YES: '是',
    NO: '否',
    noValue: '暂无',
    distributionRange: '分销产品范围授权',
    distributionRangeAll: '全部二维码可分销',
    distributionRangeYes: '指定二维码可分销',
    distributionRangeNo: '除指定二维码外可分销',
    selectDistributor: '选择产品',
    tipMessage1: '请输入名称',
    tipMessage2: '请选择授权范围',
    tipMessage3: '请输入分佣比例',
    addError1: '二维码来源已存在，请重新输入',
    prompt: '确定删除该条二维码吗？',
    searchMore: '查看产品',
    choseCode: '选择二维码',
    choseCodeError: '请选择二维码',
    nickName: '昵称',
    auditStatus: '审核状态',
    submitAudit: '确定通过审核？',
    submitAudit1: '确定处理该提现？',
    cannotSale: '禁止以后，该用户将无法分销您的所有二维码产品',
    canSale: '启用以后，该用户将分销您的所有二维码产品',
    remark: '备注',
    agree: '通过',
    handle: '处理',
    notAgree: '拒绝',
    applyMoney: '提现金额',
    applyMoney1: '提现金额(已扣手续费)',
    chargeMoney: '手续费',
    chargeMoney2: '内含手续费',
    aduitTime: '审批时间',
    aduitName: '审批人',
    remittanceExport: '汇款导出',
    realName: '账户名称',
    bankNo: '账户号码',
    bankName: '银行名称',
    branchName: '支行名称',
    accountType: '账户类型',
    tocDistributor: '所属分销商',
    distributorName: '二级分销商昵称',
    twoDistributor: '二级分销',
    oneDistributor: '分销商',
    drawaltip1: '提现金额超出账户余额',
    drawaltip2: '提现金额小于手续费',
    drawaltip3: '请输入要提现的金额',
    drawaltip4: '您有未处理的提现申请，请等待处理完成后继续提现',
    saleName: '分销用户',
    saleMoney: '二级分销收益',
    distributorMoney: '分销商收益',
    isHasMoney: '到账状态',
    isPay: '已到账',
    notPay: '未到账',
    handleStatus: '处理状态',
    handleStatus1: '待处理',
    handleStatus2: '已处理',
    handleStatus3: '已拒绝',
    handleBy: '处理人',
    handleTime: '处理时间',
    setCharge: '手续费设置',
    chargeConfirm: '您确定修改提现手续费？',
    accountStatus: '账户状态',
    canUse: '启用',
    cannotUse: '禁用',
    cannotUse1: '已解绑',
    incomeAmount: '收益金额',
    tocIncomeAmount: 'C端账户余额',
    withdrawalError1: '请输入账户名称',
    withdrawalError2: '请输入账户号码',
    withdrawalError3: '请输入银行名称',
    withdrawalError4: '请输入支行名称',
    withdrawalError5: '请输入账户类型',
    handleError1: '该用户余额不足，无法处理提现',
    handleError2: '提现处理操作只有运营商可以处理！',
    handleError3: '余额不足，无法处理提现',
    withdrawalTips: '10000JPY（包含10000）以上免手续费;10000JPY以下，收取手续费',
    withdrawalTips1: '10000JPY（包含10000）以上免手续费',
    withdrawalTips2: '10000JPY以下，收取手续费',
    applyCash: '提现申请',
    applyBy: '用户类型',
    applyUser: '申请人',
    twoApplyName: '二级分销商',
    cannotCharge: '设置的金额只能为正整数',
    name: '名称',
    Unbundling: '解绑',
    UnbundTips: '解绑成功后，该用户分销产品不再产生佣金。',
    cannotUnbund: '该用户有未入账的佣金，暂时无法解绑！',
    twoApplyNameID: '二级分销商ID',
    inputScale: '请输入分佣比例',
    keyTips: '二级分销商ID/二级分销昵称',
    saleLog: '查看直销记录',
    withdrawalTips4: '余额不足，暂不能提现'
  },
  payWay: {
    balance: '账户余额',
    weChat: '微信',
    alipay: '支付宝',
    creditCard: '信用卡',
    unionPay: '银联',
    weChatWay: '微信支付',
    payedId: '支付单号',
    alipayWay: '支付宝支付',
    linePay: 'Line支付',
    grabPay: 'Grab支付',
    zaloPay: 'Zalo支付',
    aliPayHK: '支付宝香港',
    isPay: '订单支付中',
    codeTips: '二维码已过期，请重新获取',
    codeTips1: '刷新二维码',
    codeTips2: '打开手机微信',
    codeTips3: '扫一扫二维码',
    codeTips4: '打开手机支付宝',
    codeTips5: '扫一扫继续付款',
    codeTips6: '打开手机相机',
    refundTips: '该订单已取消，您所支付的金额将退回原支付渠道，请注意查收',
    refundTips1: '该订单已支付，您所支付的金额将退回原支付渠道，请注意查收',
    refundTips2: '该订单使用第三方支付超过30天，暂不支持退款',
    refundTips3: '订单支付失败，如您已付款，您所支付的金额将退回原支付渠道，请注意查收',
    errorTips: '获取支付信息失败，请重新获取',
    partialRefundTips: '若产生部分退款，手续费不退',
    payTitle: '合作商支付订单'
  },
  schedule: {
    scheduleListTitle: '定时任务列表',
    searchText: 'Bean名称/备注',
    addSchedule: '添加定时任务',
    editSchedule: '编辑定时任务',
    beanName: 'Bean名称',
    cronExpression: 'Cron表达式',
    params: '参数',
    remark: '备注',
    serverType: '执行类型',
    serverType_1: '单服务器',
    serverType_2: '全服务器',
    status: '状态',
    status_0: '正常',
    status_1: '暂停',
    inputBeanName: '请输入Spring Bean名称',
    beanNameMustNotNull: 'Bean名称不能为空',
    inputCronExpression: '请输入Cron表达式',
    cronExpressionMustNotNull: 'Cron表达式不能为空',
    run: '立即执行',
    stop: '暂停',
    resume: '恢复'
  },
  newHome: {
    priceFormat: 'JPY {0} <span class="price-format">起</span>',
    expired: '登录已过期，请重新登录',
    searchPlaceholder: '搜索目的地/活动',
    searchButton: '搜索',
    searchResults: '项搜寻结果可预订',
    category: {
      transport: '交 通',
      themePark: '门 票',
      wifi: 'WiFi & SIM卡',
      carRental: '优惠套票',
      dayTrip: '一日游 & 多日游',
      hotel: '体验 & 美食'
    },
    productSaleLabel: {
      osakaSalesOffice: '大阪营业所',
      tokyoSalesOffice: '东京营业所',
      fukuokaSalesOffice: '福冈营业所',
      kyotoSalesOffice: '冲绳营业所',
      nagoyaSalesOffice: '名古屋营业所',
      hokkaidoSalesOffice: '北海道营业所'
    },
    popularCities: '热门目的地',
    popularCitiesEn: '受欢迎的目的地及季节限定活动合集',
    activeNumber: '个活动',
    balance: '余额',
    switchToOldVersion: '切换至旧版',
    switchToNewVersion: '切换至新版',
    viewMore: '查看更多',
    all: '全部',
    sortBy: '排序',
    easyGoRecommend: 'EasyGo推荐',
    allDates: '日期',
    priceRange: '价格范围',
    other: '其他',
    selectedExperiences: '精选必玩体验',
    topActivities: '日本最受旅客欢迎的Top活动',
    sales: '销量',
    price: '价格',
    stockQuery: '库存现询',
    noProducts: '暂无相关商品',
    salesLessThan1k: '小于1k',
    sortOptions: {
      new: '最新发布',
      sales: '销量最高'
    },
    autoConfirm: '立即确认',
    secondConfirm: '人工确认'
  }
};

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.default = {
  common: {
    zh: '简体中文',
    tw: '繁體中文',
    ja: '日本語',
    en: 'English',
    ko: '한국어',
    title: '后台管理系统',
    exit: '退出'
  },
  title: {
    popularCities: '熱門城市管理',
    addHotCity: '添加熱門城市',
    editHotCity: '編輯熱門城市',
    bannerManage: '橫幅管理'
  },
  lable: {
    translation: 'AI翻译',
    translationing: 'AI翻译中...',
    translationTip: '无可翻译数据',
    isOnline: '是否上架',
    hotCity: '熱門城市',
    cityName: '城市名稱',
    cityPicture: '城市圖片',
    picture: '圖片',
    languageType: '語言',
    sort: '排序',
    sortTip: '數值越小越靠前',
    onlineTip: '下架後不顯示客戶端',
    hotType: '熱門類型',
    type1: '熱門地區',
    type2: '熱門目的地',
    type3: '熱門地標',
    addProduct: '添加商品',
    productInformation: '產品信息',
    price: '價格',
    tags: '標籤',
    productList: '產品列表',
    bannerTitle: '橫幅主標題',
    bannerSubTitle: '橫幅副標題',
    bannerImages: '橫幅圖片'
  },
  viewMessage: {
    hotCity_message2: '請輸入城市名稱',
    hotCity_message19: '長度在 1 到 200 個字符',
    hotCity_remark_placeholder: '請輸入備註',
    banner_save_success: '保存橫幅成功！',
    banner_save_error: '保存橫幅失敗！'
  },
  menu: {
    popularCities: '熱門城市管理',
    banner: '橫幅管理',
    recommendedAttractions: '首页推荐管理'
  },
  newHome: {
    priceFormat: '{0} <span class="price-format">起</span>',
    expired: '登录过期，请重新登录',
    heroTitle: '探索精彩日本',
    heroSubtitle: '發現東京、京都、大阪的獨特魅力與體驗',
    searchPlaceholder: '搜索全球目的地/活動',
    searchButton: '搜索',
    searchResults: '項搜尋結果可預訂',
    category: {
      transport: '交 通',
      themePark: '票 卷',
      wifi: 'WiFi & SIM卡',
      carRental: '优惠套票',
      dayTrip: '一日游 & 多日游',
      hotel: '体验 & 美食'
    },
    productSaleLabel: {
      osakaSalesOffice: '大阪营业所',
      tokyoSalesOffice: '东京营业所',
      fukuokaSalesOffice: '福冈营业所',
      kyotoSalesOffice: '冲绳营业所',
      nagoyaSalesOffice: '名古屋营业所',
      hokkaidoSalesOffice: '北海道营业所'
    },
    popularCities: '熱門城市',
    popularCitiesEn: 'Popular Cities',
    balance: '餘額',
    switchToOldVersion: '切換到舊版',
    switchToNewVersion: '切換到新版',
    username: '用戶名',
    simplifiedChinese: '簡體中文',
    viewMore: '查看更多',
    all: '全部',
    subwayTransport: '地鐵交通&票',
    attractionTickets: '景點門票',
    dayTours: '日遊',
    more: '更多',
    sortBy: '排序',
    easyGoRecommend: 'EasyGo推薦',
    today: '今日',
    tomorrow: '明日',
    allDates: '日期',
    priceRange: '價格範圍',
    other: '其他',
    autoConfirm: '立即確認',
    secondConfirm: '人工確認',
    selectedExperiences: '精選必玩體驗',
    topActivities: '日本最受旅客歡迎的 Top 活動',
    sales: '銷量',
    price: '價格',
    availableDate: '可訂',
    instantConfirm: '立即確認',
    mostPopular: '最受歡迎',
    expressIssuance: '極速出',
    stockQuery: '庫存現詢',
    noProducts: '暂无数据',
    salesLessThan1k: '小于1k',
    menu: {
      merchantInfo: '商戶信息',
      orderManagement: '訂單管理',
      batchPurchase: '批量採購管理',
      tocOrderManagement: 'ToC訂單管理',
      rechargeWithdrawal: '充值/提現管理',
      systemManagement: '系統管理',
      notifications: '通知/通告',
      logout: '退出登錄'
    },
    cities: {
      tokyo: '東京',
      osaka: '大阪',
      kyoto: '京都',
      hokkaido: '北海道',
      sapporo: '札幌',
      okinawa: '沖繩',
      nara: '奈良'
    },
    sortOptions: {
      new: '最新發布',
      sales: '銷量最高'
    }
  }
};

/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 按钮Mixin（处理返回按钮逻辑）
*/
/* harmony default export */ __webpack_exports__["a"] = ({
  // 生命周期钩子
  mounted: function mounted() {
    // 初始化返回按钮
    this.initBackButtons();
  },

  methods: {
    // 检查是否存在路由历史记录
    hasHistory: function hasHistory() {
      // 检查路由历史记录长度
      return window.history.length > 1;
    },

    // 检查元素是否为返回按钮且事件会执行 $router.go(-1)
    isGoBackButton: function isGoBackButton(el) {
      var _this = this;

      if (!el) return false;

      // 检查是否为按钮元素
      if (!el.tagName || el.tagName.toLowerCase() !== 'button') return false;

      // 检查按钮文本是否包含返回按钮的文本
      var buttonText = el.textContent || el.innerText || '';

      // 安全地调用 $t
      var getTranslation = function getTranslation() {
        try {
          return _this.$t && typeof _this.$t === 'function' ? _this.$t('lable.goBack') : null; // 默认值
        } catch (e) {
          return null; // 默认值
        }
      };

      var goBackText = getTranslation();
      var isCheckBackHistory = el.className.includes('check-back-history');
      if (isCheckBackHistory && goBackText && buttonText.includes(goBackText)) {
        return true;
      }

      return false;
    },

    // 初始化返回按钮，检查是否有历史记录，无则隐藏
    initBackButtons: function initBackButtons() {
      var _this2 = this;

      // 确保在 DOM 渲染完成后执行
      this.$nextTick(function () {
        // 检查是否存在路由历史记录
        var hasHistory = _this2.hasHistory();

        // 如果有历史记录，不需要隐藏按钮
        if (hasHistory) return;

        // 查找页面中的所有按钮元素
        var buttons = document.querySelectorAll('button');
        buttons.forEach(function (button) {
          // 检查是否为返回按钮
          if (_this2.isGoBackButton(button)) {
            // 隐藏返回按钮
            button.style.display = 'none';
          }
        });

        // 查找可能包含返回按钮的其他元素（如 el-button 组件）
        // const elButtons = document.querySelectorAll('.el-button')
        // elButtons.forEach(button => {
        // // 检查是否为返回按钮
        //   if (this.isGoBackButton(button)) {
        //   // 隐藏返回按钮
        //     button.style.display = 'none'
        //   }
        // })
      });
    }
  }
});

/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_user__ = __webpack_require__(111);




var isShowLog = false;
/* harmony default export */ __webpack_exports__["a"] = ({
  /*
     带参跳转。
     注意：路由中name和path须一致.如：（path: '/hello'   name: 'hello'）
     此跳转方法到目标界面，参数会保留，刷新不会清除
     接收参数方法：
     computed: {
       params: function () {
         return {
           languageType: this.$route.query.languageType,
           productId: this.$route.query.productId,
           identify: this.$route.query.identify
         }
       }
     }
     */
  startView: function startView(name, params) {
    if (this.isNotEmpty(name)) {
      this.$router.push({
        path: '/' + name,
        name: name,
        query: params
      });
    }
  },

  // 替换view
  replaceView: function replaceView(name, params) {
    if (this.isNotEmpty(name)) {
      this.$router.replace({
        path: '/' + name,
        name: name,
        query: params
      });
    }
  },

  // 返回上一页
  backView: function backView() {
    this.$router.go(-1);
  },

  // 统一跳转方法
  base_go: function base_go(url, isReplace) {
    if (url) {
      if (isReplace) {
        this.$router.replace({ path: url });
      } else {
        this.$router.push({ path: url });
      }
    }
  },

  // 统一回退方法
  base_goBack: function base_goBack(isReplace) {
    var count = window.sessionStorage.getItem('count') || 0;
    var url = window.sessionStorage.key(count) || '/'; // 当前url
    var url1 = window.sessionStorage.key(count - 1) || '/'; // 上次访问的url
    if (this.$route.path === url) {
      // 和当前URL一致
      if (isReplace) {
        this.$router.replace({ path: url1 });
      } else {
        this.$router.push({ path: url1 });
      }
    } else {
      if (isReplace) {
        this.$router.replace({ path: url });
      } else {
        this.$router.push({ path: url });
      }
    }
  },
  getUrl: function getUrl(url) {
    if (url.includes('http:') || url.includes('https:')) return url;
    if (url.includes('/newWeb/')) return url;
    if (url.charAt(0) === '/') return '/web' + url;else return '/web/' + url;
  },
  getHttpData: function getHttpData(url, params, callback, error, isLoading) {
    var _this = this;

    // ----------------------------------------------------------------
    params = params || null;
    isLoading = true;
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["a" /* UPDATE_LOADING */], isLoading);
    // -----------------------------------------------------------------
    this.$http.get(this.getUrl(url), { params: params }).then(function (response) {
      if (isShowLog) {
        console.log('GET请求', response);
      }
      var result = response.data;
      // -------------------------------------------------------
      // this.log('GET请求', JSON.stringify(result))
      // -----------------------------------
      _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["a" /* UPDATE_LOADING */], false);
      // ------------------------------------
      if (result === undefined) {
        return callback(false);
      } else if (result.status !== '1' && result.status !== 1) {
        // 设置errorMsg
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["e" /* UPDATE_ERROR_MSG */], result.msg);
        return callback(false, _this.$store, result.msg);
      } else if (result.result) {
        return callback(result.result, _this.$store, result.msg);
      } else {
        return callback(true, _this.$store, result.msg);
      }
    }).catch(function (e) {
      _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["a" /* UPDATE_LOADING */], false);
      if (error) {
        return error(e);
      } else {
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["e" /* UPDATE_ERROR_MSG */], e.message);
        return false;
      }
    });
  },
  getTwoCycleHttpData: function getTwoCycleHttpData(url, params, callback, error, isLoading) {
    var _this2 = this;

    // ----------------------------------------------------------------
    params = params || null;
    isLoading = true;
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["a" /* UPDATE_LOADING */], isLoading);
    // -----------------------------------------------------------------
    this.$http.get(this.getUrl(url), { params: params }).then(function (response) {
      if (isShowLog) {
        console.log('GET请求', response);
      }
      var result = response.data;
      // -------------------------------------------------------
      // this.log('GET请求', JSON.stringify(result))
      // -----------------------------------
      _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["a" /* UPDATE_LOADING */], false);
      // ------------------------------------
      if (result === undefined) {
        return callback(false);
      } else if (result.status !== '1' && result.status !== 1) {
        // 设置errorMsg
        _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["e" /* UPDATE_ERROR_MSG */], result);
        return callback(result.result, _this2.$store, result);
      } else if (result.result) {
        return callback(result.result, _this2.$store, result);
      } else {
        return callback(true, _this2.$store, result);
      }
    }).catch(function (e) {
      _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["a" /* UPDATE_LOADING */], false);
      if (error) {
        return error(e);
      } else {
        _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["e" /* UPDATE_ERROR_MSG */], e.message);
        return false;
      }
    });
  },
  getTwoCyclePriceType: function getTwoCyclePriceType(index) {
    switch (index) {
      case 0:
        return '大人';
      case 1:
        return '小児';
      case 2:
        return '障害者大人';
      case 3:
        return '障害者小児';
    }
  },
  getTwoCyclePriceTypes: function getTwoCyclePriceTypes() {
    return '大人，小児，障害者大人，障害者小児';
  },
  downloadExcelHttpData: function downloadExcelHttpData(url, params) {
    params = params || null;
    var qs = __webpack_require__(84);
    params = params || {};
    var xhr = new XMLHttpRequest();
    xhr.open('GET', this.getUrl(url) + '?' + qs.stringify(params), true); // get请求，请求地址，是否异步
    xhr.responseType = 'blob';
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.setRequestHeader('uiLang', window.sessionStorage.getItem('langType'));
    xhr.setRequestHeader('accessToken', window.sessionStorage.getItem('accessToken'));
    xhr.onload = function () {
      if (this.status === 200) {
        // 获得文件名
        var filename = this.getResponseHeader('content-disposition').split('filename=')[1];
        var blob = this.response;
        var reader = new FileReader();
        reader.readAsDataURL(blob); // 转换为base64，可以直接放入a标签href
        reader.onload = function (e) {
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename);
          } else {
            // 转换完成，创建一个a标签用于下载
            var a = document.createElement('a');
            a.download = filename;
            a.href = e.target.result;
            document.body.appendChild(a); // 修复firefox中无法触发click
            a.click();
            a.remove();
          }
        };
      }
    };
    // 发送ajax请求
    xhr.send();
  },

  // 下载excel 同步
  // 2019-08-21 解决导出订单loading 无法异步显示,需要在此方法中添加返回值,为true时为异步请求数据返回
  downloadExcelHttpData1: function downloadExcelHttpData1(url, params, callback) {
    params = params || null;
    var qs = __webpack_require__(84);
    params = params || {};
    var xhr = new XMLHttpRequest();
    xhr.open('GET', this.getUrl(url) + '?' + qs.stringify(params), true); // get请求，请求地址，是否异步
    xhr.responseType = 'blob';
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.setRequestHeader('uiLang', window.sessionStorage.getItem('langType'));
    xhr.setRequestHeader('accessToken', window.sessionStorage.getItem('accessToken'));
    xhr.onload = function () {
      if (this.status === 200) {
        // 获得文件名
        var filename = this.getResponseHeader('content-disposition').split('filename=')[1];
        var blob = this.response;
        var reader = new FileReader();
        reader.readAsDataURL(blob); // 转换为base64，可以直接放入a标签href
        reader.onload = function (e) {
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename);
          } else {
            // 转换完成，创建一个a标签用于下载
            var a = document.createElement('a');
            a.download = filename;
            a.href = e.target.result;
            document.body.appendChild(a); // 修复firefox中无法触发click
            a.click();
            a.remove();
          }
        };
      }
      return callback(true);
    };
    // 发送ajax请求
    xhr.send();
    return callback(false);
  },

  // 下载zip 同步
  downloadZipHttpData1: function downloadZipHttpData1(url, params, callback) {
    params = params || null;
    var qs = __webpack_require__(84);
    params = params || {};
    var xhr = new XMLHttpRequest();
    xhr.open('GET', this.getUrl(url) + '?' + qs.stringify(params), true); // get请求，请求地址，是否异步
    xhr.responseType = 'blob';
    xhr.setRequestHeader('Content-Type', 'application/octet-stream');
    xhr.setRequestHeader('uiLang', window.sessionStorage.getItem('langType'));
    xhr.setRequestHeader('accessToken', window.sessionStorage.getItem('accessToken'));
    xhr.onload = function () {
      if (this.status === 200) {
        // 获得文件名
        var filename = this.getResponseHeader('content-disposition').split('filename=')[1];
        var blob = this.response;
        var reader = new FileReader();
        reader.readAsDataURL(blob); // 转换为base64，可以直接放入a标签href
        reader.onload = function (e) {
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename);
          } else {
            // 转换完成，创建一个a标签用于下载
            var a = document.createElement('a');
            a.download = filename;
            // a.href = e.target.result
            a.href = URL.createObjectURL(blob);
            document.body.appendChild(a); // 修复firefox中无法触发click
            a.click();
            a.remove();
          }
        };
      }
      return callback(true);
    };
    // 发送ajax请求
    xhr.send();
    return callback(false);
  },
  postHttpData: function postHttpData(url, params, callback, error, isLoading) {
    var _this3 = this;

    // ----------------------------------------------------------------
    params = params || null;
    isLoading = true;
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["a" /* UPDATE_LOADING */], isLoading);
    // -----------------------------------------------------------------
    this.$http.post(this.getUrl(url), params).then(function (response) {
      if (isShowLog) {
        console.log('POST请求', response);
      }
      var result = response.data;
      // -------------------------------------------------------
      // this.log('POST请求', JSON.stringify(result))
      // this.log('POST请求', result)
      // -------------------------------------------------------
      _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["a" /* UPDATE_LOADING */], false);
      // -------------------------------------------------------
      if (result === undefined) {
        return callback(false);
      } else if (result.status !== '1' && result.status !== 1) {
        // 等于 0 为失败
        // 设置errorMsg
        _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["e" /* UPDATE_ERROR_MSG */], result.message);
        return callback(false, _this3.$store, result.message);
      } else if (result.result) {
        return callback(result.result, _this3.$store, result.message);
      } else if (result.data) {
        return callback(result.data, _this3.$store, result.message);
      } else {
        return callback(true, _this3.$store, result.message);
      }
    }).catch(function (e) {
      _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["a" /* UPDATE_LOADING */], false);
      if (error) {
        return error(e);
      } else {
        _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["e" /* UPDATE_ERROR_MSG */], e.message);
        return false;
      }
    });
  },
  postOutHttpData: function postOutHttpData(url, params, callback, error, isLoading) {
    var _this4 = this;

    // ----------------------------------------------------------------
    params = params || null;
    isLoading = true;
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["a" /* UPDATE_LOADING */], isLoading);
    // -----------------------------------------------------------------
    this.$http.post(url, params).then(function (response) {
      if (isShowLog) {
        console.log('POST请求', response);
      }
      var result = response.data;
      // -------------------------------------------------------
      // this.log('POST请求', JSON.stringify(result))
      // this.log('POST请求', result)
      // -------------------------------------------------------
      _this4.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["a" /* UPDATE_LOADING */], false);
      // -------------------------------------------------------
      if (result === undefined) {
        return callback(false);
      } else if (result.status !== '1' && result.status !== 1) {
        // 等于 0 为失败
        // 设置errorMsg
        _this4.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["e" /* UPDATE_ERROR_MSG */], result.message);
        return callback(false, _this4.$store, result.message);
      } else if (result.result) {
        return callback(result.result, _this4.$store, result.message);
      } else {
        return callback(true, _this4.$store, result.message);
      }
    }).catch(function (e) {
      _this4.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["a" /* UPDATE_LOADING */], false);
      if (error) {
        return error(e);
      } else {
        _this4.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["e" /* UPDATE_ERROR_MSG */], e.message);
        return false;
      }
    });
  },
  postZIPHttpData: function postZIPHttpData(url, params, callback, error, isLoading) {
    var _this5 = this;

    // ----------------------------------------------------------------
    params = params || null;
    isLoading = true;
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["a" /* UPDATE_LOADING */], isLoading);
    console.log(params);
    // -----------------------------------------------------------------
    this.$http.post(this.getUrl(url), params).then(function (response) {
      if (isShowLog) {
        console.log('POST请求', response);
      }
      var result = response.data;
      // -------------------------------------------------------
      // this.log('POST请求', JSON.stringify(result))
      // this.log('POST请求', result)
      // -------------------------------------------------------
      _this5.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["a" /* UPDATE_LOADING */], false);
      // -------------------------------------------------------
      if (result === undefined) {
        return callback(false);
      } else if (result.status !== '1' && result.status !== 1) {
        // 等于 0 为失败
        // 设置errorMsg
        _this5.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["e" /* UPDATE_ERROR_MSG */], result.message);
        return callback(false, _this5.$store, result.message);
      } else if (result.result) {
        return callback(result.result, _this5.$store, result.message);
      } else {
        return callback(true, _this5.$store, result.message);
      }
    }).catch(function (e) {
      _this5.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["a" /* UPDATE_LOADING */], false);
      if (error) {
        return error(e);
      } else {
        _this5.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["e" /* UPDATE_ERROR_MSG */], e.message);
        return false;
      }
    });
  },
  uploadHttpData: function uploadHttpData(url, params, callback, error, isLoading) {
    var _this6 = this;

    isLoading = true;
    params = params || new FormData();
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["a" /* UPDATE_LOADING */], isLoading);
    this.$http.post(this.getUrl(url), params, {
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(function (response) {
      if (isShowLog) {
        console.log('上传', response);
      }
      _this6.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["a" /* UPDATE_LOADING */], false);
      var result = response.data;
      if (result.status !== '1' && result.status !== 1) {
        _this6.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["e" /* UPDATE_ERROR_MSG */], result.msg);
        callback && callback(false, _this6.$store, result.msg);
      } else if (result === undefined) {
        callback && callback(false, _this6.$store, result.msg);
      } else if (result.result) {
        callback && callback(result, _this6.$store, result.msg);
      } else {
        callback && callback(true, _this6.$store, result.msg);
      }
    }).catch(function (e) {
      _this6.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["a" /* UPDATE_LOADING */], false);
      if (error) {
        error(e);
      } else {
        _this6.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["e" /* UPDATE_ERROR_MSG */], e.message);
      }
    });
  },
  postHttp: function postHttp(url, params, callback) {
    var _this7 = this;

    // ----------------------------------------------------------------
    params = params || null;
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["a" /* UPDATE_LOADING */], true);
    // -----------------------------------------------------------------
    this.$http.post(this.getUrl(url), params).then(function (response) {
      _this7.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["a" /* UPDATE_LOADING */], false);
      var data = response.data;
      /*
        result.status
         1: 成功
         0: 失败
        result.code
        -1: 获取到的数据中没有这个值
      */
      if (data) {
        if (data.status) data.status = parseInt(data.status);else data.status = -1;
        if (data.code) data.code = parseInt(data.code);else data.code = -1;
      } else {
        data = { status: 0, code: -1 };
      }
      _this7.handleResult(data, callback);
    }).catch(function (error) {
      console.log('tag new->', error);
      _this7.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_mutation_types__["a" /* UPDATE_LOADING */], false);
    });
  },
  handleResult: function handleResult(data, callback) {
    // console.log('tag ---err', JSON.stringify(data))
    if (data.status === 1) {
      callback(true);
    } else {
      switch (data.code) {
        case -1:
          callback(false);
          break;
        case 100:
          callback(false, this.$t('errMsg.errMsg100'), data);
          break;
        case 101:
          callback(false, this.$t('errMsg.errMsg101'), data);
          break;
        case 102:
          callback(false, this.$t('errMsg.errMsg102'), data);
          break;
        case 103:
          callback(false, this.$t('errMsg.errMsg103'), data);
          break;
        case 104:
          callback(false, this.$t('errMsg.errMsg104'), data);
          break;
        case 105:
          callback(false, this.$t('errMsg.errMsg105'), data);
          break;
        case 106:
          callback(false, this.$t('errMsg.errMsg106'), data);
          break;
        case 107:
          callback(false, this.$t('errMsg.errMsg107'), data);
          break;
        case 108:
          callback(false, this.$t('errMsg.errMsg108'), data);
          break;
        case 109:
          callback(false, this.$t('errMsg.errMsg109'), data);
          break;
        case 110:
          callback(false, this.$t('errMsg.errMsg110'), data);
          break;
        case 111:
          callback(false, this.$t('errMsg.errMsg111'), data);
          break;
        case 112:
          callback(false, this.$t('errMsg.errMsg112'), data);
          break;
        case 113:
          callback(false, this.$t('errMsg.errMsg113'), data);
          break;
        case 114:
          callback(false, this.$t('errMsg.errMsg114'), data);
          break;
        case 115:
          callback(false, this.$t('errMsg.errMsg115'), data);
          break;
        case 116:
          callback(false, this.$t('errMsg.errMsg116'), data);
          break;
        case 117:
          callback(false, this.$t('errMsg.errMsg117'), data);
          break;
        case 118:
          callback(false, this.$t('errMsg.errMsg118'), data);
          break;
        case 119:
          callback(false, this.$t('errMsg.errMsg119'), data);
          break;
        case 120:
          callback(false, this.$t('errMsg.errMsg120'), data);
          break;
      }
    }
  },
  newGuid: function newGuid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  },
  openWindow_newHome: function openWindow_newHome(path) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var routeData = this.$router.resolve({
      path: '/' + path,
      query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        accessToken: __WEBPACK_IMPORTED_MODULE_2__utils_user__["a" /* default */].getAccessToken(),
        uiLang: __WEBPACK_IMPORTED_MODULE_2__utils_user__["a" /* default */].getUiLang(),
        newHome: true
      }, params)
    });
    window.open(routeData.href, '_blank');
  },
  getSalesText: function getSalesText(sales) {
    sales = Number(sales);
    // this.$t('newHome.salesLessThan1k')
    return sales < 1000 ? '1k' : (sales / 1000).toFixed(1) + 'k+';
  },
  toThousands: function toThousands(num) {
    var result = '';
    var counter = 0;
    num = (num || 0).toString().split('');
    for (var i = num.length - 1; i >= 0; i--) {
      counter++;
      result = num[i] + result;
      if (!(counter % 3) && i !== 0) {
        result = ',' + result;
      }
    }
    return result === '0' ? '' : result;
  },
  getCategoryKey: function getCategoryKey(category) {
    switch (category) {
      case 'transport':
        return 1;
      case 'themePark':
        return 2;
      case 'wifi':
        return 3;
      case 'carRental':
        return 4;
      case 'dayTrip':
        return 5;
      case 'hotel':
        return 6;
      default:
        return '';
    }
  },
  getProductTypeById: function getProductTypeById(id) {
    switch (Number(id)) {
      case 0:
        return 'lable.ticketType0';
      case 1:
        return 'lable.ticketType1';
      case 2:
        return 'lable.ticketType22';
      case 3:
        return 'lable.ticketType33';
      case 4:
        return 'lable.ticketType4';
      case 5:
        return 'lable.ticketType5';
      case 6:
        return 'lable.ticketType66';
      case 7:
        return 'lable.ticketType77';
      case 8:
        return 'lable.ticketType88';
      case 9:
        return 'lable.ticketType99';
      default:
        return null;
    }
  },
  getLanguageType: function getLanguageType(type) {
    switch (type) {
      case '1':
      case 1:
        return 'zh';
      case '2':
      case 2:
        return 'tw';
      case '3':
      case 3:
        return 'en';
      case '4':
      case 4:
        return 'ko';
      case '5':
      case 5:
        return 'ja';
      default:
        return type;
    }
  },
  translateFormData: function translateFormData(callback) {
    if (this.lastLanguageData.data && this.lastLanguageData.source && this.lastLanguageData.target && this.lastLanguageData.source !== this.lastLanguageData.target) {
      var loading = this.$loading({
        lock: true,
        text: this.$t('lable.translationing'),
        spinner: 'el-icon-loading',
        background: 'rgba(5, 4, 4, 0.7)'
      });
      var source = this.getLanguageType(this.lastLanguageData.source);
      var target = this.getLanguageType(this.lastLanguageData.target);

      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.lastLanguageData.data, {
        source: source === 'tw' ? 'zh-Hant' : source,
        target: target === 'tw' ? 'zh-Hant' : target
      });
      this.postHttpData("https://web.universaltravelai.com:2089/greate-nation-translate-api" + '/EasyGoTranslate/Translate', params, function (data) {
        loading.close();
        if (data && callback) {
          delete data.id;
          delete data.createTime;
          callback(true, data);
        }
      }, function () {
        loading.close();
      });
    } else this.$message.warning(this.$t('lable.translationTip'));
  },
  getTranslationForLocale: function getTranslationForLocale(key, localeType) {
    // 获取目标语言
    var locale = this.getLanguageType(localeType);
    // 当前语言
    var currentLocale = this.$i18n.locale;

    if (!key) return 'error-key';
    if (!locale || locale === currentLocale) return this.$i18n.t(key);

    return this.$i18n.t(key, locale);
  },


  // 获取字符串是否包含大小写字母
  hasCaseLetter: function hasCaseLetter(str) {
    return (/[a-zA-Z]/.test(str)
    );
  }
});

/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.prototype.$http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a;
    Vue.http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a;
  },

  $http: __WEBPACK_IMPORTED_MODULE_0_axios___default.a
});

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_loginNew_loginNew_vue__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_loginNew_loginNew_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_loginNew_loginNew_vue__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // mode: 'history',
  routes: [{
    path: '/',
    meta: { isLogin: false },
    redirect: '/login'
  }, {
    path: '/appPrivacy',
    meta: { isLogin: false, title: '隐私条款' },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(66).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(674)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/productPreview',
    name: 'productPreview',
    meta: { isLogin: true, title: '产品预览' },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(672)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/productNoPreview',
    name: 'productNoPreview',
    meta: { isLogin: true, title: '产品编号预览' },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(71).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(773)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/login',
    name: 'login',
    meta: { isLogin: false, title: '登录' },
    component: __WEBPACK_IMPORTED_MODULE_2__views_loginNew_loginNew_vue___default.a // resolve => require(['@/views/login/login.vue'], resolve)
  }, {
    path: '/publicNotice',
    name: 'publicNotice',
    meta: { isLogin: false, title: '通告详情' },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(708)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/selectMerchantType',
    name: 'selectMerchantType',
    meta: { isLogin: false, title: '选择用户类型' },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(75).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(709)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/backAccount',
    name: 'backAccount',
    meta: { isLogin: false, title: '找回账号和密码' },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(128).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(705)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/backAccountMsg',
    name: 'backAccountMsg',
    meta: { isLogin: false, title: '找回账号和密码' },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(59).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(706)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/register',
    name: 'register',
    meta: { isLogin: false, title: '注册' },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(707)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    data: { isRegister: true }
  }, {
    path: '/counterInfo',
    name: 'counterInfo',
    meta: { isLogin: false, title: '柜台信息' },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(85).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(792)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/supplement',
    name: '/supplement',
    meta: { isLogin: false, title: '使用流程补充' },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(90).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(767)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/barCode',
    name: 'barCode',
    meta: { isLogin: false, title: '二维码链接', content: 'width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no' },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(58).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(676)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/payResult',
    name: 'payResult',
    meta: { isLogin: false, title: '支付结果', content: 'width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no' },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(60).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(730)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/newHomePage',
    name: 'newHomeHomepage',
    meta: { isLogin: true, title: '首页' },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(714)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/newProductList',
    name: 'newHomeProductList',
    meta: { isLogin: true, title: '产品列表' },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(715)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/sysHome',
    meta: { isLogin: true, title: '主页' },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(673)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    children: [{
      path: '/',
      name: 'sysHome',
      meta: { isLogin: true, title: '系统首页' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(787)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/bulkPurchaseList',
      name: 'bulkPurchaseList',
      meta: { isLogin: true, title: '批量采购列表' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(108).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(683)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/submitAndPayOrderBatch',
      name: 'submitAndPayOrderBatch',
      meta: { isLogin: true, title: '批量采购' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(691)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/bulkPurchaseDetail',
      name: 'bulkPurchaseDetail',
      meta: { isLogin: true, title: '批量采购详情' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(109).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(682)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/productList',
      name: 'productList',
      meta: { isLogin: true, title: '产品列表' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(751)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/releaseProducts',
      name: 'releaseProducts',
      meta: { isLogin: true, title: '发布产品' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(753)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    },
    // {
    //   path: '/releaseThirdProducts',
    //   name: 'releaseThirdProducts',
    //   meta: {isLogin: true, title: '发布第三方产品'},
    //   component: resolve => require(['@/views/product/releaseThirdProducts.vue'], resolve)
    // },
    {
      path: '/supplyManageProduct',
      name: 'supplyManageProduct',
      meta: { isLogin: true, title: '产品售卖管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(65).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(771)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/tocDistributorManageProduct',
      name: 'tocDistributorManageProduct',
      meta: { isLogin: true, title: 'TOC产品售卖管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(772)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/importThirdSystemProduct',
      name: 'importThirdSystemProduct',
      meta: { isLogin: true, title: '产品售卖管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(93).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(748)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/productAuditing',
      name: 'productAuditing',
      meta: { isLogin: true, title: '产品审核列表' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(750)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/productPriceNumber',
      name: 'productPriceNumber',
      meta: { isLogin: true, title: '价格库存' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(752)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/orderManagement',
      name: 'orderManagement',
      meta: { isLogin: true, title: '订单管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(729)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/distriOrderMagnToC',
      name: 'distriOrderMagnToC',
      meta: { isLogin: true, title: '订单管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(54).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(717)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/operatorOrderManagement',
      name: 'operatorOrderManagement',
      meta: { isLogin: true, title: '运营商订单管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(718)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/supplyOrderDetail',
      name: 'supplyOrderDetail',
      meta: { isLogin: true, title: '供应商订单详情' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(728)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/jtrSupplyOrderDetail',
      name: 'jtrSupplyOrderDetail',
      meta: { isLogin: true, title: '供应商订单详情(JTR)' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(726)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/distriOrderDetail',
      name: 'distriOrderDetail',
      meta: { isLogin: true, title: '分销商订单详情' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(102).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(722)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/distriOrderToCDetail',
      name: 'distriOrderToCDetail',
      meta: { isLogin: true, title: 'TOC分销商订单详情' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(101).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(723)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/operatorOrderDetail',
      name: 'operatorOrderDetail',
      meta: { isLogin: true, title: '运营商订单详情' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(727)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/jtrOrderDetail',
      name: 'jtrOrderDetail',
      meta: { isLogin: true, title: '运营商JTR订单详情' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(100).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(724)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/jtrOrderDetailOperative',
      name: 'jtrOrderDetailOperative',
      meta: { isLogin: true, title: '运营商JTR订单详情Operative' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(99).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(725)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/distriJtrOrderToCDetail',
      name: 'distriJtrOrderToCDetail',
      meta: { isLogin: true, title: '分销商订单详情' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(103).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(721)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/distriJtrOrderDetail',
      name: 'distriJtrOrderDetail',
      meta: { isLogin: true, title: '分销商订单详情' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(104).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(720)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/jtrcancel',
      name: 'jtrcancel',
      meta: { isLogin: true, title: '部分取消' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(79).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(702)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/distributor',
      name: 'distributor',
      meta: { isLogin: true, title: '分销商管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(78).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(711)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/balance',
      name: 'balance',
      meta: { isLogin: true, title: '分销商管理余额设置' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(74).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(710)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/supplier',
      name: 'supplier',
      meta: { isLogin: true, title: '供应商管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(77).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(713)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/withdrawal',
      name: 'withdrawal',
      meta: { isLogin: true, title: '提现管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(89).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(781)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/operatorWithdrawal',
      name: 'operatorWithdrawal',
      meta: { isLogin: true, title: '充值/提现管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(125).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(775)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/recharge',
      name: 'recharge',
      meta: { isLogin: true, title: '充值管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(124).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(777)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/onlineRecharge',
      name: 'onlineRecharge',
      meta: { isLogin: true, title: '在线充值' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(63).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(774)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/pay/return',
      name: 'payReturn',
      meta: { isLogin: true, title: '回调显示页面' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(62).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(776)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/trades',
      name: 'trades',
      meta: { isLogin: true, title: '交易明细' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(121).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(780)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/record',
      name: 'record',
      meta: { isLogin: true, title: '充值提现记录' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(123).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(778)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/scenicSpotList',
      name: 'scenicSpotList',
      meta: { isLogin: true, title: '景点列表' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(784)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/banner',
      name: 'banner',
      meta: { isLogin: true, title: 'banner管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(675)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/popularCities',
      name: 'popularCities',
      meta: { isLogin: true, title: '热门城市管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(127).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(732)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/addPopularCities',
      name: 'addPopularCities',
      meta: { isLogin: true, title: '新增热门城市' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(53).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(731)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/recommendedAttractions',
      name: 'recommendedAttractions',
      meta: { isLogin: true, title: '首页推荐管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(88).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(782)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/financeStatement',
      name: 'financeStatement',
      meta: { isLogin: true, title: '财务报表' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(130).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(696)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/ActuarialManagement',
      name: 'ActuarialManagement',
      meta: { isLogin: true, title: '精算管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(131).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(694)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/ActuarialManagementDetail',
      name: 'ActuarialManagementDetail',
      meta: { isLogin: true, title: '精算管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(105).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(697)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/statementDetail',
      name: 'statementDetail',
      meta: { isLogin: true, title: '报表详情' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(129).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(700)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/setQrCode',
      name: 'setQrCode',
      meta: { isLogin: true, title: '设置二维码' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(64).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(770)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/applyDistribution',
      name: 'applyDistribution',
      meta: { isLogin: true, title: '分销审核' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(49).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(743)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/revenueManagement',
      name: 'revenueManagement',
      meta: { isLogin: true, title: '收益管理(分销toc)' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(91).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(755)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/revenueDetail',
      name: 'revenueDetail',
      meta: { isLogin: true, title: '收益详情(分销toc)' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(92).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(754)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/applyCash',
      name: 'applyCash',
      meta: { isLogin: true, title: '提现管理(分销toc)' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(50).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(742)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/operatApplyCash',
      name: 'operatApplyCash',
      meta: { isLogin: true, title: '提现管理(运营商)' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(48).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(749)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/coupon',
      name: 'coupon',
      meta: { isLogin: true, title: 'ToC优惠券管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(97).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(744)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/couponOrder',
      name: 'couponOrder',
      meta: { isLogin: true, title: '优惠券订单' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(95).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(746)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/operatorOrderMagnToC',
      name: 'operatorOrderMagnToC',
      meta: { isLogin: true, title: '运营商订单管理(toc)' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(719)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/QrCodeAndproductDetail',
      name: 'QrCodeAndproductDetail',
      meta: { isLogin: true, title: '二维码与产品' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(98).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(741)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/couponDetail',
      name: 'couponDetail',
      meta: { isLogin: true, title: '优惠券详情' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(96).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(745)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/AddRequestForPayment',
      name: 'AddRequestForPayment',
      meta: { isLogin: true, title: '请款书支付' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(698)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/ChooseAddActuary',
      name: 'ChooseAddActuary',
      meta: { isLogin: true, title: '选择新增精算类型' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(76).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(695)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/AddTemporaryPurchase',
      name: 'AddTemporaryPurchase',
      meta: { isLogin: true, title: '临时采购' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(699)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/adminAccount',
      name: 'adminAccount',
      meta: { isLogin: true, title: '管理员账号' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(70).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(789)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/noticeManager',
      name: 'noticeManager',
      meta: { isLogin: true, title: '通告管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(115).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(798)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/noticeDetails',
      name: 'noticeDetails',
      meta: { isLogin: true, title: '通告详情' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(86).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(788)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/addNotice',
      name: 'addNotice',
      meta: { isLogin: true, title: '添加通告' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(806)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/pwdSet',
      name: 'pwdSet',
      meta: { isLogin: true, title: '密码设置' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(112).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(802)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/payType',
      name: 'payType',
      meta: { isLogin: true, title: '支付方式' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(113).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(801)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/merchantInfo',
      name: 'merchantInfo',
      meta: { isLogin: true, title: '商户信息' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(796)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/clerk',
      name: 'clerk',
      meta: { isLogin: true, title: '业务员管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(119).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(790)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/exportRules',
      name: 'exportRules',
      meta: { isLogin: true, title: '导出规则一览' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(117).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(793)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/exportSetting',
      name: 'exportSetting',
      meta: { isLogin: true, title: '导出项目设置' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(116).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(794)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/addClerk',
      name: 'addClerk',
      meta: { isLogin: true, title: '添加业务员' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(83).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(803)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/operator',
      name: 'operator',
      meta: { isLogin: true, title: '管理员管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(114).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(799)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/addOperator',
      name: 'addOperator',
      meta: { isLogin: true, title: '添加管理员' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(82).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(807)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/updatePayType',
      name: 'updatePayType',
      meta: { isLogin: true, title: '修改支付方式' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(81).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(808)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/liaisons',
      name: 'liaisons',
      meta: { isLogin: true, title: '联络人管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(69).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(795)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/addLiaisons',
      name: 'addLiaisons',
      meta: { isLogin: true, title: '添加联络人' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(67).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(805)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/counter',
      name: 'counter',
      meta: { isLogin: true, title: '柜台管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(118).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(791)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/addCounter',
      name: 'addCounter',
      meta: { isLogin: true, title: '添加柜台' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(804)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/newOrderEmail',
      name: 'newOrderEmail',
      meta: { isLogin: true, title: '新订单邮件通知设置' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(68).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(797)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/reserve',
      name: 'reserve',
      meta: { isLogin: true, title: '产品预定' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(733)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/jtrreserve',
      name: 'jtrreserve',
      meta: { isLogin: true, title: 'JTR产品预定' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(701)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/confirmOrder',
      name: 'confirmOrder',
      meta: { isLogin: true, title: '提交订单' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(52).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(734)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/jtrconfirmOrder',
      name: 'jtrconfirmOrder',
      meta: { isLogin: true, title: '提交订单' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(57).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(703)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/klookConfirmOrder',
      name: 'klookConfirmOrder',
      meta: { isLogin: true, title: '提交订单' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(736)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/jtrConfirmOrderNew',
      name: 'jtrConfirmOrderNew',
      meta: { isLogin: true, title: '提交订单' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(51).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(735)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/payOrder',
      name: 'payOrder',
      meta: { isLogin: true, title: '支付订单' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(737)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/jtrpayOrderState',
      name: 'jtrpayOrderState',
      meta: { isLogin: true, title: 'jtr支付订单' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(704)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/distriOrderMagn',
      name: 'distriOrderMagn',
      meta: { isLogin: true, title: '订单管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(55).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(716)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/userDepot',
      name: 'userDepot',
      meta: { isLogin: true, title: '用户仓库管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(133).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(692)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/warehouse',
      name: 'warehouse',
      meta: { isLogin: true, title: '仓库管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(132).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(693)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/ticketDepot',
      name: 'ticketDepot',
      meta: { isLogin: true, title: '票仓一览' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(134).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(689)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/addTicketDepot',
      name: 'addTicketDepot',
      meta: { isLogin: true, title: '新增票仓' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(686)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/importTicket',
      name: 'importTicket',
      meta: { isLogin: true, title: '实体票入仓' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(135).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(687)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/ticketBatchList',
      name: 'ticketBatchList',
      meta: { isLogin: true, title: '实体票批次一览' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(106).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(688)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/pinTicket',
      name: 'pinTicket',
      meta: { isLogin: true, title: '验证销票' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(61).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(684)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/shortcutOut',
      name: 'shortcutOut',
      meta: { isLogin: true, title: '快捷销票' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(690)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/pinTicketMagn',
      name: 'pinTicketMagn',
      meta: { isLogin: true, title: '验证销票管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(107).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(685)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/pdfFiles',
      name: 'pdfFiles',
      meta: { isLogin: true, title: 'PDF文件库管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(137).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(677)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/batchList',
      name: 'batchList',
      meta: { isLogin: true, title: '批次列表' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(110).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(679)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/batchPdfFilesList',
      name: 'batchPdfFilesList',
      meta: { isLogin: true, title: '批次文件列表' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(136).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(680)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/addPdfFiles',
      name: 'addPdfFiles',
      meta: { isLogin: true, title: '添加PDF文件库' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(678)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/importPdf',
      name: 'importPdf',
      meta: { isLogin: true, title: '导入PDF文件' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(111).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(681)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/addProduct',
      name: 'addProduct',
      meta: { isLogin: true, title: '添加产品' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(758)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/operateAddProduct',
      name: 'operateAddProduct',
      meta: { isLogin: true, title: '添加产品' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(764)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/jtrAddProduct',
      name: 'jtrAddProduct',
      meta: { isLogin: true, title: '添加产品' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(760)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/klookAddProduct',
      name: 'klookAddProduct',
      meta: { isLogin: true, title: '添加产品' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(762)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/productDetail',
      name: 'productDetail',
      meta: { isLogin: true, title: '产品详情（实体票/电子票/体验）' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(765)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/diningDetail',
      name: 'diningDetail',
      meta: { isLogin: true, title: '餐厅产品详情' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(759)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/tourDetail',
      name: 'tourDetail',
      meta: { isLogin: true, title: '一日游/多日游产品详情' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(768)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/WIFIDetail',
      name: 'WIFIDetail',
      meta: { isLogin: true, title: 'WIFI产品详情' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(757)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/SIMDetail',
      name: 'SIMDetail',
      meta: { isLogin: true, title: 'SIM卡产品详情' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(756)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/trafficDetail',
      name: 'trafficDetail',
      meta: { isLogin: true, title: '交通产品详情' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(769)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/productPackageDetail',
      name: 'productPackageDetail',
      meta: { isLogin: true, title: '套餐详情' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(766)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/jtrTicketDetail',
      name: 'jtrTicketDetail',
      meta: { isLogin: true, title: 'JTR门票详情' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(761)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/klookProductDetail',
      name: 'klookProductDetail',
      meta: { isLogin: true, title: 'JTR门票详情' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(763)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/addScenicSpot',
      name: 'addScenicSpot',
      meta: { isLogin: true, title: '追加景点' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(783)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/merchantAudit',
      name: 'merchantAudit',
      meta: { isLogin: true, title: '供应商/分销商管理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(56).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(712)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/editTest',
      name: 'editTest',
      meta: { isLogin: false, title: '富文本测试' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(94).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(747)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/pageSetting',
      name: 'pageSetting',
      meta: { isLogin: false, title: '登录图片更新' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(84).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(800)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/productLogList',
      name: 'productLogList',
      meta: { isLogin: true, title: '产品Log列表' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(126).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(738)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/productLogDetail',
      name: 'productLogDetail',
      meta: { isLogin: true, title: '产品Log详情' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(72).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(740)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/productLanguageLogDetail',
      name: 'productLanguageLogDetail',
      meta: { isLogin: true, title: '产品Log详情' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(73).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(739)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/scheduleList',
      name: 'scheduleList',
      meta: { isLogin: true, title: '定时任务列表' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(120).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(785)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/addSchedule',
      name: 'addSchedule',
      meta: { isLogin: true, title: '添加定时任务' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(87).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(786)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/remind',
      name: 'remind',
      meta: { isLogin: true, title: '添加提醒' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(122).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(779)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/secondaryAgent',
      name: 'secondaryAgent',
      meta: { isLogin: false, title: '二级代理' },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(80).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(809)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }]
  }]
}));

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var localParams = 'LOCAL_PARAMS';
/* harmony default export */ __webpack_exports__["a"] = ({
  // methods: {
  /**
   * 单页面跳页，不传参的话只写的一个name则可
   * @param name
   *      目标页面的 name
   *      注意：路由中的 name 和 path 须设同样字串,如(name: 'test', path: '/test')
   * @param params
   *      传递到目标页的参数
   * @param location
   *      记录一个位置信息，用于目标页获取到传递的参数
   * @param query
   *      传递到目标页的URL参数
   */
  pushPage: function pushPage(name, params, location, query) {
    params = params || {};
    query = query || {};
    if (location) {
      query.location = location;
      sessionStorage.setItem(localParams + location, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params));
    }
    this.$router.push({
      path: '/' + name,
      name: name,
      query: query
    });
  },

  /**
   * 打开新标签页条跳页，不传参的话只写的一个name则可
   * @param name
   *      目标页面的 name
   *      注意：路由中的 name 和 path 须设同样字串,如(name: 'test', path: '/test')
   * @param params
   *      传递到目标页的参数
   * @param query
   *      传递到目标页的URL参数
   */
  resolvePage: function resolvePage(name, params, query) {
    params = params || {};
    query = query || {};
    window.open(this.$router.resolve({ path: '/' + name, name: name, query: query }).href, '_blank');
  },

  /**
   * 可不跳页直接设参数
   * @param params
   * @param location
   */
  setParams: function setParams(params, location) {
    if (location) {
      params = params || {};
      sessionStorage.setItem(localParams + location, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params));
    }
  },

  /**
   * 目标页获取参数的方法
   * @param location
   * @param redirect
   * @param redirect
   *  重定向的页面 name，当获取的参数的空时，则重定向到 redirect 页面。
   *  @param query  重定向时的 query 参数，无则不传
   * @returns {{}}
   */
  getParams: function getParams(location, redirect, query) {
    if (location) {
      var params = sessionStorage.getItem(localParams + location);
      if (params) {
        return JSON.parse(params);
      } else if (redirect) {
        query = query || {};
        this.pushPage(redirect, null, null, query);
        return null;
      } else {
        return null;
      }
    } else return null;
  },


  // ==============================================================
  /**
   * 新窗口跳页,如不需传参，则只写 name
   * @param name   新页的 name。
   * @param id     不重复的 id，这个 id 在新页的取 data 值使用。
   * @param data   需传递的数据，对象类型。
   */
  openWindow: function openWindow(name, id, data) {
    id = 'content' + id;
    var input = document.getElementById(id);
    if (input) input.value = '';else {
      input = document.createElement('input');
    }
    if (id && data) {
      input.id = id;
      input.type = 'hidden';
      input.name = 'content';
      input.value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
      document.body.appendChild(input);
    }
    window.open(window.location.origin + '#/' + name);
    // window.open(window.location.origin + '/' + name)
  },

  /**
   * openWindow(name, id, data)  打开的新窗口使用这个方法获取 data。
   * @param id  openWindow() 方法中传入的 id。
   * @returns {{}}
   */
  getOpenWindowData: function getOpenWindowData(id) {
    id = 'content' + id;
    var input = window.opener.document.getElementById(id);
    if (input) {
      var val = input.value;
      if (val) return JSON.parse(val);else return {};
    }
  }
});

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);

/* eslint-disable no-extend-native, no-unused-vars */
var isShowLog = false;
/**
 * 对Date的扩展，将 Date 转化为指定格式的String * 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、周(E)、季度(q)
 * 可以用 1-2 个占位符 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字) * eg: * (new
 * Date()).Format("yyyy-MM-dd hh:mm:ss.S")==> 2006-07-02 08:09:04.423
 * (new Date()).Format("yyyy-MM-dd E HH:mm:ss") ==> 2009-03-10 二 20:09:04
 * (new Date()).Format("yyyy-MM-dd EE hh:mm:ss") ==> 2009-03-10 周二 08:09:04
 * (new Date()).Format("yyyy-MM-dd EEE hh:mm:ss") ==> 2009-03-10 星期二 08:09:04
 * (new Date()).Format("yyyy-M-d h:m:s.S") ==> 2006-7-2 8:9:4.18
 */
Date.prototype.Format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours() % 12 === 0 ? 12 : this.getHours() % 12, // 小时
    'H+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds() // 毫秒
  };
  var week = {
    '0': '/u65e5',
    '1': '/u4e00',
    '2': '/u4e8c',
    '3': '/u4e09',
    '4': '/u56db',
    '5': '/u4e94',
    '6': '/u516d'
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length > 1 ? RegExp.$1.length > 2 ? '/u661f/u671f' : '/u5468' : '') + week[this.getDay() + '']);
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  if (isShowLog) {
    console.log('extendDate -> Format', fmt);
  }
  return fmt;
};

/**
 * @param date
 * @returns {number}
 * 如果指定的数与参数相等返回 0。
 * 如果指定的数小于参数返回  -1。
 * 如果指定的数大于参数返回   1。
 * 参数为空时返回          -2。
 * @constructor
 */
Date.prototype.Compare = function (date) {
  if (!date) return -2;
  var isDate = false;
  if (date instanceof Date) isDate = true;
  if (!isDate) {
    var timeStamp = Number(date);
    var isInteger = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(timeStamp);
    if (isInteger) date = new Date(timeStamp);else date = new Date(date);
  }
  if (!date) return -2;
  if (this.getFullYear() > date.getFullYear()) return 1;
  if (this.getFullYear() === date.getFullYear()) {
    if (this.getMonth() > date.getMonth()) return 1;
    if (this.getMonth() === date.getMonth()) {
      if (this.getDate() > date.getDate()) return 1;
      if (this.getDate() === date.getDate()) return 0;else return -1;
    } else return -1;
  } else return -1;
};

/**
 * 获取时间部分
 * @param isCutS 去掉秒为:true, 否则为:false
 * @returns {string}
 * @constructor
 */
Date.prototype.ToHmsString = function (isCutS) {
  var h = this.getHours();
  var m = this.getMinutes();
  var s = this.getSeconds();
  h = h < 10 ? '0' + h : h;
  m = m < 10 ? '0' + m : m;
  s = s < 10 ? '0' + s : s;
  if (isCutS) {
    if (s < 30) {
      return h + ':' + m;
    } else if (m === 59) {
      return ++h + ':00';
    } else {
      return h + ':' + ++m;
    }
  } else {
    return h + ':' + m + ':' + s;
  }
};

/**
 * 时间部分的比较
 * 大于：1
 * 相等：0
 * 小于：-1
 * @param date
 * @constructor
 */
Date.prototype.HmsCompareTo = function (date) {
  var h = void 0,
      m = void 0,
      s = void 0,
      arg0 = void 0,
      arg1 = void 0;
  h = this.getHours();
  m = this.getMinutes();
  s = this.getSeconds();
  arg0 = (h * 60 + m) * 60 + s;
  h = date.getHours();
  m = date.getMinutes();
  s = date.getSeconds();
  arg1 = (h * 60 + m) * 60 + s;

  var flag = arg0 > arg1 ? 1 : arg0 === arg1 ? 0 : -1;

  if (isShowLog) {
    console.log('extendDate -> HmsCompareTo', arg0, arg1, flag);
  }
  return flag;
};

// /**
//  * @param count
//  * @constructor
//  * @return
//  * 返回一个年份增加了 count 年的 date 对象
//  */
// Date.prototype.YearIncrement = function (count) {
//   return new Date(this.getFullYear() + count, this.getMonth(), this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds())
// }
/**
 * 此方法还有毛病，不要使用
 * "*******************东区时间************************************";
 * "零时区-伦敦时间：" + getLocalTime(0);
 * "东一区-柏林时间：" + getLocalTime(1);
 * "东二区-雅典时间：" + getLocalTime(2);
 * "东三区-莫斯科时间：" + getLocalTime(3);
 * "东四区-时间：" + getLocalTime(4);
 * "东五区-伊斯兰堡时间：" + getLocalTime(5);
 * "东六区-科伦坡时间：" + getLocalTime(6);
 * "东七区-曼谷时间：" + getLocalTime(7);
 * "东八区-北京时间：" + getLocalTime(8);
 * "东九区-东京时间：" + getLocalTime(9);
 * "东十区-悉尼时间：" + getLocalTime(10);
 * "东十二区-斐济时间：" + getLocalTime(12);
 * "*******************西区时间************************************");
 * "西十区-斐济时间：" + getLocalTime(-10);
 * "西九区-阿拉斯加时间：" + getLocalTime(-9);
 * "西八区-太平洋时间（美国和加拿大）：" + getLocalTime(-8);
 * "西七区-山地时间（美国和加拿大）：" + getLocalTime(-7);
 * "西六区-中部时间（美国和加拿大）：" + getLocalTime(-6);
 * "西五区-东部时间（美国和加拿大）：" + getLocalTime(-5);
 * "西四区-大西洋时间（加拿大）：" + getLocalTime(-4);
 * "西三区-巴西利亚时间：" + getLocalTime(-3);
 * @param td  时间差：time difference
 * @param isShowLog 是否打印log
 * @constructor
 */
// Date.prototype.GetUTCTime = function (td) {
//   if (typeof td !== 'number' || td === undefined) td = 0
//   let d = new Date()
//   // 得到1970年一月一日到现在的秒数
//   let len = d.getTime()
//   // 本地时间与GMT时间的时间偏移差
//   let offset = d.getTimezoneOffset() * 60000
//   // 得到现在的格林尼治时间
//   let utcTime = len + offset
//
//   if (isShowLog) {
//     console.log('extendDate -> GetUTCTime', utcTime)
//   }
//
//   return new Date(utcTime + 3600000 * td).getTime()
// }

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/**
 * Created by benon on 2017/10/11.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.saveLangType = function (langType) {
      sessionStorage.setItem('uiLang', langType);
      if (langType === 'zh') {
        sessionStorage.setItem('langType', 1);
      } else if (langType === 'tw') {
        sessionStorage.setItem('langType', 2);
      } else if (langType === 'en') {
        sessionStorage.setItem('langType', 3);
      } else if (langType === 'ko') {
        sessionStorage.setItem('langType', 4);
      } else if (langType === 'ja') {
        sessionStorage.setItem('langType', 5);
      }
    };
    Vue.prototype.getLangType = function () {
      var langType = sessionStorage.getItem('langType');
      return langType !== 0 && langType !== null ? langType : 1;
    };
    Vue.prototype.setCookie = function (name, value, expireDays) {
      var expDate = new Date();
      expDate.setTime(expDate.getTime() + expireDays * 24 * 60 * 60 * 1000);
      document.cookie = name + '=' + escape(value) + (expireDays == null ? '' : ';expires=' + expDate.toGMTString());
      console.log(name + '=' + escape(value) + (expireDays == null ? '' : ';expires=' + expDate.toGMTString()));
    };
    Vue.prototype.getCookie = function (name) {
      var arr = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
      var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
      console.log(reg);
      console.log(document.cookie.match(reg));
      if (arr === document.cookie.match(reg)) {
        console.log('has cookie!');
        return unescape(arr[2]);
      } else {
        console.log('no cookie!');
        return null;
      }
    };
    Vue.prototype.getCookie1 = function (cookieName) {
      var allCookies = document.cookie;
      // 索引长度，开始索引的位置
      var cookiePos = allCookies.indexOf(cookieName);
      // 如果找到了索引，就代表cookie存在,否则不存在
      if (cookiePos !== -1) {
        console.log('has cookie');
        // 把cookie_pos放在值的开始，只要给值加1即可
        // 计算取cookie值得开始索引，加的1为“=”
        cookiePos = cookiePos + cookieName.length + 1;
        // 计算取cookie值得结束索引
        var cookieEnd = allCookies.indexOf(';', cookiePos);
        if (cookieEnd === -1) {
          cookieEnd = allCookies.length;
        }
        // 得到想要的cookie的值
        var value = unescape(allCookies.substring(cookiePos, cookieEnd));
        return value;
      }
      console.log('no cookie');
      return null;
    };
    Vue.prototype.saveUserInfo = function (userInfo) {
      sessionStorage.setItem('jphUserInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userInfo));
    };
    // Vue.prototype.getServiceBaseUrl = function () {
    //   let baseUrl = 'http://localhost:8080'
    //   return baseUrl
    // }
    Vue.prototype.showButton = function () {
      var showButton = JSON.parse(sessionStorage.getItem('showButton'));
      return showButton;
    };
  }
});

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_js__ = __webpack_require__(323);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';
var state = __WEBPACK_IMPORTED_MODULE_2__store_js__["a" /* mState */];
// 同步
var mutations = __WEBPACK_IMPORTED_MODULE_2__store_js__["b" /* mMutations */];
// 异步
var actions = __WEBPACK_IMPORTED_MODULE_2__store_js__["c" /* mActions */];
// 计算
var getters = __WEBPACK_IMPORTED_MODULE_2__store_js__["d" /* mGetters */];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  debug: debug, state: state, mutations: mutations, actions: actions, getters: getters
}));

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  basicInfoForm: function basicInfoForm() {
    return {
      productName: '', // 产品名称
      productHighlights: '', // 产品亮点
      productInsideRemark: '', // 内部备注
      scenicSpotArr: [], // 选中景点对象。addProductl中需重新处理数据，赋值 productViewIdList ，格式如: '1,2,3'
      productManageAreaIdList: '', // 产品地区管理。格式例：'1,2,3'
      productTicketType: '', // 票种类
      productSaleDate: [] // 这是一个时间区间数组。addProductl中需重新处理数据，赋值productSaleStartDate, productSaleEndDate
    };
  },
  contentForm: function contentForm() {
    return {
      scheduleDuration: '', // 行程时长
      // productTextDescription: '', // 富文本详细文字描述
      editorProductDetail: {
        content: '',
        isChange: false,
        isOriginal: true
      },
      productViewAddress: '', // 景点地址
      productBusinessTime: '', // 营业时间
      mealTimeArr: [], // 用餐时段选中数组
      mealNumberType: 1, // 用餐人数类型
      mealIntervalType: 0, // 使用时间类型
      langArr: [], // 服务语言选中数组
      productTraffic: '', // 交通方式
      pathTypeArr: [], // 路径类型  // addProduct中需重新赋值flag
      trafficArr: [], // 交通工具  // addProduct中需重新赋值flag
      groupNumber: '', // 成团人数
      shoppingType: 0, // 购物类型
      // freeItem: '',         // 赠送项目
      editorFreeItem: {
        content: '',
        isChange: false,
        isOriginal: true
      },
      networkFlow4g: '', // 4G高速网络
      networkFlow3g: '', // 3G流量
      networkCoverage: '', // 网络覆盖
      wifiAccessories: '', // wifi配件
      simSize: '', // sim卡大小
      productCostInclude: '', // 费用包含
      productCostExclusive: '', // 费用不含
      productUseFlow: '', // 使用流程
      imageList: [],
      videoList: [],
      newProductPackageDtoList: [], // 套餐详情
      scheduleInfoDtoList: [] // 行程
    };
  },
  reserveSetForm: function reserveSetForm() {
    return {
      // reserveLimit: {
      reserveLimitDay: '', // 使用日期的多少天前
      reserveLimitTime: '', // 使用日期前的多少时间
      // },
      productConfirmType: 0, // 确认订单方式
      confirmHour: '', // 二次确认时间
      maxReserveNummber: '', // 最大预定数
      minReserveNummber: '', // 最小预定数
      // ---------------------------------------------
      orderValidType: 0, // 订单有效期类型
      delayedDay1: '', // 有效期设置-延后天数 订单有效期类型 = 1/3设值(1设置)
      delayedDay3: '', // 有效期设置-延后天数 订单有效期类型 = 1/3设值(3设置)
      specifiedDate2: '', // 有效期设置-指定日期 订单有效期类型 = 2/4设值(2设置)
      specifiedDate4: '', // 有效期设置-指定日期 订单有效期类型 = 2/4设值（4设置）
      specifiedStartDate: '', // 有效期设置-指定开始日期 订单有效期类型 = 5设值
      specifiedEndDate: '', // 有效期设置-指定结束日期 订单有效期类型 = 5设值
      specifiedStartDay: '', // 有效期设置-指定日期开始天数 订单有效期类型 = 6设值
      specifiedEndDay: '', // 有效期设置-指定日期结束天数 订单有效期类型 = 6设值
      // ---------------------------------------------
      // orderRefundType: 0,        // 订单退改类型
      orderRefund: {
        orderRefundType: 0,
        producttRefundDtoList: [],
        refundFee: ''
      }, // 包含退改类型（orderRefundType）和数据（producttRefundDtoList， refundFee）
      // producttRefundDtoList: [],
      // refundFee: '', // 当订单类型为2时， 使用这个退款手续费字段
      // -----------------------------------------------
      refundDescription: '', // 退款说明
      customerDataType: 1, // 客人资料要求类型
      // -----------------------------------------------
      mustFillInInfoArr: [], // 选中的客人必填信息类型数组。 以此值判断：姓名填写标志 ~ 领取日期填写标志 为0 还是 1.
      // -----------------------------------------------
      productCustomCustomerItemDtoList: [{
        itemSeq: '1', //  输入项枝番
        itemName: '', // 输入项名称
        itemRequiredFlag: 0, // 输入项是否能为空标志  0：可以为空、1：不能为空
        itemRange: 0, // 输入项填写范围
        itemDescription: '' // 输入项说明
      }],

      // reserveNotice: '',      // 富文本预定需知
      editorNotice: {
        content: '',
        isChange: false,
        isOriginal: true
      },

      orderLiaisonIdList: '', // 选中的订单联络人
      emergencyLiaisonIdList: '', // 选中的紧急联络人
      receiveCounterIdList: '', // 选中的领取柜台
      returnCounterIdList: '', // 选中的归还柜台
      validateClerkIdList: '' // 产品核销业务员
      // selOrderContactData: [],  // 选中的订单联络人数组。
      // selEmergencyContactData: [], // 选中的紧急联络人数组。
      // selPickUpCounterData: [],  // 选中的领取柜台数组。
      // selReturnCounterData: [] // 选中的归还柜台数组。
    };
  },
  addRequestForPayment: function addRequestForPayment() {
    return {
      productCustomCustomerItemDtoList: [{
        itemSeq: '1', //  输入项枝番
        itemName: '', // 输入项名称
        itemRequiredFlag: 0, // 输入项是否能为空标志  0：可以为空、1：不能为空
        itemRange: 0, // 输入项填写范围
        itemDescription: '' // 输入项说明
      }],
      scenicSpotArr: [] // 选中景点。赋值 productViewIdList ，格式如: '1,2,3'
    };
  }
});

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mGetters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__productFormJson_js__ = __webpack_require__(322);


var _mMutations;




var mState = {
  isLoading: false,
  direction: 'forward', // 记录方向
  msg: '', // 系统消息
  errorMsg: '', // 错误消息
  scrollTop: 0, // 滚动条距离顶部位置
  showTitle: '',
  tempData: null,
  // ===================================================== benon
  baseInfoForm: __WEBPACK_IMPORTED_MODULE_2__productFormJson_js__["a" /* default */].basicInfoForm(),
  contentForm: __WEBPACK_IMPORTED_MODULE_2__productFormJson_js__["a" /* default */].contentForm(),
  reserveSetForm: __WEBPACK_IMPORTED_MODULE_2__productFormJson_js__["a" /* default */].reserveSetForm()
};

var mMutations = (_mMutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* UPDATE_MSG */], function (state, msg) {
  state.msg = msg;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* UPDATE_ERROR_MSG */], function (state, msg) {
  state.errorMsg = msg;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* UPDATE_SCROLLTOP_POSITION */], function (state, payload) {
  state.scrollTop = payload.top;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* UPDATE_LOADING */], function (state, status) {
  state.isLoading = status;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* UPDATE_SHOW_TITLE */], function (state, title) {
  state.showTitle = title;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* UPDATE_DIRECTION */], function (state, direction) {
  state.direction = direction;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mMutations, 'setBaseInfoForm', function setBaseInfoForm(state, form) {
  state.baseInfoForm = form;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mMutations, 'setContentForm', function setContentForm(state, form) {
  state.contentForm = form;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mMutations, 'setReserveSetForm', function setReserveSetForm(state, form) {
  state.reserveSetForm = form;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mMutations, 'setPriceSetParams', function setPriceSetParams(state, params) {
  if (params.productId) state.priceSetParams.productId = params.productId;
  if (params.productName) state.priceSetParams.productName = params.productName;
  if (params.productSaleDate) state.priceSetParams.productSaleDate = params.productSaleDate;
}), _mMutations);

var mActions = {
  updateScrollPosition: function updateScrollPosition(_ref, top) {
    var commit = _ref.commit;

    commit({
      type: __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* UPDATE_SCROLLTOP_POSITION */],
      top: top
    });
  }
};

var mGetters = {};

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

__webpack_require__(608);
__webpack_require__(606);
__webpack_require__(607);
if (!window.Quill) {
  window.Quill = __webpack_require__(172);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'quill-editor',
  data: function data() {
    return {
      _content: '',
      defaultModules: {
        toolbar: [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'script': 'sub' }, { 'script': 'super' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'direction': 'rtl' }], [{ 'size': ['small', false, 'large', 'huge'] }], [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], [{ 'font': [] }], [{ 'align': [] }], ['clean'], ['link', 'image', 'video']]
      }
    };
  },
  props: {
    content: String,
    value: String,
    disabled: Boolean,
    options: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    }
  },
  mounted: function mounted() {
    this.initialize();
  },
  beforeDestroy: function beforeDestroy() {
    this.quill = null;
  },
  methods: {
    initialize: function initialize() {
      if (this.$el) {

        // options and instance
        var self = this;
        self.options.theme = self.options.theme || 'snow';
        self.options.boundary = self.options.boundary || document.body;
        self.options.modules = self.options.modules || self.defaultModules;
        self.options.modules.toolbar = self.options.modules.toolbar !== undefined ? self.options.modules.toolbar : self.defaultModules.toolbar;
        self.options.placeholder = self.options.placeholder || 'Insert text here ...';
        self.options.readOnly = self.options.readOnly !== undefined ? self.options.readOnly : false;
        self.quill = new Quill(self.$refs.editor, self.options);

        // set editor content
        if (self.value || self.content) {
          self.quill.pasteHTML(self.value || self.content);
        }

        // mark model as touched if editor lost focus
        self.quill.on('selection-change', function (range) {
          if (!range) {
            self.$emit('blur', self.quill);
          } else {
            self.$emit('focus', self.quill);
          }
        });

        // update model if text changes
        self.quill.on('text-change', function (delta, oldDelta, source) {
          var html = self.$refs.editor.children[0].innerHTML;
          var text = self.quill.getText();
          if (html === '<p><br></p>') html = '';
          self._content = html;
          self.$emit('input', self._content);
          self.$emit('change', {
            editor: self.quill,
            html: html,
            text: text
          });
        });

        // disabled
        if (this.disabled) {
          this.quill.enable(false);
        }

        // emit ready
        self.$emit('ready', self.quill);
      }
    }
  },
  watch: {
    content: function content(newVal, oldVal) {
      if (this.quill) {
        if (!!newVal && newVal !== this._content) {
          this._content = newVal;
          this.quill.pasteHTML(newVal);
        } else if (!newVal) {
          this.quill.setText('');
        }
      }
    },
    value: function value(newVal, oldVal) {
      if (this.quill) {
        if (!!newVal && newVal !== this._content) {
          this._content = newVal;
          this.quill.pasteHTML(newVal);
        } else if (!newVal) {
          this.quill.setText('');
        }
      }
    },
    disabled: function disabled(newVal, oldVal) {
      if (this.quill) {
        this.quill.enable(!newVal);
      }
    }
  }
});

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      type: [String, Number],
      default: function _default() {
        return '';
      }
    },
    placeholder: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    limit: Array,
    size: String,
    disabled: Boolean
  },
  watch: {},
  computed: {
    disabledCls: function disabledCls() {
      if (this.disabled) return 'el-input is-disabled';else return '';
    },
    sizeCls: function sizeCls() {
      if (this.size) {
        if (this.size === 'large') return 'el-input__inner large';
        if (this.size === 'small') return 'el-input__inner small';
        if (this.size === 'mini') return 'el-input__inner mini';
      } else {
        return 'el-input__inner';
      }
    },
    defaultVal: function defaultVal() {
      if (this.limit && this.limit[2] !== undefined) {
        return this.limit[2] + '';
      } else return null;
    }
  },
  mounted: function mounted() {
    this.setDefaultVal(this.$refs.input);
  },

  methods: {
    onBlur: function onBlur(target) {
      this.setDefaultVal(target);
    },
    updateValue: function updateValue(target) {
      var value = target.value;
      var newVal = this.filterValue(value);
      if (newVal !== value) target.value = newVal;
      this.$emit('input', newVal);
    },
    setDefaultVal: function setDefaultVal(target) {
      var newVal = this.filterValue(this.value);
      // 默认值，如果为空则显示默认值
      if (this.defaultVal) {
        if (newVal === null || newVal === '' || newVal === undefined || newVal === this.defaultVal) {
          target.value = this.defaultVal;
          this.$emit('input', this.defaultVal);
        }
      }
    },
    filterValue: function filterValue(value) {
      var newVal = value;

      if (newVal && this.limit && this.limit.length !== 0) {
        // 类型限制
        if (this.limit[0] === 'count') {
          newVal = newVal.replace(/[^\d]/g, '');
          newVal = parseInt(newVal);
          if (newVal <= this.limit[1]) return newVal;else return this.limit[1];
        } else if (this.limit[0] === 'number') {
          newVal = newVal.replace(/[^\d]/g, '');
        } else if (this.limit[0] === 'text') {}

        // 长度限制
        if (this.limit[1]) newVal = newVal.substring(0, this.limit[1]);
      }
      return newVal;
    }
  }
});

/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_user__ = __webpack_require__(111);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import {userList} from '../../mixins/req'
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      ruleForm: {
        loginName: '',
        password: ''
      },
      rememberLoginStatus: false,
      rules: {
        loginName: [{ required: true, message: this.$t('login.message1'), trigger: 'blur' }],
        password: [{ required: true, message: this.$t('login.message2'), trigger: 'blur' }, { pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.message3'), trigger: 'blur' }]
      },
      locale: this.$i18n.locale !== null ? this.$i18n.locale : 'en',
      text: this.$t('common.' + (this.$i18n.locale !== null ? this.$i18n.locale : 'en')),
      initImg: '/static/img/login_bg.png',
      showImg: ''
    };
  },
  created: function created() {
    var _this2 = this;

    // 读取cookie中的语言
    var langType = this.getCookie1('langType');
    if (langType !== undefined && langType !== null) {
      this.saveLangType(langType);
      this.$i18n.locale = langType;
      this.locale = langType;
      if (langType === 'zh') {
        this.text = this.$t('common.zh');
      } else if (langType === 'tw') {
        this.text = this.$t('common.tw');
      } else if (langType === 'en') {
        this.text = this.$t('common.en');
      } else if (langType === 'ko') {
        this.text = this.$t('common.ko');
      } else if (langType === 'ja') {
        this.text = this.$t('common.ja');
      }
    } else {
      this.saveLangType('en');
      this.setCookie('langType', 'en', 30);
      this.$i18n.locale = 'en';
      this.text = this.$t('common.en');
    }
    // 初始化图片处理.
    this.getHttpData('/sys/getPageImg', {}, function (data) {
      if (data) {
        if (data.img === '1') {
          _this2.isInitImg = true;
          _this2.showImg = 'background-image:url(' + _this2.initImg + ')';
        } else {
          _this2.showImg = 'background-image:url(' + data.img + ')';
        }
      }
    });
  },
  mounted: function mounted() {
    /* eslint-disable no-new */
    new __WEBPACK_IMPORTED_MODULE_0_swiper___default.a('.swiper-container', {
      autoplay: {
        disableOnInteraction: false
      },
      loop: true,
      pagination: '.swiper-pagination',
      slidesPerView: 1,
      paginationClickable: true
    });
  },

  computed: {
    languageStr: function languageStr() {
      return this.text;
    }
  },
  methods: {
    submitForm: function submitForm(formName) {
      var _this3 = this;

      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.saveLangType(_this3.$i18n.locale);
          _this3.postHttpData('/sys/user/login', __webpack_require__(84).stringify(_this3.ruleForm), function (data, s, errorMsg) {
            if (data) {
              var newHome = !!data.newHome;
              sessionStorage.setItem('isDistributor', newHome); // 实际接口返回的是是否是分销商
              delete data.newHome;
              __WEBPACK_IMPORTED_MODULE_1__utils_user__["a" /* default */].save(data, _this3.$i18n.locale, newHome);
              _this3.base_go(newHome ? '/newHomePage' : '/sysHome', true);
              var Days = 30;
              var exp = new Date();
              if (_this.rememberLoginStatus) {
                // 有效期30天
                exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
                document.cookie = 'sys.user.accessToken=' + data.accessToken + ';expires=' + exp.toGMTString() + ';path=/';
              } else {
                exp.setTime(exp.getTime() + 1 * 1 * 1 * 1 * 1);
                document.cookie = 'sys.user.accessToken=;expires=' + exp.toGMTString() + ';path=/';
              }
              // 登陆成功，获取对应的页面级控制
              _this3.getHttpData('/sys/href', '', function (data) {
                if (data) {
                  var hrefList = [];
                  data.hrefList.forEach(function (item) {
                    hrefList.push(item.href);
                  });
                  sessionStorage.setItem('href', hrefList);
                }
              });
            } else {
              if (errorMsg) {
                _this3.$message.error(_this.$t('errorMsg.user.' + errorMsg));
                return;
              }
            }
          });
        }
      });
    },
    languageCommand: function languageCommand(command) {
      this.locale = command.locale;
    }
  },
  watch: {
    locale: function locale(val) {
      this.$i18n.locale = val;
      this.saveLangType(val);
      this.setCookie('langType', val, 30);
      if (val === 'zh') {
        this.text = this.$t('common.zh');
      } else if (val === 'tw') {
        this.text = this.$t('common.tw');
      } else if (val === 'en') {
        this.text = this.$t('common.en');
      } else if (val === 'ko') {
        this.text = this.$t('common.ko');
      } else if (val === 'ja') {
        this.text = this.$t('common.ja');
      }
    }
  }
});

/***/ }),

/***/ 605:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 607:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 608:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 609:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 610:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 611:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 612:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 613:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 614:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 615:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 616:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 617:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 618:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OThGNTEyRDFGOUUzMTFFOEE3NUVDMUMxMUU2NTM5MjkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OThGNTEyRDBGOUUzMTFFOEE3NUVDMUMxMUU2NTM5MjkiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3OUVDOUNDNTAxQTExMUU4QjAyMUFGQUVCQjQ2NDA3NiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo3OUVDOUNDNjAxQTExMUU4QjAyMUFGQUVCQjQ2NDA3NiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Phnn2X0AAAV6SURBVHja5Jt9aFdVGMfPQjBilSzTGb0oTUhSmaGhNGmFYNIyNcUKBSstfEmm2Ju1ma0XjSgjewMpK/OFwteJfyi1NMrQyFFgqKmgxWoLIxaYrn59H37f4x7v7tbv97vnvs0Hvuzcu7v7O597nvuc5zznt6JMJmMuJCsKClz09vJ8Lu8FlVJiLVATfxZkmdlP5HV9j5AfqNx/JHQPVAWVdXKdAG+GNkANUFuYHQrDLobupcbmcH1vaCa1h+Drod/TACyjuA4a7vO7/cqNLai4d7nqy2iqGrqPf5NY4DGE7a3OHYHehD6FTnYxwhOguYS3D+5zaDa0xlUHL3IIOxnaoWBlJB+FBkEruoC1166ChnFUj/N8MfQRRztRwJOgl5XHbOO5lQUEIHl3x0MfqHNLoIeSAlxKlx3AY4my9zP4FGrfM4C9o6Yz8ZLBSQBerObVL6BFUKuD+4pnLIXWKveuCRp3AiUeSDoksBxkJ6SDo1xHVT7Mgxxlsbug+kITj6Aj/LR64qtDgDWcwmrUcV0sI4zRleSima52mu9wU4gJ0mGoP48HcrqLdITvJqyNymHB2vd5reezIw9aFar9WQQLnR2qXRkH8HWeaSRs+wE6w/bVcQD3Ve3fIgD+Q31O3ziAr1LtwxGt323W1i8O4FOqfU1EwGfVaPeMGvhX1e4TAWxP5cry2X9HDazLMgMiABY3vozt5jhc+mvVvj0C4Emq/VUcwBtVe4oJvz42rpM5ORpgpHSyoN+rKhYzQ4StYDXFBqwv41oerlLtWaxuuLZLoIXq+HUToKoZFHi9WqrdBM0z2YqlS1sATWRbVmMfx1YAgFv/xSdubQ6hXdkd0LPq+N2gSY6LiscuqFYd17KTlwe873zoLRUMX4PeC9pZV0W8Orq32KUmW3RbU2CSL5WN9+k5dn6XIPU49G9SgMWme4JYFd2vLkdwAZVy7DFohseDxhlH2y8u5842RupG6A2ekwD2DCVTWAP0E4sFcr3Uq67ntFPh0x/xkgeMw70ml8C3mGyBraqT34+k8jHZrnmRM8FuF5104dL9oU84elJgutEn527N0UO8ZaIboMdMtvy7iceBLEgRT7xDatBSuSz2qU7I9ud2unIPjpa47RXm/P1h2SE8wMDUSijZthnrKSPZh/IK9IJ9iPkW8QoCZj1aRrXc8yuBXEoAF1bGBzrN8/qdZJBsCB0YsDOY/QxVpzdQm0LKpW+DplK2IC/u/6oI0P+EAgxYceGX1NMWt5IdwtURVTzExdd5pjn57FmAbnMKDFhxredUoNtqsruDO020Nozp64PqnPSjFtCnnERpwEpC8Ly6XrKqqfiAqGHFvjPZrdOn1Ll5nvS2cGDATmMea0128qcD9rSJ15ZxEKxVo691gYBxg1GcB619KGvTXN+XCExeMf29qTno85QgI7xYRWOZauYC9oRJjp1Ff55UC5cSycwAXZw3MP5ovkoTf4ZqcPNWk0xbpspNZVyt5Q4M2F7MZs6VcgBbn1BYybYaPf1dBIbyfEa4WqWLBzzBIanQ9Z58YElOwHgyshgYr04tT1CQ+j+TL8H8wnYlWCpzGeEJnNwNk/+NKYGVUf5GpbfyWk7MBfgRnbbhJmdMumylaj/MeOQPzFWQXXMe5+onVYYB+tG0l46l4lLZ1QjfqdpbUvTuek1vxdzaFfDNqr3PpNf2ecpEHYHhziUK+M+UA+837d8ZGw62wX4j3Me0f2P9KNz5UFpp0fcMy0z2PS71A9ZfWzhk0m9HVftaP+ArVbu5GwC3+LF1BtzSDYCbPa9rB2D9tf2mbjbCJX7A3/KnzL27ugHwXjVwjR2AEdkkqxoBDUT7SNppWYIaAo1Ge8W56fdC+1e8/wQYACspdXYpuq33AAAAAElFTkSuQmCC"

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.7dd1d33.svg";

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(617)
}
var Component = __webpack_require__(78)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(659),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(618)
}
var Component = __webpack_require__(78)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(660),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b0f20b9c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(615)
  __webpack_require__(613)
  __webpack_require__(616)
  __webpack_require__(614)
}
var Component = __webpack_require__(78)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(658),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-45231082",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(612)
}
var Component = __webpack_require__(78)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(657),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 657:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quill-editor"
  }, [_vm._t("toolbar"), _vm._v(" "), _c('div', {
    ref: "editor"
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrap body"
  }, [_c('div', {
    staticClass: "login_head header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login_language pull-right"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.languageCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.languageStr)), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": {
        locale: 'zh'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.zh')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": {
        locale: 'en'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.en')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": {
        locale: 'ko'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.ko')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": {
        locale: 'ja'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.ja')))])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "notice_box"
  }), _vm._v(" "), _c('div', {
    staticClass: "login_bg"
  }, [_c('div', {
    staticClass: "login_main"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ms-login"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ms-login-title"
  }, [_vm._v(_vm._s(_vm.$t('login.userLogin')))]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "0px"
    }
  }, [_c('el-form-item', {
    staticClass: "username",
    attrs: {
      "prop": "loginName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('login.message1')
    },
    model: {
      value: (_vm.ruleForm.loginName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "loginName", $$v)
      },
      expression: "ruleForm.loginName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "password",
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    ref: "passwordInput",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('login.message2')
    },
    nativeOn: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm('ruleForm')
      }, function($event) {
        return (function (e) {
          e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, '')
          _vm.ruleForm.password = e.target.value
        }).apply(null, arguments)
      }]
    },
    model: {
      value: (_vm.ruleForm.password),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "password", $$v)
      },
      expression: "ruleForm.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "forgot_box"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.rememberLoginStatus),
      callback: function($$v) {
        _vm.rememberLoginStatus = $$v
      },
      expression: "rememberLoginStatus"
    }
  }, [_vm._v(_vm._s(_vm.$t('login.rememberLoginStatus')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    attrs: {
      "to": "backAccount"
    }
  }, [_vm._v(_vm._s(_vm.$t('login.forgetPassword')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "login-btn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('login.loginIn')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "login-btn login-btn-new"
  }, [_c('router-link', {
    attrs: {
      "to": "selectMerchantType"
    }
  }, [_c('el-button', [_vm._v(_vm._s(_vm.$t('login.register')))])], 1)], 1)], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "login_copyright"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('login.copyRight'))), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn"
    }
  }, [_vm._v(_vm._s(_vm.$t('login.recordInformation')))]), _vm._v(" \n    "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://jph-static.oss-ap-northeast-1.aliyuncs.com/%E7%89%B9%E5%95%86%E6%B3%95%E8%A1%A8%E8%A8%98.pdf"
    }
  }, [_vm._v(_vm._s(_vm.$t('login.recordInformation2')))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login_logo pull-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(651),
      "width": "120"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login_left_banner"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "https://greater-tokyo-pass.jp/",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "swiper_banner",
    staticStyle: {
      "background-image": "url(/static/img/gtp3.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "https://www.hozugawakudari.jp/",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "swiper_banner",
    staticStyle: {
      "background-image": "url(/static/img/11.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "http://www.fujisan.ne.jp/",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "swiper_banner",
    staticStyle: {
      "background-image": "url(/static/img/fujisan.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "http://www.tobu.co.jp/foreign/en/pass/all.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "swiper_banner",
    staticStyle: {
      "background-image": "url(/static/img/nikkopass.png)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('div', {
    staticClass: "swiper_banner",
    staticStyle: {
      "background-image": "url(/static/img/tenku.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('div', {
    staticClass: "swiper_banner",
    staticStyle: {
      "background-image": "url(/static/img/ite.jpg)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login_logo_new"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(650)
    }
  })])])
}]}

/***/ }),

/***/ 659:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 660:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.disabledCls,
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('input', {
    ref: "input",
    class: _vm.sizeCls,
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "blur": function($event) {
        return _vm.onBlur($event.target)
      },
      "input": function($event) {
        return _vm.updateValue($event.target)
      }
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 667:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(249);
module.exports = __webpack_require__(248);


/***/ })

},[668]);


// WEBPACK FOOTER //
// static/edjs/app.a61c559600f6bc84a795.js